export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Date: { input: string; output: string };
  DateTime: { input: string; output: string };
  DateTimeZ: { input: string; output: string };
  Decimal: { input: number; output: number };
  Int16: { input: number; output: number };
  Int32: { input: number; output: number };
  Int64: { input: number; output: number };
  JSON: { input: Record<string, unknown>; output: Record<string, unknown> };
  PageInfo: { input: Record<string, unknown>; output: Record<string, unknown> };
  SoftDeleteZ: { input: string; output: string };
  SyncData: { input: Record<string, unknown>; output: Record<string, unknown> };
  Time: { input: string; output: string };
  UUID: { input: string; output: string };
  Upload: { input: File; output: File };
};

export enum AiWaiterAvatarPostureId {
  Pose_1 = 'POSE_1',
  Pose_2 = 'POSE_2',
  Pose_3 = 'POSE_3',
  Pose_4 = 'POSE_4',
  Pose_5 = 'POSE_5',
}

/** AI Waiter 虛擬人正式程度 */
export enum AiWaiterFormality {
  Formal = 'Formal',
  Neutral = 'Neutral',
}

/** AI Waiter 知識庫對應項目類型 */
export enum AiWaiterKnowledgeTargetType {
  Item = 'Item',
  Label = 'Label',
}

export type AiWaiterPreviewVideo = {
  status: AiWaiterPreviewVideoStatus;
  video?: Maybe<AiWaiterVirtualHumanVideo>;
};

export enum AiWaiterPreviewVideoStatus {
  Failed = 'FAILED',
  Generating = 'GENERATING',
  Ready = 'READY',
  WaitingForVoice = 'WAITING_FOR_VOICE',
}

/** AI Waiter 虛擬人回覆長度 */
export enum AiWaiterResponseLength {
  Concise = 'Concise',
  Standard = 'Standard',
}

/** 基本設定與對 */
export type AiWaiterSettingResponse = {
  setting: BrandAiWaiterSetting;
  virtualHumans: Array<AiWaiterVirtualHumanView>;
};

/** AI Waiter 虛擬人 */
export type AiWaiterVirtualHuman = {
  brandID?: Maybe<Scalars['Int32']['output']>;
  createdAt: Scalars['DateTimeZ']['output'];
  /** 目前使用的聲音；必須屬於同一位虛擬人，NULL 表示尚未選擇 */
  currentVoiceID?: Maybe<Scalars['UUID']['output']>;
  deletedAt?: Maybe<Scalars['SoftDeleteZ']['output']>;
  disabled: Scalars['Boolean']['output'];
  formality: AiWaiterFormality;
  image?: Maybe<AiWaiterVirtualHumanImage>;
  languages: Array<AiWaiterVirtualHumanLanguage>;
  name: Scalars['String']['output'];
  nameLang: Scalars['JSON']['output'];
  of: PermissionScope;
  ownerBrand?: Maybe<Brand>;
  responseLength: AiWaiterResponseLength;
  speechRate: Scalars['Decimal']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  video?: Maybe<AiWaiterVirtualHumanVideo>;
  virtualHumanID: Scalars['UUID']['output'];
  voices: Array<AiWaiterVirtualHumanVoice>;
  /** Global 預設資料為 null；WS 自建資料必須完整指定 owner brand */
  workspaceID?: Maybe<Scalars['UUID']['output']>;
};

/** AI Waiter 虛擬人主圖 */
export type AiWaiterVirtualHumanImage = {
  alg: ImageHashAlg;
  createdAt: Scalars['DateTimeZ']['output'];
  fileSize: Scalars['Int32']['output'];
  hash: Scalars['String']['output'];
  height: Scalars['Int16']['output'];
  mime: ImageMimeType;
  updatedAt: Scalars['DateTimeZ']['output'];
  virtualHuman: AiWaiterVirtualHuman;
  virtualHumanID: Scalars['UUID']['output'];
  width: Scalars['Int16']['output'];
};

/** AI Waiter 虛擬人支援語言 */
export type AiWaiterVirtualHumanLanguage = {
  createdAt: Scalars['DateTimeZ']['output'];
  language: Language;
  languageID: Scalars['String']['output'];
  virtualHuman: AiWaiterVirtualHuman;
  virtualHumanID: Scalars['UUID']['output'];
};

/** AI 虛擬人清單的頁面用途與篩選範圍 */
export enum AiWaiterVirtualHumanPurpose {
  /** AI 虛擬人頁：所有 */
  All = 'ALL',
  /** 基本設定頁初始載入：品牌已勾選的虛擬人 */
  Basic = 'BASIC',
  /** AI 虛擬人頁：預設 */
  Default = 'DEFAULT',
  /** 基本設定頁：選擇虛擬人 Dialog */
  Dialog = 'DIALOG',
  /** AI 虛擬人頁：我的 */
  Mine = 'MINE',
}

export type AiWaiterVirtualHumanSelectionInput = {
  displayOrder: Scalars['Int16']['input'];
  virtualHumanID: Scalars['UUID']['input'];
};

/** AI Waiter 虛擬人預覽影片 */
export type AiWaiterVirtualHumanVideo = {
  alg: VideoHashAlg;
  createdAt: Scalars['DateTimeZ']['output'];
  durationInMs: Scalars['Int32']['output'];
  fileSize: Scalars['Int32']['output'];
  hash: Scalars['String']['output'];
  height: Scalars['Int16']['output'];
  mime: VideoMimeType;
  updatedAt: Scalars['DateTimeZ']['output'];
  virtualHuman: AiWaiterVirtualHuman;
  virtualHumanID: Scalars['UUID']['output'];
  width: Scalars['Int16']['output'];
};

/** 基本設定頁的虛擬人顯示資料 */
export type AiWaiterVirtualHumanView = {
  displayOrder?: Maybe<Scalars['Int16']['output']>;
  previewVideo: AiWaiterPreviewVideo;
  selected: Scalars['Boolean']['output'];
  virtualHuman: AiWaiterVirtualHuman;
};

/** AI Waiter 虛擬人聲音 */
export type AiWaiterVirtualHumanVoice = {
  createdAt: Scalars['DateTimeZ']['output'];
  processingErrorCode?: Maybe<Scalars['String']['output']>;
  providerVoiceReference?: Maybe<Scalars['String']['output']>;
  source: AiWaiterVoiceSource;
  status: AiWaiterVoiceStatus;
  updatedAt: Scalars['DateTimeZ']['output'];
  uploadAlg?: Maybe<Scalars['String']['output']>;
  uploadDurationInMs?: Maybe<Scalars['Int32']['output']>;
  uploadFileSize?: Maybe<Scalars['Int32']['output']>;
  uploadHash?: Maybe<Scalars['String']['output']>;
  uploadMime?: Maybe<Scalars['String']['output']>;
  virtualHuman: AiWaiterVirtualHuman;
  virtualHumanID: Scalars['UUID']['output'];
  voiceID: Scalars['UUID']['output'];
  voiceType: AiWaiterVoiceType;
};

/** 指定虛擬人的聲音清單；目前聲音為 voiceID 等於 currentVoiceID 的那一筆 */
export type AiWaiterVirtualHumanVoiceOptions = {
  currentVoiceID?: Maybe<Scalars['UUID']['output']>;
  /** 排序固定 createdAt ASC、voiceID ASC；沒有聲音時為空陣列 */
  voices: Array<AiWaiterVirtualHumanVoice>;
};

/** AI Waiter 虛擬人聲音來源 */
export enum AiWaiterVoiceSource {
  System = 'System',
  Upload = 'Upload',
}

/** AI Waiter 虛擬人聲音處理狀態 */
export enum AiWaiterVoiceStatus {
  Failed = 'Failed',
  Pending = 'Pending',
  Processing = 'Processing',
  Ready = 'Ready',
}

/** AI Waiter 聲音類型 */
export enum AiWaiterVoiceType {
  Custom = 'Custom',
  FemaleDefault = 'FemaleDefault',
  MaleDefault = 'MaleDefault',
}

export type ActiveSubscription = {
  appID: Scalars['UUID']['output'];
  appType: Scalars['String']['output'];
  endDate: Scalars['String']['output'];
  name: Scalars['String']['output'];
  providerCode: Scalars['String']['output'];
  quantity: Scalars['Int32']['output'];
  startDate: Scalars['String']['output'];
};

export type AddBrandDiningOptionInput = {
  brandID: Scalars['Int32']['input'];
  diningOptionType: DiningOptionType;
  disabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  workspaceID: Scalars['UUID']['input'];
};

/** 新增系統發佈 */
export type AddPublishTaskInput = {
  /** 版本說明 */
  description: Scalars['String']['input'];
  /** 生效時間(不帶入則立即生效) */
  effectiveTime?: InputMaybe<Scalars['DateTimeZ']['input']>;
  /** 版本名稱 */
  name: Scalars['String']['input'];
  /** 要選擇的發佈品牌清單 */
  selectBrandLists: Array<SelectBrandLists>;
  /** 總部 */
  workspaceID: Scalars['UUID']['input'];
};

export type AddressFieldView = {
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  placeholder: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type App = {
  /** 應用程式編號 */
  appCode?: Maybe<Scalars['String']['output']>;
  appHQAuths?: Maybe<Array<AppHqAuth>>;
  appID: Scalars['UUID']['output'];
  /** 應用程式類型 */
  appType: AppType;
  /** 自訂串接參數 */
  bindSettingsSchema?: Maybe<Scalars['JSON']['output']>;
  brandImages: Array<BrandImage>;
  callbackUrl?: Maybe<Scalars['String']['output']>;
  categories?: Maybe<Array<Category>>;
  createdAt: Scalars['DateTimeZ']['output'];
  deletedAt?: Maybe<Scalars['SoftDeleteZ']['output']>;
  /** 應用程式描述 */
  description?: Maybe<Scalars['String']['output']>;
  /** 聯絡電子郵件 */
  email?: Maybe<Scalars['String']['output']>;
  /** HMAC 金鑰 */
  hmacKey?: Maybe<Scalars['String']['output']>;
  /** HMAC 更新時間 */
  hmacUpdatedAt: Scalars['DateTimeZ']['output'];
  /** 串接模式 */
  integrationMode: AppIntegrationMode;
  /** 販售狀態 */
  isPublished: Scalars['Boolean']['output'];
  /** 應用程式圖示 */
  logo?: Maybe<Scalars['String']['output']>;
  /** 是否可設定多組串接參數 (subscriber_settings.bind_settings 可含多個元素) */
  multipleBindSettingsEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** 應用程式名稱 */
  name: Scalars['String']['output'];
  partner?: Maybe<Partner>;
  partnerID?: Maybe<Scalars['UUID']['output']>;
  plans: Array<Plan>;
  /** POS 設定參數 */
  posSettingsSchema: Scalars['JSON']['output'];
  /** 隱私政策網址 */
  privacyPolicy?: Maybe<Scalars['String']['output']>;
  /** 分潤模式 */
  profitMode?: Maybe<ProfitMode>;
  /** 分潤值 */
  profitValue?: Maybe<Scalars['Decimal']['output']>;
  /** Slug */
  slug?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTimeZ']['output'];
  /** 能見度 */
  visibility: AppVisibility;
  webhookUrl?: Maybe<Scalars['String']['output']>;
  /** 支援網站 */
  website?: Maybe<Scalars['String']['output']>;
};

export type AppCategory = {
  app: App;
  appID: Scalars['UUID']['output'];
  category: Category;
  categoryID: Scalars['UUID']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
};

export type AppCategoryKey = {
  appID: Scalars['UUID']['input'];
  categoryID: Scalars['UUID']['input'];
};

export type AppFormatDetail = {
  bindSettings: Scalars['JSON']['output'];
  posSettings: Scalars['JSON']['output'];
};

export type AppHqAuth = {
  appID: Scalars['UUID']['output'];
  authorizationID: Scalars['UUID']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type AppHqAuthKey = {
  appID: Scalars['UUID']['input'];
  authorizationID: Scalars['UUID']['input'];
  workspaceID: Scalars['UUID']['input'];
};

/** 應用程式詳細資訊 */
export type AppInfo = {
  /** 應用程式 ID */
  appID: Scalars['UUID']['output'];
  /** 應用程式類型 (例如: POSMain) */
  appType: Scalars['String']['output'];
  /** 覆蓋範圍資訊 */
  coverage: CoverageInfo;
  /** 應用程式名稱 */
  name: Scalars['String']['output'];
  /** 供應商代碼 */
  providerCode?: Maybe<Scalars['String']['output']>;
};

export enum AppIntegrationMode {
  /** 自有服務串接 */
  Internal = 'Internal',
  /** 內嵌整合 */
  Legacy = 'Legacy',
  /** API整合 */
  OpenApi = 'OpenAPI',
}

export type AppListItem = {
  app: App;
  hasSettingsSchema: Scalars['Boolean']['output'];
};

export type AppSchemas = {
  /** 綁定設定 Schema */
  bindSettingsSchema?: Maybe<Scalars['JSON']['output']>;
  /** POS 設定 Schema */
  posSettingsSchema: Scalars['JSON']['output'];
};

export type AppService = {
  app: App;
  appID: Scalars['UUID']['output'];
  callbackURL?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeZ']['output'];
  deletedAt?: Maybe<Scalars['SoftDeleteZ']['output']>;
  /** 顯示名稱 */
  displayName?: Maybe<Scalars['String']['output']>;
  /** 未使用，表示是否有支付行為 */
  payable?: Maybe<Scalars['Boolean']['output']>;
  service: Service;
  serviceID: Scalars['UUID']['output'];
  /** 未使用，對應2代支付代碼 */
  transactionType?: Maybe<Scalars['Int32']['output']>;
  updatedAt: Scalars['DateTimeZ']['output'];
  webhookURL?: Maybe<Scalars['String']['output']>;
};

export type AppServiceKey = {
  appID: Scalars['UUID']['input'];
  serviceID: Scalars['UUID']['input'];
};

export enum AppType {
  /** AI Waiter */
  AiWaiter = 'AIWaiter',
  /** 客顯 */
  Cds = 'CDS',
  /** 訂金 */
  Deposit = 'Deposit',
  /** EDC 信用卡機 */
  EdcPayment = 'EDCPayment',
  /** 電子發票加值中心 */
  EInvoiceCenter = 'EInvoiceCenter',
  /** 庫存 */
  Inventory = 'Inventory',
  /** 廚顯 */
  Kds = 'KDS',
  /** 會員 Member Management System */
  Mms = 'MMS',
  /** 線上點餐 */
  OnlineOrder = 'OnlineOrder',
  /** 第三方支付 */
  OnlinePayment = 'OnlinePayment',
  /** POS 主機 */
  PosMain = 'POSMain',
  /** POS 子機 */
  PosSub = 'POSSub',
  /** 線下支付 */
  Payment = 'Payment',
  /** 預付 */
  Prepay = 'Prepay',
  /** 預售 */
  Presale = 'Presale',
  /** 叫號 Queue Management System */
  Qms = 'QMS',
  /** 訂位 */
  Reservation = 'Reservation',
  /**
   * 舊版銷售管理類型；新 App 請使用 Sales
   * @deprecated Use Sales instead
   */
  Sale = 'Sale',
  /** 銷售管理 */
  Sales = 'Sales',
  /** 掃碼點餐 */
  ScanOrder = 'ScanOrder',
  /** 自助點餐 */
  SelfOrder = 'SelfOrder',
  /** 儲值 */
  StoredValue = 'StoredValue',
}

export enum AppVisibility {
  /** 私有 */
  Private = 'Private',
  /** 公開 */
  Public = 'Public',
}

export type AppWebhookEvent = {
  app: App;
  appID: Scalars['UUID']['output'];
  eventID: Scalars['UUID']['output'];
  eventReceived: Scalars['Boolean']['output'];
  eventType: Scalars['String']['output'];
  requestData: Scalars['String']['output'];
  requestTime: Scalars['DateTimeZ']['output'];
  retryCount: Scalars['Int16']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  webhookEventID: Scalars['UUID']['output'];
  webhookUrl: Scalars['String']['output'];
};

export type AppsPagination = {
  apps: Array<AppListItem>;
  pageInfo: CursorPageInfo;
};

export enum AuthorizationMode {
  /** 品牌 */
  Brand = 'Brand',
  /** 門市 */
  Shop = 'Shop',
  /** 總部 */
  Workspace = 'Workspace',
}

/** 條碼類型 */
export enum BarcodeType {
  /** 金額條碼 */
  Amt = 'Amt',
  /** 金額條碼+檢核碼 */
  AmtChk = 'AmtChk',
  /** 二維金額條碼 */
  Qr = 'QR',
}

export enum BillingCycle {
  /** 固定週期 */
  Fixed = 'Fixed',
  /** 永久 */
  Forever = 'Forever',
}

export enum BillingFrequency {
  /** 永久 */
  Forever = 'Forever',
  /** 每月 */
  Monthly = 'Monthly',
  /** 每年 */
  Yearly = 'Yearly',
}

export enum BillingInterval {
  /** 每月 */
  Monthly = 'Monthly',
  /** 每年 */
  Yearly = 'Yearly',
}

export type BindShopResponse = {
  pDevice?: Maybe<PDevice>;
};

/** 黑白樣式 */
export enum BlackWhiteStyle {
  /** 白底黑字 */
  BlackInWhite = 'BlackInWhite',
  /** 黑底白字 */
  WhiteInBlack = 'WhiteInBlack',
}

/** 品牌 */
export type Brand = {
  /** 品牌 AI Waiter 知識庫商品與標籤對應 */
  brandAIWaiterKnowledgeEntries: Array<BrandAiWaiterKnowledgeEntry>;
  /** 品牌 AI Waiter 知識庫常見問題 */
  brandAIWaiterKnowledgeFaqs: Array<BrandAiWaiterKnowledgeFaq>;
  /** 品牌 AI Waiter 設定 */
  brandAIWaiterSetting?: Maybe<BrandAiWaiterSetting>;
  /** 品牌選用的 AI Waiter 虛擬人 */
  brandAIWaiterVirtualHumans: Array<BrandAiWaiterVirtualHuman>;
  brandDiningOptions: Array<BrandDiningOption>;
  brandID: Scalars['Int32']['output'];
  /** 品牌 POS 更新策略 */
  brandPOSUpdatePolicy?: Maybe<BrandPosUpdatePolicy>;
  /** 營業日切換時間 */
  businessDayCutoffTime: Scalars['Time']['output'];
  /** 品牌代碼(ID) */
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 顯示順序 */
  displayOrder: Scalars['Int16']['output'];
  itemCategories: Array<ItemCategory>;
  itemTypes: Array<ItemType>;
  labelGroups: Array<LabelGroup>;
  /** 品牌名稱 */
  name: Scalars['String']['output'];
  subBrands: Array<SubBrand>;
  uncategorizedShops: Array<Shop>;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 品牌 AI Waiter 知識庫別名 */
export type BrandAiWaiterKnowledgeAlias = {
  aliasName: Scalars['String']['output'];
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  displayOrder: Scalars['Int16']['output'];
  entry: BrandAiWaiterKnowledgeEntry;
  knowledgeAliasID: Scalars['UUID']['output'];
  knowledgeEntryID: Scalars['UUID']['output'];
  normalizedAlias: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 品牌 AI Waiter 知識庫商品或標籤對應 */
export type BrandAiWaiterKnowledgeEntry = {
  aliases: Array<BrandAiWaiterKnowledgeAlias>;
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  item?: Maybe<Item>;
  itemID?: Maybe<Scalars['Int32']['output']>;
  knowledgeEntryID: Scalars['UUID']['output'];
  label?: Maybe<Label>;
  labelID?: Maybe<Scalars['Int32']['output']>;
  targetType: AiWaiterKnowledgeTargetType;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 品牌 AI Waiter 知識庫常見問題 */
export type BrandAiWaiterKnowledgeFaq = {
  answer: Scalars['String']['output'];
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  knowledgeFAQID: Scalars['UUID']['output'];
  question: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 品牌 AI Waiter 設定 */
export type BrandAiWaiterSetting = {
  activate: Scalars['Boolean']['output'];
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  idleEndConversationInMin: Scalars['Int16']['output'];
  silencePromptTimeoutInSec: Scalars['Int16']['output'];
  unrecognizedSpeechMessage: Scalars['String']['output'];
  unrecognizedSpeechMessageLang: Scalars['JSON']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  welcomeMessage: Scalars['String']['output'];
  welcomeMessageLang: Scalars['JSON']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 品牌選用的 AI Waiter 虛擬人 */
export type BrandAiWaiterVirtualHuman = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  displayOrder: Scalars['Int16']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  virtualHuman: AiWaiterVirtualHuman;
  virtualHumanID: Scalars['UUID']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 品牌與門店覆蓋細節 */
export type BrandCoverage = {
  brandID: Scalars['Int']['output'];
  shops: Array<Scalars['Int']['output']>;
};

/** 品牌用餐方式設定 */
export type BrandDiningOption = {
  brand: Brand;
  brandDiningOptionID: Scalars['Int32']['output'];
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  deletedAt?: Maybe<Scalars['SoftDeleteZ']['output']>;
  /** 用餐方式類型 */
  diningOptionType: DiningOptionType;
  /** 停用 */
  disabled: Scalars['Boolean']['output'];
  /** 自訂名稱 */
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type BrandDiningOptionKey = {
  brandDiningOptionID: Scalars['Int32']['input'];
  brandID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

export type BrandImage = {
  app: App;
  appID: Scalars['UUID']['output'];
  brandImageID: Scalars['UUID']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 圖片描述 */
  description?: Maybe<Scalars['String']['output']>;
  /** 圖片名稱 */
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTimeZ']['output'];
};

export type BrandKey = {
  brandID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

/** 品牌會員標籤 */
export type BrandMemberTag = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  brandMemberTagID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 停用 */
  disabled: Scalars['Boolean']['output'];
  /** 自訂名稱 */
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type BrandOrderInput = {
  brandID: Scalars['Int32']['input'];
  displayOrder: Scalars['Int16']['input'];
};

/** 品牌 POS 更新策略 */
export type BrandPosUpdatePolicy = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  fixedTime?: Maybe<Scalars['Time']['output']>;
  mode: PosUpdateMode;
  policyVersion: Scalars['Int64']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 品牌支付方式 */
export type BrandPaymentMethod = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  brandPaymentMethodID: Scalars['Int32']['output'];
  /** 自訂代碼 */
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  deletedAt?: Maybe<Scalars['SoftDeleteZ']['output']>;
  /** 停用 */
  disabled: Scalars['Boolean']['output'];
  /** 顯示順序(群組內使用) */
  displayOrder: Scalars['Int16']['output'];
  /** 擴充設定 */
  extendSetting?: Maybe<Scalars['JSON']['output']>;
  /** 一般設定 */
  generalSetting?: Maybe<Scalars['JSON']['output']>;
  /** 顯示名稱(群組時為群組名稱，非群組時為支付方式名稱) */
  name: Scalars['String']['output'];
  parent?: Maybe<BrandPaymentMethod>;
  /** 父品牌支付方式ID(品牌支付方式被加入群組時才有值) */
  parentID?: Maybe<Scalars['Int32']['output']>;
  sysPaymentMethod?: Maybe<SysPaymentMethod>;
  /** 系統支付方式ID */
  sysPaymentMethodID?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type BrandPaymentMethodInput = {
  brandKey: BrandKey;
  /** update時填BrandPaymentMethodID，不填SysPaymentMethodID */
  brandPaymentMethodID?: InputMaybe<Scalars['Int32']['input']>;
  code: Scalars['String']['input'];
  extendSetting?: InputMaybe<Scalars['JSON']['input']>;
  generalSetting?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
  /** create時填SysPaymentMethodID，不填brandPaymentMethodID */
  sysPaymentMethodID?: InputMaybe<Scalars['String']['input']>;
};

export type BrandPaymentMethodKey = {
  brandID: Scalars['Int32']['input'];
  brandPaymentMethodID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

export type BrandPaymentMethodOrderInput = {
  brandPaymentMethodID: Scalars['Int32']['input'];
  displayOrder: Scalars['Int16']['input'];
};

export type BrandPortalCarouselImage = {
  alg: ImageHashAlg;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  displayOrder: Scalars['Int16']['output'];
  fileSize: Scalars['Int32']['output'];
  hash: Scalars['String']['output'];
  height: Scalars['Int16']['output'];
  imageID: Scalars['Int32']['output'];
  mime: ImageMimeType;
  updatedAt: Scalars['DateTimeZ']['output'];
  width: Scalars['Int16']['output'];
  workspaceID: Scalars['UUID']['output'];
};

export type BrandPortalSetting = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  brandImageAlg?: Maybe<ImageHashAlg>;
  brandImageFileSize?: Maybe<Scalars['Int32']['output']>;
  brandImageHash?: Maybe<Scalars['String']['output']>;
  brandImageHeight?: Maybe<Scalars['Int16']['output']>;
  brandImageMime?: Maybe<ImageMimeType>;
  brandImageWidth?: Maybe<Scalars['Int16']['output']>;
  carouselImages: Array<BrandPortalCarouselImage>;
  createdAt: Scalars['DateTimeZ']['output'];
  notes: Scalars['String']['output'];
  selectedShops: Array<Shop>;
  shopApplyMode: ShopApplyMode;
  showAddress: Scalars['Boolean']['output'];
  showBusinessHours: Scalars['Boolean']['output'];
  showDescription: Scalars['Boolean']['output'];
  showDiningOption: Scalars['Boolean']['output'];
  showDistance: Scalars['Boolean']['output'];
  showPhone: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspaceID: Scalars['UUID']['output'];
};

export type BrandPortalSettingInput = {
  /** 品牌入口頁主圖；不傳則不變更主圖 */
  brandImageFile?: InputMaybe<Scalars['Upload']['input']>;
  /** 輪播圖排序與新增資料 */
  carouselImages?: InputMaybe<Array<PortalCarouselImageInput>>;
  /** 刪除主圖 */
  clearBrandImageFile?: InputMaybe<Scalars['Boolean']['input']>;
  /** 要刪除的輪播圖 imageID */
  deleteCarouselImageIDs?: InputMaybe<Array<Scalars['Int32']['input']>>;
  notes: Scalars['String']['input'];
  /** 指定門市；shopApplyMode 為 SelectedShops 時使用 */
  selectedShopKeys?: InputMaybe<Array<ShopKey>>;
  /** 門市套用模式 */
  shopApplyMode: ShopApplyMode;
  showAddress: Scalars['Boolean']['input'];
  showBusinessHours: Scalars['Boolean']['input'];
  showDescription: Scalars['Boolean']['input'];
  showDiningOption: Scalars['Boolean']['input'];
  showDistance: Scalars['Boolean']['input'];
  showPhone: Scalars['Boolean']['input'];
};

export type BrandPortalSettingKey = {
  brandID: Scalars['Int32']['output'];
  workspaceID: Scalars['UUID']['output'];
};

export type BrandShopCount = {
  brandID: Scalars['Int32']['output'];
  count: Scalars['Int32']['output'];
};

/** 商品群組 */
export type Bundle = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  bundleID: Scalars['Int32']['output'];
  /** 商品群組內商品 */
  bundleItems: Array<BundleItem>;
  /** 商品群組類型(任選|固定) */
  bundleType: BundleType;
  createdAt: Scalars['DateTimeZ']['output'];
  /** 商品群組關聯 */
  itemBundles?: Maybe<Array<ItemBundle>>;
  /** 商品群組名稱 */
  name: Scalars['String']['output'];
  /** 每項商品可選最多份數 (0 表示不限制) */
  sameItemSelectableMaxCount: Scalars['Int16']['output'];
  /** 可選最多份數 */
  selectableMaxCount: Scalars['Int16']['output'];
  /** 可選最少份數 (0 表示非必選) */
  selectableMinCount: Scalars['Int16']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** Bundle輸入 */
export type BundleInput = {
  bundleItemInputs?: InputMaybe<Array<InputMaybe<BundleItemInput>>>;
  bundleType: BundleType;
  name: Scalars['String']['input'];
  sameItemSelectableMaxCount: Scalars['Int16']['input'];
  selectableMaxCount: Scalars['Int16']['input'];
  selectableMinCount: Scalars['Int16']['input'];
};

/** 商品群組內商品 */
export type BundleItem = {
  brandID: Scalars['Int32']['output'];
  bundle: Bundle;
  bundleID: Scalars['Int32']['output'];
  bundleItemItemPriceOptions: Array<BundleItemItemPriceOption>;
  createdAt: Scalars['DateTimeZ']['output'];
  deletedAt?: Maybe<Scalars['SoftDeleteZ']['output']>;
  /** 顯示順序 */
  displayOrder: Scalars['Int16']['output'];
  item: Item;
  itemID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 目標Item輸入 */
export type BundleItemInput = {
  bundleItemItemPriceOptionInputs?: InputMaybe<
    Array<InputMaybe<BundleItemItemPriceOptionInput>>
  >;
  displayOrder: Scalars['Int16']['input'];
  itemID: Scalars['Int32']['input'];
};

/** 商品群組內商品：項目可選商品價位 */
export type BundleItemItemPriceOption = {
  brandID: Scalars['Int32']['output'];
  bundleID: Scalars['Int32']['output'];
  bundleItem: BundleItem;
  createdAt: Scalars['DateTimeZ']['output'];
  /** 預設選取數量 */
  defaultSelectCount: Scalars['Int16']['output'];
  /** 顯示順序 */
  displayOrder: Scalars['Int16']['output'];
  itemID: Scalars['Int32']['output'];
  itemPriceOption: ItemPriceOption;
  itemPriceOptionID: Scalars['Int32']['output'];
  /** 售價(單價) */
  price: Scalars['Decimal']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 目標ItemPriceOption輸入 */
export type BundleItemItemPriceOptionInput = {
  defaultSelectCount: Scalars['Int16']['input'];
  displayOrder: Scalars['Int16']['input'];
  itemPriceOptionID: Scalars['Int32']['input'];
  price: Scalars['Decimal']['input'];
};

export type BundleItemItemPriceOptionKey = {
  brandID: Scalars['Int32']['input'];
  bundleID: Scalars['Int32']['input'];
  itemID: Scalars['Int32']['input'];
  itemPriceOptionID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

export type BundleItemKey = {
  brandID: Scalars['Int32']['input'];
  bundleID: Scalars['Int32']['input'];
  itemID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

export type BundleKey = {
  brandID: Scalars['Int32']['input'];
  bundleID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

/** 查詢分頁結果 */
export type BundlePagination = {
  bundles?: Maybe<Array<Bundle>>;
  pageInfo: CursorPageInfo;
};

/** 商品群組類型 */
export enum BundleType {
  /** 固定商品群組 */
  FixedBundle = 'FixedBundle',
  /** 任選商品群組 */
  MixmatchBundle = 'MixmatchBundle',
}

/** 營業時段 */
export type BusinessSession = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  /** 結束營業時間 (NULL 表示營業中, NOT NULL 表示已關帳) */
  closeTime?: Maybe<Scalars['DateTimeZ']['output']>;
  createdAt: Scalars['DateTimeZ']['output'];
  opUser?: Maybe<Employee>;
  /** 操作人員 */
  opUserID?: Maybe<Scalars['UUID']['output']>;
  sessionID: Scalars['UUID']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  /** 開始營業時間 */
  startTime: Scalars['DateTimeZ']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 品牌 CDS 設定 */
export type CdsBrandSetting = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  /** 輪播廣告播放時間 (秒) */
  carouselDuration: Scalars['Int16']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 顯示模式 */
  displayMode: CdsDisplayMode;
  /** 當價格為 0 時不顯示套餐組合名稱 */
  notDisplayComposeNameWhenZeroPrice: Scalars['Boolean']['output'];
  /** 明細商品顯示樣式 */
  orderDetailDisplayStyle: CdsOrderDetailDisplayStyle;
  /** 客顯明細商品排序方式 */
  orderDetailSort: CdsOrderDetailSort;
  /** 明細顯示方式 */
  showOrderDetail: Scalars['Boolean']['output'];
  /** 顯示時機 */
  showWhenOrdering: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 品牌 CDS 設定 */
export type CdsBrandSettingInput = {
  /** 輪播廣告播放時間 (秒) */
  carouselDuration: Scalars['Int16']['input'];
  /** 顯示模式 */
  displayMode: CdsDisplayMode;
  /** 當價格為 0 時不顯示套餐組合名稱 */
  notDisplayComposeNameWhenZeroPrice: Scalars['Boolean']['input'];
  /** 明細商品顯示樣式 */
  orderDetailDisplayStyle: CdsOrderDetailDisplayStyle;
  /** 客顯明細商品排序方式 */
  orderDetailSort: CdsOrderDetailSort;
  /** 明細顯示方式 */
  showOrderDetail: Scalars['Boolean']['input'];
  /** 顯示時機 */
  showWhenOrdering: Scalars['Boolean']['input'];
};

export type CdsBrandSettingWithAd = {
  /** 品牌CDS設定 */
  cdsBrandSetting?: Maybe<CdsBrandSetting>;
  /** CDS輪播廣告列表 */
  cdsCarouselAd?: Maybe<Array<Maybe<CdsCarouselAd>>>;
  /** CDS固定廣告列表 */
  cdsFixedAd?: Maybe<Array<Maybe<CdsFixedAd>>>;
};

/** 客顯輪播廣告 */
export type CdsCarouselAd = {
  adID: Scalars['Int32']['output'];
  alg: Scalars['String']['output'];
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 顯示順序 */
  displayOrder: Scalars['Int16']['output'];
  duration: Scalars['Int32']['output'];
  /** 刊登結束時間 */
  effectiveEndTime?: Maybe<Scalars['DateTimeZ']['output']>;
  /** 開始刊登時間 */
  effectiveStartTime?: Maybe<Scalars['DateTimeZ']['output']>;
  fileSize: Scalars['Int32']['output'];
  /** 媒體屬性 */
  hash: Scalars['String']['output'];
  height: Scalars['Int32']['output'];
  linkCDSCarouselAdShop: Array<LinkCdsCarouselAdShop>;
  mime: Scalars['String']['output'];
  /** 廣告名稱 */
  name: Scalars['String']['output'];
  /** 發佈門市模式 */
  shopApplyMode: ShopApplyMode;
  updatedAt: Scalars['DateTimeZ']['output'];
  width: Scalars['Int32']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 客顯輪播廣告 */
export type CdsCarouselAdInput = {
  /** 廣告ID (更新時必要) */
  adID?: InputMaybe<Scalars['Int32']['input']>;
  /** 影片時長(秒)，圖片請填0 */
  duration?: InputMaybe<Scalars['Int32']['input']>;
  /** 刊登結束時間 */
  effectiveEndTime?: InputMaybe<Scalars['DateTimeZ']['input']>;
  /** 開始刊登時間 */
  effectiveStartTime?: InputMaybe<Scalars['DateTimeZ']['input']>;
  /** 廣告名稱 */
  name?: InputMaybe<Scalars['String']['input']>;
  /** 發佈門市模式 */
  shopApplyMode?: InputMaybe<ShopApplyMode>;
};

/** CDS 輪播廣告 */
export type CdsCarouselAdWithFileInput = {
  cdsCarouselAdInput: CdsCarouselAdInput;
  file?: InputMaybe<Scalars['Upload']['input']>;
  linkCDSCarouselAdShopInput?: InputMaybe<
    Array<InputMaybe<LinkCdsCarouselAdShopInput>>
  >;
};

/** CDS 顯示模式 */
export enum CdsDisplayMode {
  /** 廣告 + 點餐資訊 */
  AdAndOrderingInfo = 'AdAndOrderingInfo',
  /** 全螢幕輪播 */
  FullScreenCarousel = 'FullScreenCarousel',
}

/** CDS 固定廣告內容 */
export type CdsFixedAd = {
  adID: Scalars['Int32']['output'];
  alg: Scalars['String']['output'];
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 顯示順序 */
  displayOrder: Scalars['Int16']['output'];
  /** 刊登結束時間 */
  effectiveEndTime?: Maybe<Scalars['DateTimeZ']['output']>;
  /** 開始刊登時間 */
  effectiveStartTime?: Maybe<Scalars['DateTimeZ']['output']>;
  fileSize: Scalars['Int32']['output'];
  /** 媒體屬性 */
  hash: Scalars['String']['output'];
  height: Scalars['Int32']['output'];
  linkCDSFixedAdShop: Array<LinkCdsFixedAdShop>;
  mime: Scalars['String']['output'];
  /** 廣告名稱 */
  name: Scalars['String']['output'];
  /** 發佈門市模式 */
  shopApplyMode: ShopApplyMode;
  updatedAt: Scalars['DateTimeZ']['output'];
  width: Scalars['Int32']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** CDS 固定廣告內容 */
export type CdsFixedAdInput = {
  /** 廣告ID (更新時必要) */
  adID?: InputMaybe<Scalars['Int32']['input']>;
  /** 刊登結束時間 */
  effectiveEndTime?: InputMaybe<Scalars['DateTimeZ']['input']>;
  /** 開始刊登時間 */
  effectiveStartTime?: InputMaybe<Scalars['DateTimeZ']['input']>;
  /** 廣告名稱 */
  name?: InputMaybe<Scalars['String']['input']>;
  /** 發佈門市模式 */
  shopApplyMode?: InputMaybe<ShopApplyMode>;
};

/** CDS 固定廣告 */
export type CdsFixedAdWithFileInput = {
  cdsFixedAdInput: CdsFixedAdInput;
  file?: InputMaybe<Scalars['Upload']['input']>;
  linkCDSFixedAdShopInput?: InputMaybe<
    Array<InputMaybe<LinkCdsFixedAdShopInput>>
  >;
};

/** CDS 點餐明細商品顯示樣式 */
export enum CdsOrderDetailDisplayStyle {
  /** 套餐組合顯示 */
  Compose = 'Compose',
  /** 單品分開顯示 */
  Detail = 'Detail',
}

/** CDS 點餐明細商品排序方式 */
export enum CdsOrderDetailSort {
  /** 依商品分類排序 */
  ByCategory = 'ByCategory',
  /** 依同品項排序 */
  ByItem = 'ByItem',
  /** 依點餐順序 */
  ByOrderTime = 'ByOrderTime',
}

/** 取消系統發佈 */
export type CancelPublishTaskInput = {
  /** 發佈ID */
  publishTaskID: Scalars['Int32']['input'];
  /** 總部 */
  workspaceID: Scalars['UUID']['input'];
};

export type CashDrawerPagination = {
  cashDrawerTransactions?: Maybe<Array<CashDrawerTransaction>>;
  pageInfo: CursorPageInfo;
};

export type CashDrawerSearchParams = {
  businessDateRange?: InputMaybe<TimeRange>;
  createdAtRange?: InputMaybe<TimeRange>;
};

/** 錢櫃交易 */
export type CashDrawerTransaction = {
  /** 交易金額 */
  amount: Scalars['Decimal']['output'];
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  /** 營業日期 */
  businessDate: Scalars['Date']['output'];
  /** 交易編號 */
  code?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeZ']['output'];
  deletedAt?: Maybe<Scalars['SoftDeleteZ']['output']>;
  /** 裝置機號 */
  deviceCode: Scalars['String']['output'];
  deviceShift?: Maybe<DeviceShift>;
  opUser?: Maybe<Employee>;
  /** 操作人員 */
  opUserID?: Maybe<Scalars['UUID']['output']>;
  /** 開錢櫃原因 */
  openReason?: Maybe<Scalars['String']['output']>;
  /** 開錢櫃原因編號 */
  reasonCode?: Maybe<Scalars['String']['output']>;
  /** 關聯的裝置班次 */
  shiftID?: Maybe<Scalars['UUID']['output']>;
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  transactionID: Scalars['UUID']['output'];
  /** 交易類型 */
  transactionType: CashDrawerTransactionType;
  updatedAt: Scalars['DateTimeZ']['output'];
  vDevice: VDevice;
  vDeviceID: Scalars['Int32']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 錢櫃交易類型 */
export enum CashDrawerTransactionType {
  /** 錢櫃取消 */
  CashDrawerCancel = 'CashDrawerCancel',
  /** 留存金 */
  CashReserve = 'CashReserve',
  /** 其他支出 */
  OtherExpense = 'OtherExpense',
  /** 其他收入 */
  OtherIncome = 'OtherIncome',
}

export type Category = {
  apps?: Maybe<Array<App>>;
  categoryID: Scalars['UUID']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayOrder: Scalars['Int16']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
};

/** 桌位變動提醒 */
export enum ChangingTableRemindMode {
  /** 移桌 */
  Change = 'Change',
  /** 併桌/拆桌 */
  CombineSeparate = 'CombineSeparate',
}

/** 關帳狀態 */
export enum CloseStatus {
  /** 取消 */
  Cancel = 'Cancel',
  /** 強制結束 */
  Forced = 'Forced',
  /** 正常結束 */
  Normal = 'Normal',
}

export type Cluster = {
  clusterID: Scalars['Int32']['output'];
  itemID: Scalars['Int32']['output'];
};

export type ConfLoyaltyProgram = {
  /** 啟用 */
  activate: Scalars['Boolean']['output'];
  /** 背景圖片大小 */
  bgFileSize?: Maybe<Scalars['Int32']['output']>;
  /** 背景圖片連結 */
  bgHash?: Maybe<Scalars['String']['output']>;
  /** 背景圖片高 */
  bgHeight?: Maybe<Scalars['Int16']['output']>;
  /** 背景圖片寬 */
  bgWidth?: Maybe<Scalars['Int16']['output']>;
  createdAt: Scalars['DateTimeZ']['output'];
  /** 圖片雜湊算法 */
  imgAlg?: Maybe<ImageHashAlg>;
  /** 圖片MIME類型 */
  imgMime?: Maybe<ImageMimeType>;
  /** 發卡層級 */
  issuanceLevel: IssuanceLevel;
  /** logo 圖片大小 */
  logoFileSize?: Maybe<Scalars['Int32']['output']>;
  /** logo 圖片連結 */
  logoHash?: Maybe<Scalars['String']['output']>;
  /** logo 圖片高 */
  logoHeight?: Maybe<Scalars['Int16']['output']>;
  /** logo 圖片寬 */
  logoWidth?: Maybe<Scalars['Int16']['output']>;
  /** 手動調整點數 */
  manualAdjustPoints: Scalars['Boolean']['output'];
  mbrand?: Maybe<Mbrand>;
  /** 品牌ID */
  mbrandID?: Maybe<Scalars['Int32']['output']>;
  name: Scalars['String']['output'];
  organization: Organization;
  /** 組織ID */
  organizationID: Scalars['UUID']['output'];
  /** 參與會員類型 */
  participantType: ParticipantType;
  /** 會員點數使用範圍 */
  pointUsageScope: PointUsageScope;
  /** 隱私條款 */
  privacyTerms: Scalars['String']['output'];
  programID: Scalars['UUID']['output'];
  /** 加入會員連結 */
  registerUrls?: Maybe<Scalars['JSON']['output']>;
  /** 註冊時顯示隱私條款 */
  showPrivacyTermsOnRegister: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
};

export type ConfLoyaltyProgramInput = {
  /** 啟用(目前畫面上沒有開關，預設為啟用) */
  activate: Scalars['Boolean']['input'];
  /** 發卡層級 */
  issuanceLevel: IssuanceLevel;
  /** 點數手動加扣點 */
  manualAdjustPoints: Scalars['Boolean']['input'];
  /** 會員卡名稱 */
  name: Scalars['String']['input'];
  /** 參與會員類型 */
  participantType: ParticipantType;
  /** 會員點數使用範圍 */
  pointUsageScope: PointUsageScope;
  /** 加入會員連結 */
  registerUrls?: InputMaybe<Scalars['JSON']['input']>;
};

export type ConfPointEarnExtraItem = {
  createdAt: Scalars['DateTimeZ']['output'];
  /** 額外加點 */
  givePointPerItem: Scalars['Int32']['output'];
  /** 商品代碼  格式 <brandID>:<itemID>:<itemPriceOptionID> */
  itemCode: Scalars['String']['output'];
  /** 制度規則 */
  program: ConfLoyaltyProgram;
  /** 制度規則ID */
  programID: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
};

export type ConfPointEarnExtraItemInput = {
  /** 額外加點 */
  givePointPerItem: Scalars['Int32']['input'];
  /** 商品代碼(item_prince_option_id)，因item_code不一定為唯一值，故使用item_prince_option_id */
  itemCode: Scalars['String']['input'];
};

export type ConfPointRedeemDiscount = {
  /** 啟用 */
  activate: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 排除商品  格式 {<brandID>: [<itemID>:<itemPriceOptionID>]} */
  exclusiveItemCodes?: Maybe<Scalars['JSON']['output']>;
  pointDiscountAmount: Scalars['Decimal']['output'];
  /** 經由線上訂單 */
  pointDiscountViaOnlineOrder: Scalars['Boolean']['output'];
  /** 經由POS */
  pointDiscountViaPos: Scalars['Boolean']['output'];
  /** 點數折抵規則 */
  pointRedeemAmount: Scalars['Int32']['output'];
  /** 制度規則 */
  program: ConfLoyaltyProgram;
  /** 制度規則ID */
  programID: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
};

export type ConfPointRedeemDiscountInput = {
  /** 啟用 */
  activate: Scalars['Boolean']['input'];
  /** 排除商品 */
  exclusiveItemCodes?: InputMaybe<Scalars['JSON']['input']>;
  /** 兌換金額 */
  pointDiscountAmount: Scalars['Decimal']['input'];
  /** 經由線上訂單 */
  pointDiscountViaOnlineOrder: Scalars['Boolean']['input'];
  /** 經由POS */
  pointDiscountViaPos: Scalars['Boolean']['input'];
  /** 點數兌換 */
  pointRedeemAmount: Scalars['Int32']['input'];
};

export type ConfProgramParticipant = {
  createdAt: Scalars['DateTimeZ']['output'];
  /** 品牌 */
  mbrand?: Maybe<Mbrand>;
  /** 品牌ID */
  mbrandID?: Maybe<Scalars['Int32']['output']>;
  /** 門市 */
  mshop?: Maybe<Mshop>;
  /** 門市ID */
  mshopID?: Maybe<Scalars['Int32']['output']>;
  /** 組織 */
  organization: Organization;
  /** 組織ID */
  organizationID: Scalars['UUID']['output'];
  participantID: Scalars['UUID']['output'];
  /** 制度規則 */
  program: ConfLoyaltyProgram;
  /** 制度規則ID */
  programID: Scalars['UUID']['output'];
};

export type ConfProgramParticipantInput = {
  mbrandID?: InputMaybe<Scalars['Int32']['input']>;
  mshopID?: InputMaybe<Scalars['Int32']['input']>;
  organizationID: Scalars['UUID']['input'];
};

export type ConfProgramPointEarnRule = {
  /** 消費滿金額取得一點 */
  aPointPerPurchaseAmount: Scalars['Decimal']['output'];
  /** 啟用 */
  activate: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 依用餐方式給於點數-外送 */
  diningOptionDelivery: Scalars['Boolean']['output'];
  /** 依用餐方式給於點數-內用 */
  diningOptionDineIn: Scalars['Boolean']['output'];
  /** 依用餐方式給於點數-自取 */
  diningOptionPickup: Scalars['Boolean']['output'];
  /** 依用餐方式給於點數-外帶 */
  diningOptionTakeout: Scalars['Boolean']['output'];
  /** 點數效期(天) */
  pointExpiryInDays?: Maybe<Scalars['Int32']['output']>;
  /** 點數效期 */
  pointExpiryType: PointExpiryType;
  /** 制度規則 */
  program: ConfLoyaltyProgram;
  /** 制度規則ID */
  programID: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
};

export type ConfProgramPointEarnRuleInput = {
  /** 每消費多少金額獲得1點 */
  aPointPerPurchaseAmount: Scalars['Decimal']['input'];
  /** 啟用 */
  activate: Scalars['Boolean']['input'];
  /** 依用餐方式給於點數-外送 */
  diningOptionDelivery: Scalars['Boolean']['input'];
  /** 依用餐方式給於點數-內用 */
  diningOptionDineIn: Scalars['Boolean']['input'];
  /** 依用餐方式給於點數-自取 */
  diningOptionPickup: Scalars['Boolean']['input'];
  /** 依用餐方式給於點數-外帶 */
  diningOptionTakeout: Scalars['Boolean']['input'];
  /** 點數有效期限天數 */
  pointExpiryInDays?: InputMaybe<Scalars['Int32']['input']>;
  /** 點數有效期限類型 */
  pointExpiryType: PointExpiryType;
};

export type ConfProgramRedeemItem = {
  /** 啟用 */
  activate: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 制度規則 */
  program: ConfLoyaltyProgram;
  /** 制度規則ID */
  programID: Scalars['UUID']['output'];
  /** 經由線上訂單 */
  viaOnlineOrder: Scalars['Boolean']['output'];
  /** 經由POS */
  viaPos: Scalars['Boolean']['output'];
  /** 經由掃描訂單 */
  viaScanOrder: Scalars['Boolean']['output'];
};

export type ConfProgramRedeemItemInput = {
  /** 啟用 */
  activate: Scalars['Boolean']['input'];
  /** 經由線上訂單 */
  viaOnlineOrder: Scalars['Boolean']['input'];
  /** 經由POS */
  viaPos: Scalars['Boolean']['input'];
  /** 經由掃描訂單 */
  viaScanOrder: Scalars['Boolean']['input'];
};

/** 出單機連線媒介 */
export enum ConnectMediaType {
  /** 藍牙 */
  Bluetooth = 'Bluetooth',
  /** 網路 */
  Network = 'Network',
}

/** 顧客姓名/電話顯示方式 */
export enum ConsumerInfoVisibility {
  /** 隱藏：所有用餐方式 */
  AllHidden = 'AllHidden',
  /** 顯示 */
  Complete = 'Complete',
  /** 隱藏：指定用餐方式 */
  PartialHidden = 'PartialHidden',
}

/** 合約主檔 */
export type Contract = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  /** 合約編號 */
  contractCode: Scalars['UUID']['output'];
  /** 合約明細 */
  contractDetails?: Maybe<Array<ContractDetail>>;
  contractID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  deletedAt?: Maybe<Scalars['SoftDeleteZ']['output']>;
  /** 合約名稱 */
  name: Scalars['String']['output'];
  /** 合約期限(結束) */
  periodEnd: Scalars['DateTime']['output'];
  /** 合約期限(開始) */
  periodStart: Scalars['DateTime']['output'];
  shop?: Maybe<Shop>;
  shopID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 合約附件 */
export type ContractAttachment = {
  attachmentID: Scalars['Int32']['output'];
  /** 附件位址 */
  attachmentUrl?: Maybe<Scalars['String']['output']>;
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  contract?: Maybe<Contract>;
  contractID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 備註 */
  note?: Maybe<Scalars['String']['output']>;
  shop?: Maybe<Shop>;
  shopID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 合約明細 */
export type ContractDetail = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  contract?: Maybe<Contract>;
  /** 合約編號 */
  contractCode: Scalars['UUID']['output'];
  contractID: Scalars['Int32']['output'];
  /** 合約類型 */
  contractType: ContractType;
  createdAt: Scalars['DateTimeZ']['output'];
  deletedAt?: Maybe<Scalars['SoftDeleteZ']['output']>;
  detailID: Scalars['Int32']['output'];
  /** 名稱 */
  name: Scalars['String']['output'];
  /** 備註 */
  note?: Maybe<Scalars['String']['output']>;
  /** 數量 */
  number: Scalars['Int16']['output'];
  /** 原單價 */
  originPrice: Scalars['Decimal']['output'];
  /** 合約期限(結束) */
  periodEnd: Scalars['DateTime']['output'];
  /** 合約期限(開始) */
  periodStart: Scalars['DateTime']['output'];
  /** 單價 */
  price: Scalars['Decimal']['output'];
  shop?: Maybe<Shop>;
  shopID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 合約類型 */
export enum ContractType {
  Cds = 'CDS',
  Kds = 'KDS',
  PosCashier = 'POS_Cashier',
  PosOrderTaker = 'POS_OrderTaker',
}

export type CostReport = {
  avgCostPerPerson: Scalars['Decimal']['output'];
  time: Scalars['DateTime']['output'];
};

/** 國家 */
export type Country = {
  /** 國家貨幣 */
  countryCurrencies: Array<CountryCurrency>;
  countryID: Scalars['String']['output'];
  /** 國家時區 */
  countryTimezones: Array<CountryTimezone>;
  /** 國家名稱 */
  name: Scalars['String']['output'];
};

/** 國家貨幣 */
export type CountryCurrency = {
  country: Country;
  countryID: Scalars['String']['output'];
  currency: Currency;
  currencyID: Scalars['String']['output'];
};

/** 國家時區 */
export type CountryTimezone = {
  country: Country;
  countryID: Scalars['String']['output'];
  timezone: Timezone;
  timezoneID: Scalars['String']['output'];
};

/** 應用程式覆蓋範圍 */
export type CoverageInfo = {
  /** 品牌覆蓋列表 */
  brands: Array<BrandCoverage>;
};

export type CreateAGroupOfBrandPaymentMethodsInput = {
  brandKey: BrandKey;
  name: Scalars['String']['input'];
  updateOrder?: InputMaybe<Array<BrandPaymentMethodOrderInput>>;
};

export type CreateItemCategoryInput = {
  brandID: Scalars['Int32']['input'];
  code: Scalars['String']['input'];
  itemIDs?: InputMaybe<Array<Scalars['Int32']['input']>>;
  name: Scalars['String']['input'];
  parent?: InputMaybe<Scalars['Int32']['input']>;
  workspaceID: Scalars['UUID']['input'];
};

export type CreateItemImageThumbInput = {
  alg: ImageHashAlg;
  brandID: Scalars['Int32']['input'];
  fileSize: Scalars['Int32']['input'];
  hash: Scalars['String']['input'];
  height: Scalars['Int16']['input'];
  mime: ImageMimeType;
  width: Scalars['Int16']['input'];
  workspaceID: Scalars['UUID']['input'];
};

export type CreateKeypadInput = {
  /** 鍵盤使用商品 */
  itemIDs?: InputMaybe<Array<Scalars['Int32']['input']>>;
  /** 鍵盤名稱 */
  name: Scalars['String']['input'];
  shopKey: ShopKey;
};

export type CreateMemberInput = {
  /** 地址 */
  address?: InputMaybe<Scalars['JSON']['input']>;
  /** 生日 */
  birthday?: InputMaybe<Scalars['Date']['input']>;
  /** 公司名稱 */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** 國碼 */
  countryCode: Scalars['String']['input'];
  /** 國別 */
  countryID: Scalars['String']['input'];
  /** 電子郵件 */
  email?: InputMaybe<Scalars['String']['input']>;
  /** 姓名 */
  fullName?: InputMaybe<Scalars['String']['input']>;
  /** 性別 */
  gender: Gender;
  /** 語言 */
  languageID: Scalars['String']['input'];
  /** 電話 */
  phone: Scalars['String']['input'];
  /** 會員載具/捐贈/統編 */
  preferences?: InputMaybe<MemberPreferencesInput>;
};

export type CreateMenuCategoryInput = {
  brandID: Scalars['Int32']['input'];
  displayOrder: Scalars['Int16']['input'];
  menuID: Scalars['Int32']['input'];
  name: Scalars['String']['input'];
  nameLang?: InputMaybe<MultiLangInput>;
  workspaceID: Scalars['UUID']['input'];
};

export type CreateMenuInput = {
  brandID: Scalars['Int32']['input'];
  /** 菜單供應時段 */
  menuSupplyHours?: InputMaybe<Array<MenuSupplyHourInput>>;
  /** 菜單類型 */
  menuType: MenuType;
  /** 菜單名稱 */
  name: Scalars['String']['input'];
  /** 菜單名稱(多語系) */
  nameLang?: InputMaybe<MultiLangInput>;
  /** POS 菜單格數：欄 */
  posGridCols?: InputMaybe<Scalars['Int16']['input']>;
  /** POS 菜單格數：列 */
  posGridRows?: InputMaybe<Scalars['Int16']['input']>;
  /** POS 菜單鍵盤模式 */
  posKeyboardMode?: InputMaybe<PosMenuKeyboardMode>;
  /** 預約餐門市 */
  preorderShopID?: InputMaybe<Scalars['Int32']['input']>;
  /** 菜單供應時段類型 */
  supplyHours?: InputMaybe<MenuSupplyHourType>;
  workspaceID: Scalars['UUID']['input'];
};

export type CreateMenuItemInput = {
  brandID: Scalars['Int32']['input'];
  itemID: Scalars['Int32']['input'];
  /** 菜單分類商品 */
  menuCategoryMenuItems: Array<MenuCategoryMenuItemInput>;
  menuID: Scalars['Int32']['input'];
  /** 已選品牌用餐方式 */
  selectedBrandDiningOptions: Array<LinkMenuItemBrandDiningOptionInput>;
  /** 已選商品價位 */
  selectedItemPriceOptions: Array<LinkMenuItemItemPriceOptionInput>;
  workspaceID: Scalars['UUID']['input'];
};

export type CrossBrandPortalCarouselImage = {
  alg: ImageHashAlg;
  createdAt: Scalars['DateTimeZ']['output'];
  displayOrder: Scalars['Int16']['output'];
  fileSize: Scalars['Int32']['output'];
  hash: Scalars['String']['output'];
  height: Scalars['Int16']['output'];
  imageID: Scalars['Int32']['output'];
  mime: ImageMimeType;
  pageID: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  width: Scalars['Int16']['output'];
  workspaceID: Scalars['UUID']['output'];
};

export type CrossBrandPortalSetting = {
  brandImageAlg?: Maybe<ImageHashAlg>;
  brandImageFileSize?: Maybe<Scalars['Int32']['output']>;
  brandImageHash?: Maybe<Scalars['String']['output']>;
  brandImageHeight?: Maybe<Scalars['Int16']['output']>;
  brandImageMime?: Maybe<ImageMimeType>;
  brandImageWidth?: Maybe<Scalars['Int16']['output']>;
  carouselImages: Array<CrossBrandPortalCarouselImage>;
  createdAt: Scalars['DateTimeZ']['output'];
  notes: Scalars['String']['output'];
  pageID: Scalars['UUID']['output'];
  pageName: Scalars['String']['output'];
  selectedShops: Array<Shop>;
  shopApplyMode: ShopApplyMode;
  showAddress: Scalars['Boolean']['output'];
  showBrandFilter: Scalars['Boolean']['output'];
  showBusinessHours: Scalars['Boolean']['output'];
  showDescription: Scalars['Boolean']['output'];
  showDiningOption: Scalars['Boolean']['output'];
  showDistance: Scalars['Boolean']['output'];
  showPhone: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspaceID: Scalars['UUID']['output'];
};

export type CrossBrandPortalSettingInput = {
  /** 跨品牌入口頁主圖；不傳則不變更主圖 */
  brandImageFile?: InputMaybe<Scalars['Upload']['input']>;
  /** 輪播圖排序與新增資料 */
  carouselImages?: InputMaybe<Array<PortalCarouselImageInput>>;
  /** 刪除主圖 */
  clearBrandImageFile?: InputMaybe<Scalars['Boolean']['input']>;
  /** 要刪除的輪播圖 imageID */
  deleteCarouselImageIDs?: InputMaybe<Array<Scalars['Int32']['input']>>;
  notes: Scalars['String']['input'];
  /** 跨品牌入口頁名稱 */
  pageName: Scalars['String']['input'];
  /** 指定門市；shopApplyMode 為 SelectedShops 時使用 */
  selectedShopKeys?: InputMaybe<Array<ShopKey>>;
  /** 門市套用模式 */
  shopApplyMode: ShopApplyMode;
  showAddress: Scalars['Boolean']['input'];
  showBrandFilter: Scalars['Boolean']['input'];
  showBusinessHours: Scalars['Boolean']['input'];
  showDescription: Scalars['Boolean']['input'];
  showDiningOption: Scalars['Boolean']['input'];
  showDistance: Scalars['Boolean']['input'];
  showPhone: Scalars['Boolean']['input'];
};

export type CrossBrandPortalSettingKey = {
  pageID: Scalars['UUID']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 貨幣 */
export type Currency = {
  currencyID: Scalars['String']['output'];
  /** 小數位數 */
  decimalPlaces: Scalars['Int16']['output'];
  /** 貨幣名稱 */
  name: Scalars['String']['output'];
  /** 貨幣符號 */
  symbol: Scalars['String']['output'];
};

/** Cursor 方向 */
export enum CursorDir {
  Backward = 'Backward',
  Forward = 'Forward',
}

/** 分頁資訊 */
export type CursorPageInfo = {
  nextCursor?: Maybe<Scalars['String']['output']>;
  prevCursor?: Maybe<Scalars['String']['output']>;
};

/** 分頁參數輸入 */
export type CursorPageInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit: Scalars['Int32']['input'];
  sortField: Scalars['String']['input'];
  sortOrder: SortOrder;
};

/** 顧客 */
export type Customer = {
  /** 顧客地址 */
  address?: Maybe<Scalars['String']['output']>;
  /** 顧客生日 */
  birthday?: Maybe<Scalars['Date']['output']>;
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  customerID: Scalars['UUID']['output'];
  /** 顧客距離 */
  distance?: Maybe<Scalars['Int16']['output']>;
  /** 顧客性別 */
  gender: Gender;
  /** 顧客姓名 */
  name: Scalars['String']['output'];
  /** 顧客備註 */
  note?: Maybe<Scalars['String']['output']>;
  /** 顧客電話 */
  phone?: Maybe<Scalars['String']['output']>;
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type CustomerCsvInput = {
  /** 匯出常用聯絡人csv欄位 */
  columnIndices: CustomerColumnIndices;
  /** 語系 */
  locale: Locales;
  /** 搜尋 */
  search?: InputMaybe<Scalars['String']['input']>;
  /** 搜尋關鍵字 */
  searchCondition?: InputMaybe<CustomerSearchCondition>;
  /** 搜尋常用聯絡人列表(篩選條件) */
  searchParams?: InputMaybe<CustomerSearchParams>;
  shopKey: ShopKey;
  /** 排序 (欄位) */
  sortField: Scalars['String']['input'];
  /** 排序 (升/降) */
  sortOrder: SortOrder;
  /** 時區 */
  timezone: Scalars['String']['input'];
};

export type CustomerColumnIndices = {
  /** 地址 */
  address?: InputMaybe<Scalars['Int16']['input']>;
  /** 品牌 */
  brandName?: InputMaybe<Scalars['Int16']['input']>;
  /** 建立時間 */
  createdAt?: InputMaybe<Scalars['Int16']['input']>;
  /** 姓名 */
  name?: InputMaybe<Scalars['Int16']['input']>;
  /** 電話 */
  phone?: InputMaybe<Scalars['Int16']['input']>;
  /** 門市 */
  shopName?: InputMaybe<Scalars['Int16']['input']>;
};

export type CustomerInput = {
  /** 顧客地址 */
  address?: InputMaybe<Scalars['String']['input']>;
  /** 顧客生日 */
  birthday?: InputMaybe<Scalars['Date']['input']>;
  brandID: Scalars['Int32']['input'];
  /** 顧客距離 */
  distance?: InputMaybe<Scalars['Int16']['input']>;
  /** 顧客性別 */
  gender: Gender;
  /** 顧客姓名 */
  name: Scalars['String']['input'];
  /** 顧客備註 */
  note?: InputMaybe<Scalars['String']['input']>;
  /** 顧客電話 */
  phone?: InputMaybe<Scalars['String']['input']>;
  shopID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

export type CustomerList = {
  /** 地址 */
  address?: Maybe<Scalars['String']['output']>;
  /** 品牌 */
  brandName?: Maybe<Scalars['String']['output']>;
  /** 建立時間 */
  createdAt?: Maybe<Scalars['DateTimeZ']['output']>;
  customerID?: Maybe<Scalars['UUID']['output']>;
  /** 顧客姓名 */
  name?: Maybe<Scalars['String']['output']>;
  /** 顧客電話 */
  phone?: Maybe<Scalars['String']['output']>;
  /** 門市 */
  shopName?: Maybe<Scalars['String']['output']>;
};

export type CustomerPagination = {
  customers: Array<CustomerList>;
  pageInfo: CursorPageInfo;
};

/** Customer search condition for filtering customers by specific fields */
export enum CustomerSearchCondition {
  /** 以顧客姓名搜尋 */
  Name = 'Name',
  /** 以電話號碼搜尋 */
  Phone = 'Phone',
}

/** 搜尋常用聯絡人列表(篩選條件) */
export type CustomerSearchParams = {
  /** 建立日期範圍 */
  createdAtRange?: InputMaybe<TimeRange>;
};

/** 自訂出單QRCode */
export enum CustomizedPaperQrCode {
  /** 發票左側QRCode */
  LeftSideOfInvoice = 'LeftSideOfInvoice',
  /** 不列印 */
  NotPrint = 'NotPrint',
  /** 指定文字 */
  SpecificText = 'SpecificText',
}

/** 出單切紙方式 */
export enum CutMethod {
  /** 每項商品一張 */
  EachItem = 'EachItem',
  /** 同商品分類一張 */
  EachItemCate = 'EachItemCate',
  /** 整張訂單一張 */
  EachOrder = 'EachOrder',
  /** 同商品一張 */
  EachSameItem = 'EachSameItem',
}

/** 週間時間類型 */
export enum DayTimeType {
  /** 每日固定 */
  EveryDay = 'EveryDay',
  /** 星期一至日可選擇 */
  WeekDay = 'WeekDay',
}

export type DelBrandDiningOptionsInput = {
  brandDiningOptionIDs: Array<Scalars['Int32']['input']>;
  brandID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

/** 僅能刪除本品牌自建的虛擬人；同時移除品牌選用，不刪除 GCS 檔案，也不呼叫 Provider */
export type DeleteAiWaiterVirtualHumanInput = {
  brandKey: BrandKey;
  virtualHumanID: Scalars['UUID']['input'];
};

/** 軟刪除成功回應 */
export type DeleteAiWaiterVirtualHumanResponse = {
  virtualHumanID: Scalars['UUID']['output'];
};

export type DeleteItemCategoriesInput = {
  brandID: Scalars['Int32']['input'];
  itemCategoryIDs: Array<Scalars['Int32']['input']>;
  workspaceID: Scalars['UUID']['input'];
};

export type DeleteRoleInput = {
  replaceRoleID?: InputMaybe<Scalars['Int32']['input']>;
  roleID: Scalars['Int32']['input'];
};

export type DeleteStopSaleItemInput = {
  itemID: Scalars['Int32']['input'];
  itemPriceOptionID: Scalars['Int32']['input'];
};

export type DetailOfKeypadItemsResponse = {
  itemCategories?: Maybe<Array<ItemCategory>>;
  uncategorizedItems?: Maybe<Array<Item>>;
};

export type DetailOfKeypadResponse = {
  keyButtonList: KeyButtonList;
  keypad: Keypad;
};

export type DetailOfLabelGroupResponse = {
  labelGroup: LabelGroup;
  shops?: Maybe<Array<Shop>>;
  subBrands?: Maybe<Array<SubBrand>>;
};

export type Developer = {
  apps: Array<App>;
  createdAt: Scalars['DateTimeZ']['output'];
  developerID: Scalars['UUID']['output'];
  email: Scalars['String']['output'];
  fullName?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  privacyPolicy?: Maybe<Scalars['String']['output']>;
  state: DeveloperState;
  updatedAt: Scalars['DateTimeZ']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export enum DeveloperState {
  /** 停用 */
  Disabled = 'Disabled',
  /** 啟用 */
  Enabled = 'Enabled',
  /** 通過驗證 */
  Verified = 'Verified',
}

export type DeviceAsset = PPrinter | VDevice;

export type DeviceAssetPagination = {
  boughtNum: Scalars['Int16']['output'];
  boundNum: Scalars['Int16']['output'];
  items: Array<DeviceAsset>;
  pageInfo: CursorPageInfo;
};

export type DeviceInfoInput = {
  ddVersion?: InputMaybe<Scalars['String']['input']>;
  /** 裝置編碼 */
  deviceCode: Scalars['UUID']['input'];
  model: Scalars['String']['input'];
  name: Scalars['String']['input'];
  network?: InputMaybe<NetworkInfoInput>;
  os?: InputMaybe<Scalars['String']['input']>;
  publishVersion?: InputMaybe<Scalars['String']['input']>;
};

export type DevicePagination = {
  boughtNum: Scalars['Int16']['output'];
  boundNum: Scalars['Int16']['output'];
  pageInfo: CursorPageInfo;
  vDevices?: Maybe<Array<VDevice>>;
};

/** 裝置班次 */
export type DeviceShift = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  businessSession: BusinessSession;
  /** 留存金 */
  cashReserve?: Maybe<Scalars['Decimal']['output']>;
  /** 班次結束時間 */
  closeTime?: Maybe<Scalars['DateTimeZ']['output']>;
  createdAt: Scalars['DateTimeZ']['output'];
  /** 裝置機號 */
  deviceCode: Scalars['String']['output'];
  opUser?: Maybe<Employee>;
  /** 操作人員 */
  opUserID?: Maybe<Scalars['UUID']['output']>;
  /** 關聯的營業時段 */
  sessionID: Scalars['UUID']['output'];
  shiftID: Scalars['UUID']['output'];
  /** 班次類型 */
  shiftType: ShiftType;
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  /** 班次開始時間 */
  startTime: Scalars['DateTimeZ']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  vDevice: VDevice;
  vDeviceID: Scalars['Int32']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type DiningOption = {
  scanOrderSettingDiningIn?: Maybe<ScanOrderSettingDiningIn>;
  scanOrderSettingTakeOut?: Maybe<ScanOrderSettingTakeOut>;
  shopO2OSetting?: Maybe<ShopO2OSetting>;
};

/** 用餐方式選擇模式 */
export enum DiningOptionSelectMode {
  /** 一般 */
  General = 'General',
  /** 強制 */
  Mandatory = 'Mandatory',
  /** 預設 */
  Preset = 'Preset',
}

/** 用餐方式/單號樣式 */
export enum DiningOptionTicketInfo {
  /** 固定樣式 */
  Fix = 'Fix',
  /** 依用餐方式設定 */
  OnDiningOption = 'OnDiningOption',
}

export type DiningOptionTicketNoStyleInput = {
  brandDiningOptionID: Scalars['Int32']['input'];
  style: BlackWhiteStyle;
};

/** 用餐方式類型 */
export enum DiningOptionType {
  /** 外送 */
  Delivery = 'Delivery',
  /** 堂食 */
  DineIn = 'DineIn',
  /** 無 */
  None = 'None',
  /** 自取 */
  PickUp = 'PickUp',
  /** 外帶 */
  TakeOut = 'TakeOut',
}

export type DisableBrandPaymentMethods = {
  brandKey: BrandKey;
  disabledPaymentIDs?: InputMaybe<Array<Scalars['Int32']['input']>>;
  enabledPaymentIDs?: InputMaybe<Array<Scalars['Int32']['input']>>;
};

/** 優惠折扣 */
export type Discount = {
  /** 是否為新建實例 */
  IsNewInstance: Scalars['Boolean']['output'];
  /** 優惠啟用狀態 */
  activate: Scalars['Boolean']['output'];
  /** 優惠進階名稱 */
  advNames?: Maybe<Array<DiscountAdvName>>;
  /** 優惠條碼 */
  barcode: Scalars['String']['output'];
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  /** 優惠計算規則 */
  calcMethod: DiscountCalcMethod;
  /** 優惠編號(ID) */
  code: Scalars['String']['output'];
  /** 優惠折扣按鍵顏色 */
  color: Scalars['String']['output'];
  /** 優惠內容 */
  content: DiscountContent;
  createdAt: Scalars['DateTimeZ']['output'];
  /** 優惠條件 */
  criteria: DiscountCriteria;
  /** 優惠週間時間類型 */
  dayTimeType?: Maybe<DiscountDayTimeType>;
  /** 優惠選擇週間時間 */
  dayTimes?: Maybe<Array<DiscountDayTime>>;
  /** 依距離分界自訂免外送費門檻級距 */
  deliveryFeeDistanceTiers?: Maybe<Array<DiscountDeliveryFeeDistanceTier>>;
  discountID: Scalars['Int32']['output'];
  /** 折扣可抵扣低消費用: 只適用於現金折扣(折扣計算於低消之後) */
  discountMinChargeEnabled: Scalars['Boolean']['output'];
  /** 折扣可抵扣服務費: 只適用於現金折扣(折扣計算於服務費之後) */
  discountServiceFeeEnabled: Scalars['Boolean']['output'];
  /** 鍵盤顯示排序 */
  displayOrder: Scalars['Int16']['output'];
  /** 優惠結束時間 */
  endTime: Scalars['DateTime']['output'];
  /** 優惠執行方式 */
  exec: DiscountExec;
  /** 優惠贈送商品分類 */
  giftItemCategories?: Maybe<Array<DiscountGiftItemCategory>>;
  /** 優惠贈送商品 */
  giftItems?: Maybe<Array<DiscountGiftItem>>;
  /** 優惠折扣名稱 */
  name: Scalars['String']['output'];
  /** 優惠優先權 / 請透過Setter指定新值 */
  priority: Scalars['Int16']['output'];
  /** 優惠使用渠道 */
  selChannels?: Maybe<Array<DiscountSelChannel>>;
  /** 優惠選擇商品分類 */
  selItemCategories?: Maybe<Array<DiscountSelItemCategory>>;
  /** 優惠選擇商品方式 */
  selItemMethod: DiscountSelItemMethod;
  /** 優惠選擇商品 */
  selItems?: Maybe<Array<DiscountSelItem>>;
  /** 優惠選擇用餐方式 */
  selShopDiningOptions?: Maybe<Array<DiscountSelShopDiningOption>>;
  /** 優惠門市套用模式：指定門市 */
  selShops?: Maybe<Array<DiscountSelShop>>;
  /** 優惠門市套用模式：指定品牌分類 */
  selSubBrands?: Maybe<Array<DiscountSelSubBrand>>;
  /** 門市套用模式 */
  shopApplyMode: ShopApplyMode;
  /** 選擇用餐方式 */
  shopDiningOptionApplyMode: ShopDiningOptionApplyMode;
  /** 指定週間時間: 若啟用， refer to DiscountDayTime */
  specifiedDayTimeEnabled: Scalars['Boolean']['output'];
  /** 優惠開始時間 */
  startTime: Scalars['DateTime']['output'];
  /** 狀態 */
  status: DiscountStatus;
  /** 優惠對象類型：若限制為「會員」， refer to DiscountSelMemberLevel */
  targetType: DiscountTargetType;
  /** 優惠折扣類型 */
  type: DiscountType;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 優惠折扣進階名稱 */
export type DiscountAdvName = {
  /** 優惠進階名稱類型 */
  advNameType: DiscountAdvNameType;
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  discount: Discount;
  discountID: Scalars['Int32']['output'];
  /** 優惠進階名稱 */
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type DiscountAdvNameInput = {
  /** 進階名稱類別 */
  advNameType: DiscountAdvNameType;
  /** 優惠進階名稱 */
  name: Scalars['String']['input'];
};

/** 優惠進階名稱類型 */
export enum DiscountAdvNameType {
  /** 顧客聯 */
  Customer = 'Customer',
  /** 廚房聯 */
  Kitchen = 'Kitchen',
  /** POS端顯示 */
  Pos = 'POS',
  /** 關帳小結 */
  Settlement = 'Settlement',
}

export type DiscountAggregate = {
  /** 品牌分類 */
  brandName: Scalars['String']['output'];
  /** 用餐方式名稱 */
  diningOptionName: Scalars['String']['output'];
  /** 用餐方式類型 */
  diningOptionType: Scalars['String']['output'];
  /** 折扣金額 */
  discountAmount: Scalars['Decimal']['output'];
  /** 折扣金額百分比 */
  discountAmountPercent: Scalars['Decimal']['output'];
  /** 折扣編號 */
  discountCode: Scalars['String']['output'];
  discountID: Scalars['Int']['output'];
  /** 折扣名稱 */
  discountName: Scalars['String']['output'];
  /** 數量 */
  discountQuantity: Scalars['Int']['output'];
  /** 折扣數量百分比 */
  discountQuantityPercent: Scalars['Decimal']['output'];
  /** 折扣類型 */
  discountType: Scalars['String']['output'];
  /** 操作人員 */
  employeeName: Scalars['String']['output'];
  /** 商品編號 */
  itemCode: Scalars['String']['output'];
  /** 商品類型 */
  itemKind: Scalars['String']['output'];
  /** 商品名稱 */
  itemName: Scalars['String']['output'];
  /** 價位ID */
  itemPriceOptionID?: Maybe<Scalars['Int']['output']>;
  /** 價位名稱 */
  itemPriceOptionName: Scalars['String']['output'];
  rank: Scalars['Int']['output'];
  /** 門市 */
  shopName: Scalars['String']['output'];
};

export type DiscountBaseInfoInput = {
  /** 優惠條碼 */
  barcode?: InputMaybe<Scalars['String']['input']>;
  /** 優惠計算規則 */
  calcMethod: DiscountCalcMethod;
  /** 優惠編號 */
  code?: InputMaybe<Scalars['String']['input']>;
  /** 按鍵預設顏色 */
  color: Scalars['String']['input'];
  /** 優惠週間時間類型 */
  dayTimeType?: InputMaybe<DiscountDayTimeType>;
  /** 優惠ID */
  discountID?: InputMaybe<Scalars['Int32']['input']>;
  /** 折扣可抵扣低消: 只適用於現金折扣(折扣計算於低消之後) */
  discountMinChargeEnabled: Scalars['Boolean']['input'];
  /** 折扣可抵扣服務費: 只適用於現金折扣(折扣計算於服務費之後) */
  discountServiceFeeEnabled: Scalars['Boolean']['input'];
  /** 優惠結束時間 */
  endTime: Scalars['DateTime']['input'];
  /** 優惠名稱 */
  name: Scalars['String']['input'];
  /** 門市套用模式 */
  shopApplyMode: ShopApplyMode;
  /** 選擇用餐方式 */
  shopDiningOptionApplyMode: ShopDiningOptionApplyMode;
  /** 指定週間時間: 若啟用， refer to DiscountDayTime */
  specifiedDayTimeEnabled: Scalars['Boolean']['input'];
  /** 優惠開始時間 */
  startTime: Scalars['DateTime']['input'];
  /** 優惠對象類型：若限制為「會員」， refer to DiscountSelMemberLevel */
  targetType: DiscountTargetType;
  /** 優惠類型 */
  type: DiscountType;
};

/** 優惠計算規則 */
export enum DiscountCalcMethod {
  /** 現金折扣(折扣計算於服務費之後) */
  DiscountAfterServiceFee = 'DiscountAfterServiceFee',
  /** 商品折扣(折扣計算於服務費之前) */
  DiscountBeforeServiceFee = 'DiscountBeforeServiceFee',
}

/** 優惠使用渠道 */
export enum DiscountChannel {
  /** 線上訂單 */
  OnlineOrder = 'OnlineOrder',
  /** POS */
  Pos = 'POS',
  /** 掃碼訂單 */
  ScanOrder = 'ScanOrder',
}

/** 優惠折扣內容 */
export type DiscountContent = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 外送費折抵金額 */
  deliveryFeeDiscountAmount?: Maybe<Scalars['Decimal']['output']>;
  discount: Discount;
  discountID: Scalars['Int32']['output'];
  /** 贈送商品數量 */
  giftItemCount?: Maybe<Scalars['Int16']['output']>;
  /** 設定每筆訂單最多使用次數 */
  maxUsagePerOrder?: Maybe<Scalars['Int16']['output']>;
  /** 設定每筆訂單最多使用次數啟用 */
  maxUsagePerOrderEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** 優惠折扣方式 [金額 | 百分比 | 免費] */
  method?: Maybe<DiscountMethod>;
  /** 指定N次商品折扣 */
  specifiedItemCount?: Maybe<Scalars['Int16']['output']>;
  /** 優惠內容型別 [折扣 | 指定N次商品折扣 | 免服務費 | 指定折扣金額 | 贈送商品] */
  type: DiscountContentType;
  updatedAt: Scalars['DateTimeZ']['output'];
  /** 優惠折扣值 */
  value?: Maybe<Scalars['Decimal']['output']>;
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type DiscountContentInput = {
  /** 外送費折抵金額 */
  deliveryFeeDiscountAmount?: InputMaybe<Scalars['Decimal']['input']>;
  /** 贈送商品數量 */
  giftItemCount?: InputMaybe<Scalars['Int16']['input']>;
  /** 設定每筆訂單最多使用次數 */
  maxUsagePerOrder?: InputMaybe<Scalars['Int16']['input']>;
  /** 設定每筆訂單最多使用次數 */
  maxUsagePerOrderEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** 折扣方式 */
  method?: InputMaybe<DiscountMethod>;
  /** 指定商品數量折扣 */
  specifiedItemCount?: InputMaybe<Scalars['Int16']['input']>;
  /** 優惠內容類別 */
  type: DiscountContentType;
  /** 優惠內容類別 (值) */
  value?: InputMaybe<Scalars['Decimal']['input']>;
};

/** 優惠內容分類 */
export enum DiscountContentType {
  /** 折抵外送費 */
  DeliveryFeeAmountOff = 'DeliveryFeeAmountOff',
  /** 折扣 */
  Discount = 'Discount',
  /** 指定折扣(後)金額 ORG SpecifiedItemAmount */
  DiscountedItemPrice = 'DiscountedItemPrice',
  /** 依照距離分界，自訂免外送費門檻 */
  DistanceCustomThreshold = 'DistanceCustomThreshold',
  /** 免外送費 */
  FreeDeliveryFee = 'FreeDeliveryFee',
  /** 贈送商品 */
  GiftItem = 'GiftItem',
  /** 指定商品數量折扣 N次 ORG SpecifiedItemCount */
  ItemCountDiscount = 'ItemCountDiscount',
  /** 免服務費 ORG ServiceFee */
  NoServiceFee = 'NoServiceFee',
}

/** 優惠折扣條件 */
export type DiscountCriteria = {
  /** 滿額 */
  amountRequired?: Maybe<Scalars['Boolean']['output']>;
  /** 滿額金額 */
  amountThreshold?: Maybe<Scalars['Decimal']['output']>;
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  /** 商品優惠(指定商品、單件商品) */
  combineItemEnabled: Scalars['Boolean']['output'];
  /** 整筆訂單優惠 */
  combineOrderEnabled: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 使用此優惠不能跨日銷退 */
  crossDayRefundDisabled: Scalars['Boolean']['output'];
  /** 外送費優惠條件類型 */
  deliveryFeeConditionType?: Maybe<DiscountDeliveryFeeConditionType>;
  discount: Discount;
  discountID: Scalars['Int32']['output'];
  /** 商品限制類型 */
  itemLimitType?: Maybe<DiscountItemLimitType>;
  /** 商品最低價格 */
  itemMinPrice?: Maybe<Scalars['Decimal']['output']>;
  /** 限制商品最低價格 */
  itemMinPriceLimited?: Maybe<Scalars['Boolean']['output']>;
  /** 是否包含其它費用 */
  otherFeeIncluded?: Maybe<Scalars['Boolean']['output']>;
  /** 滿量 */
  quantityRequired?: Maybe<Scalars['Boolean']['output']>;
  /** 滿量數量 */
  quantityThreshold?: Maybe<Scalars['Int16']['output']>;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type DiscountCriteriaInput = {
  /** 基本條件-訂單滿指定金額開啟 */
  amountRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** 基本條件-訂單滿指定金額 */
  amountThreshold?: InputMaybe<Scalars['Decimal']['input']>;
  /** 進階條件(優惠)-併用設定-商品優惠(指定商品、單件商品) */
  combineItemEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** 進階條件(優惠)-併用設定-整筆訂單優惠 */
  combineOrderEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** 進階條件(優惠)-使用此優惠不能跨日銷退 */
  crossDayRefundDisabled: Scalars['Boolean']['input'];
  /** 外送費優惠條件類型 */
  deliveryFeeConditionType?: InputMaybe<DiscountDeliveryFeeConditionType>;
  /** 進階條件(訂單)-商品限制 */
  itemLimitType?: InputMaybe<DiscountItemLimitType>;
  /** 進階條件(訂單)-限制商品最低價格 */
  itemMinPrice?: InputMaybe<Scalars['Decimal']['input']>;
  /** 進階條件(訂單)-限制商品最低價格 */
  itemMinPriceLimited?: InputMaybe<Scalars['Boolean']['input']>;
  /** 基本條件-包含其它費用加總開啟 */
  otherFeeIncluded?: InputMaybe<Scalars['Boolean']['input']>;
  /** 基本條件-訂單滿指定商品數量開啟 */
  quantityRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** 基本條件-訂單滿指定商品數量 */
  quantityThreshold?: InputMaybe<Scalars['Int16']['input']>;
};

/** 優惠選擇週間時間 */
export type DiscountDayTime = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  discount: Discount;
  discountID: Scalars['Int32']['output'];
  /** 優惠結束時間 */
  endTime: Scalars['Time']['output'];
  /** 優惠開始時間 */
  startTime: Scalars['Time']['output'];
  timeID: Scalars['Int32']['output'];
  /** 星期幾: DiscountDayTimeType 為 WeekDay 才有 (0: 星期日, 1: 星期一, 2: 星期二, 3: 星期三, 4: 星期四, 5: 星期五, 6: 星期六) */
  weekDay?: Maybe<Scalars['Int16']['output']>;
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type DiscountDayTimeInput = {
  /** 優惠結束時間 */
  endTime: Scalars['Time']['input'];
  /** 優惠開始時間 */
  startTime: Scalars['Time']['input'];
  timeID?: InputMaybe<Scalars['Int32']['input']>;
  /** 星期幾: DiscountDayTimeType 為 WeekDay 才有 */
  weekDay?: InputMaybe<Scalars['Int16']['input']>;
};

/** 優惠週間時間類型 */
export enum DiscountDayTimeType {
  /** 每日固定 */
  EveryDay = 'EveryDay',
  /** 星期一至日可選擇 */
  WeekDay = 'WeekDay',
}

/** 外送費優惠條件類型 */
export enum DiscountDeliveryFeeConditionType {
  /** 依距離自訂 */
  DistanceCustom = 'DistanceCustom',
  /** 滿指定金額 */
  MinAmount = 'MinAmount',
  /** 不需要任何條件 */
  None = 'None',
}

/** 依距離分界自訂免外送費門檻 */
export type DiscountDeliveryFeeDistanceTier = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  discount: Discount;
  discountID: Scalars['Int32']['output'];
  /** 結束距離 (公里) */
  endDistanceKm: Scalars['Decimal']['output'];
  /** 免外送費門檻金額 (消費金額) */
  minOrderAmount: Scalars['Decimal']['output'];
  /** 起始距離 (公里) */
  startDistanceKm?: Maybe<Scalars['Decimal']['output']>;
  tierID: Scalars['Int32']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type DiscountDeliveryFeeDistanceTierInput = {
  /** 結束距離 (公里) */
  endDistanceKm: Scalars['Decimal']['input'];
  /** 免外送費門檻金額 (消費金額) */
  minOrderAmount: Scalars['Decimal']['input'];
  /** 起始距離 (公里) */
  startDistanceKm?: InputMaybe<Scalars['Decimal']['input']>;
  tierID?: InputMaybe<Scalars['Int32']['input']>;
};

/** 折扣顯示格式 */
export enum DiscountDisplayFormat {
  /** 折數 */
  Discount = 'Discount',
  /** 百分比 */
  Percentage = 'Percentage',
}

/** 優惠折扣執行方式 */
export type DiscountExec = {
  /** 優惠串接來源: 若設定為「串接」才有 */
  apiSource?: Maybe<DiscountExecApiSource>;
  /** 優惠執行套用方式 */
  applyMode?: Maybe<DiscountExecApplyMode>;
  /** 優惠執行套用順序 */
  applyPriority?: Maybe<DiscountExecApplyPriority>;
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  discount: Discount;
  discountID: Scalars['Int32']['output'];
  /** 優惠執行方式 */
  method: DiscountExecMethod;
  /** 串接離線時店員可自行選擇優惠 */
  offlineStaffDiscountSelectionEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** 線上訂單優惠執行套用順序 */
  onlineOrderApplyPriority?: Maybe<OnlineOrderDiscountExecApplyPriority>;
  /** 優惠碼 */
  promoCode?: Maybe<Scalars['String']['output']>;
  /** 優惠碼已使用次數 */
  promoCodeUsageCount: Scalars['Int32']['output'];
  /** 優惠碼總共可使用次數上限 */
  promoCodeUsageLimit?: Maybe<Scalars['Int32']['output']>;
  /** 優惠碼總次數使用限制是否啟用 */
  promoCodeUsageLimitEnabled?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 優惠串接來源 */
export enum DiscountExecApiSource {
  /** Edenred */
  Edenred = 'Edenred',
  /** Ocard */
  Ocard = 'Ocard',
  /** WP */
  Wp = 'WP',
}

/** 優惠執行套用方式 */
export enum DiscountExecApplyMode {
  /** 自動「套用整筆訂單」商品 */
  AutoApplyOrder = 'AutoApplyOrder',
  /** 依照手動「點擊次數」帶入 */
  ManualClickCount = 'ManualClickCount',
  /** 依照手動「選擇商品」帶入 */
  ManualSelectItem = 'ManualSelectItem',
}

/** 優惠執行套用順序 */
export enum DiscountExecApplyPriority {
  /** 價錢從高到低優先 */
  PriceHighToLow = 'PriceHighToLow',
  /** 價錢從低到高優先 */
  PriceLowToHigh = 'PriceLowToHigh',
  /** 依照人員自行選擇優惠商品 */
  StaffSelection = 'StaffSelection',
}

export type DiscountExecInput = {
  /** 優惠串接來源: 若設定為「串接」才有 */
  apiSource?: InputMaybe<DiscountExecApiSource>;
  /** 優惠執行套用方式 */
  applyMode?: InputMaybe<DiscountExecApplyMode>;
  /** 優惠執行套用順序 */
  applyPriority?: InputMaybe<DiscountExecApplyPriority>;
  /** 優惠執行方式 */
  method: DiscountExecMethod;
  /** 串接離線時店員可自行選擇優惠 */
  offlineStaffDiscountSelectionEnabled?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  /** 線上訂單優惠執行套用順序 */
  onlineOrderApplyPriority?: InputMaybe<OnlineOrderDiscountExecApplyPriority>;
  /** 優惠碼 */
  promoCode?: InputMaybe<Scalars['String']['input']>;
  /** 優惠碼總共可使用次數上限 */
  promoCodeUsageLimit?: InputMaybe<Scalars['Int32']['input']>;
  /** 優惠碼總次數使用限制是否啟用 */
  promoCodeUsageLimitEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** 優惠執行方式 */
export enum DiscountExecMethod {
  /** 串接 */
  Api = 'API',
  /** 自動 */
  Auto = 'Auto',
  /** 手動 */
  Manual = 'Manual',
  /** 優惠碼 */
  PromoCode = 'PromoCode',
}

/** 優惠折扣贈送商品 */
export type DiscountGiftItem = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  discount: Discount;
  discountID: Scalars['Int32']['output'];
  item: Item;
  /** 優惠選擇商品 */
  itemID: Scalars['Int32']['output'];
  itemPriceOption: ItemPriceOption;
  itemPriceOptionID: Scalars['Int32']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 優惠折扣贈送商品分類 */
export type DiscountGiftItemCategory = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  discount: Discount;
  discountID: Scalars['Int32']['output'];
  itemCategory: ItemCategory;
  /** 優惠選擇商品分類 */
  itemCategoryID: Scalars['Int32']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 優惠商品限制類型 */
export enum DiscountItemLimitType {
  /** 不限制 */
  NoLimit = 'NoLimit',
  /** 相同商品 */
  SameItem = 'SameItem',
  /** 同價位 */
  SamePrice = 'SamePrice',
}

export type DiscountKey = {
  brandID: Scalars['Int32']['input'];
  discountID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

/** 標籤套用優惠方式 */
export enum DiscountLabelApplyMode {
  /** 不包含在優惠中 */
  Exclude = 'Exclude',
  /** 包含在優惠中 */
  Include = 'Include',
  /** 正值標籤不帶入，負值標籤帶入 */
  PosExclNegIncl = 'PosExclNegIncl',
}

/** 優惠折扣方式 */
export enum DiscountMethod {
  /** 金額 */
  Amount = 'Amount',
  /** 免費 */
  Free = 'Free',
  /** 百分比 */
  PercentageOff = 'PercentageOff',
}

export enum DiscountOp {
  /** 啟用 */
  Activate = 'ACTIVATE',
  /** 停用 */
  Deactivate = 'DEACTIVATE',
  /** 刪除 */
  Delete = 'DELETE',
}

export type DiscountPagination = {
  discounts?: Maybe<Array<Discount>>;
  pageInfo: CursorPageInfo;
};

export type DiscountPercent = {
  discountName: Scalars['String']['output'];
  percent: Scalars['Decimal']['output'];
};

/** 折扣小數進位規則 */
export enum DiscountRoundingRule {
  /** 無條件捨去 */
  RoundDown = 'RoundDown',
  /** 五捨六入 */
  RoundHalfDown = 'RoundHalfDown',
  /** 四捨五入 */
  RoundHalfUp = 'RoundHalfUp',
  /** 無條件進位 */
  RoundUp = 'RoundUp',
}

/** 優惠使用渠道關係表 */
export type DiscountSelChannel = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  /** 使用渠道 */
  channel: DiscountChannel;
  createdAt: Scalars['DateTimeZ']['output'];
  discount: Discount;
  discountID: Scalars['Int32']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type DiscountSelChannelInput = {
  /** 優惠使用渠道 */
  channel: DiscountChannel;
};

/** 優惠折扣選擇商品 */
export type DiscountSelItem = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  discount: Discount;
  discountID: Scalars['Int32']['output'];
  item: Item;
  /** 優惠選擇商品 */
  itemID: Scalars['Int32']['output'];
  itemPriceOption: ItemPriceOption;
  itemPriceOptionID: Scalars['Int32']['output'];
  postDiscountPrice: Scalars['Decimal']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 優惠折扣選擇商品分類 */
export type DiscountSelItemCategory = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  discount: Discount;
  discountID: Scalars['Int32']['output'];
  itemCategory: ItemCategory;
  /** 優惠選擇商品分類 */
  itemCategoryID: Scalars['Int32']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type DiscountSelItemInput = {
  /** 優惠選擇商品 */
  itemID: Scalars['Int32']['input'];
  /** 商品價位 */
  itemPriceOptionID: Scalars['Int32']['input'];
  /** 優惠後金額 */
  postDiscountPrice?: InputMaybe<Scalars['Decimal']['input']>;
};

/** 優惠選擇商品方式 */
export enum DiscountSelItemMethod {
  /** 排除商品 */
  Exclude = 'Exclude',
  /** 包含商品 */
  Include = 'Include',
}

/** 優惠門市套用模式：指定門市 */
export type DiscountSelShop = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  discount: Discount;
  discountID: Scalars['Int32']['output'];
  shop: Shop;
  /** 優惠門市套用模式：指定門市 */
  shopID: Scalars['Int32']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 優惠選擇用餐方式 */
export type DiscountSelShopDiningOption = {
  brand: Brand;
  /** 優惠選擇用餐方式 */
  brandDiningOptionID: Scalars['Int32']['output'];
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  discount: Discount;
  discountID: Scalars['Int32']['output'];
  shopDiningOption: ShopDiningOption;
  shopID: Scalars['Int32']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type DiscountSelShopDiningOptionInput = {
  brandDiningOptionID: Scalars['Int32']['input'];
  shopID: Scalars['Int32']['input'];
};

/** 優惠門市套用模式：指定品牌分類 */
export type DiscountSelSubBrand = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  discount: Discount;
  discountID: Scalars['Int32']['output'];
  subBrand: SubBrand;
  /** 優惠門市套用模式：指定品牌分類 */
  subBrandID: Scalars['Int32']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 優惠折扣來源 */
export enum DiscountSource {
  /** 門市後台定義 */
  Backend = 'Backend',
  /** POS手動優惠 */
  PosManual = 'POSManual',
}

/** 優惠折扣狀態 */
export enum DiscountStatus {
  /** 停用 */
  Deactivated = 'Deactivated',
  /** 已結束 */
  Expired = 'Expired',
  /** 未開始 */
  Oncoming = 'Oncoming',
  /** 進行中 */
  Ongoing = 'Ongoing',
}

/** 優惠對象類型 */
export enum DiscountTargetType {
  /** 會員 */
  Member = 'Member',
  /** 不限制 */
  NoLimit = 'NoLimit',
  /** 員工 */
  Staff = 'Staff',
}

/** 優惠折扣類型(當 discountSource = Backend 時使用) */
export enum DiscountType {
  /** 外送費 */
  DeliveryFee = 'DeliveryFee',
  /** 整筆訂單折扣 */
  Order = 'Order',
  /** 單件商品折扣 */
  SingleItem = 'SingleItem',
  /** 指定商品折扣 */
  SpecifiedItem = 'SpecifiedItem',
}

export type DiscountsFilterInput = {
  calendar: ReportCalendar;
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
  diningOptionName?: InputMaybe<Scalars['String']['input']>;
  diningOptionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  employeeIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  searchField?: InputMaybe<ReportDiscountSearchField>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  shopKeys: Array<ShopKey>;
  timezone: Scalars['String']['input'];
};

export type DiscountsOverview = {
  amountPercentOfAll: Array<DiscountPercent>;
  groupBy: ReportDiscountGroupMode;
  groups: Array<ReportDiscountsGroup>;
  quantityPercentOfAll: Array<DiscountPercent>;
  totalAmount: Scalars['String']['output'];
  totalQuantity: Scalars['Int']['output'];
};

export type DownloadSyncDataMessage = {
  apiID: Scalars['String']['input'];
  endTime: Scalars['DateTimeZ']['input'];
  startTime: Scalars['DateTimeZ']['input'];
  vDeviceID: Scalars['Int32']['input'];
};

export type DownloadSyncDataRes = {
  gzipData: Scalars['String']['output'];
};

/** 電話E.164國碼 */
export type E164CountryCode = {
  code: Scalars['String']['output'];
  iso2?: Maybe<Scalars['String']['output']>;
  iso3?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nameLang: MultiLang;
  nsnMax?: Maybe<Scalars['Int16']['output']>;
  nsnMin?: Maybe<Scalars['Int16']['output']>;
};

export type EInvoiceSource = {
  bindSetting: Scalars['JSON']['output'];
  eInvoiceSourceID: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  status?: Maybe<SubscriptionStatus>;
};

export type EInvoiceSourcesResp = {
  eInvoiceSource: Array<Maybe<EInvoiceSource>>;
};

export type EmailVerificationInBatchResponse = {
  numberSent: Scalars['Int']['output'];
  success: Scalars['Boolean']['output'];
};

/** 電子郵件驗證類型 */
export enum EmailVerificationType {
  /** 變更email */
  ChangeEmail = 'ChangeEmail',
  /** 設定密碼 */
  Init = 'Init',
  /** 重設密碼 */
  Reset = 'Reset',
}

/** 員工 */
export type Employee = {
  activate: Scalars['Boolean']['output'];
  allRoleName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeZ']['output'];
  deletedAt?: Maybe<Scalars['SoftDeleteZ']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employeeID: Scalars['UUID']['output'];
  employeeOfficialTeams?: Maybe<Array<EmployeeOfficialTeam>>;
  employeePortraits?: Maybe<Array<EmployeePortrait>>;
  employeeUniqueCode?: Maybe<EmployeeUniqueCode>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  metadata: Scalars['JSON']['output'];
  orgBelongs: Array<OrgBelong>;
  phone?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<Role>>;
  updatedAt: Scalars['DateTimeZ']['output'];
  user?: Maybe<User>;
  userActivityAt?: Maybe<Scalars['DateTimeZ']['output']>;
  userID?: Maybe<Scalars['UUID']['output']>;
  workspace?: Maybe<Workspace>;
  workspaceID: Scalars['UUID']['output'];
};

export type EmployeeImageUpdateResponse = {
  employeeImage: EmployeePortrait;
};

export type EmployeeKey = {
  employeeID: Scalars['UUID']['input'];
};

/** 員工團隊關聯 */
export type EmployeeOfficialTeam = {
  createdAt: Scalars['DateTimeZ']['output'];
  employee: Employee;
  employeeID: Scalars['UUID']['output'];
  officialTeam: OfficialTeam;
  officialTeamID: Scalars['UUID']['output'];
  officialTeamRole: OfficialTeamRole;
  officialTeamRoleID: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
};

/** 匯出訂單csv欄位(Employee) */
export type EmployeeOrderColumnIndices = {
  /** 員工名稱 */
  name: Scalars['Int16']['input'];
};

export type EmployeePagination = {
  employees: Array<Employee>;
  pageInfo: CursorPageInfo;
};

export type EmployeePinGenAndCheckResponse = {
  pin?: Maybe<Scalars['String']['output']>;
  validation?: Maybe<Scalars['Boolean']['output']>;
};

/** 員工頭像 */
export type EmployeePortrait = {
  alg: ImageHashAlg;
  createdAt: Scalars['DateTimeZ']['output'];
  employee: Employee;
  employeeID: Scalars['UUID']['output'];
  /** 檔案大小 */
  fileSize: Scalars['Int32']['output'];
  hash: Scalars['String']['output'];
  /** 高度 */
  height: Scalars['Int16']['output'];
  mime: ImageMimeType;
  portraitID: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  /** 寬度 <= 600px */
  width: Scalars['Int16']['output'];
};

export type EmployeeSearchParams = {
  code?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** 匯出訂單csv欄位(Employee) */
export type EmployeeTransactionColumnIndices = {
  /** 員工名稱 */
  name: Scalars['Int16']['input'];
};

/** 員工編號 / 員工通行碼 */
export type EmployeeUniqueCode = {
  createdAt: Scalars['DateTimeZ']['output'];
  employee: Employee;
  /** 員工編號 */
  employeeCode?: Maybe<Scalars['String']['output']>;
  employeeID: Scalars['UUID']['output'];
  /** 員工通行碼 */
  pin?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace?: Maybe<Workspace>;
  workspaceID: Scalars['UUID']['output'];
};

/** 日結報表 */
export type EodCloseReport = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  /** 營業日期 */
  businessDate: Scalars['Date']['output'];
  businessSession: BusinessSession;
  /** 關帳狀態 (正常結束：正常情況下結束營業；強制結束：結束營業時有未小結子機；取消：將強制狀態的子機小結後，原本的強制狀態資料會轉為取消) */
  closeStatus: CloseStatus;
  createdAt: Scalars['DateTimeZ']['output'];
  deletedAt?: Maybe<Scalars['SoftDeleteZ']['output']>;
  /** 裝置機號 */
  deviceCode: Scalars['String']['output'];
  opUser?: Maybe<Employee>;
  /** 操作人員 */
  opUserID?: Maybe<Scalars['UUID']['output']>;
  /** 日結報表內容 */
  reportContent: Scalars['JSON']['output'];
  reportID: Scalars['UUID']['output'];
  /** 關聯的營業時段 */
  sessionID: Scalars['UUID']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  /** 出單票據設定 */
  ticketSetting?: Maybe<Scalars['JSON']['output']>;
  vDevice: VDevice;
  vDeviceID: Scalars['Int32']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type EodCloseReportSearchParams = {
  businessDateRange?: InputMaybe<TimeRange>;
  createdAtRange?: InputMaybe<TimeRange>;
};

export type EodCloseReportsPagination = {
  eodCloseReports?: Maybe<Array<EodColumnIndices>>;
  pageInfo: CursorPageInfo;
};

export type EodColumnIndices = {
  businessCloseTime: Scalars['DateTimeZ']['output'];
  closeStatus: Scalars['String']['output'];
  deviceName: Scalars['String']['output'];
  offline: Scalars['Float']['output'];
  online: Scalars['Float']['output'];
  operatorName: Scalars['String']['output'];
  orderNet: Scalars['Float']['output'];
  reportID?: Maybe<Scalars['String']['output']>;
  revenue: Scalars['Float']['output'];
  totalVoidAmount: Scalars['Float']['output'];
  totalVoidCount: Scalars['Int']['output'];
  vDeviceID?: Maybe<Scalars['Int']['output']>;
};

export type ExportAEodReportCsvFileInput = {
  locale: Locales;
  reportKey: ReportKey;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type ExportAShiftCloseReportCsvFileInput = {
  /** 語系 */
  locale: Locales;
  reportKey: ReportKey;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type ExportCashDrawerTransactionsInput = {
  locale: Locales;
  searchParams: CashDrawerSearchParams;
  shopKey: ShopKey;
  sortField: Scalars['String']['input'];
  sortOrder: SortOrder;
};

export type ExportEodReportsCsvFileInput = {
  eodCloseSearchParams: EodCloseReportSearchParams;
  locale: Locales;
  shopKey: ShopKey;
  sortField: Scalars['String']['input'];
  sortOrder: SortOrder;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type ExportItemsCsvInput = {
  brandKey: BrandKey;
  exportData: Scalars['Boolean']['input'];
  locale: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
};

export type ExportShiftCloseReportsCsvInput = {
  /** 語系 */
  locale: Locales;
  searchParams: ShiftCloseReportSearchParams;
  shopKey: ShopKey;
  sortField: Scalars['String']['input'];
  sortOrder: SortOrder;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export enum FilterBindState {
  Bound = 'Bound',
  Unbind = 'Unbind',
}

export enum FilterConnectState {
  Connectd = 'Connectd',
  Disconnected = 'Disconnected',
}

/** 店家資訊字體大小 */
export enum FontSize {
  /** 特大 */
  ExtraLarge = 'ExtraLarge',
  /** 極小 */
  ExtraSmall = 'ExtraSmall',
  /** 大 */
  Large = 'Large',
  /** 中 */
  Medium = 'Medium',
  /** 小 */
  Small = 'Small',
}

/** 性別 */
export enum Gender {
  /** 女 */
  Female = 'Female',
  /** 男 */
  Male = 'Male',
  /** 其他 */
  Other = 'Other',
  /** 不願透露 */
  Undisclosed = 'Undisclosed',
}

export type GenerateAiWaiterPreviewVideoInput = {
  brandKey: BrandKey;
  /** 此階段僅接受 POSE_1；其他值會被拒絕。一個虛擬人只能保存一支影片，多 posture 尚未支援 */
  postureID?: InputMaybe<AiWaiterAvatarPostureId>;
  virtualHumanID: Scalars['UUID']['input'];
};

export type GetAiWaiterSettingInput = {
  brandKey: BrandKey;
  name?: InputMaybe<Scalars['String']['input']>;
  purpose: AiWaiterVirtualHumanPurpose;
};

export type GetAiWaiterVirtualHumanInput = {
  brandKey: BrandKey;
  virtualHumanID: Scalars['UUID']['input'];
};

export type GetAiWaiterVirtualHumansInput = {
  brandKey: BrandKey;
  name?: InputMaybe<Scalars['String']['input']>;
  purpose: AiWaiterVirtualHumanPurpose;
};

export type GetDiningReportResponse = {
  diningRank: Array<RankDetails>;
  totalAmount: Scalars['Decimal']['output'];
  totalCount: Scalars['Int32']['output'];
};

export type GetEmployeeResponse = {
  employee: Employee;
  permissionDetails: Array<PermissionDetail>;
  portrait?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Role>;
};

export type GetFixedTransactionDataResponse = {
  itemRank: ItemRank;
  revenue: Revenue;
  transaction: TransactionReport;
};

export type GetOnlineOrderOverviewInput = {
  calendar: ReportCalendar;
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
  shopKey: ShopKey;
  timeUnit?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['String']['input'];
};

export type GetOnlineOrderOverviewResponse = {
  ratio: OnlineOrderRatioOverview;
  revenue: OnlineOrderRevenueOverview;
  volume: OnlineOrderVolumeOverview;
};

export type GetPaymentReportResponse = {
  paymentRanks: Array<RankDetails>;
  totalAmount: Scalars['Decimal']['output'];
  totalCount: Scalars['Int32']['output'];
};

export type GetRevenueReportResponse = {
  acceptTimeUnit: Array<Scalars['String']['output']>;
  revenueReports: Array<RevenueReport>;
  yRange: Array<Scalars['Decimal']['output']>;
};

export type GetTransactionReportInput = {
  calendar: ReportCalendar;
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
  orderBy?: InputMaybe<OrderBy>;
  shopKey: ShopKey;
  timeUnit?: InputMaybe<Scalars['String']['input']>;
  timezone: Scalars['String']['input'];
};

export type GetTransactionReportResponse = {
  acceptTimeUnit: Array<Scalars['String']['output']>;
  avgCost: Scalars['Decimal']['output'];
  avgCostPerPerson: Scalars['Decimal']['output'];
  costReports: Array<CostReport>;
  customersNum: Scalars['Int32']['output'];
  transactionNum: Scalars['Int32']['output'];
  yRange: Array<Scalars['Decimal']['output']>;
};

export type Grid = {
  col: Scalars['Int16']['output'];
  colSpan: Scalars['Int16']['output'];
  row: Scalars['Int16']['output'];
  rowSpan: Scalars['Int16']['output'];
};

export type IdValuePairInput = {
  ID: Scalars['Int32']['input'];
  Value: Scalars['Int16']['input'];
};

/** 商品圖片Hash演算法 */
export enum ImageHashAlg {
  Sha1 = 'Sha1',
}

/** 商品圖片媒體類型 */
export enum ImageMimeType {
  Jpeg = 'JPEG',
  Png = 'PNG',
  Webp = 'WEBP',
}

/** Logo 類型 */
export enum ImageType {
  /** 正常大小 */
  Normal = 'Normal',
  /** 縮略圖 */
  Thumb = 'Thumb',
}

export type ImportItemsCsvFileResponse = {
  filePath: Scalars['String']['output'];
  itemResult: ItemResult;
};

export type ImportItemsCsvInput = {
  brandKey: BrandKey;
  file: Scalars['Upload']['input'];
};

export type ImportMembersCsvFileResponse = {
  filePath: Scalars['String']['output'];
  memberResult: ImportMembersCsvResult;
};

export type ImportMembersCsvResult = {
  createdCardIDs: Array<Scalars['UUID']['output']>;
  createdMemberIDs: Array<Scalars['UUID']['output']>;
  skippedCount: Scalars['Int32']['output'];
  source: Scalars['String']['output'];
};

/** 基礎設施區域 */
export enum InfraRegion {
  Taiwan = 'Taiwan',
  Tokyo = 'Tokyo',
}

export type InputOrgBelongKey = {
  BrandID?: InputMaybe<Scalars['Int32']['input']>;
  ShopID?: InputMaybe<Scalars['Int32']['input']>;
  WorkspaceID: Scalars['UUID']['input'];
};

export enum InstructionMode {
  /** 依照各門市品牌設定 */
  Apart = 'Apart',
  /** 統一開通資訊 */
  Uniform = 'Uniform',
}

/** 發票 */
export type Invoice = {
  /** 發票金額 */
  amount: Scalars['Decimal']['output'];
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  /** 營業日 */
  businessDate: Scalars['Date']['output'];
  /** 載具號碼 */
  carrierCode?: Maybe<Scalars['String']['output']>;
  /** 載具顯碼 */
  carrierID1?: Maybe<Scalars['String']['output']>;
  /** 載具隱碼 */
  carrierID2?: Maybe<Scalars['String']['output']>;
  /** 載具類型 */
  carrierType?: Maybe<InvoiceCarrierType>;
  createdAt: Scalars['DateTimeZ']['output'];
  /** 信用卡號碼 */
  creditCardNo?: Maybe<Scalars['String']['output']>;
  /** 折讓時間 */
  creditedAt?: Maybe<Scalars['DateTimeZ']['output']>;
  deletedAt?: Maybe<Scalars['SoftDeleteZ']['output']>;
  /** 機號 */
  deviceCode: Scalars['String']['output'];
  /** 捐贈碼 */
  donationCode?: Maybe<Scalars['String']['output']>;
  /** 發票內容 */
  invoiceContent: Scalars['String']['output'];
  invoiceID: Scalars['UUID']['output'];
  /** 發票號碼 */
  invoiceNo: Scalars['String']['output'];
  /** 發票隨機碼 */
  invoiceRandomNo: Scalars['String']['output'];
  /** 發票狀態 */
  invoiceStatus: InvoiceStatus;
  /** 是否已列印過(正本) */
  isPrinted: Scalars['Boolean']['output'];
  /** 備註 */
  note?: Maybe<Scalars['String']['output']>;
  opUser?: Maybe<Employee>;
  /** 操作人員 */
  opUserID?: Maybe<Scalars['UUID']['output']>;
  order: Order;
  orderID: Scalars['UUID']['output'];
  /** 未稅額 */
  preTaxAmount: Scalars['Decimal']['output'];
  /** 退款來源發票 */
  refundedFrom?: Maybe<Invoice>;
  /** 退款來源發票ID */
  refundedFromID?: Maybe<Scalars['UUID']['output']>;
  /** 退款來源訂單 */
  refundedFromOrder?: Maybe<Order>;
  /** 退款來源訂單ID */
  refundedFromOrderID?: Maybe<Scalars['UUID']['output']>;
  /** 退款來源交易 */
  refundedFromTransaction?: Maybe<Transaction>;
  /** 退款來源交易ID */
  refundedFromTransactionID?: Maybe<Scalars['UUID']['output']>;
  /** 換開來源發票 */
  reissuedFrom?: Maybe<Invoice>;
  /** 換開來源發票ID */
  reissuedFromID?: Maybe<Scalars['UUID']['output']>;
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  /** 稅額 */
  taxAmount: Scalars['Decimal']['output'];
  /** 統一編號 */
  taxID?: Maybe<Scalars['String']['output']>;
  transaction: Transaction;
  transactionID: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  /** 發票上傳狀態 */
  uploadStatus?: Maybe<InvoiceUploadStatus>;
  /** 作廢原因 */
  voidReason?: Maybe<Scalars['String']['output']>;
  /** 作廢時間 */
  voidedAt?: Maybe<Scalars['DateTimeZ']['output']>;
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 發票載具類型 */
export enum InvoiceCarrierType {
  /** 金融卡 (BK0001) */
  BankCard = 'BankCard',
  /** 自然人憑證 (CQ0001) */
  Citizen = 'Citizen',
  /** 信用卡 (EK0002) */
  CreditCard = 'CreditCard',
  /** 悠遊卡 (1K0001) */
  EasyCard = 'EasyCard',
  /** iCash (2G0001) */
  ICash = 'ICash',
  /** 一卡通 (1H0001) */
  IPass = 'IPass',
  /** 手機條碼 (3J0002) */
  Mobile = 'Mobile',
}

/** 匯出發票csv欄位(Invoice) */
export type InvoiceColumnIndices = {
  /** 發票金額 */
  amount: Scalars['Int16']['input'];
  /** 載具/捐贈碼 */
  carrierOrDonationCode: Scalars['Int16']['input'];
  /** 開立時間 */
  createdAt: Scalars['Int16']['input'];
  /** 發票序號 */
  invoiceNo: Scalars['Int16']['input'];
  /** 發票狀態 */
  invoiceStatus: Scalars['Int16']['input'];
  /** 訂單 */
  order: OrderInvoiceColumnIndices;
  /** 發票未稅額 */
  preTaxAmount: Scalars['Int16']['input'];
  /** 發票稅額 */
  taxAmount: Scalars['Int16']['input'];
  /** 統編 */
  taxID: Scalars['Int16']['input'];
  /** 交易 */
  transaction: TransactionInvoiceColumnIndices;
  /** 作廢時間 */
  voidedAt: Scalars['Int16']['input'];
};

/** 匯出訂單csv欄位(Invoice) */
export type InvoiceOrderColumnIndices = {
  /** 發票號碼 */
  invoiceNo: Scalars['Int16']['input'];
};

/** 發票分頁 */
export type InvoicePagination = {
  invoices?: Maybe<Array<Invoice>>;
  pageInfo: CursorPageInfo;
};

export type InvoiceReason = {
  code: Scalars['String']['output'];
  invoiceReasonID: Scalars['Int16']['output'];
  taxRate: Scalars['String']['output'];
};

/** 搜尋關鍵字 */
export enum InvoiceSearchCondition {
  /** 載具/捐贈碼 */
  CarrierOrDonationCode = 'CARRIER_OR_DONATION_CODE',
  /** 發票號碼 */
  InvoiceNo = 'INVOICE_NO',
  /** 訂單序號 */
  OrderNo = 'ORDER_NO',
  /** 統編 */
  TaxId = 'TAX_ID',
  /** 交易序號 */
  TransactionNo = 'TRANSACTION_NO',
}

/** 搜尋發票列表(篩選條件) */
export type InvoiceSearchParams = {
  /** 支付方式 */
  brandPaymentMethodName?: InputMaybe<Scalars['String']['input']>;
  /** 營業日範圍 */
  businessDateRange?: InputMaybe<TimeRange>;
  /** 系統日範圍 */
  createdAtRange?: InputMaybe<TimeRange>;
  /** 發票狀態 */
  invoiceStatus?: InputMaybe<Array<InvoiceStatus>>;
  /** 營業日範圍（訂單） */
  orderBusinessDateRange?: InputMaybe<TimeRange>;
  /** 系統日範圍（訂單） */
  orderCreatedAtRange?: InputMaybe<TimeRange>;
  /** 作廢時間範圍 */
  voidedAtRange?: InputMaybe<TimeRange>;
};

/** 發票狀態 */
export enum InvoiceStatus {
  /** 已折讓 */
  Credited = 'Credited',
  /** 已開立 */
  Issued = 'Issued',
  /** 已作廢 */
  Voided = 'Voided',
}

export type InvoiceTransactionColumnIndices = {
  /** 發票金額 */
  amount: Scalars['Int16']['input'];
  /** 發票號碼 */
  invoiceNo: Scalars['Int16']['input'];
};

/** 發票類型 */
export enum InvoiceType {
  Carrier = 'Carrier',
  Paper = 'Paper',
}

/** 發票上傳狀態 */
export enum InvoiceUploadStatus {
  /** 上傳失敗 */
  Failed = 'Failed',
  /** 進行中 */
  Processing = 'Processing',
  /** 已上傳 */
  Uploaded = 'Uploaded',
}

export type InvoicesCsvInput = {
  /** 匯出訂單csv欄位 */
  columnIndices: InvoiceColumnIndices;
  /** 語系 */
  locale: Locales;
  /** 搜尋 */
  search?: InputMaybe<Scalars['String']['input']>;
  /** 搜尋關鍵字 */
  searchCondition: InvoiceSearchCondition;
  /** 搜尋訂單列表(篩選條件) */
  searchParams: InvoiceSearchParams;
  shopKey: ShopKey;
  /** 排序 (欄位) */
  sortField: Scalars['String']['input'];
  /** 排序 (升/降) */
  sortOrder: SortOrder;
  /** 時區 */
  timezone: Scalars['String']['input'];
};

export enum IssuanceLevel {
  /** 品牌 */
  Brand = 'Brand',
  /** 總部 */
  Hq = 'HQ',
}

/** 商品 */
export type Item = {
  /** 是否可手動更改稅率 */
  allowChangeTaxRate: Scalars['Boolean']['output'];
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  /** 編號(主) */
  code: Scalars['String']['output'];
  /** 按鍵顏色 */
  color: Scalars['String']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 預設稅金 (用於擇一計算方式) */
  defaultTaxID?: Maybe<Scalars['Int16']['output']>;
  defaultTaxUnit?: Maybe<TaxUnit>;
  deletedAt?: Maybe<Scalars['SoftDeleteZ']['output']>;
  /** 停用 */
  disabled: Scalars['Boolean']['output'];
  hasNestedBundle?: Maybe<Scalars['Boolean']['output']>;
  /** 商品簡介 */
  intro: Scalars['String']['output'];
  /** 商品簡介(多語系) */
  introLang: MultiLang;
  itemAdvNames?: Maybe<Array<ItemAdvName>>;
  itemBundles: Array<ItemBundle>;
  itemCategory?: Maybe<ItemCategory>;
  /** 商品分類 */
  itemCategoryID?: Maybe<Scalars['Int32']['output']>;
  itemID: Scalars['Int32']['output'];
  itemImages: Array<ItemImage>;
  /** 商品種類(單品|套餐) */
  itemKind: ItemKind;
  /** 選擇標籤群組 */
  itemLabelGroups: Array<ItemLabelGroup>;
  itemPriceOptions: Array<ItemPriceOption>;
  itemType?: Maybe<ItemType>;
  /** 商品類型 */
  itemTypeID?: Maybe<Scalars['Int32']['output']>;
  linkItemShops: Array<LinkItemShop>;
  linkItemSubBrands: Array<LinkItemSubBrand>;
  /** 商品名稱 */
  name: Scalars['String']['output'];
  /** 商品名稱(多語系) */
  nameLang: MultiLang;
  /** 不列入報表統計 */
  noStatistic: Scalars['Boolean']['output'];
  /** 只在 POS 使用 */
  posOnly: Scalars['Boolean']['output'];
  /** 下架時間(預設 9999-12-31 23:59:59) */
  saleEndTime: Scalars['DateTime']['output'];
  /** 上架時間(預設 0001-01-01 00:00:00) */
  saleStartTime: Scalars['DateTime']['output'];
  /** 門市套用模式 (販售地點) */
  shopApplyMode: ShopApplyMode;
  /** 商品稅別 */
  taxCategory: TaxCategory;
  taxGroup?: Maybe<TaxGroup>;
  /** 商品稅金群組 */
  taxGroupID?: Maybe<Scalars['Int16']['output']>;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 商品進階名稱 */
export type ItemAdvName = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  item: Item;
  itemAdvNameType: ItemAdvNameType;
  itemID: Scalars['Int32']['output'];
  /** 名稱 */
  name: Scalars['String']['output'];
  /** 名稱(多語系) */
  nameLang: MultiLang;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 商品進階名稱 */
export type ItemAdvNameInput = {
  brandID: Scalars['Int32']['input'];
  itemAdvNameType: ItemAdvNameType;
  /** createItem時不帶itemID，updateItem時必填 */
  itemID?: InputMaybe<Scalars['Int32']['input']>;
  /** 名稱 */
  name: Scalars['String']['input'];
  /** 名稱(多語系) */
  nameLang: MultiLangInput;
  workspaceID: Scalars['UUID']['input'];
};

export type ItemAdvNameKey = {
  brandID: Scalars['Int32']['input'];
  itemAdvNameType: ItemAdvNameType;
  itemID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

/** 商品進階名稱類型 */
export enum ItemAdvNameType {
  Customer = 'Customer',
  FoodPanda = 'FoodPanda',
  Kitchen = 'Kitchen',
  Nidin = 'Nidin',
  Pos = 'POS',
  Settlement = 'Settlement',
  Sticker = 'Sticker',
  UberEats = 'UberEats',
}

/** 商品進階價位 */
export type ItemAdvPrice = {
  /** 品牌用餐方式 */
  brandDiningOptionID?: Maybe<Scalars['Int32']['output']>;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  itemAdvPriceID: Scalars['Int32']['output'];
  itemID: Scalars['Int32']['output'];
  itemPriceOption: ItemPriceOption;
  itemPriceOptionID: Scalars['Int32']['output'];
  /** 原價 */
  originPrice: Scalars['Decimal']['output'];
  /** 售價 */
  price: Scalars['Decimal']['output'];
  /** 所需點數 */
  redeemPoint: Scalars['Int32']['output'];
  /** 品牌分類 */
  subBrandID?: Maybe<Scalars['Int32']['output']>;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type ItemAdvPriceKey = {
  BrandID: Scalars['Int32']['input'];
  ItemAdvPriceID: Scalars['Int32']['input'];
  ItemID: Scalars['Int32']['input'];
  ItemPriceOptionID: Scalars['Int32']['input'];
  WorkspaceID: Scalars['UUID']['input'];
};

export type ItemAggregate = {
  /** 品牌分類 */
  brandName: Scalars['String']['output'];
  /** 商品主編號 */
  code: Scalars['String']['output'];
  /** 招待數量 */
  complimentaryQuantity: Scalars['Int']['output'];
  /** 用餐方式名稱 */
  diningOptionName: Scalars['String']['output'];
  /** 用餐方式類型 */
  diningOptionType: Scalars['String']['output'];
  /** 單品折扣 */
  discountAmount: Scalars['Decimal']['output'];
  /** 商品分類 */
  itemCategory: Scalars['String']['output'];
  itemID: Scalars['Int']['output'];
  /** 商品名稱 */
  itemName: Scalars['String']['output'];
  /** 商品單價 */
  itemPrice: Scalars['Decimal']['output'];
  /** 價位ID */
  itemPriceOptionID: Scalars['Int']['output'];
  /** 價位名稱 */
  itemPriceOptionName: Scalars['String']['output'];
  /** 數量 */
  itemQuantity: Scalars['Int']['output'];
  /** 商品銷售類型(單品Single、套餐主項ComboMain、套餐子項ComboSub) */
  itemSaleType: Scalars['String']['output'];
  /** 商品數量百分比 */
  quantityPercent: Scalars['Decimal']['output'];
  rank: Scalars['Int']['output'];
  /** 門市 */
  shopName: Scalars['String']['output'];
  /** 銷售金額(折扣後) */
  totalAmountAfterDiscount: Scalars['Decimal']['output'];
  /** 銷售金額(折扣後)百分比 */
  totalAmountAfterDiscountPercent: Scalars['Decimal']['output'];
  /** 銷售金額(折扣前) */
  totalAmountBeforeDiscount: Scalars['Decimal']['output'];
  /** 銷售金額(折扣前)百分比 */
  totalAmountBeforeDiscountPercent: Scalars['Decimal']['output'];
};

/** 套餐內容組合 */
export type ItemBundle = {
  brandID: Scalars['Int32']['output'];
  bundle: Bundle;
  bundleID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 顯示順序 */
  displayOrder: Scalars['Int16']['output'];
  item: Item;
  itemID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type ItemBundleInput = {
  brandID: Scalars['Int32']['input'];
  bundleID: Scalars['Int32']['input'];
  displayOrder: Scalars['Int16']['input'];
  /** createItem時不帶itemID，updateItem時必填 */
  itemID?: InputMaybe<Scalars['Int32']['input']>;
  workspaceID: Scalars['UUID']['input'];
};

export type ItemBundleKey = {
  brandID: Scalars['Int32']['input'];
  bundleID: Scalars['Int32']['input'];
  itemID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

/** 商品分類 */
export type ItemCategory = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  /** 分類編號 */
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  deletedAt?: Maybe<Scalars['SoftDeleteZ']['output']>;
  /** 顯示順序 */
  displayOrder: Scalars['Int16']['output'];
  itemCategoryID: Scalars['Int32']['output'];
  items: Array<Item>;
  /** 商品分類名稱 */
  name: Scalars['String']['output'];
  parent?: Maybe<ItemCategory>;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 商品分類 */
export type ItemCategoryItemsArgs = {
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  itemKind?: InputMaybe<ItemKind>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type ItemCategoryKey = {
  brandID: Scalars['Int32']['input'];
  itemCategoryID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

/** 商品分類(新增商品用) */
export type ItemCategoryNameInput = {
  brandID: Scalars['Int32']['input'];
  /** 使用商品分類 ID (帶入後不需使用 name) */
  itemCategoryID?: InputMaybe<Scalars['Int32']['input']>;
  /** 建立商品分類名稱 (帶入後不需使用 itemCategoryID) */
  name?: InputMaybe<Scalars['String']['input']>;
  workspaceID: Scalars['UUID']['input'];
};

export type ItemCategoryOrderInput = {
  displayOrder: Scalars['Int16']['input'];
  itemCategoryID: Scalars['Int32']['input'];
};

export type ItemCategoryPagination = {
  itemCategories?: Maybe<Array<ItemCategory>>;
  pageInfo: CursorPageInfo;
  uncategorizedItems?: Maybe<Array<Item>>;
};

export type ItemCategoryPaginationUncategorizedItemsArgs = {
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  itemKind?: InputMaybe<ItemKind>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export enum ItemCategorySortField {
  CreatedAt = 'createdAt',
  DisplayOrder = 'displayOrder',
  Name = 'name',
  UpdatedAt = 'updatedAt',
}

/** 商品圖片 */
export type ItemImage = {
  alg: ImageHashAlg;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 檔案大小 */
  fileSize: Scalars['Int32']['output'];
  hash: Scalars['String']['output'];
  /** 高度 */
  height: Scalars['Int16']['output'];
  item: Item;
  itemID: Scalars['Int32']['output'];
  itemImageThumbs: Array<ItemImageThumb>;
  mime: ImageMimeType;
  updatedAt: Scalars['DateTimeZ']['output'];
  /** 寬度 */
  width: Scalars['Int16']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type ItemImageKey = {
  brandID: Scalars['Int32']['output'];
  itemID: Scalars['Int32']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 商品圖片縮圖 */
export type ItemImageThumb = {
  alg: ImageHashAlg;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 檔案大小 */
  fileSize: Scalars['Int32']['output'];
  hash: Scalars['String']['output'];
  /** 高度 */
  height: Scalars['Int16']['output'];
  itemID: Scalars['Int32']['output'];
  itemImage: ItemImage;
  itemImageThumbID: Scalars['Int32']['output'];
  mime: ImageMimeType;
  updatedAt: Scalars['DateTimeZ']['output'];
  /** 寬度 */
  width: Scalars['Int16']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type ItemImageThumbKey = {
  brandID: Scalars['Int32']['output'];
  itemID: Scalars['Int32']['output'];
  itemImageThumbID: Scalars['Int32']['output'];
  workspaceID: Scalars['UUID']['output'];
};

export type ItemKey = {
  brandID: Scalars['Int32']['input'];
  itemID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

/** 商品種類 */
export enum ItemKind {
  /** 套餐 */
  Combo = 'Combo',
  /** 單品 */
  Single = 'Single',
}

/** 商品選擇標籤群組 */
export type ItemLabelGroup = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 顯示順序 */
  displayOrder: Scalars['Int16']['output'];
  item: Item;
  itemID: Scalars['Int32']['output'];
  labelGroup: LabelGroup;
  labelGroupID: Scalars['Int32']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type ItemLabelGroupInput = {
  brandID: Scalars['Int32']['input'];
  displayOrder: Scalars['Int16']['input'];
  /** createItem時不帶itemID，updateItem時必填 */
  itemID?: InputMaybe<Scalars['Int32']['input']>;
  labelGroupID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

export type ItemLabelGroupKey = {
  brandID: Scalars['Int32']['input'];
  itemID: Scalars['Int32']['input'];
  labelGroupID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

export type ItemListWithItemPriceOption = {
  itemID: Scalars['Int32']['output'];
  itemName: Scalars['String']['output'];
  options: Array<ItemPriceOptionList>;
};

export type ItemPagination = {
  items: Array<Item>;
  pageInfo: CursorPageInfo;
};

export type ItemPercent = {
  itemName: Scalars['String']['output'];
  percent: Scalars['Decimal']['output'];
};

/** 商品價位規格 */
export type ItemPriceOption = {
  /** 條碼 */
  barcode: Scalars['String']['output'];
  brandID: Scalars['Int32']['output'];
  bundleItemItemPriceOptions?: Maybe<Array<BundleItemItemPriceOption>>;
  /** 商品價位可招待 */
  complimentary: Scalars['Boolean']['output'];
  /** 成本 */
  cost: Scalars['Decimal']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 預設選取 */
  defaultSelect: Scalars['Boolean']['output'];
  /** 顯示順序 */
  displayOrder: Scalars['Int16']['output'];
  item: Item;
  itemAdvPrices: Array<ItemAdvPrice>;
  /** 編號(子) */
  itemCode: Scalars['String']['output'];
  itemID: Scalars['Int32']['output'];
  itemPriceOptionID: Scalars['Int32']['output'];
  /** 價位名稱 */
  name: Scalars['String']['output'];
  /** 價位名稱(多語系) */
  nameLang: MultiLang;
  /** 原價 */
  originPrice: Scalars['Decimal']['output'];
  /** 售價 */
  price: Scalars['Decimal']['output'];
  /** 價位類型 */
  priceType: ItemPriceType;
  /** 計價方式 */
  pricingMethod: ItemPricingMethod;
  /** 所需點數 */
  redeemPoint: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  /** 單價基準量 */
  weightBaseQuantity?: Maybe<Scalars['Decimal']['output']>;
  /** 重量單位 */
  weightUnit?: Maybe<WeightUnit>;
  /** 單位售價 */
  weightUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type ItemPriceOptionKey = {
  BrandID: Scalars['Int32']['input'];
  ItemID: Scalars['Int32']['input'];
  ItemPriceOptionID: Scalars['Int32']['input'];
  WorkspaceID: Scalars['UUID']['input'];
};

export type ItemPriceOptionList = {
  itemPriceOptionID: Scalars['Int32']['output'];
  name: Scalars['String']['output'];
  price: Scalars['Decimal']['output'];
};

/** 商品價位類型 */
export enum ItemPriceType {
  /** 固定價 */
  Fixed = 'Fixed',
  /** 變動價(時價) */
  Variable = 'Variable',
}

/** 計價方式 */
export enum ItemPricingMethod {
  /** 手動輸入 */
  Manual = 'Manual',
  /** 依重量計算 */
  Weight = 'Weight',
}

export type ItemRank = {
  details: Array<RankDetails>;
  totalAmount: Scalars['Int32']['output'];
};

export type ItemResult = {
  clusters?: Maybe<Array<Cluster>>;
  items?: Maybe<Array<Scalars['Int32']['output']>>;
};

export enum ItemSortField {
  CreatedAt = 'createdAt',
  Name = 'name',
  UpdatedAt = 'updatedAt',
}

/** 商品拆分狀態 */
export enum ItemSplitState {
  /** 金額已修改 */
  AmountModified = 'AmountModified',
  /** 未拆分 */
  None = 'None',
  /** 已拆分 */
  Splitted = 'Splitted',
}

/** 商品類型 */
export type ItemType = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 顯示順序 */
  displayOrder: Scalars['Int16']['output'];
  itemTypeID: Scalars['Int32']['output'];
  linkItems: Array<Item>;
  /** 商品類型名稱 */
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type ItemTypeKey = {
  brandID: Scalars['Int32']['input'];
  itemTypeID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

export type ItemWithItemPriceOption = {
  itemID: Scalars['Int32']['input'];
  itemPriceOptionID: Scalars['Int32']['input'];
};

export type ItemsFilterInput = {
  calendar: ReportCalendar;
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
  diningOptionName?: InputMaybe<Scalars['String']['input']>;
  diningOptionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  itemCategoryID?: InputMaybe<Array<Scalars['Int']['input']>>;
  itemIDs?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** 商品銷售類型 */
  itemSaleTypeOptions?: InputMaybe<Array<Scalars['String']['input']>>;
  searchField?: InputMaybe<ReportItemSearchField>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  shopKeys: Array<ShopKey>;
  timezone: Scalars['String']['input'];
};

export type ItemsOverview = {
  amountPercentOfAll: Array<ItemPercent>;
  groupBy: ReportItemGroupMode;
  groups: Array<ReportItemsGroup>;
  quantityPercentOfAll: Array<ItemPercent>;
  totalAmount: Scalars['String']['output'];
  totalQuantity: Scalars['Int']['output'];
};

/** 鍵盤按鍵 */
export type KeyButton = {
  brandID: Scalars['Int32']['output'];
  /** 起始行 */
  col: Scalars['Int16']['output'];
  /** 行數 */
  colSpan: Scalars['Int16']['output'];
  /** 顏色 */
  color: Scalars['String']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  keyButtonID: Scalars['Int32']['output'];
  keypad: Keypad;
  keypadID: Scalars['Int32']['output'];
  /** 標籤群組ID(type 為 Label 才會有) */
  labelGroupID?: Maybe<Scalars['Int32']['output']>;
  /** 標籤群組內的標籤(type 為 Label 才會有) */
  labelGroupLabel?: Maybe<LabelGroupLabel>;
  /** 標籤ID(type 為 Label 才會有) */
  labelID?: Maybe<Scalars['Int32']['output']>;
  /** 鍵盤按鈕使用優惠 */
  linkKeybuttonDiscount?: Maybe<LinkKeybuttonDiscount>;
  /** 按鍵文字 */
  name: Scalars['String']['output'];
  /** 商品價位顯示順序(type 為 PriceOption 才會有) */
  priceOptionDisplayOrder?: Maybe<Scalars['Int16']['output']>;
  /** 起始列 */
  row: Scalars['Int16']['output'];
  /** 列數 */
  rowSpan: Scalars['Int16']['output'];
  shopID: Scalars['Int32']['output'];
  /** 鍵盤按鍵類型 */
  type: KeyButtonType;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type KeyButtonInput = {
  /** 起始行 */
  col: Scalars['Int16']['input'];
  /** 行數 */
  colSpan: Scalars['Int16']['input'];
  /** 顏色 */
  color: Scalars['String']['input'];
  /** 優惠ID，新增/更新優惠按鈕需要 */
  discountID?: InputMaybe<Scalars['Int32']['input']>;
  /** 按鍵ID，新增優惠按鈕時不帶 */
  keyButtonID?: InputMaybe<Scalars['Int32']['input']>;
  keypadKey: KeypadKey;
  /** 起始列 */
  row: Scalars['Int16']['input'];
  /** 列數 */
  rowSpan: Scalars['Int16']['input'];
};

export type KeyButtonKey = {
  brandID: Scalars['Int32']['input'];
  keyButtonID: Scalars['Int32']['input'];
  keypadID: Scalars['Int32']['input'];
  shopID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

export type KeyButtonList = {
  labelButtonGroups?: Maybe<Array<LabelButtonGroup>>;
  priceOptions?: Maybe<Array<PriceOptionButton>>;
};

/** 鍵盤按鍵類型 */
export enum KeyButtonType {
  /** 折扣 */
  Discount = 'Discount',
  /** 標籤 */
  Label = 'Label',
  /** 手動折扣 */
  ManualDiscount = 'ManualDiscount',
  /** 備註 */
  Note = 'Note',
  /** 商品價位 */
  PriceOption = 'PriceOption',
}

export type KeyButtonsOfKeypadInput = {
  /** 鍵盤按鍵 */
  keyButtons?: InputMaybe<Array<KeyButtonInput>>;
  keypadKey: KeypadKey;
};

/** 鍵盤 */
export type Keypad = {
  brandID: Scalars['Int32']['output'];
  /** 總行數 */
  cols: Scalars['Int16']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 顯示順序 */
  displayOrder: Scalars['Int16']['output'];
  /** 鍵盤按鍵 */
  keyButtons: Array<KeyButton>;
  keypadID: Scalars['Int32']['output'];
  /** 鍵盤使用商品 */
  linkKeypadItems: Array<LinkKeypadItem>;
  /** 鍵盤名稱 */
  name: Scalars['String']['output'];
  /** 總列數 */
  rows: Scalars['Int16']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type KeypadDisplayOrderInput = {
  shopKey: ShopKey;
  /** 更新鍵盤順序 */
  updateOrder?: InputMaybe<Array<KeypadOrderInput>>;
};

export type KeypadKey = {
  brandID: Scalars['Int32']['input'];
  keypadID: Scalars['Int32']['input'];
  shopID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

export type KeypadOrderInput = {
  displayOrder: Scalars['Int16']['input'];
  keypadID: Scalars['Int32']['input'];
};

export type KeypadPagination = {
  keypads?: Maybe<Array<KeypadResponse>>;
  pageInfo: CursorPageInfo;
};

export type KeypadResponse = {
  available: Scalars['Boolean']['output'];
  keypad: Keypad;
};

export enum KeypadSortField {
  DisplayOrder = 'displayOrder',
}

/** 標籤 */
export type Label = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  /** 標籤編號 */
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 顯示順序 */
  displayOrder: Scalars['Int16']['output'];
  /** 標籤群組標籤 */
  labelGroupLabels?: Maybe<Array<LabelGroupLabel>>;
  labelID: Scalars['Int32']['output'];
  /** 標籤名稱 */
  name: Scalars['String']['output'];
  /** 標籤名稱(多語系) */
  nameLang: MultiLang;
  /** 此標籤只在POS使用 */
  posOnly: Scalars['Boolean']['output'];
  /** 價錢 */
  price: Scalars['Decimal']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type LabelAggregate = {
  /** 標籤總金額 */
  amount: Scalars['Decimal']['output'];
  /** 品牌分類 */
  brandName?: Maybe<Scalars['String']['output']>;
  diningOptionName?: Maybe<Scalars['String']['output']>;
  /** 用餐方式類型 */
  diningOptionType?: Maybe<Scalars['String']['output']>;
  /** 商品編號(其實是價位編號) */
  itemCode?: Maybe<Scalars['String']['output']>;
  itemID: Scalars['Int']['output'];
  /** 商品類型(套餐、單品) */
  itemKind?: Maybe<Scalars['String']['output']>;
  /** 商品名稱 */
  itemName?: Maybe<Scalars['String']['output']>;
  itemPriceOptionID: Scalars['Int']['output'];
  /** 價位名稱 */
  itemPriceOptionName?: Maybe<Scalars['String']['output']>;
  labelGroupID: Scalars['Int']['output'];
  /** 標籤群組名稱 */
  labelGroupName?: Maybe<Scalars['String']['output']>;
  labelID: Scalars['Int']['output'];
  /** 標籤名稱 */
  labelName?: Maybe<Scalars['String']['output']>;
  /** 標籤售價 */
  labelPrice: Scalars['Decimal']['output'];
  /** 標籤數量 */
  labelQuantity: Scalars['Int']['output'];
  /** 標籤數量百分比 */
  quantityPercent: Scalars['Decimal']['output'];
  rank: Scalars['Int']['output'];
  /** 門市 */
  shopName?: Maybe<Scalars['String']['output']>;
};

export type LabelButton = {
  keyButtonID: Scalars['Int32']['output'];
  labelGroupLabel: LabelGroupLabel;
};

export type LabelButtonGroup = {
  labelButtons?: Maybe<Array<LabelButton>>;
  labelGroup: LabelGroup;
};

/** 標籤群組 */
export type LabelGroup = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 顯示順序 */
  displayOrder: Scalars['Int16']['output'];
  /** 商品選擇標籤群組 */
  itemLabelGroups?: Maybe<Array<ItemLabelGroup>>;
  labelGroupID: Scalars['Int32']['output'];
  /** 標籤群組內的標籤 */
  labelGroupLabels: Array<LabelGroupLabel>;
  linkShopLabelGroups: Array<LinkShopLabelGroup>;
  linkSubBrandLabelGroups: Array<LinkSubBrandLabelGroup>;
  /** 標籤群組名稱 */
  name: Scalars['String']['output'];
  /** 標籤群組名稱(多語系) */
  nameLang: MultiLang;
  /** 此標籤群組不列入報表統計 */
  noStatistic: Scalars['Boolean']['output'];
  /** 此標籤群組只在POS使用 */
  posOnly: Scalars['Boolean']['output'];
  /** 每項標籤可選最多份數 (0 表示不限制) */
  sameLabelSelectableMaxCount: Scalars['Int16']['output'];
  /** 可選最多份數 */
  selectableMaxCount: Scalars['Int16']['output'];
  /** 可選最少份數 (0 表示非必選) */
  selectableMinCount: Scalars['Int16']['output'];
  /** 門市套用模式 (指定使用門市) */
  shopApplyMode: ShopApplyMode;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type LabelGroupInput = {
  ItemIDs?: InputMaybe<Array<Scalars['Int32']['input']>>;
  LabelGroupLabelInputs?: InputMaybe<Array<LabelGroupLabelInput>>;
  Name: Scalars['String']['input'];
  NoStatistic: Scalars['Boolean']['input'];
  PosOnly: Scalars['Boolean']['input'];
  SameLabelSelectableMaxCount: Scalars['Int16']['input'];
  SelectableMaxCount: Scalars['Int16']['input'];
  SelectableMinCount: Scalars['Int16']['input'];
  ShopApplyMode: ShopApplyMode;
  SpecifyShops?: InputMaybe<SpecifyShopInput>;
};

export type LabelGroupKey = {
  BrandID: Scalars['Int32']['input'];
  LabelGroupID: Scalars['Int32']['input'];
  WorkspaceID: Scalars['UUID']['input'];
};

/** 標籤群組內的標籤 */
export type LabelGroupLabel = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 預設選取 */
  defaultSelect: Scalars['Boolean']['output'];
  /** 顯示順序 */
  displayOrder: Scalars['Int16']['output'];
  label: Label;
  labelGroup: LabelGroup;
  labelGroupID: Scalars['Int32']['output'];
  labelID: Scalars['Int32']['output'];
  /** 價錢 */
  price: Scalars['Decimal']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type LabelGroupLabelInput = {
  DefaultSelect: Scalars['Boolean']['input'];
  DisplayOrder: Scalars['Int16']['input'];
  LabelID: Scalars['Int32']['input'];
  Price: Scalars['Decimal']['input'];
};

export type LabelGroupLabelKey = {
  brandID: Scalars['Int32']['input'];
  labelGroupID: Scalars['Int32']['input'];
  labelID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

/** 查詢標籤群組分頁結果 */
export type LabelGroupPagination = {
  labelGroups?: Maybe<Array<LabelGroup>>;
  pageInfo: CursorPageInfo;
};

export type LabelInput = {
  Code: Scalars['String']['input'];
  DisplayOrder: Scalars['Int16']['input'];
  Name: Scalars['String']['input'];
  PosOnly: Scalars['Boolean']['input'];
  Price: Scalars['Decimal']['input'];
};

export type LabelKey = {
  BrandID: Scalars['Int32']['input'];
  LabelID: Scalars['Int32']['input'];
  WorkspaceID: Scalars['UUID']['input'];
};

/** 查詢標籤分頁結果 */
export type LabelPagination = {
  labels?: Maybe<Array<Label>>;
  pageInfo: CursorPageInfo;
};

export type LabelPercent = {
  labelName: Scalars['String']['output'];
  percent: Scalars['Decimal']['output'];
};

export enum LabelSearchField {
  ItemName = 'ItemName',
  LabelName = 'LabelName',
}

export enum LabelSortField {
  Amount = 'Amount',
  BrandName = 'BrandName',
  DiningOptionName = 'DiningOptionName',
  DiningOptionType = 'DiningOptionType',
  ItemCode = 'ItemCode',
  ItemKind = 'ItemKind',
  ItemName = 'ItemName',
  ItemPriceOptionName = 'ItemPriceOptionName',
  LabelGroupName = 'LabelGroupName',
  LabelName = 'LabelName',
  LabelPrice = 'LabelPrice',
  LabelQuantity = 'LabelQuantity',
  None = 'None',
  ShopName = 'ShopName',
}

export type LabelsFilterInput = {
  calendar: ReportCalendar;
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
  diningOptionName?: InputMaybe<Scalars['String']['input']>;
  diningOptionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  labelGroupIDs?: InputMaybe<Array<Scalars['Int']['input']>>;
  labelIDs?: InputMaybe<Array<Scalars['Int']['input']>>;
  searchField?: InputMaybe<LabelSearchField>;
  searchText?: InputMaybe<Scalars['String']['input']>;
  shopKeys: Array<ShopKey>;
  timezone: Scalars['String']['input'];
};

export type LabelsOverview = {
  amountPercentOfAll: Array<LabelPercent>;
  groupBy: ReportLabelGroupMode;
  groups: Array<ReportLabelsGroup>;
  quantityPercentOfAll: Array<LabelPercent>;
  totalAmount: Scalars['String']['output'];
  totalQuantity: Scalars['Int']['output'];
};

/** 語言 */
export type Language = {
  languageID: Scalars['String']['output'];
  /** 原生語言名稱 */
  nativeName: Scalars['String']['output'];
};

export type LinePaySetting = {
  channelID: Scalars['String']['output'];
  channelSecretKey: Scalars['String']['output'];
  deviceProfileID: Scalars['String']['output'];
  deviceType: Scalars['String']['output'];
};

export type LinePaySettingInput = {
  channelID: Scalars['String']['input'];
  channelSecretKey: Scalars['String']['input'];
  deviceProfileID: Scalars['String']['input'];
  deviceType: Scalars['String']['input'];
};

/** 客顯輪播廣告與門市關聯 */
export type LinkCdsCarouselAdShop = {
  adID: Scalars['Int32']['output'];
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  shopID: Scalars['Int32']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 客顯輪播廣告與門市關聯 */
export type LinkCdsCarouselAdShopInput = {
  adID?: InputMaybe<Scalars['Int32']['input']>;
  brandID: Scalars['Int32']['input'];
  shopID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

/** 客顯固定廣告與門市關聯 */
export type LinkCdsFixedAdShop = {
  adID: Scalars['Int32']['output'];
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  shopID: Scalars['Int32']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 客顯固定廣告與門市關聯 */
export type LinkCdsFixedAdShopInput = {
  adID?: InputMaybe<Scalars['Int32']['input']>;
  brandID: Scalars['Int32']['input'];
  shopID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

export type LinkEmployeeInput = {
  email: Scalars['String']['input'];
  employeeID: Scalars['UUID']['input'];
  newEmail?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

/** 員工與角色連結 */
export type LinkEmployeeRole = {
  createdAt: Scalars['DateTimeZ']['output'];
  employee: Employee;
  employeeID: Scalars['UUID']['output'];
  role: Role;
  roleID: Scalars['Int32']['output'];
};

/** 商品販售地點指定門市 */
export type LinkItemShop = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  item: Item;
  itemID: Scalars['Int32']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 商品販售地點指定門市 */
export type LinkItemShopInput = {
  brandID: Scalars['Int32']['input'];
  shopID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

export type LinkItemShopKey = {
  brandID: Scalars['Int32']['input'];
  itemID: Scalars['Int32']['input'];
  shopID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

/** 商品販售地點指定品牌分類 */
export type LinkItemSubBrand = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  item: Item;
  itemID: Scalars['Int32']['output'];
  subBrand: SubBrand;
  subBrandID: Scalars['Int32']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 商品販售地點指定品牌分類 */
export type LinkItemSubBrandInput = {
  brandID: Scalars['Int32']['input'];
  subBrandID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

export type LinkItemSubBrandKey = {
  brandID: Scalars['Int32']['input'];
  itemID: Scalars['Int32']['input'];
  subBrandID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

/** 鍵盤按鈕使用優惠 */
export type LinkKeybuttonDiscount = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  discount: Discount;
  discountID: Scalars['Int32']['output'];
  keyButton: KeyButton;
  keyButtonID: Scalars['Int32']['output'];
  keypadID: Scalars['Int32']['output'];
  shopID: Scalars['Int32']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 鍵盤使用商品 */
export type LinkKeypadItem = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  item: Item;
  itemID: Scalars['Int32']['output'];
  keypad: Keypad;
  keypadID: Scalars['Int32']['output'];
  shopID: Scalars['Int32']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type LinkKeypadItemKey = {
  brandID: Scalars['Int32']['input'];
  itemID: Scalars['Int32']['input'];
  keypadID: Scalars['Int32']['input'];
  shopID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

/** 已選品牌用餐方式 */
export type LinkMenuItemBrandDiningOption = {
  brandDiningOption: BrandDiningOption;
  brandDiningOptionID: Scalars['Int32']['output'];
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  menu: Menu;
  menuID: Scalars['Int32']['output'];
  menuItem: MenuItem;
  menuItemID: Scalars['Int32']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type LinkMenuItemBrandDiningOptionInput = {
  /** 品牌用餐方式 */
  brandDiningOptionID: Scalars['Int32']['input'];
  brandID: Scalars['Int32']['input'];
  menuID: Scalars['Int32']['input'];
  /** createMenuItem時不帶menuItemID，updateMenuItem時必填 */
  menuItemID?: InputMaybe<Scalars['Int32']['input']>;
  workspaceID: Scalars['UUID']['input'];
};

export type LinkMenuItemBrandDiningOptionKey = {
  brandDiningOptionID: Scalars['Int32']['input'];
  brandID: Scalars['Int32']['input'];
  menuID: Scalars['Int32']['input'];
  menuItemID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

/** 已選商品價位 */
export type LinkMenuItemItemPriceOption = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  item: Item;
  itemID: Scalars['Int32']['output'];
  itemPriceOption: ItemPriceOption;
  itemPriceOptionID: Scalars['Int32']['output'];
  menu: Menu;
  menuID: Scalars['Int32']['output'];
  menuItem: MenuItem;
  menuItemID: Scalars['Int32']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type LinkMenuItemItemPriceOptionInput = {
  brandID: Scalars['Int32']['input'];
  /** 商品價位 */
  itemID: Scalars['Int32']['input'];
  itemPriceOptionID: Scalars['Int32']['input'];
  menuID: Scalars['Int32']['input'];
  /** createMenuItem時不帶menuItemID，updateMenuItem時必填 */
  menuItemID?: InputMaybe<Scalars['Int32']['input']>;
  workspaceID: Scalars['UUID']['input'];
};

export type LinkMenuItemItemPriceOptionKey = {
  brandID: Scalars['Int32']['input'];
  itemID: Scalars['Int32']['input'];
  itemPriceOptionID: Scalars['Int32']['input'];
  menuID: Scalars['Int32']['input'];
  menuItemID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

/** 線上訂單消費者會員連結 */
export type LinkOnlineOrderConsumerMember = {
  consumerID: Scalars['UUID']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  memberCard?: Maybe<Scalars['String']['output']>;
  memberSourceID?: Maybe<Scalars['UUID']['output']>;
};

/** 訂單桌位關聯 */
export type LinkOrderTable = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 訂單 */
  order: Order;
  orderID: Scalars['UUID']['output'];
  shopAreaID: Scalars['Int32']['output'];
  shopID: Scalars['Int32']['output'];
  /** 桌位 */
  shopTable: ShopTable;
  shopTableID: Scalars['Int32']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 權限主副表連結 */
export type LinkPermissionDetailsPermission = {
  createdAt: Scalars['DateTimeZ']['output'];
  permission: Permission;
  permissionDetail: PermissionDetail;
  permissionDetailID: Scalars['UUID']['output'];
  permissionID: Scalars['UUID']['output'];
};

/** 依用餐方式：顧客姓名樣式 */
export type LinkPrintLayoutBaseConsumerNameStyle = {
  brand: Brand;
  brandDiningOptionID: Scalars['Int32']['output'];
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  printLayoutBaseID: Scalars['Int32']['output'];
  shop: Shop;
  shopDiningOption: ShopDiningOption;
  shopID: Scalars['Int32']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 顧客電話樣式 */
export type LinkPrintLayoutBaseConsumerPhoneStyle = {
  brand: Brand;
  brandDiningOptionID: Scalars['Int32']['output'];
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  printLayoutBaseID: Scalars['Int32']['output'];
  shop: Shop;
  shopDiningOption: ShopDiningOption;
  shopID: Scalars['Int32']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 角色與權限連結 */
export type LinkRolePermission = {
  createdAt: Scalars['DateTimeZ']['output'];
  of: PermissionScope;
  permission: Permission;
  permissionID: Scalars['UUID']['output'];
  roleTemplate: RoleTemplate;
  roleTemplateID: Scalars['UUID']['output'];
};

export type LinkRolePermissionInput = {
  of: Scalars['String']['input'];
  permissionID: Scalars['UUID']['input'];
  roleTemplateID: Scalars['UUID']['input'];
};

export type LinkShopGroupShop = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  group: ShopGroup;
  groupID: Scalars['Int32']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 門市標籤群組 */
export type LinkShopLabelGroup = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  labelGroup: LabelGroup;
  labelGroupID: Scalars['Int32']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type LinkShopLabelGroupKey = {
  brandID: Scalars['Int32']['input'];
  labelGroupID: Scalars['Int32']['input'];
  shopID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

/** 門市與菜單關聯 */
export type LinkShopMenu = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  menu: Menu;
  menuID: Scalars['Int32']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type LinkShopMenuKey = {
  brandID: Scalars['Int32']['input'];
  menuID: Scalars['Int32']['input'];
  shopID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

/** 品牌分類套用標籤群組 */
export type LinkSubBrandLabelGroup = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  labelGroup: LabelGroup;
  labelGroupID: Scalars['Int32']['output'];
  subBrand: SubBrand;
  subBrandID: Scalars['Int32']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 系統稅金群組-稅金關聯 */
export type LinkSysTaxGroupUnit = {
  createdAt: Scalars['DateTimeZ']['output'];
  sysTaxGroup: SysTaxGroup;
  sysTaxGroupID: Scalars['Int16']['output'];
  sysTaxID: Scalars['Int16']['output'];
  sysTaxUnit: SysTaxUnit;
};

export type LinkTicketCheckoutItemCategory = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  itemCategory: ItemCategory;
  itemCategoryID: Scalars['Int32']['output'];
  shopID: Scalars['Int32']['output'];
  ticketID: Scalars['Int32']['output'];
  workspaceID: Scalars['UUID']['output'];
};

export type LinkTicketCheckoutItemPriceOption = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  item: Item;
  itemID: Scalars['Int32']['output'];
  itemPriceOption: ItemPriceOption;
  itemPriceOptionID: Scalars['Int32']['output'];
  shopID: Scalars['Int32']['output'];
  ticketID: Scalars['Int32']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 廚房單 x 商品分類 */
export type LinkTicketKitchenItemCategory = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  itemCategory: ItemCategory;
  itemCategoryID: Scalars['Int32']['output'];
  shopID: Scalars['Int32']['output'];
  ticketID: Scalars['Int32']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 廚房單 x 售價選項 */
export type LinkTicketKitchenItemPriceOption = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  item: Item;
  itemID: Scalars['Int32']['output'];
  itemPriceOption: ItemPriceOption;
  itemPriceOptionID: Scalars['Int32']['output'];
  shopID: Scalars['Int32']['output'];
  ticketID: Scalars['Int32']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 廚房單 x 標籤 */
export type LinkTicketKitchenLabel = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  label: Label;
  labelID: Scalars['Int32']['output'];
  shopID: Scalars['Int32']['output'];
  ticketID: Scalars['Int32']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 廚房單 x 標籤群組 */
export type LinkTicketKitchenLabelGroup = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  labelGroup: LabelGroup;
  labelGroupID: Scalars['Int32']['output'];
  shopID: Scalars['Int32']['output'];
  ticketID: Scalars['Int32']['output'];
  workspaceID: Scalars['UUID']['output'];
};

export type LinkTicketOrderItemCategory = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  itemCategory: ItemCategory;
  itemCategoryID: Scalars['Int32']['output'];
  shopID: Scalars['Int32']['output'];
  ticketID: Scalars['Int32']['output'];
  workspaceID: Scalars['UUID']['output'];
};

export type LinkTicketOrderItemPriceOption = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  item: Item;
  itemID: Scalars['Int32']['output'];
  itemPriceOption: ItemPriceOption;
  itemPriceOptionID: Scalars['Int32']['output'];
  shopID: Scalars['Int32']['output'];
  ticketID: Scalars['Int32']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 貼紙 x 自訂備註 對應 */
export type LinkTicketStickerCustomizedNote = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  shopID: Scalars['Int32']['output'];
  ticketCustomizedNote: TicketStickerCustomizedNote;
  ticketCustomizedNoteID: Scalars['Int32']['output'];
  ticketStickerID: Scalars['Int32']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 貼紙 x 商品分類 對應 */
export type LinkTicketStickerItemCategory = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  itemCategory: ItemCategory;
  itemCategoryID: Scalars['Int32']['output'];
  shopID: Scalars['Int32']['output'];
  ticketID: Scalars['Int32']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 貼紙 x 售價選項 對應 */
export type LinkTicketStickerItemPriceOption = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  item: Item;
  itemID: Scalars['Int32']['output'];
  itemPriceOption: ItemPriceOption;
  itemPriceOptionID: Scalars['Int32']['output'];
  shopID: Scalars['Int32']['output'];
  ticketID: Scalars['Int32']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 貼紙 x 標籤 對應 */
export type LinkTicketStickerLabel = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  label: Label;
  labelID: Scalars['Int32']['output'];
  shopID: Scalars['Int32']['output'];
  ticketID: Scalars['Int32']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 貼紙 x 標籤群組 對應 */
export type LinkTicketStickerLabelGroup = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  labelGroup: LabelGroup;
  labelGroupID: Scalars['Int32']['output'];
  shopID: Scalars['Int32']['output'];
  ticketID: Scalars['Int32']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 虛擬印表機 與 實體印表機 對應 */
export type LinkVPrinterPPrinter = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  pPrinter: PPrinter;
  pPrinterID: Scalars['Int32']['output'];
  shopID: Scalars['Int32']['output'];
  vPrinter: VPrinter;
  vPrinterID: Scalars['Int32']['output'];
  workspaceID: Scalars['UUID']['output'];
};

export type ListAiWaiterVoiceOptionsInput = {
  brandKey: BrandKey;
  virtualHumanID: Scalars['UUID']['input'];
};

export type ListConfigLoyaltyData = {
  confLoyaltyProgram?: Maybe<ConfLoyaltyProgram>;
};

export type ListConfigLoyaltyResponse = {
  data: ListConfigLoyaltyData;
  success: Scalars['Boolean']['output'];
};

export type ListInvoiceSettingResp = {
  shopInvoiceSetting?: Maybe<ShopInvoiceSetting>;
  subscriberSetting?: Maybe<SubscriberSetting>;
  taxation: Array<Maybe<Taxation>>;
};

export type ListRoleResponse = {
  activate: Scalars['Boolean']['output'];
  of: Scalars['String']['output'];
  roleCode: Scalars['String']['output'];
  roleCount: Scalars['Int32']['output'];
  roleDescription: Scalars['String']['output'];
  roleID: Scalars['Int32']['output'];
  roleName: Scalars['String']['output'];
  roleTemplateID: Scalars['UUID']['output'];
};

export type ListServicewareResponse = {
  /** 使用商品數量；以關聯商品價位筆數計算 */
  itemCount: Scalars['Int32']['output'];
  /** 使用標籤數量；以關聯標籤筆數計算 */
  labelCount: Scalars['Int32']['output'];
  serviceware: Serviceware;
};

export type ListSpendAnalysisOutput = {
  average: Scalars['Decimal']['output'];
  itemPreferences: Array<Maybe<Purchase>>;
  labelPreferences: Array<Maybe<Purchase>>;
  miseedReservation?: Maybe<Scalars['Int16']['output']>;
  missedOrder?: Maybe<Scalars['Int16']['output']>;
  spendCount: Scalars['Int16']['output'];
  spendTotal: Scalars['Decimal']['output'];
};

export enum Locales {
  EnUs = 'en_US',
  JaJp = 'ja_JP',
  KoKr = 'ko_KR',
  ZhTw = 'zh_TW',
}

export type LoginRole = {
  displayID: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  of: PermissionScope;
  roleID: Scalars['Int32']['output'];
  roleTemplateID: Scalars['UUID']['output'];
};

/** 登入來源 */
export enum LoginSource {
  /** Android */
  Android = 'Android',
  /** 瀏覽器 */
  Browser = 'Browser',
  /** iOS */
  IOs = 'iOS',
}

export type MainPageCdsCarouselAdInput = {
  adID?: InputMaybe<Scalars['Int32']['input']>;
  /** 顯示順序 */
  displayOrder: Scalars['Int16']['input'];
};

export type MainPageCdsFixedAdInput = {
  adID?: InputMaybe<Scalars['Int32']['input']>;
  /** 顯示順序 */
  displayOrder: Scalars['Int16']['input'];
};

export type Mbrand = {
  createdAt: Scalars['DateTimeZ']['output'];
  mbrandID: Scalars['Int32']['output'];
  /** 品牌名稱 */
  name: Scalars['String']['output'];
  organizationID: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
};

/** 總部餐別設定 */
export type MealSession = {
  /** 是否啟用 */
  activate: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 顯示順序 */
  displayOrder: Scalars['Int16']['output'];
  /** 結束時間 */
  endTime: Scalars['Time']['output'];
  mealSessionID: Scalars['Int32']['output'];
  /** 餐別取餐時間 */
  mealSessionPickupTimes: Array<MealSessionPickupTime>;
  /** 餐別名稱 */
  name: Scalars['String']['output'];
  /** 開始時間 */
  startTime: Scalars['Time']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 餐別取餐時間設定 */
export type MealSessionPickupTime = {
  createdAt: Scalars['DateTimeZ']['output'];
  /** 顯示順序 */
  displayOrder: Scalars['Int16']['output'];
  mealSession: MealSession;
  mealSessionID: Scalars['Int32']['output'];
  mealSessionPickupTimeID: Scalars['Int32']['output'];
  /** 取餐時間 */
  pickupTime: Scalars['Time']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type Member = {
  /** 啟用 */
  activate: Scalars['Boolean']['output'];
  /** 生日 */
  birthday?: Maybe<Scalars['Date']['output']>;
  card?: Maybe<MemberCard>;
  /** 電話  e.164 */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** 國別 */
  countryID: Scalars['String']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 預設地址 */
  defaultAddressID?: Maybe<Scalars['UUID']['output']>;
  e164CountryCode?: Maybe<E164CountryCode>;
  /** 電子郵件 */
  email?: Maybe<Scalars['String']['output']>;
  /** 姓名 */
  fullName?: Maybe<Scalars['String']['output']>;
  /** 性別 */
  gender: Gender;
  /** 語言 */
  languageID: Scalars['String']['output'];
  /** 最後登入時間 */
  lastLoginAt?: Maybe<Scalars['DateTimeZ']['output']>;
  memberAddress: Array<MemberAddress>;
  /** 會員編號 */
  memberCode: Scalars['String']['output'];
  memberID: Scalars['UUID']['output'];
  /** 會員備註 */
  note?: Maybe<Scalars['String']['output']>;
  /** 組織 */
  organization: Organization;
  /** 組織ID */
  organizationID: Scalars['UUID']['output'];
  /** 密碼雜湊 */
  passwordHash: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  /** 頭像位址 */
  portraitUrl?: Maybe<Scalars['String']['output']>;
  /** 其它資訊 */
  preferences?: Maybe<Scalars['JSON']['output']>;
  /** 服務公司 */
  serviceCompanyName?: Maybe<Scalars['String']['output']>;
  source: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  /** 是否已驗證 */
  validated: Scalars['Boolean']['output'];
  wallet?: Maybe<PointWallet>;
  workspaceMember?: Maybe<WorkspaceMember>;
};

export type MemberActivity = {
  activityID: Scalars['UUID']['output'];
  /** 活動內容 */
  content: Scalars['JSON']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 會員 */
  member: Member;
  /** 會員ID */
  memberID: Scalars['UUID']['output'];
};

export type MemberAddress = {
  addressID: Scalars['UUID']['output'];
  /** 聯絡地址 */
  contactAddress: Scalars['JSON']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  memberID: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
};

export type MemberAddressInput = {
  addressID?: InputMaybe<Scalars['UUID']['input']>;
  contactAddress: Scalars['JSON']['input'];
};

export type MemberAddressView = {
  addressID: Scalars['UUID']['output'];
  fields: Array<AddressFieldView>;
};

export type MemberCsvInput = {
  /** 匯出會員csv欄位 */
  columnIndices: MemberColumnIndices;
  /** 語系 */
  locale: Locales;
  /** 搜尋 */
  search?: InputMaybe<Scalars['String']['input']>;
  /** 搜尋關鍵字 */
  searchCondition?: InputMaybe<MemberSearchCondition>;
  /** 搜尋會員列表(篩選條件) */
  searchParams?: InputMaybe<MemberSearchParams>;
  shopKey: ShopKey;
  /** 排序 (欄位) */
  sortField: Scalars['String']['input'];
  /** 排序 (升/降) */
  sortOrder: SortOrder;
  /** 時區 */
  timezone: Scalars['String']['input'];
};

export type MemberCard = {
  /** 啟用 */
  activate: Scalars['Boolean']['output'];
  /** 會員卡號 */
  cardCode: Scalars['String']['output'];
  cardID: Scalars['UUID']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 會員 */
  member: Member;
  /** 會員ID */
  memberID: Scalars['UUID']['output'];
  /** 制度規則 */
  program: ConfLoyaltyProgram;
  /** 制度規則ID */
  programID: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
};

export type MemberCardSetting = {
  /** 會員卡啟用狀態 */
  activate: Scalars['Boolean']['output'];
  /** 是否允許在POS註冊 */
  allowedRegisterByPos: Scalars['Boolean']['output'];
  /** 品牌ID */
  brandID?: Maybe<Scalars['Int32']['output']>;
  createdAt: Scalars['DateTimeZ']['output'];
  memberCardSettingID: Scalars['UUID']['output'];
  /** 會員來源ID */
  memberSourceID: Scalars['UUID']['output'];
  /** 隱私條款 */
  privacyTerms: Scalars['String']['output'];
  /** 註冊時顯示隱私條款 */
  showPrivacyTermsOnRegister: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  /** 總部ID */
  workspaceID: Scalars['UUID']['output'];
};

export type MemberCardSettingInput = {
  /** 允許POS端註冊 */
  allowedRegisterByPos: Scalars['Boolean']['input'];
  memberSourceID: Scalars['UUID']['input'];
  /** 隱私條款 */
  privacyTerms: Scalars['String']['input'];
  /** 顯示隱私條款 */
  showPrivacyTermsOnRegister: Scalars['Boolean']['input'];
};

export enum MemberCardType {
  /** 品牌卡 */
  BrandCard = 'BrandCard',
  /** 總部卡 */
  WorkspaceCard = 'WorkspaceCard',
}

export type MemberCardTypeInput = {
  cardType: MemberCardType;
  workspaceID: Scalars['UUID']['input'];
};

export type MemberCardTypeSetting = {
  /** 會員卡種類 */
  cardType: MemberCardType;
  createdAt: Scalars['DateTimeZ']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspaceID: Scalars['UUID']['output'];
};

export type MemberColumnIndices = {
  /** 狀態 */
  activate?: InputMaybe<Scalars['Int16']['input']>;
  /** 累積消費總額 */
  amount?: InputMaybe<Scalars['Int16']['input']>;
  /** 會員點數 */
  balance?: InputMaybe<Scalars['Int16']['input']>;
  /** 會員卡號 */
  cardCode?: InputMaybe<Scalars['Int16']['input']>;
  /** 消費次數 */
  count?: InputMaybe<Scalars['Int16']['input']>;
  /** 電子信箱 */
  email?: InputMaybe<Scalars['Int16']['input']>;
  /** 最後消費日期 */
  lastConsumeAt?: InputMaybe<Scalars['Int16']['input']>;
  /** 姓名 */
  name?: InputMaybe<Scalars['Int16']['input']>;
  /** 電話 */
  phone?: InputMaybe<Scalars['Int16']['input']>;
  /** 註冊時間 */
  registerAt?: InputMaybe<Scalars['Int16']['input']>;
  /** 會員來源 */
  source?: InputMaybe<Scalars['Int16']['input']>;
};

export type MemberDetails = {
  addressViews: Array<MemberAddressView>;
  member: Member;
  workspaceMemberTags: Array<WorkspaceMemberTag>;
};

export type MemberPagination = {
  members: Array<Member>;
  pageInfo: CursorPageInfo;
};

export type MemberPreferencesInput = {
  /** 會員載具 */
  carrierID?: InputMaybe<Scalars['String']['input']>;
  /** 捐贈條碼 */
  donationBarcode?: InputMaybe<Scalars['String']['input']>;
  /** 統一編號 */
  uniformNumber?: InputMaybe<Scalars['String']['input']>;
};

/** 搜尋關鍵字 */
export enum MemberSearchCondition {
  /** 會員卡號 */
  CardCode = 'CardCode',
  /** 電子信箱 */
  Email = 'Email',
  /** 姓名 */
  Name = 'Name',
  /** 電話 */
  Phone = 'Phone',
}

export type MemberSearchParams = {
  activate?: InputMaybe<Scalars['Boolean']['input']>;
  lastConsumeAtRange?: InputMaybe<TimeRange>;
  registerAtRange?: InputMaybe<TimeRange>;
};

export type MemberSourceGroup = {
  cardType: MemberCardType;
  sources: Array<MemberSourceInfo>;
};

export type MemberSourceInfo = {
  activate: Scalars['Boolean']['output'];
  displayName: Scalars['String']['output'];
  memberSourceID: Scalars['UUID']['output'];
  providerCode: Scalars['String']['output'];
};

export type MembershipConfig = {
  brandID?: Maybe<Scalars['Int32']['output']>;
  confLoyaltyProgram?: Maybe<ConfLoyaltyProgram>;
  confPointEarnExtraItem?: Maybe<Array<Maybe<ConfPointEarnExtraItem>>>;
  confPointRedeemDiscount?: Maybe<ConfPointRedeemDiscount>;
  confProgramParticipant?: Maybe<Array<Maybe<ConfProgramParticipant>>>;
  confProgramPointEarnRule?: Maybe<ConfProgramPointEarnRule>;
  confProgramRedeemItem?: Maybe<ConfProgramRedeemItem>;
  memberCardSetting?: Maybe<MemberCardSetting>;
  memberCardTypeSetting?: Maybe<MemberCardTypeSetting>;
  workspaceID: Scalars['UUID']['output'];
};

export type MembershipConfigInput = {
  /** 背景圖片 */
  bgImage?: InputMaybe<Scalars['Upload']['input']>;
  /** 刪除背景圖片 */
  clearBg: Scalars['Boolean']['input'];
  /** 刪除Logo圖片 */
  clearLogo: Scalars['Boolean']['input'];
  confLoyaltyProgram?: InputMaybe<ConfLoyaltyProgramInput>;
  /** 指定商品加贈點數 */
  confPointEarnExtraItem?: InputMaybe<Array<ConfPointEarnExtraItemInput>>;
  /** 點數消費折抵 */
  confPointRedeemDiscount?: InputMaybe<ConfPointRedeemDiscountInput>;
  /** 參與門市 */
  confProgramParticipant?: InputMaybe<Array<ConfProgramParticipantInput>>;
  /** 點數消費集點 */
  confProgramPointEarnRule?: InputMaybe<ConfProgramPointEarnRuleInput>;
  /** 點數兌換商品 */
  confProgramRedeemItem?: InputMaybe<ConfProgramRedeemItemInput>;
  /** LOGO圖片 */
  logoImage?: InputMaybe<Scalars['Upload']['input']>;
  memberCardSetting: MemberCardSettingInput;
  memberCardSettingID?: InputMaybe<Scalars['UUID']['input']>;
  programID?: InputMaybe<Scalars['UUID']['input']>;
};

/** 菜單 */
export type Menu = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 使用門市 */
  linkShopMenus: Array<LinkShopMenu>;
  /** 菜單分類 */
  menuCategories: Array<MenuCategory>;
  menuID: Scalars['Int32']['output'];
  /** 菜單商品 */
  menuItems: Array<MenuItem>;
  /** 菜單類型 */
  menuType: MenuType;
  /** 菜單名稱 */
  name: Scalars['String']['output'];
  /** 菜單名稱(多語系) */
  nameLang: MultiLang;
  /** POS 菜單格數：欄 */
  posGridCols: Scalars['Int16']['output'];
  /** POS 菜單格數：列 */
  posGridRows: Scalars['Int16']['output'];
  /** POS 菜單鍵盤模式 */
  posKeyboardMode: PosMenuKeyboardMode;
  supplyHours?: Maybe<MenuSupplyHourType>;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 菜單分類 */
export type MenuCategory = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 顯示順序 */
  displayOrder: Scalars['Int16']['output'];
  menu: Menu;
  menuCategoryID: Scalars['Int32']['output'];
  /** 菜單分類商品 */
  menuCategoryMenuItems: Array<MenuCategoryMenuItem>;
  menuID: Scalars['Int32']['output'];
  /** 菜單分類名稱 */
  name: Scalars['String']['output'];
  /** 菜單分類名稱(多語系) */
  nameLang: MultiLang;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type MenuCategoryKey = {
  brandID: Scalars['Int32']['input'];
  menuCategoryID: Scalars['Int32']['input'];
  menuID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

/** 菜單分類商品 */
export type MenuCategoryMenuItem = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 列表顯示順序 */
  displayOrder: Scalars['Int16']['output'];
  menu: Menu;
  menuCategory: MenuCategory;
  menuCategoryID: Scalars['Int32']['output'];
  menuID: Scalars['Int32']['output'];
  menuItem: MenuItem;
  menuItemID: Scalars['Int32']['output'];
  /** POS 顯示位置行 */
  posDisplayCol: Scalars['Int16']['output'];
  /** POS 顯示位置列 */
  posDisplayRow: Scalars['Int16']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type MenuCategoryMenuItemInput = {
  brandID: Scalars['Int32']['input'];
  /** 列表顯示順序 */
  displayOrder: Scalars['Int16']['input'];
  menuCategoryID: Scalars['Int32']['input'];
  menuID: Scalars['Int32']['input'];
  /** createMenuItem時不帶menuItemID，updateMenuItem時必填 */
  menuItemID?: InputMaybe<Scalars['Int32']['input']>;
  /** POS 顯示位置行 */
  posDisplayCol?: InputMaybe<Scalars['Int16']['input']>;
  /** POS 顯示位置列 */
  posDisplayRow?: InputMaybe<Scalars['Int16']['input']>;
  workspaceID: Scalars['UUID']['input'];
};

export type MenuCategoryMenuItemKey = {
  brandID: Scalars['Int32']['input'];
  menuCategoryID: Scalars['Int32']['input'];
  menuID: Scalars['Int32']['input'];
  menuItemID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

/** 菜單詳情 */
export type MenuDetails = {
  menu: Menu;
  /** 菜單公休日 */
  menuOffDays: Array<MenuOffDay>;
  /** 菜單時段 */
  menuSupplyHours: Array<MenuSupplyHour>;
};

/** 菜單商品 */
export type MenuItem = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  item: Item;
  itemID: Scalars['Int32']['output'];
  menu: Menu;
  /** 菜單分類商品 */
  menuCategoryMenuItems: Array<MenuCategoryMenuItem>;
  menuID: Scalars['Int32']['output'];
  menuItemID: Scalars['Int32']['output'];
  /** 已選品牌用餐方式 */
  selectedBrandDiningOptions: Array<LinkMenuItemBrandDiningOption>;
  /** 已選商品價位 */
  selectedItemPriceOptions: Array<LinkMenuItemItemPriceOption>;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type MenuItemKey = {
  brandID: Scalars['Int32']['input'];
  menuID: Scalars['Int32']['input'];
  menuItemID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

export type MenuKey = {
  brandID: Scalars['Int32']['input'];
  menuID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

export type MenuListItem = {
  menuID: Scalars['Int32']['output'];
  menuSupplyHours: Array<MenuSupplyHour>;
  menuType: MenuType;
  name: Scalars['String']['output'];
  nameLang?: Maybe<MultiLang>;
  usage: Array<MenuUsageGroup>;
};

export type MenuListPagination = {
  menus?: Maybe<Array<MenuListItem>>;
  pageInfo: CursorPageInfo;
};

/** 菜單公休日 */
export type MenuOffDay = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  menu: Menu;
  menuID: Scalars['Int32']['output'];
  offDay: Scalars['Date']['output'];
  offDayID: Scalars['Int32']['output'];
  workspaceID: Scalars['UUID']['output'];
};

export type MenuOffDayInput = {
  offDay: Scalars['Date']['input'];
  offDayID?: InputMaybe<Scalars['Int32']['input']>;
};

/** 查詢分頁結果 */
export type MenuPagination = {
  menus?: Maybe<Array<Menu>>;
  pageInfo: CursorPageInfo;
};

/** 預約餐商品取餐數量限制 */
export type MenuPreorderQuantityLimit = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 預約餐數量限制類型 */
  limitType: MenuPreorderQuantityLimitType;
  mealSession?: Maybe<MealSession>;
  mealSessionID?: Maybe<Scalars['Int32']['output']>;
  mealSessionPickupTime?: Maybe<MealSessionPickupTime>;
  mealSessionPickupTimeID?: Maybe<Scalars['Int32']['output']>;
  menuID: Scalars['Int32']['output'];
  menuItem: MenuItem;
  menuItemID: Scalars['Int32']['output'];
  menuPreorderQuantityLimitID: Scalars['Int32']['output'];
  /** 取餐數量上限 */
  quantityLimit?: Maybe<Scalars['Int32']['output']>;
  /** 販售日期 */
  saleDate?: Maybe<Scalars['Date']['output']>;
  updatedAt: Scalars['DateTimeZ']['output'];
  /** 已使用數量紀錄 */
  usages: Array<MenuPreorderQuantityLimitUsage>;
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 預約餐數量限制類型 */
export enum MenuPreorderQuantityLimitType {
  /** 依照餐別 */
  ByMeal = 'ByMeal',
  /** 依照餐別日期 */
  ByMealDate = 'ByMealDate',
  /** 不限制 */
  NoLimit = 'NoLimit',
  /** 整天 */
  WholeDay = 'WholeDay',
}

/** 預約餐商品數量限制已使用數量紀錄 */
export type MenuPreorderQuantityLimitUsage = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  menuPreorderQuantityLimit: MenuPreorderQuantityLimit;
  menuPreorderQuantityLimitID: Scalars['Int32']['output'];
  menuPreorderQuantityLimitUsageID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  /** 目前已使用的數量 */
  usedQuantity: Scalars['Int32']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 預約餐日曆排餐 */
export type MenuPreorderSchedule = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  mealSession: MealSession;
  mealSessionID: Scalars['Int32']['output'];
  menuID: Scalars['Int32']['output'];
  menuItem: MenuItem;
  menuItemID: Scalars['Int32']['output'];
  menuPreorderScheduleID: Scalars['Int32']['output'];
  /** 販售日期 */
  saleDate: Scalars['Date']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 跨服務菜單 provisioning durable idempotency 與補償所有權紀錄 */
export type MenuProvisionRecord = {
  brandID: Scalars['Int32']['output'];
  correlationID: Scalars['UUID']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  menuID?: Maybe<Scalars['Int32']['output']>;
  provider: OnlineOrderProvider;
  shopID: Scalars['Int32']['output'];
  sourceStoreID: Scalars['String']['output'];
  status: MenuProvisionStatus;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 跨服務菜單 provisioning 狀態 */
export enum MenuProvisionStatus {
  Compensated = 'Compensated',
  Provisioned = 'Provisioned',
  Provisioning = 'Provisioning',
}

export enum MenuSortField {
  CreatedAt = 'createdAt',
  Name = 'name',
  UpdatedAt = 'updatedAt',
}

/** 外部菜單來源識別與 DD3 target registry */
export type MenuSourceEntity = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  entityType: MenuSourceEntityType;
  firstSeenRunID: Scalars['UUID']['output'];
  lastSeenRunID: Scalars['UUID']['output'];
  provider: OnlineOrderProvider;
  shopID: Scalars['Int32']['output'];
  sourceEntityPK: Scalars['Int64']['output'];
  sourceID: Scalars['String']['output'];
  sourceMenuID: Scalars['String']['output'];
  sourceParentID: Scalars['String']['output'];
  sourceStoreID: Scalars['String']['output'];
  stableSourceKey: Scalars['String']['output'];
  targetRef: Scalars['JSON']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 外部菜單來源實體類型 */
export enum MenuSourceEntityType {
  Category = 'Category',
  Item = 'Item',
  Label = 'Label',
  LabelGroup = 'LabelGroup',
}

/** 外部菜單 staging/published CAS head */
export type MenuSourceHead = {
  brandID: Scalars['Int32']['output'];
  provider: OnlineOrderProvider;
  publishedHash?: Maybe<Scalars['String']['output']>;
  publishedRunID?: Maybe<Scalars['UUID']['output']>;
  publishedVersion?: Maybe<Scalars['String']['output']>;
  shopID: Scalars['Int32']['output'];
  sourceMenuID: Scalars['String']['output'];
  sourceStoreID: Scalars['String']['output'];
  stagingHash?: Maybe<Scalars['String']['output']>;
  stagingRunID?: Maybe<Scalars['UUID']['output']>;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 外部菜單發佈 outbox 狀態 */
export enum MenuSourceOutboxStatus {
  DeadLetter = 'DeadLetter',
  Delivered = 'Delivered',
  Failed = 'Failed',
  Pending = 'Pending',
  Processing = 'Processing',
}

/** 外部菜單 transactional publish outbox */
export type MenuSourcePublishOutbox = {
  attempts: Scalars['Int32']['output'];
  availableAt: Scalars['DateTimeZ']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  eventID: Scalars['UUID']['output'];
  eventType: Scalars['String']['output'];
  lastError?: Maybe<Scalars['String']['output']>;
  lockedUntil?: Maybe<Scalars['DateTimeZ']['output']>;
  payload: Scalars['JSON']['output'];
  runID: Scalars['UUID']['output'];
  status: MenuSourceOutboxStatus;
  updatedAt: Scalars['DateTimeZ']['output'];
};

/** 經驗證的 POS 菜單發佈 receipt */
export type MenuSourcePublishReceipt = {
  canonicalHash: Scalars['String']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  evidenceDigest: Scalars['String']['output'];
  posVersion: Scalars['String']['output'];
  receipt: Scalars['JSON']['output'];
  receiptID: Scalars['String']['output'];
  runID: Scalars['UUID']['output'];
  verifiedAt: Scalars['DateTimeZ']['output'];
};

/** 外部菜單不可變同步執行與 staging snapshot */
export type MenuSourceSyncRun = {
  brandID: Scalars['Int32']['output'];
  canonicalHash: Scalars['String']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  errorCode?: Maybe<Scalars['String']['output']>;
  errorSummary?: Maybe<Scalars['String']['output']>;
  expectedPublishedHash?: Maybe<Scalars['String']['output']>;
  idempotencyKey: Scalars['String']['output'];
  mappingProjection: Scalars['JSON']['output'];
  normalizedMenu: Scalars['JSON']['output'];
  provider: OnlineOrderProvider;
  publishAttempts: Scalars['Int32']['output'];
  publishedAt?: Maybe<Scalars['DateTimeZ']['output']>;
  requestDigest: Scalars['String']['output'];
  runID: Scalars['UUID']['output'];
  shopID: Scalars['Int32']['output'];
  sourceMenuID: Scalars['String']['output'];
  sourceStoreID: Scalars['String']['output'];
  stage: MenuSourceSyncStage;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 外部菜單同步執行階段 */
export enum MenuSourceSyncStage {
  Applied = 'Applied',
  FailedPublish = 'FailedPublish',
  Published = 'Published',
  Publishing = 'Publishing',
  Superseded = 'Superseded',
}

/** 菜單供應時段 */
export type MenuSupplyHour = {
  activate: Scalars['Boolean']['output'];
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  endTime: Scalars['Time']['output'];
  hourID: Scalars['Int32']['output'];
  menu: Menu;
  menuID: Scalars['Int32']['output'];
  startTime: Scalars['Time']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  weekDay: Scalars['Int16']['output'];
  workspaceID: Scalars['UUID']['output'];
};

export type MenuSupplyHourInput = {
  endTime: Scalars['Time']['input'];
  hourID?: InputMaybe<Scalars['Int32']['input']>;
  startTime: Scalars['Time']['input'];
  weekDay: Scalars['Int16']['input'];
};

/** 菜單供應時間類型 */
export enum MenuSupplyHourType {
  /** 每週 */
  ByWeekdays = 'ByWeekdays',
  /** 固定 */
  Fixed = 'Fixed',
}

/** 菜單類型 */
export enum MenuType {
  /** FoodPanda */
  Fp = 'FP',
  /** 線上點餐 */
  OnlineOrder = 'OnlineOrder',
  /** POS */
  Pos = 'POS',
  /** 預約餐 */
  PreOrder = 'PreOrder',
  /** 掃碼點餐 */
  ScanOrder = 'ScanOrder',
  /** Uber Eats */
  Ue = 'UE',
}

export type MenuUsageGroup = {
  shops: Array<MenuUsageShop>;
  subBrand?: Maybe<SubBrand>;
};

export type MenuUsageShop = {
  shop: Shop;
  syncAt?: Maybe<Scalars['DateTimeZ']['output']>;
  syncStatus?: Maybe<ShopMenuSyncStatus>;
};

/** 低消設定 */
export type MinCharge = {
  /** 費用顯示名稱 */
  advName: Scalars['String']['output'];
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 是否啟用低消 */
  enabled: Scalars['Boolean']['output'];
  /** 低消排除計算的商品 */
  exclItems: Array<MinChargeExclItem>;
  /** 計費對象-成人 */
  includeAdult: Scalars['Boolean']['output'];
  /** 計費對象-兒童 */
  includeChild: Scalars['Boolean']['output'];
  /** 達標計算方式 */
  minChargeAchieveMethod: MinChargeAchieveMethod;
  /** 低消模式選擇 */
  minChargeMode: MinChargeMode;
  /** 單點商品折抵方式 */
  minChargeSingleItemOffsetMode?: Maybe<MinChargeSingleItemOffsetMode>;
  /** 單點商品合計滿固定金額可折抵一位低消之金額 */
  minChargeSingleItemThresholdAmount?: Maybe<Scalars['Decimal']['output']>;
  /** 每人需消費金額 */
  minChargeUnifiedThresholdAmount?: Maybe<Scalars['Decimal']['output']>;
  /** 未達低消時收取方式 */
  minChargeUnmetAction: MinChargeUnmetAction;
  /** 收取固定金額之金額 */
  minChargeUnmetFixedAmount?: Maybe<Scalars['Decimal']['output']>;
  /** 低消套用用餐方式 */
  selDiningOptions: Array<MinChargeSelDiningOption>;
  shop: Shop;
  /** 用餐方式套用模式 */
  shopDiningOptionApplyMode: ShopDiningOptionApplyMode;
  shopID: Scalars['Int32']['output'];
  /** 低消稅別 */
  taxCategory: TaxCategory;
  /** 低消稅金群組 */
  taxGroup?: Maybe<TaxGroup>;
  /** 低消稅金群組 ID */
  taxGroupID?: Maybe<Scalars['Int16']['output']>;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 達標計算方式 */
export enum MinChargeAchieveMethod {
  /** 不含服務費 */
  ExcludeServiceFee = 'ExcludeServiceFee',
  /** 含服務費 */
  IncludeServiceFee = 'IncludeServiceFee',
}

/** 低消排除計算商品 */
export type MinChargeExclItem = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  item: Item;
  /** 商品 */
  itemID: Scalars['Int32']['output'];
  minCharge: MinCharge;
  shopID: Scalars['Int32']['output'];
  workspaceID: Scalars['UUID']['output'];
};

export type MinChargeInput = {
  /** 費用顯示名稱 */
  advName: Scalars['String']['input'];
  /** 是否啟用低消 */
  enabled: Scalars['Boolean']['input'];
  /** 低消排除計算的商品 */
  exclItems?: InputMaybe<Array<InputMaybe<Scalars['Int32']['input']>>>;
  /** 計費對象-成人 */
  includeAdult: Scalars['Boolean']['input'];
  /** 計費對象-兒童 */
  includeChild: Scalars['Boolean']['input'];
  /** 達標計算方式 */
  minChargeAchieveMethod: MinChargeAchieveMethod;
  /** 低消模式選擇 */
  minChargeMode: MinChargeMode;
  /** 單點商品折抵方式 */
  minChargeSingleItemOffsetMode?: InputMaybe<MinChargeSingleItemOffsetMode>;
  /** 單點商品合計滿固定金額可折抵一位低消之金額 */
  minChargeSingleItemThresholdAmount?: InputMaybe<Scalars['Decimal']['input']>;
  /** 每人需消費金額 */
  minChargeUnifiedThresholdAmount?: InputMaybe<Scalars['Decimal']['input']>;
  /** 未達低消時收取方式 */
  minChargeUnmetAction: MinChargeUnmetAction;
  /** 收取固定金額之金額 */
  minChargeUnmetFixedAmount?: InputMaybe<Scalars['Decimal']['input']>;
  /** 低消套用用餐方式 */
  selDiningOptions?: InputMaybe<Array<InputMaybe<Scalars['Int32']['input']>>>;
  /** 用餐方式套用模式 */
  shopDiningOptionApplyMode: ShopDiningOptionApplyMode;
  /** 低消稅別 */
  taxCategory: TaxCategory;
  /** 低消稅金群組 ID */
  taxGroupID?: InputMaybe<Scalars['Int16']['input']>;
};

/** 低消模式選擇 */
export enum MinChargeMode {
  /** 套餐與單點分開計算 */
  Separate = 'Separate',
  /** 所有餐點統一計算 */
  Unified = 'Unified',
}

/** 低消套用用餐方式 */
export type MinChargeSelDiningOption = {
  /** 用餐方式 */
  brandDiningOptionID: Scalars['Int32']['output'];
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  minCharge: MinCharge;
  shopDiningOption: ShopDiningOption;
  shopID: Scalars['Int32']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 單點商品低消折抵方式 */
export enum MinChargeSingleItemOffsetMode {
  /** 滿固定金額可折抵一位低消 */
  FixedAmount = 'FixedAmount',
  /** 不可折抵低消 */
  NotAllowed = 'NotAllowed',
}

/** 未達低消時收取方式 */
export enum MinChargeUnmetAction {
  /** 低消費用差額 */
  ChargeDifference = 'ChargeDifference',
  /** 固定金額 */
  ChargeFixed = 'ChargeFixed',
}

export type Mshop = {
  createdAt: Scalars['DateTimeZ']['output'];
  mbrandID: Scalars['Int32']['output'];
  mshopID: Scalars['Int32']['output'];
  /** 門市名稱 */
  name: Scalars['String']['output'];
  organizationID: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
};

export type MultiLang = {
  en_US: Scalars['String']['output'];
  ja_JP?: Maybe<Scalars['String']['output']>;
  ko_KR?: Maybe<Scalars['String']['output']>;
  zh_TW: Scalars['String']['output'];
};

export type MultiLangInput = {
  en_US: Scalars['String']['input'];
  ja_JP?: InputMaybe<Scalars['String']['input']>;
  ko_KR?: InputMaybe<Scalars['String']['input']>;
  zh_TW: Scalars['String']['input'];
};

export type MultiShopBrandGroup = {
  brandID: Scalars['Int32']['output'];
  brandName: Scalars['String']['output'];
  subBrands: Array<MultiShopSubBrandGroup>;
};

export type MultiShopPage = {
  brandID?: Maybe<Scalars['Int32']['output']>;
  brandName?: Maybe<Scalars['String']['output']>;
  lineOAURL?: Maybe<Scalars['String']['output']>;
  pageID?: Maybe<Scalars['UUID']['output']>;
  pageName?: Maybe<Scalars['String']['output']>;
  selectedShopsCount: Scalars['Int']['output'];
  webURL: Scalars['String']['output'];
  workspaceID: Scalars['UUID']['output'];
};

export type MultiShopPagePagination = {
  pageInfo: CursorPageInfo;
  pages: Array<MultiShopPage>;
};

export type MultiShopShop = {
  name: Scalars['String']['output'];
  shopID: Scalars['Int32']['output'];
};

export type MultiShopShopsResult = {
  /** 跨品牌時回傳此欄位 */
  brands?: Maybe<Array<MultiShopBrandGroup>>;
  /** 同品牌時回傳此欄位 */
  subBrands?: Maybe<Array<MultiShopSubBrandGroup>>;
};

export type MultiShopSubBrandGroup = {
  shops: Array<MultiShopShop>;
  subBrandID?: Maybe<Scalars['Int32']['output']>;
  subBrandName: Scalars['String']['output'];
};

export type Mutation = {
  /** 啟用或停用會員卡 */
  activateMemberCard: Scalars['Boolean']['output'];
  /** 新增品牌用餐方式 */
  addBrandDiningOptions: Array<BrandDiningOption>;
  /** 增量新增會員標籤 */
  addMemberTags: Scalars['Boolean']['output'];
  /** 新增實體出單機與虛擬出單機的link(配對使用) */
  addPPrinterLinks: Scalars['Boolean']['output'];
  /** 新增發佈 */
  addPublishTask: Scalars['Boolean']['output'];
  addRole: ListRoleResponse;
  /** 同步資料上傳 */
  addSyncData: Scalars['Boolean']['output'];
  /** 綁定員工電子郵件 */
  bindEmployeeEmail: Scalars['Boolean']['output'];
  bindShop?: Maybe<BindShopResponse>;
  bindTheDevice: Scalars['Boolean']['output'];
  /** 綁定總部會員 */
  bindWSMember: Scalars['Boolean']['output'];
  /** 取消系統發佈 */
  cancelPublishTask: Scalars['Boolean']['output'];
  /** 修改員工電子郵件 */
  changeEmployeeEmail: Scalars['Boolean']['output'];
  /** 修改密碼 */
  changeUserPassword: Scalars['Boolean']['output'];
  /** 複製優惠 */
  cloneADiscount: Scalars['Boolean']['output'];
  /** 複製出單樣式至同台出單/貼紙機 */
  copyATicketOfVPrinter: Scalars['Boolean']['output'];
  /** 複製鍵盤 */
  copyApplyKeypadToShops: Scalars['Boolean']['output'];
  /** 複製出單機設定 */
  copyApplyPrinterToShops: Scalars['Boolean']['output'];
  /** 複製桌位 */
  copyShopTable: ShopTable;
  /**
   * 複製單台出單機設定（來源 -> 目標）。
   *   使用說明：
   *   - 指定 destVPrinterKey：複製到現有出單機（需搭配 mode）。
   *   - 指定 destShopKey + printerInput：於目標門市新增出單機後再複製（忽略 mode）。
   */
  copyVPrinterStyles: Scalars['Boolean']['output'];
  /** 新增品牌支付方式 */
  createABrandPaymentMethod?: Maybe<Scalars['Int32']['output']>;
  /** 新增Bundle */
  createABundle: Bundle;
  /** 新增品牌支付方式群組 */
  createAGroupOfBrandPaymentMethods?: Maybe<Scalars['Int32']['output']>;
  /** 新增標籤 */
  createALabel?: Maybe<Label>;
  /** 新增標籤群組 */
  createALabelGroup: LabelGroup;
  createAPOS: Scalars['Boolean']['output'];
  /**
   * 新增 POS，並在同一個交易內一併綁定設備。
   * POS 建立與所有設備綁定要嘛全部成功、要嘛全部失敗，不會留下部分綁定的中間狀態。
   * equipments 為空或省略時等同單純新增 POS。
   */
  createAPOSWithEquipments: Scalars['Boolean']['output'];
  /** 新增稅金群組 */
  createATaxGroup: Scalars['Boolean']['output'];
  /** 新增稅金 */
  createATaxUnit: Scalars['Boolean']['output'];
  /** 新增出單樣式 */
  createATicket?: Maybe<Scalars['Int32']['output']>;
  /** 新增出單機 */
  createAVPrinter: VPrinter;
  /** 新增商品 */
  createItem?: Maybe<Scalars['Int32']['output']>;
  /** 新增商品分類 */
  createItemCategory?: Maybe<Scalars['Int32']['output']>;
  /** 新增鍵盤與套用商品 */
  createKeypadWItem?: Maybe<Scalars['Int32']['output']>;
  /** 加入會員 */
  createMember: Member;
  /** 新增菜單 */
  createMenu: Menu;
  createStopSale: Scalars['Boolean']['output'];
  /**
   * 為指定 POS 新增綁定設備。
   * appID 必須是 listBindableEquipmentApps 回傳的應用程式之一；
   * bindSettingID 必須是該應用程式於此門市已設定的串接參數其中一組的 id。
   */
  createTheVDeviceEquipment: Scalars['Boolean']['output'];
  /** 刪除品牌用餐方式 */
  delBrandDiningOptions: Scalars['Boolean']['output'];
  /** 刪除商品圖片 */
  delItemImages: Scalars['Boolean']['output'];
  /** 刪除店家圖片 */
  delShopImages: Scalars['Boolean']['output'];
  /** 刪除品牌用餐方式 */
  deleteABrandPaymentMethod: Scalars['Boolean']['output'];
  /** 刪除自訂出單樣式 */
  deleteACustomizedTicket: Scalars['Boolean']['output'];
  deleteAIWaiterVirtualHuman: DeleteAiWaiterVirtualHumanResponse;
  /** 刪除稅金群組 */
  deleteATaxGroup: Scalars['Boolean']['output'];
  /** 刪除稅金 */
  deleteATaxUnit: Scalars['Boolean']['output'];
  /** 刪除出單樣式 */
  deleteATicket: Scalars['Boolean']['output'];
  /** 刪除出單機 */
  deleteAVPrinter: Scalars['Boolean']['output'];
  /** 刪除Bundle */
  deleteBundles: Scalars['Boolean']['output'];
  /** 刪除CDS廣告 */
  deleteCDSAd: Scalars['Boolean']['output'];
  /** 刪除跨品牌入口頁設定 */
  deleteCrossBrandPortalSetting: Scalars['Boolean']['output'];
  deleteEmployee: Scalars['Boolean']['output'];
  deleteEmployeePortrait: Scalars['Boolean']['output'];
  /** 刪除商品分類 */
  deleteItemCategories: Scalars['Boolean']['output'];
  /** 刪除商品 */
  deleteItems: Scalars['Boolean']['output'];
  /** 刪除鍵盤 */
  deleteKeypad: Scalars['Boolean']['output'];
  /** 刪除標籤群組 */
  deleteLabelGroups: Scalars['Boolean']['output'];
  /** 刪除標籤 */
  deleteLabels: Scalars['Boolean']['output'];
  /** 批次刪除會員地址 */
  deleteMemberAddresses: Scalars['Boolean']['output'];
  /** 刪除菜單分類 */
  deleteMenuCategories: Scalars['Boolean']['output'];
  /** 刪除菜單 */
  deleteMenus: Scalars['Boolean']['output'];
  /** 刪除實體出單機 */
  deletePPrinter: Scalars['Boolean']['output'];
  /** 刪除logo圖片 */
  deletePrinterLogoImages: Scalars['Boolean']['output'];
  deleteRole: Scalars['Boolean']['output'];
  /** 刪除裝飾 */
  deleteShopAreaDecoration: Scalars['Boolean']['output'];
  /** 刪除桌位 */
  deleteShopTable: Scalars['Boolean']['output'];
  deleteStopSale: Scalars['Boolean']['output'];
  deleteTheVDevice: Scalars['Boolean']['output'];
  /** 刪除綁定設備 */
  deleteTheVDeviceEquipment: Scalars['Boolean']['output'];
  /** 停用/啟用品牌用餐方式 */
  disableBrandPaymentMethods: Scalars['Boolean']['output'];
  disableEmployee: Scalars['Boolean']['output'];
  /** 停售商品 */
  disableItems: Scalars['Boolean']['output'];
  disableRole: Scalars['Boolean']['output'];
  /** 解散品牌用餐方式群組 */
  disbandAGroupOfBrandPaymentMethods: Scalars['Boolean']['output'];
  /** 複製Bundle */
  duplicateABundle: Scalars['Boolean']['output'];
  /** 複製標籤群組 */
  duplicateALabelGroup: Scalars['Boolean']['output'];
  /** 複製商品 */
  duplicateItems: Array<Scalars['Int32']['output']>;
  /** 複製菜單 */
  duplicateMenu: Menu;
  duplicateRole: Scalars['Boolean']['output'];
  employeePinGenAndCheck: EmployeePinGenAndCheckResponse;
  exportAEodReportCSVFile: Scalars['String']['output'];
  exportAShiftCloseReportCSVFile: Scalars['String']['output'];
  exportCashDrawerTransactions: Scalars['String']['output'];
  exportCustomerListCSV: Scalars['String']['output'];
  exportDiscountsOverviewCSV: Scalars['String']['output'];
  exportEodReportsCSVFile: Scalars['String']['output'];
  /** 匯出發票csv */
  exportInvoicesCSVFile: Scalars['String']['output'];
  /** 匯出商品csv */
  exportItemsCSVFile: Scalars['String']['output'];
  exportItemsOverviewCSV: Scalars['String']['output'];
  exportLabelsOverviewCSV: Scalars['String']['output'];
  /** 匯出會員匯入模板csv */
  exportMemberImportTemplateCSV: Scalars['String']['output'];
  /** 匯出會員 */
  exportMemberListCSV: Scalars['String']['output'];
  exportOnlineOrderListCSV: Scalars['String']['output'];
  /** 匯出訂單csv */
  exportOrdersCSVFile: Scalars['String']['output'];
  exportShiftCloseReportsCSVFile: Scalars['String']['output'];
  /** 匯出交易csv */
  exportTransactionsCSVFile: Scalars['String']['output'];
  generateAIWaiterPreviewVideo: AiWaiterPreviewVideo;
  /** 匯入商品csv */
  importItemsCSVFile: ImportItemsCsvFileResponse;
  /** 匯入會員csv */
  importMembersCSVFile: ImportMembersCsvFileResponse;
  initPassword: Scalars['Boolean']['output'];
  linkEmployee: Scalars['Boolean']['output'];
  /** 使用者登入，取得 HMAC 密鑰（Web 與 IoT 共用） */
  login: Array<WorkspacePermission>;
  putAIWaiterVirtualHumanImage: PutAiWaiterVirtualHumanImageResponse;
  putAIWaiterVirtualHumanVoice: PutAiWaiterVirtualHumanVoiceResponse;
  /** 上傳商品圖片 */
  putItemImage: PutItemImageResponse;
  /** 上傳logo圖片 */
  putPrinterLogoImage: PrintLayoutBaseLogo;
  /** 上傳店家圖片 */
  putShopImage: Array<ShopImage>;
  /** 忘記密碼 */
  recoveryPassword: Scalars['Boolean']['output'];
  refreshGitToken: RefreshGitTokenResponse;
  /** 作廢訂單 */
  refundAnOrder: Scalars['Boolean']['output'];
  registerAsServiceHub: Scalars['Boolean']['output'];
  registerCDS: Scalars['Boolean']['output'];
  /** 增量移除會員標籤 */
  removeMemberTags: Scalars['Boolean']['output'];
  /** 移除實體出單機與虛擬出單機的link(配對使用) */
  removePPrinterLinks: Scalars['Boolean']['output'];
  /** 重設密碼 */
  resetPassword: Scalars['Boolean']['output'];
  /** 儲存品牌CDS設定 */
  saveCDSBrandSetting: Scalars['Boolean']['output'];
  /** 儲存標籤與備註 */
  saveTagsAndNotes: Scalars['Boolean']['output'];
  /** 發送電子郵件驗證碼 */
  sendEmailVerification: Scalars['Boolean']['output'];
  /** 批量發送電子郵件驗證碼 */
  sendEmailVerificationInBatch: EmailVerificationInBatchResponse;
  setAIWaiterSetting: SetAiWaiterSettingResponse;
  /** 更新品牌用餐方式 */
  setBrandDiningOptions: Array<BrandDiningOption>;
  setCustomer: Scalars['Boolean']['output'];
  /** 會員卡類型設定 */
  setMemberCardType: Scalars['Boolean']['output'];
  /** 設定會員預設地址 */
  setMemberDefaultAddress: Scalars['Boolean']['output'];
  /** 會員制度設定 */
  setMembershipConfig: Scalars['Boolean']['output'];
  /** 低消設定 */
  setMinChargeSetting: Scalars['Boolean']['output'];
  setOnlineOrderSetting: Scalars['Boolean']['output'];
  /** 更新實體出單機與虛擬出單機的link(同步使用) */
  setPPrinterLinks: Scalars['Boolean']['output'];
  /** 掃碼訂單-基本設定 */
  setScanOrderSetting: Scalars['Boolean']['output'];
  /** 掃碼訂單-內用點餐設定 */
  setScanOrderSettingDiningIn: Scalars['Boolean']['output'];
  /** 掃碼訂單-外帶點餐設定 */
  setScanOrderSettingTakeOut: Scalars['Boolean']['output'];
  /** 同步菜單至第三方 */
  syncShopMenu: Scalars['Boolean']['output'];
  unbindTheVDevice: Scalars['Boolean']['output'];
  unregisterCDS: Scalars['Boolean']['output'];
  unregisterTheServiceHub: Scalars['Boolean']['output'];
  /** 更新品牌支付方式 */
  updateABrandPaymentMethod: Scalars['Boolean']['output'];
  /** 更新Bundle */
  updateABundle: Scalars['Boolean']['output'];
  /** 更新自訂出單樣式 */
  updateACustomizedTicket: Scalars['Boolean']['output'];
  /** 更新品牌支付方式群組 */
  updateAGroupOfBrandPaymentMethods: Scalars['Boolean']['output'];
  /** 更新標籤 */
  updateALabel: Scalars['Boolean']['output'];
  /** 更新標籤群組 */
  updateALabelGroup: Scalars['Boolean']['output'];
  /** 更新樣式基本設定 */
  updateAPrintLayoutBase: Scalars['Boolean']['output'];
  /** 更新門市優惠計算規則 */
  updateAServiceFee: Scalars['Boolean']['output'];
  /** 更新門市優惠計算規則 */
  updateAShopDiscountRule: Scalars['Boolean']['output'];
  updateAShopPOSSetting: Scalars['Boolean']['output'];
  /** 更新門市支付方式 */
  updateAShopPaymentMethod: Scalars['Boolean']['output'];
  /** 更新稅金群組 */
  updateATaxGroup: Scalars['Boolean']['output'];
  /** 更新稅金 */
  updateATaxUnit: Scalars['Boolean']['output'];
  /** 更新出單樣式 */
  updateATicket: Scalars['Boolean']['output'];
  /** 更新出單機 */
  updateAVPrinter: Scalars['Boolean']['output'];
  /** 更新總部 */
  updateAWorkspace: Scalars['Boolean']['output'];
  /** 訂單/交易調整 */
  updateAnOrder: Scalars['Boolean']['output'];
  updateBrandDisplayOrder: Scalars['Boolean']['output'];
  /** 更新品牌 POS 更新策略 */
  updateBrandPOSUpdatePolicy: BrandPosUpdatePolicy;
  /** 更新品牌入口頁設定 */
  updateBrandPortalSetting: BrandPortalSetting;
  /** 更新品牌原因設定 */
  updateBrandReasonTemplates: Scalars['Boolean']['output'];
  /** 更新CDS輪播廣告 */
  updateCDSCarouselAd: Scalars['Boolean']['output'];
  /** 更新CDS固定廣告 */
  updateCDSFixedAd: Scalars['Boolean']['output'];
  /** 新增或更新跨品牌入口頁設定 */
  updateCrossBrandPortalSetting: CrossBrandPortalSetting;
  /** 更新所有出單機樣式順序 */
  updateDisplayOrderOfTickets: Scalars['Boolean']['output'];
  /** 更新出單機順序 */
  updateDisplayOrderOfVPrinters: Scalars['Boolean']['output'];
  /** 更新優惠鍵盤排序 */
  updateDisplayOrdersOfDiscounts: Scalars['Boolean']['output'];
  updateEmployee: Scalars['UUID']['output'];
  /** 修改員工姓名 */
  updateEmployeeNameByEmployeeID: Scalars['Boolean']['output'];
  updateEmployeePortrait: EmployeeImageUpdateResponse;
  /** 更新商品 */
  updateItem: Scalars['Boolean']['output'];
  /** 更新商品分類 */
  updateItemCategory: Scalars['Boolean']['output'];
  /** 更新商品分類順序 */
  updateItemCategoryDisplayOrder: Scalars['Boolean']['output'];
  /** 更新鍵盤順序 */
  updateKeypadDisplayOrder: Scalars['Boolean']['output'];
  /** 更新鍵盤名稱與套用商品 */
  updateKeypadWItem: Scalars['Boolean']['output'];
  /** 更新菜單套用門市 */
  updateLinkShopMenus: Scalars['Boolean']['output'];
  /** 編輯會員(open-api) */
  updateMemberInfo: Member;
  /** 更新菜單 */
  updateMenu: Menu;
  /** 新增/更新菜單分類 */
  updateMenuCategories: Array<MenuCategory>;
  /** 更新菜單公休日 */
  updateMenuOffDays: Scalars['Boolean']['output'];
  /** 更新菜單供應時段 */
  updateMenuSupplyHours: Scalars['Boolean']['output'];
  updateOnlineOrderPickupSetting: Scalars['Boolean']['output'];
  updateOnlineOrderTimeSetting: Scalars['Boolean']['output'];
  updatePDeviceInfo: UpdatePDeviceInfoResponse;
  /** 更新實體出單機 */
  updatePPrinterInfo?: Maybe<Scalars['Int32']['output']>;
  /** 更新優惠優先權 */
  updatePrioritiesOfDiscounts: Scalars['Boolean']['output'];
  updateRole: Scalars['Boolean']['output'];
  updateRolePermission: Scalars['Boolean']['output'];
  updateRoleTemplatePermissions: RoleTemplate;
  /** 批次更新商品配件關聯商品與標籤 */
  updateServicewareRelations: Scalars['Boolean']['output'];
  /** 編輯區域列表，包含新增、修改、刪除 */
  updateShopArea: Scalars['Boolean']['output'];
  /** 編輯區域資訊，包含桌位和裝飾資訊 */
  updateShopAreaInfo: Scalars['Boolean']['output'];
  updateShopContainerWeightManagement: Scalars['Boolean']['output'];
  /** 更新門市用餐方式 */
  updateShopDiningOptions: Scalars['Boolean']['output'];
  updateShopDisplayOrder: Scalars['Boolean']['output'];
  updateShopMemberTag: Scalars['Boolean']['output'];
  /** 更新門市叫餐備註設定 */
  updateShopOrderRemarkSetting: Scalars['Boolean']['output'];
  /** 更新門市叫餐備註名稱 */
  updateShopOrderRemarkTitles: Scalars['Boolean']['output'];
  /** 更新門市支付方式順序 */
  updateShopPaymentMethodDisplayOrder: Scalars['Boolean']['output'];
  /** 更新門市支付方式設定 */
  updateShopPaymentSetting: Scalars['Boolean']['output'];
  updateShopPermissionVerifications: Scalars['Boolean']['output'];
  /** 更新門市原因設定 */
  updateShopReasonSettings: Scalars['Boolean']['output'];
  /** 編輯桌位，包含新增、修改 */
  updateShopTable: Scalars['Boolean']['output'];
  updateShops: Scalars['Boolean']['output'];
  /** 更新優惠狀態 */
  updateStatusOfDiscounts: Scalars['Boolean']['output'];
  updateStoreStatus: Scalars['Boolean']['output'];
  updateSubscriberSettings: Scalars['Boolean']['output'];
  /**
   * equipments 省略/null：不動設備綁定，行為與原本相同。
   * equipments 有提供（含空陣列）：依清單同步綁定設備——有 equipmentID 的更新，
   * 沒有的新增，資料庫裡屬於這台 POS 但沒出現在清單裡的視為刪除。
   * 與 POS 欄位更新同包在一個交易內，任一步失敗整個 rollback。
   */
  updateTheVDevice: Scalars['Boolean']['output'];
  /**
   * 編輯綁定設備。設備類型（appID）為唯讀不可變更，僅能更換串接參數；顯示名稱一律衍生自
   * bindSettingID 對應的 settingName，不再能於此獨立改名。
   */
  updateTheVDeviceEquipment: Scalars['Boolean']['output'];
  /** 新增CDS輪播廣告 */
  uploadCDSCarouselAd: Scalars['Int32']['output'];
  /** 新增CDS固定廣告 */
  uploadCDSFixedAd: Scalars['Int32']['output'];
  uploadSyncData: Scalars['String']['output'];
  upsertAIWaiterVirtualHuman: AiWaiterVirtualHuman;
  upsertBrand: Scalars['Boolean']['output'];
  upsertBrandMemberTag: Scalars['Boolean']['output'];
  /** 新增/更新優惠 */
  upsertDiscount?: Maybe<Scalars['Int32']['output']>;
  upsertInvoiceSetting: Scalars['Boolean']['output'];
  /** 新增或更新鍵盤按鍵(改變位置大小顏色) */
  upsertKeyButtonsOfKeypad: Scalars['Boolean']['output'];
  /** 批次新增/更新會員地址 */
  upsertMemberAddresses: Scalars['Boolean']['output'];
  /** 新增或更新品牌商品配件設定 */
  upsertServiceware: Scalars['Boolean']['output'];
  upsertShopContainers: Scalars['Boolean']['output'];
  upsertShopDetails: Scalars['Boolean']['output'];
  upsertShopGroups: Scalars['Boolean']['output'];
};

export type MutationActivateMemberCardArgs = {
  activate: Scalars['Boolean']['input'];
  brandKey: BrandKey;
  cardCode: Scalars['String']['input'];
};

export type MutationAddBrandDiningOptionsArgs = {
  input: Array<AddBrandDiningOptionInput>;
};

export type MutationAddMemberTagsArgs = {
  memberID: Scalars['UUID']['input'];
  memberSourceID: Scalars['UUID']['input'];
  tags: Array<Scalars['String']['input']>;
  workspaceID: Scalars['UUID']['input'];
};

export type MutationAddPPrinterLinksArgs = {
  pPrinterIDs: Array<Scalars['Int32']['input']>;
  shopKey: ShopKey;
  vPrinterID: Scalars['Int32']['input'];
};

export type MutationAddPublishTaskArgs = {
  input: AddPublishTaskInput;
};

export type MutationAddRoleArgs = {
  descr?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  workspaceID: Scalars['UUID']['input'];
};

export type MutationAddSyncDataArgs = {
  shopKey: ShopKey;
  syncData: Array<Scalars['SyncData']['input']>;
  vDeviceID: Scalars['Int32']['input'];
};

export type MutationBindEmployeeEmailArgs = {
  email: Scalars['String']['input'];
  employeeID: Scalars['UUID']['input'];
};

export type MutationBindShopArgs = {
  deviceCode: Scalars['UUID']['input'];
  shopKey: ShopKey;
};

export type MutationBindTheDeviceArgs = {
  pDeviceID: Scalars['Int32']['input'];
  shopKey: ShopKey;
  vDeviceID: Scalars['Int32']['input'];
};

export type MutationBindWsMemberArgs = {
  cardNumber: Scalars['String']['input'];
  memberID: Scalars['UUID']['input'];
  memberSourceID: Scalars['UUID']['input'];
  workspaceID: Scalars['UUID']['input'];
};

export type MutationCancelPublishTaskArgs = {
  input: CancelPublishTaskInput;
};

export type MutationChangeEmployeeEmailArgs = {
  email: Scalars['String']['input'];
  employeeID: Scalars['UUID']['input'];
};

export type MutationChangeUserPasswordArgs = {
  email: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};

export type MutationCloneADiscountArgs = {
  discountKey: DiscountKey;
};

export type MutationCopyATicketOfVPrinterArgs = {
  ticketKey: TicketKey;
};

export type MutationCopyApplyKeypadToShopsArgs = {
  shopIDs: Array<Scalars['Int32']['input']>;
  shopKey: ShopKey;
};

export type MutationCopyApplyPrinterToShopsArgs = {
  shopIDs: Array<Scalars['Int32']['input']>;
  shopKey: ShopKey;
};

export type MutationCopyShopTableArgs = {
  shopAreaID: Scalars['Int32']['input'];
  shopKey: ShopKey;
  shopTableID: Scalars['Int32']['input'];
};

export type MutationCopyVPrinterStylesArgs = {
  dedupeCustomized?: InputMaybe<Scalars['Boolean']['input']>;
  destShopKey?: InputMaybe<ShopKey>;
  destVPrinterKey?: InputMaybe<VPrinterKey>;
  includeCustomized?: InputMaybe<Scalars['Boolean']['input']>;
  mode: SingleCopyMode;
  printerInput?: InputMaybe<PrinterInput>;
  selectedTickets: Array<TicketKey>;
  srcVPrinterKey: VPrinterKey;
};

export type MutationCreateABrandPaymentMethodArgs = {
  input: BrandPaymentMethodInput;
};

export type MutationCreateABundleArgs = {
  brandKey: BrandKey;
  bundleInput: BundleInput;
};

export type MutationCreateAGroupOfBrandPaymentMethodsArgs = {
  input: CreateAGroupOfBrandPaymentMethodsInput;
};

export type MutationCreateALabelArgs = {
  brandKey: BrandKey;
  input: LabelInput;
};

export type MutationCreateALabelGroupArgs = {
  brandKey: BrandKey;
  input: LabelGroupInput;
};

export type MutationCreateAposArgs = {
  autoCheckoutOnConfirm?: InputMaybe<Scalars['Boolean']['input']>;
  deviceCode: Scalars['String']['input'];
  isCashier: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  posOrderStyle: PosOrderStyle;
  shopKey: ShopKey;
};

export type MutationCreateAposWithEquipmentsArgs = {
  autoCheckoutOnConfirm?: InputMaybe<Scalars['Boolean']['input']>;
  deviceCode: Scalars['String']['input'];
  equipments?: InputMaybe<Array<UpsertVDeviceEquipmentInput>>;
  isCashier: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  posOrderStyle: PosOrderStyle;
  shopKey: ShopKey;
};

export type MutationCreateATaxGroupArgs = {
  taxGroupInput: TaxGroupInput;
  workspaceDiningOptionDefaultTaxInput?: InputMaybe<
    Array<InputMaybe<WorkspaceDiningOptionDefaultTaxInput>>
  >;
  workspaceID: Scalars['UUID']['input'];
};

export type MutationCreateATaxUnitArgs = {
  input: TaxUnitInput;
  workspaceID: Scalars['UUID']['input'];
};

export type MutationCreateATicketArgs = {
  input: TicketInput;
  vPrinterKey: VPrinterKey;
};

export type MutationCreateAvPrinterArgs = {
  input: PrinterInput;
  shopKey: ShopKey;
};

export type MutationCreateItemArgs = {
  input: UpdateItemInput;
};

export type MutationCreateItemCategoryArgs = {
  input: CreateItemCategoryInput;
};

export type MutationCreateKeypadWItemArgs = {
  input: CreateKeypadInput;
};

export type MutationCreateMemberArgs = {
  brandKey: BrandKey;
  input: CreateMemberInput;
  memberSourceID: Scalars['UUID']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
};

export type MutationCreateMenuArgs = {
  input: CreateMenuInput;
};

export type MutationCreateStopSaleArgs = {
  shopKey: ShopKey;
  stopSaleItemInput?: InputMaybe<Array<InputMaybe<StopSaleItemInput>>>;
  stopSaleLabelInput?: InputMaybe<Array<InputMaybe<StopSaleLabelInput>>>;
};

export type MutationCreateTheVDeviceEquipmentArgs = {
  appID: Scalars['UUID']['input'];
  bindSettingID: Scalars['UUID']['input'];
  name?: Scalars['String']['input'];
  vDeviceKey: VDeviceKey;
};

export type MutationDelBrandDiningOptionsArgs = {
  input: DelBrandDiningOptionsInput;
};

export type MutationDelItemImagesArgs = {
  itemKey: ItemKey;
};

export type MutationDelShopImagesArgs = {
  imageIDs: Array<Scalars['String']['input']>;
  shopKey: ShopKey;
};

export type MutationDeleteABrandPaymentMethodArgs = {
  brandPaymentMethodKey: BrandPaymentMethodKey;
};

export type MutationDeleteACustomizedTicketArgs = {
  force?: InputMaybe<Scalars['Boolean']['input']>;
  shopKey: ShopKey;
  ticketID: Scalars['Int32']['input'];
  type: TicketCustomizedType;
};

export type MutationDeleteAiWaiterVirtualHumanArgs = {
  input: DeleteAiWaiterVirtualHumanInput;
};

export type MutationDeleteATaxGroupArgs = {
  taxGroupKey: TaxGroupKey;
};

export type MutationDeleteATaxUnitArgs = {
  taxUnitKey: TaxUnitKey;
};

export type MutationDeleteATicketArgs = {
  ticketKey: TicketKey;
};

export type MutationDeleteAvPrinterArgs = {
  vPrinterKey: VPrinterKey;
};

export type MutationDeleteBundlesArgs = {
  brandKey: BrandKey;
  bundleIDs: Array<Scalars['Int32']['input']>;
};

export type MutationDeleteCdsAdArgs = {
  brandKey: BrandKey;
  cdsCarouselAdID?: InputMaybe<Array<InputMaybe<Scalars['Int32']['input']>>>;
  cdsFixedAdID?: InputMaybe<Array<InputMaybe<Scalars['Int32']['input']>>>;
};

export type MutationDeleteCrossBrandPortalSettingArgs = {
  pageID: Scalars['UUID']['input'];
  workspaceID: Scalars['UUID']['input'];
};

export type MutationDeleteEmployeeArgs = {
  employeeID: Scalars['UUID']['input'];
};

export type MutationDeleteEmployeePortraitArgs = {
  employeeID: Scalars['UUID']['input'];
};

export type MutationDeleteItemCategoriesArgs = {
  input: DeleteItemCategoriesInput;
};

export type MutationDeleteItemsArgs = {
  brandKey: BrandKey;
  itemIDs: Array<Scalars['Int32']['input']>;
};

export type MutationDeleteKeypadArgs = {
  keypadIDs: Array<Scalars['Int32']['input']>;
  shopKey: ShopKey;
};

export type MutationDeleteLabelGroupsArgs = {
  brandKey: BrandKey;
  labelGroupIDs: Array<Scalars['Int32']['input']>;
};

export type MutationDeleteLabelsArgs = {
  brandKey?: InputMaybe<BrandKey>;
  labelIDs: Array<Scalars['Int32']['input']>;
};

export type MutationDeleteMemberAddressesArgs = {
  addressIDs: Array<Scalars['UUID']['input']>;
  memberID: Scalars['UUID']['input'];
};

export type MutationDeleteMenuCategoriesArgs = {
  brandKey: BrandKey;
  menuCategoryIDs: Array<Scalars['Int32']['input']>;
  menuID: Scalars['Int32']['input'];
};

export type MutationDeleteMenusArgs = {
  brandKey: BrandKey;
  menuIDs: Array<Scalars['Int32']['input']>;
};

export type MutationDeletePPrinterArgs = {
  pPrinterKey: PPrinterKey;
};

export type MutationDeletePrinterLogoImagesArgs = {
  printLayoutBaseKey: PrintLayoutBaseKey;
};

export type MutationDeleteRoleArgs = {
  input: DeleteRoleInput;
};

export type MutationDeleteShopAreaDecorationArgs = {
  shopAreaDecorationIDs: Array<InputMaybe<Scalars['Int32']['input']>>;
  shopAreaID: Scalars['Int32']['input'];
  shopKey: ShopKey;
};

export type MutationDeleteShopTableArgs = {
  shopAreaID: Scalars['Int32']['input'];
  shopKey: ShopKey;
  shopTableID: Scalars['Int32']['input'];
};

export type MutationDeleteStopSaleArgs = {
  deleteStopSaleItemInput?: InputMaybe<
    Array<InputMaybe<DeleteStopSaleItemInput>>
  >;
  deleteStopSaleLabelInput?: InputMaybe<
    Array<InputMaybe<Scalars['Int32']['input']>>
  >;
  shopKey: ShopKey;
};

export type MutationDeleteTheVDeviceArgs = {
  vDeviceKey: VDeviceKey;
};

export type MutationDeleteTheVDeviceEquipmentArgs = {
  equipmentID: Scalars['Int32']['input'];
  vDeviceKey: VDeviceKey;
};

export type MutationDisableBrandPaymentMethodsArgs = {
  input: DisableBrandPaymentMethods;
};

export type MutationDisableEmployeeArgs = {
  employeeID: Scalars['UUID']['input'];
};

export type MutationDisableItemsArgs = {
  brandKey: BrandKey;
  disabled: Scalars['Boolean']['input'];
  itemIDs: Array<Scalars['Int32']['input']>;
};

export type MutationDisableRoleArgs = {
  roleID: Scalars['Int32']['input'];
};

export type MutationDisbandAGroupOfBrandPaymentMethodsArgs = {
  brandPaymentMethodKey: BrandPaymentMethodKey;
};

export type MutationDuplicateABundleArgs = {
  bundleKey: BundleKey;
};

export type MutationDuplicateALabelGroupArgs = {
  brandKey: BrandKey;
  labelGroupID: Scalars['Int32']['input'];
};

export type MutationDuplicateItemsArgs = {
  brandKey: BrandKey;
  itemIDs: Array<Scalars['Int32']['input']>;
};

export type MutationDuplicateMenuArgs = {
  brandKey: BrandKey;
  menuID: Scalars['Int32']['input'];
};

export type MutationDuplicateRoleArgs = {
  roleID: Scalars['Int32']['input'];
};

export type MutationEmployeePinGenAndCheckArgs = {
  pin?: InputMaybe<Scalars['String']['input']>;
  workspaceID: Scalars['UUID']['input'];
};

export type MutationExportAEodReportCsvFileArgs = {
  input: ExportAEodReportCsvFileInput;
};

export type MutationExportAShiftCloseReportCsvFileArgs = {
  input: ExportAShiftCloseReportCsvFileInput;
};

export type MutationExportCashDrawerTransactionsArgs = {
  input: ExportCashDrawerTransactionsInput;
};

export type MutationExportCustomerListCsvArgs = {
  CustomerCSVInput: CustomerCsvInput;
};

export type MutationExportDiscountsOverviewCsvArgs = {
  filter: ReportDiscountsCsvInput;
};

export type MutationExportEodReportsCsvFileArgs = {
  input: ExportEodReportsCsvFileInput;
};

export type MutationExportInvoicesCsvFileArgs = {
  input: InvoicesCsvInput;
};

export type MutationExportItemsCsvFileArgs = {
  input: ExportItemsCsvInput;
};

export type MutationExportItemsOverviewCsvArgs = {
  filter: ReportItemsCsvInput;
};

export type MutationExportLabelsOverviewCsvArgs = {
  filter: ReportLabelsCsvInput;
};

export type MutationExportMemberImportTemplateCsvArgs = {
  locale: Locales;
};

export type MutationExportMemberListCsvArgs = {
  memberCSVInput: MemberCsvInput;
};

export type MutationExportOnlineOrderListCsvArgs = {
  input: OnlineOrderListCsvInput;
};

export type MutationExportOrdersCsvFileArgs = {
  input: OrdersCsvInput;
};

export type MutationExportShiftCloseReportsCsvFileArgs = {
  input: ExportShiftCloseReportsCsvInput;
};

export type MutationExportTransactionsCsvFileArgs = {
  input: TransactionsCsvInput;
};

export type MutationGenerateAiWaiterPreviewVideoArgs = {
  input: GenerateAiWaiterPreviewVideoInput;
};

export type MutationImportItemsCsvFileArgs = {
  input: ImportItemsCsvInput;
};

export type MutationImportMembersCsvFileArgs = {
  brandKey: BrandKey;
  file: Scalars['Upload']['input'];
};

export type MutationInitPasswordArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  verificationNumber: Scalars['String']['input'];
};

export type MutationLinkEmployeeArgs = {
  input: LinkEmployeeInput;
};

export type MutationLoginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  source: LoginSource;
  workspaceCode?: InputMaybe<Scalars['String']['input']>;
};

export type MutationPutAiWaiterVirtualHumanImageArgs = {
  input: PutAiWaiterVirtualHumanImageInput;
};

export type MutationPutAiWaiterVirtualHumanVoiceArgs = {
  input: PutAiWaiterVirtualHumanVoiceInput;
};

export type MutationPutItemImageArgs = {
  file: Scalars['Upload']['input'];
  itemKey: ItemKey;
};

export type MutationPutPrinterLogoImageArgs = {
  file: Scalars['Upload']['input'];
  printLayoutBaseKey: PrintLayoutBaseKey;
};

export type MutationPutShopImageArgs = {
  files: Array<Scalars['Upload']['input']>;
  shopKey: ShopKey;
};

export type MutationRecoveryPasswordArgs = {
  email: Scalars['String']['input'];
};

export type MutationRefreshGitTokenArgs = {
  brandID?: InputMaybe<Scalars['Int32']['input']>;
  shopID?: InputMaybe<Scalars['Int32']['input']>;
  vDeviceID?: InputMaybe<Scalars['Int32']['input']>;
  workspaceID: Scalars['UUID']['input'];
};

export type MutationRefundAnOrderArgs = {
  method: VoidMethod;
  orderKey: OrderKey;
  reason: Scalars['String']['input'];
};

export type MutationRegisterAsServiceHubArgs = {
  pDeviceID: Scalars['Int32']['input'];
  shopKey: ShopKey;
};

export type MutationRegisterCdsArgs = {
  pDeviceKey: PDeviceKey;
};

export type MutationRemoveMemberTagsArgs = {
  memberID: Scalars['UUID']['input'];
  memberSourceID: Scalars['UUID']['input'];
  tags: Array<Scalars['String']['input']>;
  workspaceID: Scalars['UUID']['input'];
};

export type MutationRemovePPrinterLinksArgs = {
  pPrinterIDs: Array<Scalars['Int32']['input']>;
  shopKey: ShopKey;
  vPrinterID: Scalars['Int32']['input'];
};

export type MutationResetPasswordArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  verificationNumber: Scalars['String']['input'];
};

export type MutationSaveCdsBrandSettingArgs = {
  brandKey: BrandKey;
  cdsBrandSettingInput: CdsBrandSettingInput;
  mainPageCDSCarouselAdInput?: InputMaybe<
    Array<InputMaybe<MainPageCdsCarouselAdInput>>
  >;
  mainPageCDSFixedAdInput?: InputMaybe<
    Array<InputMaybe<MainPageCdsFixedAdInput>>
  >;
};

export type MutationSaveTagsAndNotesArgs = {
  memberID: Scalars['UUID']['input'];
  memberSourceID: Scalars['UUID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceID: Scalars['UUID']['input'];
};

export type MutationSendEmailVerificationArgs = {
  email: Scalars['String']['input'];
  type: EmailVerificationType;
  workspaceID?: InputMaybe<Scalars['UUID']['input']>;
};

export type MutationSendEmailVerificationInBatchArgs = {
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  workspaceID?: InputMaybe<Scalars['UUID']['input']>;
};

export type MutationSetAiWaiterSettingArgs = {
  input: SetAiWaiterSettingInput;
};

export type MutationSetBrandDiningOptionsArgs = {
  input: Array<SetBrandDiningOptionInput>;
};

export type MutationSetCustomerArgs = {
  input: CustomerInput;
};

export type MutationSetMemberCardTypeArgs = {
  input: MemberCardTypeInput;
};

export type MutationSetMemberDefaultAddressArgs = {
  addressID: Scalars['UUID']['input'];
  memberID: Scalars['UUID']['input'];
};

export type MutationSetMembershipConfigArgs = {
  brandID?: InputMaybe<Scalars['Int32']['input']>;
  input: MembershipConfigInput;
  workspaceID: Scalars['UUID']['input'];
};

export type MutationSetMinChargeSettingArgs = {
  minChargeInput: MinChargeInput;
  shopKey: ShopKey;
};

export type MutationSetOnlineOrderSettingArgs = {
  onlineOrderSettingInput: OnlineOrderSettingInput;
  shopKey: ShopKey;
};

export type MutationSetPPrinterLinksArgs = {
  pPrinterIDs: Array<Scalars['Int32']['input']>;
  shopKey: ShopKey;
  vPrinterID: Scalars['Int32']['input'];
};

export type MutationSetScanOrderSettingArgs = {
  scanOrderSettingInput: ScanOrderSettingInput;
  shopKey: ShopKey;
};

export type MutationSetScanOrderSettingDiningInArgs = {
  scanOrderSettingDiningInInput: ScanOrderSettingDiningInInput;
  shopKey: ShopKey;
};

export type MutationSetScanOrderSettingTakeOutArgs = {
  scanOrderSettingTakeOutInput: ScanOrderSettingTakeOutInput;
  shopKey: ShopKey;
};

export type MutationSyncShopMenuArgs = {
  input: SyncShopMenuInput;
};

export type MutationUnbindTheVDeviceArgs = {
  vDeviceKey: VDeviceKey;
};

export type MutationUnregisterCdsArgs = {
  pDeviceKey: PDeviceKey;
};

export type MutationUnregisterTheServiceHubArgs = {
  vDeviceKey: VDeviceKey;
};

export type MutationUpdateABrandPaymentMethodArgs = {
  input: BrandPaymentMethodInput;
};

export type MutationUpdateABundleArgs = {
  bundleInput: BundleInput;
  bundleKey: BundleKey;
};

export type MutationUpdateACustomizedTicketArgs = {
  input: UpdateCustomizedTicketPayload;
  shopKey: ShopKey;
  ticketID?: InputMaybe<Scalars['Int32']['input']>;
};

export type MutationUpdateAGroupOfBrandPaymentMethodsArgs = {
  input: UpdateAGroupOfBrandPaymentMethodsInput;
};

export type MutationUpdateALabelArgs = {
  brandKey?: InputMaybe<BrandKey>;
  input: LabelInput;
  labelID: Scalars['Int32']['input'];
};

export type MutationUpdateALabelGroupArgs = {
  brandKey: BrandKey;
  input: LabelGroupInput;
  labelGroupID: Scalars['Int32']['input'];
};

export type MutationUpdateAPrintLayoutBaseArgs = {
  input: UpdateAPrintLayoutBaseInput;
};

export type MutationUpdateAServiceFeeArgs = {
  input: UpdateAServiceFeeInput;
};

export type MutationUpdateAShopDiscountRuleArgs = {
  input: UpdateAShopDiscountRuleInput;
};

export type MutationUpdateAShopPosSettingArgs = {
  input: UpdateAShopPosSettingInput;
};

export type MutationUpdateAShopPaymentMethodArgs = {
  input: UpdateAShopPaymentMethodInput;
};

export type MutationUpdateATaxGroupArgs = {
  taxGroupInput: TaxGroupInput;
  taxGroupKey: TaxGroupKey;
  workspaceDiningOptionDefaultTaxInput?: InputMaybe<
    Array<InputMaybe<WorkspaceDiningOptionDefaultTaxInput>>
  >;
};

export type MutationUpdateATaxUnitArgs = {
  input: TaxUnitInput;
  taxUnitKey: TaxUnitKey;
};

export type MutationUpdateATicketArgs = {
  input: UpdateTicketInput;
};

export type MutationUpdateAvPrinterArgs = {
  input: PrinterInput;
  vPrinterKey: VPrinterKey;
};

export type MutationUpdateAWorkspaceArgs = {
  input: UpdateAWorkspaceInput;
};

export type MutationUpdateAnOrderArgs = {
  input: UpdateAnOrderInput;
  orderKey: OrderKey;
};

export type MutationUpdateBrandDisplayOrderArgs = {
  input: UpdateBrandOrderInput;
};

export type MutationUpdateBrandPosUpdatePolicyArgs = {
  input: UpdateBrandPosUpdatePolicyInput;
};

export type MutationUpdateBrandPortalSettingArgs = {
  input: UpdateBrandPortalSettingInput;
};

export type MutationUpdateBrandReasonTemplatesArgs = {
  input: UpdateABrandReasonTemplateInput;
};

export type MutationUpdateCdsCarouselAdArgs = {
  brandKey: BrandKey;
  cdsCarouselAdWithFileInput: CdsCarouselAdWithFileInput;
};

export type MutationUpdateCdsFixedAdArgs = {
  brandKey: BrandKey;
  cdsFixedAdWithFileInput: CdsFixedAdWithFileInput;
};

export type MutationUpdateCrossBrandPortalSettingArgs = {
  input: UpdateCrossBrandPortalSettingInput;
};

export type MutationUpdateDisplayOrderOfTicketsArgs = {
  input?: InputMaybe<Array<TicketDisplayOrderInput>>;
};

export type MutationUpdateDisplayOrderOfVPrintersArgs = {
  input: PrinterDisplayOrderInput;
};

export type MutationUpdateDisplayOrdersOfDiscountsArgs = {
  brandKey: BrandKey;
  discountDisplayOrderList: Array<IdValuePairInput>;
};

export type MutationUpdateEmployeeArgs = {
  input: UpdateEmployeeInput;
};

export type MutationUpdateEmployeeNameByEmployeeIdArgs = {
  employeeID: Scalars['UUID']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type MutationUpdateEmployeePortraitArgs = {
  employeeID: Scalars['UUID']['input'];
  file: Scalars['Upload']['input'];
  workspaceID: Scalars['UUID']['input'];
};

export type MutationUpdateItemArgs = {
  input: UpdateItemInput;
};

export type MutationUpdateItemCategoryArgs = {
  input: UpdateItemCategoryInput;
};

export type MutationUpdateItemCategoryDisplayOrderArgs = {
  input: UpdateItemCategoryOrderInput;
};

export type MutationUpdateKeypadDisplayOrderArgs = {
  input: KeypadDisplayOrderInput;
};

export type MutationUpdateKeypadWItemArgs = {
  input: UpdateKeypadInput;
};

export type MutationUpdateLinkShopMenusArgs = {
  input: UpdateLinkShopMenusInput;
};

export type MutationUpdateMemberInfoArgs = {
  brandKey: BrandKey;
  cardCode: Scalars['String']['input'];
  input: UpdateMemberInput;
  memberSourceID: Scalars['UUID']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
};

export type MutationUpdateMenuArgs = {
  input: UpdateMenuInput;
};

export type MutationUpdateMenuCategoriesArgs = {
  input: Array<UpdateMenuCategoryInput>;
};

export type MutationUpdateMenuOffDaysArgs = {
  input: UpdateMenuOffDaysInput;
};

export type MutationUpdateMenuSupplyHoursArgs = {
  input: UpdateMenuSupplyHoursInput;
};

export type MutationUpdateOnlineOrderPickupSettingArgs = {
  input: UpdateOnlineOrderPickupSettingInput;
};

export type MutationUpdateOnlineOrderTimeSettingArgs = {
  input: UpdateOnlineOrderTimeSettingInput;
};

export type MutationUpdatePDeviceInfoArgs = {
  deviceInfo: DeviceInfoInput;
  pDeviceKey: PDeviceKey;
};

export type MutationUpdatePPrinterInfoArgs = {
  input: UpdatePPrinterInfoInput;
  pPrinterID?: InputMaybe<Scalars['Int32']['input']>;
  shopKey: ShopKey;
};

export type MutationUpdatePrioritiesOfDiscountsArgs = {
  brandKey: BrandKey;
  discountPriorityList: Array<IdValuePairInput>;
  filterPriorityCategory: PriorityCategory;
};

export type MutationUpdateRoleArgs = {
  input: UpdateRoleInput;
};

export type MutationUpdateRolePermissionArgs = {
  input?: InputMaybe<UpdateRolePermissionInput>;
};

export type MutationUpdateRoleTemplatePermissionsArgs = {
  permissionDetailIDs: Array<Scalars['UUID']['input']>;
  roleTemplateID: Scalars['UUID']['input'];
};

export type MutationUpdateServicewareRelationsArgs = {
  input: UpdateServicewareRelationsInput;
};

export type MutationUpdateShopAreaArgs = {
  deleteShopAreaIDs?: InputMaybe<Array<InputMaybe<Scalars['Int32']['input']>>>;
  shopAreaInput: Array<InputMaybe<ShopAreaInput>>;
  shopKey: ShopKey;
};

export type MutationUpdateShopAreaInfoArgs = {
  shopAreaDecorationInput: Array<InputMaybe<ShopAreaDecorationInput>>;
  shopAreaID: Scalars['Int32']['input'];
  shopKey: ShopKey;
  shopTableInput: Array<InputMaybe<ShopTableInput>>;
};

export type MutationUpdateShopContainerWeightManagementArgs = {
  input: UpdateShopContainerWeightManagementInput;
};

export type MutationUpdateShopDiningOptionsArgs = {
  input: UpdateShopDiningOptionInput;
};

export type MutationUpdateShopDisplayOrderArgs = {
  input: UpdateShopDisplayOrderInput;
};

export type MutationUpdateShopMemberTagArgs = {
  input: UpdateShopMemberTagInput;
};

export type MutationUpdateShopOrderRemarkSettingArgs = {
  input: UpdateShopOrderRemarkSettingInput;
};

export type MutationUpdateShopOrderRemarkTitlesArgs = {
  input: UpdateShopOrderRemarkTitlesInput;
};

export type MutationUpdateShopPaymentMethodDisplayOrderArgs = {
  shopKey: ShopKey;
  updateOrder?: InputMaybe<Array<BrandPaymentMethodOrderInput>>;
};

export type MutationUpdateShopPaymentSettingArgs = {
  input: UpdateShopPaymentSettingInput;
};

export type MutationUpdateShopPermissionVerificationsArgs = {
  input: UpdateShopPermissionVerificationsInput;
};

export type MutationUpdateShopReasonSettingsArgs = {
  input: UpdateAShopReasonSettingInput;
};

export type MutationUpdateShopTableArgs = {
  shopAreaID: Scalars['Int32']['input'];
  shopKey: ShopKey;
  shopTableInput: Array<InputMaybe<ShopTableInput>>;
};

export type MutationUpdateShopsArgs = {
  input: UpdateShopInput;
};

export type MutationUpdateStatusOfDiscountsArgs = {
  brandKey: BrandKey;
  discountIDs: Array<Scalars['Int32']['input']>;
  op: DiscountOp;
};

export type MutationUpdateStoreStatusArgs = {
  appID: Scalars['UUID']['input'];
  brandID: Scalars['Int32']['input'];
  posIntegrationEnabled: Scalars['Boolean']['input'];
  shopID: Scalars['Int32']['input'];
  storeID: Scalars['String']['input'];
  workspaceID: Scalars['UUID']['input'];
};

export type MutationUpdateSubscriberSettingsArgs = {
  appID: Scalars['UUID']['input'];
  bindSettings?: InputMaybe<Scalars['JSON']['input']>;
  brandID: Scalars['Int32']['input'];
  posSettings?: InputMaybe<Scalars['JSON']['input']>;
  shopID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

export type MutationUpdateTheVDeviceArgs = {
  autoCheckoutOnConfirm?: InputMaybe<Scalars['Boolean']['input']>;
  code: Scalars['String']['input'];
  disableCDS?: InputMaybe<Scalars['Boolean']['input']>;
  equipments?: InputMaybe<Array<UpsertVDeviceEquipmentInput>>;
  isCashier?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  posOrderStyle?: InputMaybe<PosOrderStyle>;
  vDeviceKey: VDeviceKey;
};

export type MutationUpdateTheVDeviceEquipmentArgs = {
  bindSettingID?: InputMaybe<Scalars['UUID']['input']>;
  equipmentID: Scalars['Int32']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  vDeviceKey: VDeviceKey;
};

export type MutationUploadCdsCarouselAdArgs = {
  brandKey: BrandKey;
  cdsCarouselAdWithFileInput: CdsCarouselAdWithFileInput;
};

export type MutationUploadCdsFixedAdArgs = {
  brandKey: BrandKey;
  cdsFixedAdWithFileInput: CdsFixedAdWithFileInput;
};

export type MutationUploadSyncDataArgs = {
  apiID: Scalars['String']['input'];
  shopKey: ShopKey;
  syncData: Array<Scalars['SyncData']['input']>;
  vDeviceID: Scalars['Int32']['input'];
};

export type MutationUpsertAiWaiterVirtualHumanArgs = {
  input: UpsertAiWaiterVirtualHumanInput;
};

export type MutationUpsertBrandArgs = {
  input: UpsertBrandInput;
};

export type MutationUpsertBrandMemberTagArgs = {
  input: UpsertBrandMemberTagInput;
};

export type MutationUpsertDiscountArgs = {
  advNames?: InputMaybe<Array<DiscountAdvNameInput>>;
  baseInfo: DiscountBaseInfoInput;
  brandKey: BrandKey;
  content: DiscountContentInput;
  criteria: DiscountCriteriaInput;
  dayTimes?: InputMaybe<Array<DiscountDayTimeInput>>;
  deliveryFeeDistanceTiers?: InputMaybe<
    Array<DiscountDeliveryFeeDistanceTierInput>
  >;
  exec: DiscountExecInput;
  giftItemCategoryIDs?: InputMaybe<
    Array<InputMaybe<Scalars['Int32']['input']>>
  >;
  giftItems?: InputMaybe<Array<DiscountSelItemInput>>;
  selChannels: Array<DiscountSelChannelInput>;
  selItemCategoryIDs?: InputMaybe<Array<InputMaybe<Scalars['Int32']['input']>>>;
  selItems?: InputMaybe<Array<DiscountSelItemInput>>;
  selShopDiningOptions?: InputMaybe<Array<DiscountSelShopDiningOptionInput>>;
  selShopIDs?: InputMaybe<Array<InputMaybe<Scalars['Int32']['input']>>>;
  selSubBrandIDs?: InputMaybe<Array<InputMaybe<Scalars['Int32']['input']>>>;
};

export type MutationUpsertInvoiceSettingArgs = {
  upsertInvoiceSettingInput: UpsertInvoiceSettingInput;
};

export type MutationUpsertKeyButtonsOfKeypadArgs = {
  input: KeyButtonsOfKeypadInput;
};

export type MutationUpsertMemberAddressesArgs = {
  inputs: Array<MemberAddressInput>;
  memberID: Scalars['UUID']['input'];
};

export type MutationUpsertServicewareArgs = {
  input: UpsertServicewareInput;
};

export type MutationUpsertShopContainersArgs = {
  input: UpsertShopContainersInput;
};

export type MutationUpsertShopDetailsArgs = {
  input: UpsertShopDetailsInput;
};

export type MutationUpsertShopGroupsArgs = {
  input: UpsertShopGroupInput;
};

export type NetworkInfoInput = {
  dns?: InputMaybe<Scalars['String']['input']>;
  gw?: InputMaybe<Scalars['String']['input']>;
  ip?: InputMaybe<Scalars['String']['input']>;
  ssid?: InputMaybe<Scalars['String']['input']>;
};

export type NonRevenuePayment = {
  brandPaymentMethodName: Scalars['String']['output'];
  paymentAmount: Scalars['Decimal']['output'];
  sysPaymentMethodID: Scalars['String']['output'];
};

/** O2O 外送距離限制規則 */
export enum O2ODeliveryDistanceRule {
  /** 外送最遠距離限制 */
  Max = 'Max',
  /** 不限制外送距離 */
  NoLimit = 'NoLimit',
}

/** O2O 外送費消費金額計算方式 */
export enum O2ODeliveryFeeCalcMode {
  /** 依折扣後金額計算 */
  AfterDiscount = 'AfterDiscount',
  /** 依折扣前金額計算 */
  BeforeDiscount = 'BeforeDiscount',
}

/** O2O 外送費規則 */
export enum O2ODeliveryFeeRule {
  /** 固定外送費 */
  Fixed = 'Fixed',
  /** 不收外送費用 */
  NoCharge = 'NoCharge',
}

/** O2O 會員登入需求類型 */
export enum O2OMemberLoginRequiredType {
  /** 強制 */
  Force = 'Force',
  /** 不需要 */
  NoNeed = 'NoNeed',
  /** 不強制 */
  NotForce = 'NotForce',
}

/** O2O 會員登入時機類型 */
export enum O2OMemberLoginTimingType {
  /** 開始點單前 */
  BeforeStartOrder = 'BeforeStartOrder',
  /** 送出訂單前 */
  BeforeSubmitOrder = 'BeforeSubmitOrder',
}

/** O2O 點餐時段類型 */
export enum O2OOrderingHoursType {
  /** 依照星期 */
  ByWeekDay = 'ByWeekDay',
  /** 固定時間 */
  Fixed = 'Fixed',
}

/** 服務類型 */
export enum O2OServiceType {
  OnlineOrder = 'OnlineOrder',
  ScanOrder = 'ScanOrder',
}

/** 組織品牌 */
export type OBrand = {
  createdAt: Scalars['DateTimeZ']['output'];
  name: Scalars['String']['output'];
  obrandID: Scalars['Int32']['output'];
  oorganization: OOrganization;
  oorganizationID: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
};

/** 組織 */
export type OOrganization = {
  createdAt: Scalars['DateTimeZ']['output'];
  name: Scalars['String']['output'];
  obrands: Array<OBrand>;
  oorganizationID: Scalars['UUID']['output'];
  oshops: Array<OShop>;
  updatedAt: Scalars['DateTimeZ']['output'];
};

/** 會員組織對應 */
export type OOrganizationMap = {
  createdAt: Scalars['DateTimeZ']['output'];
  extBrandID: Scalars['Int32']['output'];
  extOrganizationID: Scalars['UUID']['output'];
  extShopID: Scalars['Int32']['output'];
  obrandID: Scalars['Int32']['output'];
  oorganizationID: Scalars['UUID']['output'];
  oshop: OShop;
  oshopID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
};

/** 組織門市 */
export type OShop = {
  brand: OBrand;
  createdAt: Scalars['DateTimeZ']['output'];
  name: Scalars['String']['output'];
  obrandID: Scalars['Int32']['output'];
  oorganization: OOrganization;
  oorganizationID: Scalars['UUID']['output'];
  oshopID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
};

/** 團隊 */
export type OfficialTeam = {
  ancestors: Array<OfficialTeam>;
  childrenTeams: Array<OfficialTeam>;
  /** 國家 */
  country: Country;
  /** 國家ID */
  countryID: Scalars['String']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  employeeOfficialTeams: Array<EmployeeOfficialTeam>;
  hasChildren: Scalars['Boolean']['output'];
  managers: Array<EmployeeOfficialTeam>;
  memberCount: Scalars['Int32']['output'];
  name: Scalars['String']['output'];
  nameLang: MultiLang;
  officialTeamID: Scalars['UUID']['output'];
  parentTeam?: Maybe<OfficialTeam>;
  parentTeamID?: Maybe<Scalars['UUID']['output']>;
  teamCode: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
};

/** 團隊角色 */
export type OfficialTeamRole = {
  createdAt: Scalars['DateTimeZ']['output'];
  name: Scalars['String']['output'];
  nameLang: MultiLang;
  officialTeamRoleID: Scalars['UUID']['output'];
  slug: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
};

/** 性別 */
export enum Ogender {
  Female = 'Female',
  Male = 'Male',
  Other = 'Other',
  Undisclosed = 'Undisclosed',
}

/** 線上訂單 */
export type OnlineOrder = {
  consumerID?: Maybe<Scalars['UUID']['output']>;
  createdAt: Scalars['DateTimeZ']['output'];
  deliveryFeeAmount: Scalars['Decimal']['output'];
  deliveryFeeDiscount: Scalars['Decimal']['output'];
  details: Array<OnlineOrderDetail>;
  discountAmount: Scalars['Decimal']['output'];
  discounts: Array<OnlineOrderDiscount>;
  exclusiveTaxAmount: Scalars['Decimal']['output'];
  /** 外部訂單單號 */
  externalOrderCode?: Maybe<Scalars['String']['output']>;
  /** 外部訂單序號 */
  externalOrderNo?: Maybe<Scalars['String']['output']>;
  fetchType: OnlineOrderFetchType;
  memberCardNumber?: Maybe<Scalars['String']['output']>;
  memberSourceID?: Maybe<Scalars['UUID']['output']>;
  meta?: Maybe<OnlineOrderMeta>;
  minChargeAmount: Scalars['Decimal']['output'];
  needExtraBag: Scalars['Boolean']['output'];
  needUtensil: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  obrandID: Scalars['Int32']['output'];
  oorganizationID: Scalars['UUID']['output'];
  /** 訂單單號 */
  orderCode: Scalars['String']['output'];
  orderID: Scalars['UUID']['output'];
  /** 訂單序號 */
  orderNo: Scalars['String']['output'];
  orderStatus: OnlineOrderStatus;
  orderType: OnlineOrderSchedulingType;
  oshop: OShop;
  oshopID: Scalars['Int32']['output'];
  payments: Array<OnlineOrderPayment>;
  preTaxAmount: Scalars['Decimal']['output'];
  preorderPickupTime?: Maybe<Scalars['DateTimeZ']['output']>;
  /** 拒絕/取消原因 */
  rejectCancelReason?: Maybe<Scalars['String']['output']>;
  serviceFeeAmount: Scalars['Decimal']['output'];
  serviceType: O2OServiceType;
  subtotalAmount: Scalars['Decimal']['output'];
  taxAmount: Scalars['Decimal']['output'];
  /** 訂單稅金資訊 */
  taxInfo: Scalars['JSON']['output'];
  totalAmount: Scalars['Decimal']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
};

/** 線上訂單消費者 */
export type OnlineOrderConsumer = {
  activities?: Maybe<OnlineOrderConsumerActivity>;
  address?: Maybe<Scalars['String']['output']>;
  addressMisc?: Maybe<Scalars['String']['output']>;
  addresses: Array<OnlineOrderConsumerAddress>;
  birthday?: Maybe<Scalars['Date']['output']>;
  consumerID: Scalars['UUID']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  e164CountryCode?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  facebook?: Maybe<Scalars['String']['output']>;
  gender: OnlineOrderGender;
  line?: Maybe<Scalars['String']['output']>;
  linkConsumerMember?: Maybe<LinkOnlineOrderConsumerMember>;
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  passwordHash?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  portraits: Array<OnlineOrderConsumerPortrait>;
  updatedAt: Scalars['DateTimeZ']['output'];
  validated: Scalars['Boolean']['output'];
};

/** 線上訂單消費者活動 */
export type OnlineOrderConsumerActivity = {
  activities: Scalars['JSON']['output'];
  activityID: Scalars['UUID']['output'];
  consumerID: Scalars['UUID']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
};

/** 線上訂單消費者地址 */
export type OnlineOrderConsumerAddress = {
  address: Scalars['String']['output'];
  addressID: Scalars['UUID']['output'];
  addressMisc?: Maybe<Scalars['String']['output']>;
  consumerID: Scalars['UUID']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
};

/** 線上訂單消費者圖像 */
export type OnlineOrderConsumerPortrait = {
  alg: Scalars['String']['output'];
  consumerID: Scalars['UUID']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  fileSize: Scalars['Int32']['output'];
  hash: Scalars['String']['output'];
  height: Scalars['Int32']['output'];
  mime: Scalars['String']['output'];
  portraitID: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  width: Scalars['Int32']['output'];
};

/** 線上訂單明細 */
export type OnlineOrderDetail = {
  /** 加點序號 */
  addOnSeq?: Maybe<Scalars['Int16']['output']>;
  bundleID?: Maybe<Scalars['Int32']['output']>;
  createdAt: Scalars['DateTimeZ']['output'];
  displayOrder: Scalars['Int16']['output'];
  itemAdvPriceID?: Maybe<Scalars['Int32']['output']>;
  itemCategoryID?: Maybe<Scalars['Int32']['output']>;
  itemCategoryName?: Maybe<Scalars['String']['output']>;
  itemID: Scalars['Int32']['output'];
  itemKind: ItemKind;
  itemName: Scalars['String']['output'];
  itemPrice: Scalars['Decimal']['output'];
  itemPriceOptionID?: Maybe<Scalars['Int32']['output']>;
  itemPriceOptionName?: Maybe<Scalars['String']['output']>;
  itemQuantity: Scalars['Int32']['output'];
  labels: Array<OnlineOrderDetailsLabel>;
  menuCategoryID?: Maybe<Scalars['Int32']['output']>;
  menuID?: Maybe<Scalars['Int32']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  obrandID: Scalars['Int32']['output'];
  oorganizationID: Scalars['UUID']['output'];
  orderDetailID: Scalars['UUID']['output'];
  orderID: Scalars['UUID']['output'];
  oshopID: Scalars['Int32']['output'];
  parentDetail?: Maybe<OnlineOrderDetail>;
  parentDetailID?: Maybe<Scalars['UUID']['output']>;
  /** 加點狀態 */
  status?: Maybe<OnlineOrderDetailStatus>;
  subtotalAmount: Scalars['Decimal']['output'];
  taxAmount: Scalars['Decimal']['output'];
  taxCategory: TaxCategory;
  taxUnitInfo?: Maybe<Scalars['JSON']['output']>;
  totalAmount: Scalars['Decimal']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
};

/** 線上訂單明細狀態 */
export enum OnlineOrderDetailStatus {
  /** 待處理 */
  Pending = 'Pending',
  /** 處理中 */
  Processing = 'Processing',
  /** 已拒絕 */
  Rejected = 'Rejected',
}

/** 線上訂單明細標籤 */
export type OnlineOrderDetailsLabel = {
  createdAt: Scalars['DateTimeZ']['output'];
  displayOrder: Scalars['Int16']['output'];
  labelGroupID?: Maybe<Scalars['Int32']['output']>;
  labelGroupName?: Maybe<Scalars['String']['output']>;
  labelID: Scalars['Int32']['output'];
  labelName: Scalars['String']['output'];
  labelPrice: Scalars['Decimal']['output'];
  labelQuantity: Scalars['Int16']['output'];
  obrandID: Scalars['Int32']['output'];
  oorganizationID: Scalars['UUID']['output'];
  orderDetailID: Scalars['UUID']['output'];
  orderID: Scalars['UUID']['output'];
  oshopID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
};

/** 線上訂單折扣 */
export type OnlineOrderDiscount = {
  amount: Scalars['Decimal']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  discountID: Scalars['UUID']['output'];
  discountType: OnlineOrderDiscountType;
  name: Scalars['String']['output'];
  obrandID: Scalars['Int32']['output'];
  oorganizationID: Scalars['UUID']['output'];
  orderID: Scalars['UUID']['output'];
  oshopID: Scalars['Int32']['output'];
  sourceID?: Maybe<Scalars['String']['output']>;
};

/** 線上訂單優惠執行套用順序 */
export enum OnlineOrderDiscountExecApplyPriority {
  /** 價錢從高到低優先 */
  PriceHighToLow = 'PriceHighToLow',
  /** 價錢從低到高優先 */
  PriceLowToHigh = 'PriceLowToHigh',
}

/** 訂單折扣類型 */
export enum OnlineOrderDiscountType {
  Coupon = 'Coupon',
  Member = 'Member',
  Promotion = 'Promotion',
}

/** 取餐方式 */
export enum OnlineOrderFetchType {
  Delivery = 'Delivery',
  DineIn = 'DineIn',
  PickUp = 'PickUp',
  TakeOut = 'TakeOut',
}

/** 線上訂單性別 */
export enum OnlineOrderGender {
  Female = 'Female',
  Male = 'Male',
  Other = 'Other',
  Undisclosed = 'Undisclosed',
}

/** 線上訂單發票類型 */
export enum OnlineOrderInvoiceType {
  Carrier = 'Carrier',
  Paper = 'Paper',
}

export type OnlineOrderList = {
  /** 撥款金額 (銷售總額−平台手續費) */
  appropriationAmount: Scalars['Decimal']['output'];
  /** 訂單日期 */
  createdAt: Scalars['DateTimeZ']['output'];
  /** 外送費 */
  deliveryFeeAmount: Scalars['Decimal']['output'];
  /** 折扣金額 */
  discountAmount: Scalars['Decimal']['output'];
  /** 外加稅金 */
  exclusiveTaxAmount: Scalars['Decimal']['output'];
  /** 外部訂單代碼 */
  externalOrderCode?: Maybe<Scalars['String']['output']>;
  /** 線上訂單序號 */
  externalOrderNo?: Maybe<Scalars['String']['output']>;
  /** 支付方式 */
  onlineOrderPayments: Array<OnlineOrderPayments>;
  /** 訂單單號 */
  orderCode: Scalars['String']['output'];
  orderID: Scalars['UUID']['output'];
  /** 訂單序號 */
  orderNo: Scalars['String']['output'];
  /** 來源 */
  orderSource: Scalars['String']['output'];
  /** 訂單狀態 */
  orderStatus: Scalars['String']['output'];
  /** 訂單進度 */
  orderSubStatus?: Maybe<Scalars['String']['output']>;
  /** 訂單類型 */
  orderType: Scalars['String']['output'];
  /** 交易時間 */
  paymentTime: Array<Scalars['DateTimeZ']['output']>;
  /** 平台手續費 */
  platformServiceFeeAmount: Scalars['Decimal']['output'];
  /** 作廢訂單序號 */
  refundedOrderNo?: Maybe<Scalars['String']['output']>;
  /** 服務費 */
  serviceFeeAmount: Scalars['Decimal']['output'];
  /** 商品總額 */
  subtotalAmount: Scalars['Decimal']['output'];
  /** 銷售總額 */
  totalAmount: Scalars['Decimal']['output'];
};

export type OnlineOrderListCsvInput = {
  /** 匯出線上訂單列表csv欄位 */
  columnIndices: OnlineOrderListColumnIndices;
  /** 語系 */
  locale: Locales;
  /** 搜尋關鍵字 */
  search?: InputMaybe<Scalars['String']['input']>;
  /** 搜尋欄位 */
  searchCondition?: InputMaybe<OnlineOrderSearchCondition>;
  /** 篩選條件 */
  searchParams: OnlineOrderSearchParams;
  shopKey: ShopKey;
  /** 排序 (欄位) */
  sortField: Scalars['String']['input'];
  /** 排序 (升/降) */
  sortOrder: SortOrder;
  /** 時區 */
  timezone: Scalars['String']['input'];
};

export type OnlineOrderListColumnIndices = {
  /** 撥款金額 (銷售總額−平台手續費) */
  appropriationAmount?: InputMaybe<Scalars['Int16']['input']>;
  /** 訂單日期 */
  createdAt?: InputMaybe<Scalars['Int16']['input']>;
  /** 外送費 */
  deliveryFeeAmount?: InputMaybe<Scalars['Int16']['input']>;
  /** 折扣金額 */
  discountAmount?: InputMaybe<Scalars['Int16']['input']>;
  /** 外加稅金 */
  exclusiveTaxAmount?: InputMaybe<Scalars['Int16']['input']>;
  /** 線上訂單單號 */
  externalOrderCode?: InputMaybe<Scalars['Int16']['input']>;
  /** 線上訂單序號 */
  externalOrderNo?: InputMaybe<Scalars['Int16']['input']>;
  /** 支付方式 */
  onlineOrderPayments?: InputMaybe<Scalars['Int16']['input']>;
  /** 訂單單號 */
  orderCode?: InputMaybe<Scalars['Int16']['input']>;
  /** 訂單序號 */
  orderNo?: InputMaybe<Scalars['Int16']['input']>;
  /** 來源 */
  orderSource?: InputMaybe<Scalars['Int16']['input']>;
  /** 訂單狀態 */
  orderStatus?: InputMaybe<Scalars['Int16']['input']>;
  /** 訂單進度 */
  orderSubStatus?: InputMaybe<Scalars['Int16']['input']>;
  /** 訂單類型 */
  orderType?: InputMaybe<Scalars['Int16']['input']>;
  /** 支付時間 */
  paymentTime?: InputMaybe<Scalars['Int16']['input']>;
  /** 平台手續費 */
  platformServiceFeeAmount?: InputMaybe<Scalars['Int16']['input']>;
  /** 作廢訂單序號 */
  refundedOrderNo?: InputMaybe<Scalars['Int16']['input']>;
  /** 服務費 */
  serviceFeeAmount?: InputMaybe<Scalars['Int16']['input']>;
  /** 商品總額 */
  subtotalAmount?: InputMaybe<Scalars['Int16']['input']>;
  /** 銷售總額 */
  totalAmount?: InputMaybe<Scalars['Int16']['input']>;
};

export type OnlineOrderListPagination = {
  onlineOrders: Array<OnlineOrderList>;
  pageInfo: CursorPageInfo;
};

/** 線上訂單Meta */
export type OnlineOrderMeta = {
  carrierCode?: Maybe<Scalars['String']['output']>;
  contactAddress?: Maybe<Scalars['String']['output']>;
  contactDistance?: Maybe<Scalars['Decimal']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactGender?: Maybe<OnlineOrderGender>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['String']['output']>;
  e164CountryCode?: Maybe<Scalars['String']['output']>;
  /** 擴充資訊(JSON) */
  extraData?: Maybe<Scalars['JSON']['output']>;
  invoiceNo?: Maybe<Scalars['String']['output']>;
  invoiceType?: Maybe<OnlineOrderInvoiceType>;
  obrandID: Scalars['Int32']['output'];
  oorganizationID: Scalars['UUID']['output'];
  orderID: Scalars['UUID']['output'];
  oshopID: Scalars['Int32']['output'];
  paymentMethod?: Maybe<OnlineOrderPaymentMethod>;
  vatNo?: Maybe<Scalars['String']['output']>;
};

export enum OnlineOrderNumberingMode {
  /** 分開取號 */
  Separate = 'Separate',
  /** 與 POS 統一取號 */
  UnifiedWithPos = 'UnifiedWithPOS',
}

export type OnlineOrderOffDayInput = {
  offDay: Scalars['Date']['input'];
  offDayID?: InputMaybe<Scalars['Int32']['input']>;
};

export type OnlineOrderOrderingHourInput = {
  endTime: Scalars['Time']['input'];
  hourID?: InputMaybe<Scalars['Int32']['input']>;
  startTime: Scalars['Time']['input'];
  weekDay: Scalars['Int16']['input'];
};

/** 線上訂單支付 */
export type OnlineOrderPayment = {
  amount: Scalars['Decimal']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  currency: Scalars['String']['output'];
  externalTransactionalID?: Maybe<Scalars['String']['output']>;
  obrandID: Scalars['Int32']['output'];
  oorganizationID: Scalars['UUID']['output'];
  orderID: Scalars['UUID']['output'];
  oshopID: Scalars['Int32']['output'];
  payInfoUrl?: Maybe<Scalars['String']['output']>;
  paymentID: Scalars['UUID']['output'];
  rawResponse?: Maybe<Scalars['String']['output']>;
  refunds: Array<OnlineOrderPaymentRefund>;
  status: OnlineOrderTransactionStatus;
  updatedAt: Scalars['DateTimeZ']['output'];
};

/** 線上訂單支付方式 */
export enum OnlineOrderPaymentMethod {
  LinePay = 'LinePay',
  OnSite = 'OnSite',
  StripeOnline = 'StripeOnline',
}

/** 線上訂單支付退款 */
export type OnlineOrderPaymentRefund = {
  amount: Scalars['Decimal']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  obrandID: Scalars['Int32']['output'];
  oorganizationID: Scalars['UUID']['output'];
  orderID: Scalars['UUID']['output'];
  oshopID: Scalars['Int32']['output'];
  paymentID: Scalars['UUID']['output'];
  rawResponse?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  refundID: Scalars['UUID']['output'];
  refundTransactionID?: Maybe<Scalars['String']['output']>;
  status: OnlineOrderTransactionStatus;
};

export type OnlineOrderPayments = {
  /** 支付金額 */
  amount: Scalars['Decimal']['output'];
  name: Scalars['String']['output'];
};

/** 線上點餐提供者 */
export enum OnlineOrderProvider {
  Dd2 = 'DD2',
  EightWay = 'EightWay',
  FoodPanda = 'FoodPanda',
  UberEats = 'UberEats',
}

/** 線上點餐OAuth權限 */
export type OnlineOrderProviderOAuthToken = {
  accessToken: Scalars['String']['output'];
  clientID: Scalars['String']['output'];
  expiresAt: Scalars['DateTimeZ']['output'];
  isActive: Scalars['Boolean']['output'];
  issuedAt: Scalars['DateTimeZ']['output'];
  provider: OnlineOrderProvider;
  refreshToken?: Maybe<Scalars['String']['output']>;
  scopes: Scalars['String']['output'];
  tokenID: Scalars['Int64']['output'];
};

export type OnlineOrderRatioOverview = {
  /** 線上與掃碼點餐筆數佔全店總訂單的比例 */
  percentageExcludeOffline: Scalars['Decimal']['output'];
  /** 總訂單筆數及其分類佔比明細 */
  totalOrders: TotalOrderRatioDetail;
};

export type OnlineOrderRevenueDetail = {
  amount: Scalars['Decimal']['output'];
  details?: Maybe<Array<OnlineOrderSourceDetail>>;
  percentage: Scalars['Decimal']['output'];
};

export type OnlineOrderRevenueOverview = {
  onlineOrder: OnlineOrderRevenueDetail;
  scanOrder: OnlineOrderRevenueDetail;
  totalRevenue: Scalars['Decimal']['output'];
};

export type OnlineOrderRevenueTrendDetail = {
  onlineOrder: Scalars['Decimal']['output'];
  onlineOrderDetails?: Maybe<Array<OnlineOrderSourceDetail>>;
  onlineOrderPercentage: Scalars['Decimal']['output'];
  scanOrder: Scalars['Decimal']['output'];
  scanOrderDetails?: Maybe<Array<OnlineOrderSourceDetail>>;
  scanOrderPercentage: Scalars['Decimal']['output'];
  time: Scalars['DateTime']['output'];
  totalRevenue: Scalars['Decimal']['output'];
};

export type OnlineOrderRevenueTrendResponse = {
  acceptTimeUnit: Array<Scalars['String']['output']>;
  revenueTrends: Array<OnlineOrderRevenueTrendDetail>;
  yRange: Array<Scalars['Decimal']['output']>;
};

/** 訂單類型 */
export enum OnlineOrderSchedulingType {
  Immediate = 'Immediate',
  Preorder = 'Preorder',
}

export enum OnlineOrderSearchCondition {
  /** 外部訂單單號 */
  ExternalOrderCode = 'externalOrderCode',
  /** 外部訂單序號 */
  ExternalOrderNo = 'externalOrderNo',
  /** 訂單單號 */
  OrderCode = 'orderCode',
  /** 訂單序號 */
  OrderNo = 'orderNo',
}

/** 篩選條件 */
export type OnlineOrderSearchParams = {
  /** 搜尋訂單區間 */
  businessDateRange?: InputMaybe<TimeRange>;
  createdAtRange?: InputMaybe<TimeRange>;
  /** 訂單狀態 (沒傳入則查詢全部狀態) */
  orderStatus?: InputMaybe<OrderStatus>;
  /** 訂單類型 */
  orderType?: InputMaybe<OrderType>;
  /** 訂單來源 */
  providerOrder?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** 預訂時間 */
  reservedAtRange?: InputMaybe<TimeRange>;
};

export type OnlineOrderSettingInput = {
  deleteIDs?: InputMaybe<Array<Scalars['Int32']['input']>>;
  files?: InputMaybe<Array<Scalars['Upload']['input']>>;
  shopO2OSettingInput: ShopO2OSettingInput;
};

/** 線上訂單設定套用範圍 */
export enum OnlineOrderSettingsScope {
  /** 套用至所有訂單來源 */
  AllSources = 'AllSources',
  /** 依訂單來源分別設定 */
  BySource = 'BySource',
}

export type OnlineOrderSourceDetail = {
  amount: Scalars['Decimal']['output'];
  count: Scalars['Int32']['output'];
  percentage: Scalars['Decimal']['output'];
  source: Scalars['String']['output'];
};

/** 訂單狀態 */
export enum OnlineOrderStatus {
  /** 已完成 */
  Completed = 'Completed',
  /** 已刪除-客戶主動取消 */
  Deleted = 'Deleted',
  /** 配送中 */
  Delivering = 'Delivering',
  /** 未接單 */
  Pending = 'Pending',
  /** 進行中 */
  Processing = 'Processing',
  /** 可取餐 */
  Ready = 'Ready',
  /** 已退回-店家拒絕接單 */
  Rejected = 'Rejected',
  /** 已終止-店家主動終止訂單 */
  Terminated = 'Terminated',
}

export type OnlineOrderTimeSetting = {
  offDays: Array<ShopO2OOffDay>;
  orderingHours: Array<ShopO2OOrderingHour>;
};

/** 交易狀態 */
export enum OnlineOrderTransactionStatus {
  Failed = 'Failed',
  Pending = 'Pending',
  Refund = 'Refund',
  Success = 'Success',
}

export type OnlineOrderVolumeDetail = {
  count: Scalars['Int32']['output'];
  details?: Maybe<Array<OnlineOrderSourceDetail>>;
  percentage: Scalars['Decimal']['output'];
};

export type OnlineOrderVolumeOverview = {
  onlineOrder: OnlineOrderVolumeDetail;
  scanOrder: OnlineOrderVolumeDetail;
  totalVolume: Scalars['Int32']['output'];
};

export type OnlineOrderVolumeTrendDetail = {
  onlineOrder: Scalars['Int32']['output'];
  onlineOrderDetails?: Maybe<Array<OnlineOrderSourceDetail>>;
  onlineOrderPercentage: Scalars['Decimal']['output'];
  scanOrder: Scalars['Int32']['output'];
  scanOrderDetails?: Maybe<Array<OnlineOrderSourceDetail>>;
  scanOrderPercentage: Scalars['Decimal']['output'];
  time: Scalars['DateTime']['output'];
  totalVolume: Scalars['Int32']['output'];
};

export type OnlineOrderVolumeTrendResponse = {
  acceptTimeUnit: Array<Scalars['String']['output']>;
  volumeTrends: Array<OnlineOrderVolumeTrendDetail>;
  yRange: Array<Scalars['Decimal']['output']>;
};

/** 訂單 */
export type Order = {
  /** 大人人數 */
  adult: Scalars['Int16']['output'];
  /** 嬰兒座椅數量 */
  babyChair: Scalars['Int16']['output'];
  brand: Brand;
  /** 品牌用餐方式 */
  brandDiningOption: BrandDiningOption;
  /** 品牌用餐方式ID */
  brandDiningOptionID: Scalars['Int32']['output'];
  brandID: Scalars['Int32']['output'];
  /** 營業日 */
  businessDate: Scalars['Date']['output'];
  /** 取消時間 */
  cancelledAt?: Maybe<Scalars['DateTimeZ']['output']>;
  /** 載具號碼 */
  carrierCode?: Maybe<Scalars['String']['output']>;
  /** 載具顯碼 */
  carrierID1?: Maybe<Scalars['String']['output']>;
  /** 載具隱碼 */
  carrierID2?: Maybe<Scalars['String']['output']>;
  /** 發票載具 */
  carrierType?: Maybe<InvoiceCarrierType>;
  /** 結帳時間 */
  checkedOutAt?: Maybe<Scalars['DateTimeZ']['output']>;
  /** 小孩人數 */
  child: Scalars['Int16']['output'];
  /** 顧客地址 */
  contactAddress?: Maybe<Scalars['String']['output']>;
  /** 顧客距離 */
  contactDistance?: Maybe<Scalars['Decimal']['output']>;
  /** 顧客電子郵件 */
  contactEmail?: Maybe<Scalars['String']['output']>;
  /** 顧客性別 */
  contactGender?: Maybe<Gender>;
  /** 顧客姓名 */
  contactName?: Maybe<Scalars['String']['output']>;
  /** 顧客電話 */
  contactPhone?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeZ']['output'];
  /** 顧客 */
  customer: Customer;
  /** 顧客 ID */
  customerID?: Maybe<Scalars['UUID']['output']>;
  /** 外送費 */
  deliveryFeeAmount: Scalars['Decimal']['output'];
  /** 機號 */
  deviceCode: Scalars['String']['output'];
  /** 用餐方式名稱 */
  diningOptionName: Scalars['String']['output'];
  /** 用餐方式類型 */
  diningOptionType: DiningOptionType;
  /** 折扣金額 */
  discountAmount: Scalars['Decimal']['output'];
  /** 捐贈碼 */
  donationCode?: Maybe<Scalars['String']['output']>;
  /** 外加稅 */
  exclusiveTaxAmount: Scalars['Decimal']['output'];
  /** 外部訂單單號 */
  externalOrderCode?: Maybe<Scalars['String']['output']>;
  /** 外部訂單序號 */
  externalOrderNo?: Maybe<Scalars['String']['output']>;
  /** 是否為主單 */
  isLeadOrder: Scalars['Boolean']['output'];
  /** 是否為 POS 訂單（由 order_source_id 自動計算） */
  isPosOrder?: Maybe<Scalars['Boolean']['output']>;
  /** 主單 */
  leadOrder?: Maybe<Order>;
  /** 主單 ID */
  leadOrderID?: Maybe<Scalars['UUID']['output']>;
  /** 訂單桌位關聯 */
  linkOrderTables: Array<LinkOrderTable>;
  /** 會員 */
  member: WorkspaceMember;
  /** 會員 ID */
  memberID?: Maybe<Scalars['UUID']['output']>;
  /** 會員來源 ID */
  memberSourceID?: Maybe<Scalars['UUID']['output']>;
  /** 中繼資料(JSON) */
  meta?: Maybe<Scalars['JSON']['output']>;
  /** 低消金額 */
  minChargeAmount: Scalars['Decimal']['output'];
  /** 是否需要額外提袋 */
  needExtraBag: Scalars['Boolean']['output'];
  /** 是否需要餐具 */
  needUtensil: Scalars['Boolean']['output'];
  /** 訂單備註 */
  note?: Maybe<Scalars['String']['output']>;
  opUser?: Maybe<Employee>;
  /** 操作人員 */
  opUserID?: Maybe<Scalars['UUID']['output']>;
  /** 訂單分類 */
  orderCategory: OrderCategory;
  /** 訂單單號 */
  orderCode: Scalars['String']['output'];
  /** 點餐單號模式 */
  orderCodeMode: OrderCodeMode;
  /** 訂單明細 */
  orderDetails: Array<OrderDetail>;
  /** 訂單優惠折扣 */
  orderDiscounts?: Maybe<Array<OrderDiscount>>;
  orderID: Scalars['UUID']['output'];
  /** 訂單序號 */
  orderNo: Scalars['String']['output'];
  /** 叫餐備註 */
  orderRemark?: Maybe<Scalars['String']['output']>;
  /** 叫餐備註名稱 */
  orderRemarkTitle?: Maybe<Scalars['String']['output']>;
  /** 訂單來源 */
  orderSource: OrderSource;
  /** 訂單來源 App */
  orderSourceApp?: Maybe<App>;
  /** 訂單來源 ID */
  orderSourceID?: Maybe<Scalars['UUID']['output']>;
  /** 訂單狀態 */
  orderStatus: OrderStatus;
  /** 訂單子狀態 */
  orderSubStatus?: Maybe<OrderSubStatus>;
  /** 訂單類型 */
  orderType: OrderType;
  /** 暫存時間 */
  parkedAt?: Maybe<Scalars['DateTimeZ']['output']>;
  /** 平台服務費 */
  platformServiceFeeAmount: Scalars['Decimal']['output'];
  /** 未稅額 */
  preTaxAmount: Scalars['Decimal']['output'];
  /** 退款原因 */
  refundReason?: Maybe<Scalars['String']['output']>;
  /** 退款時間 */
  refundedAt?: Maybe<Scalars['DateTimeZ']['output']>;
  /** 退款來源訂單 */
  refundedFrom?: Maybe<Order>;
  /** 退款來源訂單ID */
  refundedFromID?: Maybe<Scalars['UUID']['output']>;
  /** 預訂時間 */
  reservedAt?: Maybe<Scalars['DateTimeZ']['output']>;
  /** 訂單排程類型 (區分現做或預約) */
  schedulingType: OrderSchedulingType;
  /** 服務費金額 */
  serviceFeeAmount: Scalars['Decimal']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  /** 狀態日誌(JSON) */
  statusLog?: Maybe<Scalars['JSON']['output']>;
  /** 商品金額 = SUM (orderDetails.subtotalAmount) */
  subtotalAmount: Scalars['Decimal']['output'];
  /** 桌位資訊(JSON) */
  tableInfo?: Maybe<Scalars['JSON']['output']>;
  /**
   * 桌號
   * @deprecated use tableInfo instead
   */
  tableNo?: Maybe<Scalars['String']['output']>;
  /** 稅額 */
  taxAmount: Scalars['Decimal']['output'];
  /** 統一編號 */
  taxID?: Maybe<Scalars['String']['output']>;
  /** 訂單稅金資訊 */
  taxInfo?: Maybe<Scalars['JSON']['output']>;
  /** 訂單總金額(含稅) = 商品金額 + 其他費用 (服務費、低消) - 折扣 + 其它(外加稅) */
  totalAmount: Scalars['Decimal']['output'];
  /** 交易 */
  transactions: Array<Transaction>;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export enum OrderBy {
  Amount = 'Amount',
  Count = 'Count',
}

/** 訂單分類 */
export enum OrderCategory {
  /** 線下 */
  Offline = 'Offline',
  /** 線上 */
  Online = 'Online',
}

/** 點餐單號模式 */
export enum OrderCodeMode {
  /** 分袋模式(一張單一個單號，分袋使用順序號) */
  BagSeqNo = 'BagSeqNo',
  /** 一般模式(一張單一個單號) */
  General = 'General',
  /** 多領餐號模式(一張單多個單號) */
  MultiOrderCode = 'MultiOrderCode',
}

/** 匯出訂單csv欄位(Order) */
export type OrderColumnIndices = {
  /** 營業日 */
  businessDate: Scalars['Int16']['input'];
  /** 訂單日期 */
  createdAt: Scalars['Int16']['input'];
  /** 裝置資訊 */
  deviceCode: Scalars['Int16']['input'];
  /** 用餐方式(名稱) */
  diningOptionName: Scalars['Int16']['input'];
  /** 折扣 */
  discountAmount: Scalars['Int16']['input'];
  employee?: InputMaybe<EmployeeOrderColumnIndices>;
  /** 外部單號 */
  externalOrderNo: Scalars['Int16']['input'];
  /** 訂單員工 */
  opUserID?: InputMaybe<Scalars['Int16']['input']>;
  /** 單號 */
  orderCode: Scalars['Int16']['input'];
  /** 訂單序號 */
  orderNo: Scalars['Int16']['input'];
  /** 訂單來源 */
  orderSource: Scalars['Int16']['input'];
  /** 狀態 */
  orderStatus: Scalars['Int16']['input'];
  /** 訂單類型 */
  orderType: Scalars['Int16']['input'];
  /** 人數 */
  people: Scalars['Int16']['input'];
  /** 預訂時間 */
  reservedAt: Scalars['Int16']['input'];
  /** 服務費 */
  serviceFeeAmount: Scalars['Int16']['input'];
  /** 商品總額 */
  subtotalAmount: Scalars['Int16']['input'];
  /** 桌號 */
  tableNo: Scalars['Int16']['input'];
  /** 稅額 */
  taxAmount: Scalars['Int16']['input'];
  /** 銷售總額 */
  totalAmount: Scalars['Int16']['input'];
  /** 交易 */
  transactions: TransactionOrderColumnIndices;
};

/** 訂單明細 */
export type OrderDetail = {
  /** 是否為 POS 系統加點項目 */
  addOnByPos?: Maybe<Scalars['Boolean']['output']>;
  /** 加點序號 */
  addOnSeq?: Maybe<Scalars['Int16']['output']>;
  /** 加點狀態 */
  addOnStatus?: Maybe<OrderDetailAddOnStatus>;
  /** 拆帳主單商品分配到的外送費 */
  allocatedDeliveryFeeAmount?: Maybe<Scalars['Decimal']['output']>;
  /** 拆帳主單商品分配到的外加稅。 */
  allocatedExclusiveTaxAmount: Scalars['Decimal']['output'];
  /** 拆帳主單商品分配到的低消金額 */
  allocatedMinChargeAmount: Scalars['Decimal']['output'];
  /** 拆帳要分配的整單折扣金額 */
  allocatedOrderDiscountAmount: Scalars['Decimal']['output'];
  /** 拆帳要分配的服務費金額 */
  allocatedServiceFeeAmount: Scalars['Decimal']['output'];
  /** 拆帳主單商品分配到的稅金。 */
  allocatedTaxAmount: Scalars['Decimal']['output'];
  /** 拆帳主單分配到的整筆訂單權重金額。 */
  allocatedTotalAmountWeight: Scalars['Decimal']['output'];
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  /** 商品群組ID */
  bundleID?: Maybe<Scalars['Int32']['output']>;
  /** 更換時間 */
  changedAt?: Maybe<Scalars['DateTimeZ']['output']>;
  /** 更換的訂單明細 */
  changedFrom?: Maybe<OrderDetail>;
  /** 更換的訂單明細ID */
  changedFromID?: Maybe<Scalars['UUID']['output']>;
  /** 招待理由 */
  complimentaryReason?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeZ']['output'];
  /** 第幾次刪單 */
  deleteSeq: Scalars['Int16']['output'];
  deletedAt?: Maybe<Scalars['SoftDeleteZ']['output']>;
  /** 機號 */
  deviceCode: Scalars['String']['output'];
  /** 訂單明細分群單號(分袋/多領餐號模式時使用) */
  groupOrderCode?: Maybe<Scalars['String']['output']>;
  /** 是否為招待 */
  isComplimentary: Scalars['Boolean']['output'];
  /** 第幾次出單 */
  issueSeq: Scalars['Int16']['output'];
  /** 出單時間 */
  issuedAt?: Maybe<Scalars['DateTimeZ']['output']>;
  /** 商品 */
  item: Item;
  /** 商品進階價位ID */
  itemAdvPriceID?: Maybe<Scalars['Int32']['output']>;
  /** 商品分類ID */
  itemCategoryID?: Maybe<Scalars['Int32']['output']>;
  /** 商品分類名稱 */
  itemCategoryName: Scalars['String']['output'];
  /** 商品ID */
  itemID: Scalars['Int32']['output'];
  /** 商品種類 */
  itemKind: ItemKind;
  /** 商品名稱 */
  itemName: Scalars['String']['output'];
  /** 單價 */
  itemPrice: Scalars['Decimal']['output'];
  /** 商品價位顏色 */
  itemPriceOptionColor?: Maybe<Scalars['String']['output']>;
  /** 商品價位ID */
  itemPriceOptionID: Scalars['Int32']['output'];
  /** 商品價位名稱 */
  itemPriceOptionName: Scalars['String']['output'];
  /** 數量 */
  itemQuantity: Scalars['Int16']['output'];
  /** 菜單分類ID */
  menuCategoryID?: Maybe<Scalars['Int32']['output']>;
  /** 菜單ID */
  menuID?: Maybe<Scalars['Int32']['output']>;
  /** 備註 */
  note?: Maybe<Scalars['String']['output']>;
  opUser?: Maybe<Employee>;
  /** 操作人員 */
  opUserID?: Maybe<Scalars['UUID']['output']>;
  order: Order;
  /** 訂單明細優惠折扣 */
  orderDetailDiscounts?: Maybe<Array<OrderDetailDiscount>>;
  orderDetailID: Scalars['UUID']['output'];
  /** 訂單明細 */
  orderDetailLabels: Array<OrderDetailLabel>;
  /** 訂單明細狀態 */
  orderDetailStatus: OrderDetailStatus;
  orderID: Scalars['UUID']['output'];
  /** 父訂單明細 */
  parent?: Maybe<OrderDetail>;
  /** 父訂單明細ID */
  parentID?: Maybe<Scalars['UUID']['output']>;
  /** 退餐理由 */
  returnReason?: Maybe<Scalars['String']['output']>;
  /** 退餐時間 */
  returnedAt?: Maybe<Scalars['DateTimeZ']['output']>;
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  /** 商品金額 = 商品單價 ± 標籤 * 數量總額 */
  subtotalAmount: Scalars['Decimal']['output'];
  /** 稅額 */
  taxAmount: Scalars['Decimal']['output'];
  /** 稅金類別 */
  taxCategory: TaxCategory;
  /** 商品稅率是否被修改 */
  taxRateChanged: Scalars['Boolean']['output'];
  /** 稅金資訊(JSON 格式組成一個 Array，每個元素為一個 Object，包含「稅金名稱」、「稅金計算方式」、「稅率 %」、「進位方式」) */
  taxUnitInfo?: Maybe<Scalars['JSON']['output']>;
  /** 訂單明細總金額 (訂單明細關聯的商品金額加總。套餐 = 套餐頭 + 套餐細項商品金額加總。單品/套餐細項 = 商品金額) */
  totalAmount: Scalars['Decimal']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  /** 重量 */
  weight?: Maybe<Scalars['Decimal']['output']>;
  /** 單價基準量 */
  weightBaseQuantity?: Maybe<Scalars['Decimal']['output']>;
  /** 重量單位 */
  weightUnit?: Maybe<WeightUnit>;
  /** 單位售價 */
  weightUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 訂單明細加點狀態 */
export enum OrderDetailAddOnStatus {
  /** 待處理 */
  Pending = 'Pending',
  /** 處理中 */
  Processing = 'Processing',
  /** 已拒絕 */
  Rejected = 'Rejected',
}

/** 訂單明細優惠折扣 */
export type OrderDetailDiscount = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  /** 優惠計算規則 */
  calcMethod: DiscountCalcMethod;
  createdAt: Scalars['DateTimeZ']['output'];
  deletedAt?: Maybe<Scalars['SoftDeleteZ']['output']>;
  /** 優惠折扣 */
  discount?: Maybe<Discount>;
  /** 優惠金額 */
  discountAmount: Scalars['Decimal']['output'];
  /** 優惠編號(ID) */
  discountCode?: Maybe<Scalars['String']['output']>;
  /** 優惠套用次數 */
  discountCount: Scalars['Int16']['output'];
  /** 優惠折扣ID */
  discountID?: Maybe<Scalars['Int32']['output']>;
  /** 優惠折扣名稱 */
  discountName: Scalars['String']['output'];
  /** 優惠優先權 */
  discountPriority: Scalars['Int16']['output'];
  /** 指定優惠 Session ID：當指定商品優惠套用了多次後（例如：買五送一，買了十二杯所以可以套用兩次），用來分辨哪些折扣是在同一輪被加入的，也在 UI 排序時使用。 */
  discountSessionID?: Maybe<Scalars['Int16']['output']>;
  /** 商品項目折扣分配。-> 商品可選多數量，這裡表示哪一個項目被分配到折扣 */
  discountShareByIndex?: Maybe<Scalars['JSON']['output']>;
  /** 優惠折扣來源 */
  discountSource: DiscountSource;
  /** 優惠折扣類型 */
  discountType?: Maybe<DiscountType>;
  /** 手動優惠折扣資訊(JSON 格式組成一個 Object，包含「折扣套用方式（全部數量或單筆）」、「折扣明細」) */
  manualDiscountInfo?: Maybe<Scalars['JSON']['output']>;
  /** 手動優惠折扣原因 */
  manualDiscountReason?: Maybe<Scalars['String']['output']>;
  order: Order;
  orderDetail: OrderDetail;
  orderDetailDiscountID: Scalars['UUID']['output'];
  orderDetailID: Scalars['UUID']['output'];
  orderID: Scalars['UUID']['output'];
  /** 服務費來源折扣金額 */
  serviceFeeBaseDiscountAmount: Scalars['Decimal']['output'];
  /** 商品項目服務費來源金額折扣分配 */
  serviceFeeBaseDiscountShareByIndex?: Maybe<Scalars['JSON']['output']>;
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 訂單明細標籤 */
export type OrderDetailLabel = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  deletedAt?: Maybe<Scalars['SoftDeleteZ']['output']>;
  /** 顯示順序 */
  displayOrder: Scalars['Int16']['output'];
  /** 標籤顏色 */
  labelColor?: Maybe<Scalars['String']['output']>;
  /** 標籤群組ID */
  labelGroupID?: Maybe<Scalars['Int32']['output']>;
  /** 標籤群組名稱 */
  labelGroupName?: Maybe<Scalars['String']['output']>;
  labelID: Scalars['Int32']['output'];
  /** 標籤名稱 */
  labelName: Scalars['String']['output'];
  /** 標籤價錢 */
  labelPrice: Scalars['Decimal']['output'];
  /** 標籤數量 */
  labelQuantity: Scalars['Int16']['output'];
  order: Order;
  orderDetail: OrderDetail;
  orderDetailID: Scalars['UUID']['output'];
  orderID: Scalars['UUID']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 訂單明細狀態 */
export enum OrderDetailStatus {
  /** 餐點已叫餐 */
  Called = 'Called',
  /** 餐點已更換 */
  Changed = 'Changed',
  /** 餐點已刪除 */
  Deleted = 'Deleted',
  /** 餐點已出單 */
  Issued = 'Issued',
  /** 進行中 */
  Processing = 'Processing',
  /** 餐點已出餐 */
  Served = 'Served',
}

/** 訂單優惠折扣 */
export type OrderDiscount = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  /** 優惠計算規則 */
  calcMethod: DiscountCalcMethod;
  createdAt: Scalars['DateTimeZ']['output'];
  deletedAt?: Maybe<Scalars['SoftDeleteZ']['output']>;
  /** 優惠折扣 */
  discount?: Maybe<Discount>;
  /** 折扣金額 */
  discountAmount: Scalars['Decimal']['output'];
  /** 優惠編號(ID) */
  discountCode?: Maybe<Scalars['String']['output']>;
  /** 優惠套用次數 */
  discountCount: Scalars['Int16']['output'];
  /** 優惠折扣ID */
  discountID?: Maybe<Scalars['Int32']['output']>;
  /** 優惠折扣名稱 */
  discountName: Scalars['String']['output'];
  /** 優惠優先權 */
  discountPriority: Scalars['Int16']['output'];
  /** 優惠折扣來源 */
  discountSource: DiscountSource;
  /** 優惠折扣類型 */
  discountType?: Maybe<DiscountType>;
  /** 手動優惠折扣資訊(JSON 格式組成一個 Object，包含「折扣金額」、「折扣方式」、「折扣輸入數值」) */
  manualDiscountInfo?: Maybe<Scalars['JSON']['output']>;
  /** 手動優惠折扣原因 */
  manualDiscountReason?: Maybe<Scalars['String']['output']>;
  /** 低消來源折扣金額 */
  minChargeDiscountAmount: Scalars['Decimal']['output'];
  order: Order;
  /** 參與折扣的商品 IDs */
  orderDetailIDs?: Maybe<Array<Scalars['UUID']['output']>>;
  orderDiscountID: Scalars['UUID']['output'];
  orderID: Scalars['UUID']['output'];
  /** 服務費來源折扣金額 */
  serviceFeeBaseDiscountAmount: Scalars['Decimal']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 訂單折扣類型 */
export enum OrderDiscountType {
  Coupon = 'Coupon',
  Member = 'Member',
  Promotion = 'Promotion',
}

/** 取餐方式 */
export enum OrderFetchType {
  Delivery = 'Delivery',
  Pickup = 'Pickup',
}

export type OrderInvoiceColumnIndices = {
  /** 訂單日期 */
  createdAt: Scalars['Int16']['input'];
  /** 訂單序號 */
  orderNo: Scalars['Int16']['input'];
};

export type OrderKey = {
  brandID: Scalars['Int32']['input'];
  orderID: Scalars['UUID']['input'];
  shopID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

/** 訂單分頁 */
export type OrderPagination = {
  orders?: Maybe<Array<Order>>;
  pageInfo: CursorPageInfo;
};

/** 支付方式 */
export enum OrderPaymentMethod {
  LinePay = 'LinePay',
  OnSite = 'OnSite',
}

export type OrderRatioDetail = {
  /** 訂單筆數 */
  count: Scalars['Int32']['output'];
  /** 佔總訂單筆數的比例 */
  percentage: Scalars['Decimal']['output'];
};

/** 訂單類型 (區分現做或預約) */
export enum OrderSchedulingType {
  /** 立即 */
  Immediate = 'Immediate',
  /** 預約 */
  PreOrder = 'PreOrder',
}

/** 搜尋關鍵字 */
export enum OrderSearchCondition {
  /** 發票號碼 */
  InvoiceNo = 'INVOICE_NO',
  /** 單號 */
  OrderCode = 'ORDER_CODE',
  /** 訂單序號 */
  OrderNo = 'ORDER_NO',
  /** 交易序號 */
  TransactionNo = 'TRANSACTION_NO',
}

/** 搜尋訂單列表(篩選條件) */
export type OrderSearchParams = {
  /** 支付方式 */
  brandPaymentMethodName?: InputMaybe<Scalars['String']['input']>;
  /** 營業日範圍 */
  businessDateRange?: InputMaybe<TimeRange>;
  /** 系統日範圍 */
  createdAtRange?: InputMaybe<TimeRange>;
  /** 用餐方式名稱 */
  diningOptionName?: InputMaybe<Scalars['String']['input']>;
  /** 用餐方式類型 */
  diningOptionType?: InputMaybe<Array<DiningOptionType>>;
  /** 訂單來源 */
  orderSource?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 訂單狀態 */
  orderStatus?: InputMaybe<Array<OrderStatus>>;
  /** 訂單類型 */
  orderType?: InputMaybe<OrderType>;
  /** 預訂時間 */
  reservedAtRange?: InputMaybe<TimeRange>;
};

/** 訂單來源 */
export enum OrderSource {
  /** Foodpanda */
  Foodpanda = 'Foodpanda',
  /** 線上點餐 */
  OnlineOrder = 'OnlineOrder',
  /** POS */
  Pos = 'POS',
  /** 掃碼點餐 */
  QrCode = 'QRCode',
  /** UberEats */
  UberEats = 'UberEats',
}

/** 訂單狀態 */
export enum OrderStatus {
  /** 已取消 */
  Cancelled = 'Cancelled',
  /** 已結帳 */
  CheckedOut = 'CheckedOut',
  /** 結帳中 */
  CheckingOut = 'CheckingOut',
  /** 已完成 */
  Completed = 'Completed',
  /** 待處理(未接單) */
  Pending = 'Pending',
  /** 處理中(已接單) */
  Processing = 'Processing',
  /** 準備完成 */
  Ready = 'Ready',
  /** 已退款 */
  Refunded = 'Refunded',
}

/** 訂單子狀態 */
export enum OrderSubStatus {
  /** 已接單 */
  Accepted = 'Accepted',
  /** 客人已取消 */
  CancelledByConsumer = 'CancelledByConsumer',
  /** 店家已取消 */
  CancelledByShop = 'CancelledByShop',
  /** POS 結束交易 */
  ClosedByPos = 'ClosedByPOS',
  /** 已送達 */
  Delivered = 'Delivered',
  /** POS 顧客離開 */
  LeftByPos = 'LeftByPOS',
  /** 逾期未取 */
  OverdueUnclaimed = 'OverdueUnclaimed',
  /** 已略過 */
  Passed = 'Passed',
  /** 已取餐 */
  PickedUp = 'PickedUp',
  /** 可取餐 */
  Ready = 'Ready',
}

/** 匯出支付csv欄位(Order) */
export type OrderTransactionColumnIndices = {
  /** 訂單日期 */
  createdAt: Scalars['Int16']['input'];
  /** 訂單單號 */
  orderCode: Scalars['Int16']['input'];
  /** 訂單序號 */
  orderNo: Scalars['Int16']['input'];
  /** 銷售總額 */
  totalAmount: Scalars['Int16']['input'];
};

/** 交易狀態 */
export enum OrderTransactionStatus {
  Failed = 'Failed',
  Pending = 'Pending',
  Refund = 'Refund',
  Success = 'Success',
}

/** 訂單類型 */
export enum OrderType {
  /** 一般 */
  General = 'General',
  /** 退款 */
  Refund = 'Refund',
}

export type OrdersCsvInput = {
  /** 匯出訂單csv欄位 */
  columnIndices: OrderColumnIndices;
  /** 語系 */
  locale: Locales;
  /** 搜尋 */
  search?: InputMaybe<Scalars['String']['input']>;
  /** 搜尋關鍵字 */
  searchCondition: OrderSearchCondition;
  /** 搜尋訂單列表(篩選條件) */
  searchParams: OrderSearchParams;
  shopKey: ShopKey;
  /** 排序 (欄位) */
  sortField: Scalars['String']['input'];
  /** 排序 (升/降) */
  sortOrder: SortOrder;
  /** 時區 */
  timezone: Scalars['String']['input'];
};

/** 員工隸屬(Workspace/Brand/Shop) */
export type OrgBelong = {
  belongID: Scalars['Int32']['output'];
  brand?: Maybe<Brand>;
  brandID?: Maybe<Scalars['Int32']['output']>;
  createdAt: Scalars['DateTimeZ']['output'];
  employee: Employee;
  employeeID: Scalars['UUID']['output'];
  of: OrgBelongOf;
  shop?: Maybe<Shop>;
  shopID?: Maybe<Scalars['Int32']['output']>;
  workspace?: Maybe<Workspace>;
  workspaceID: Scalars['UUID']['output'];
};

export type OrgBelongKey = {
  BrandID: Scalars['Int32']['output'];
  ShopID: Scalars['Int32']['output'];
  WorkspaceID: Scalars['UUID']['output'];
};

/** 員工隸屬範圍 */
export enum OrgBelongOf {
  Brand = 'Brand',
  Shop = 'Shop',
  Workspace = 'Workspace',
}

export type Organization = {
  createdAt: Scalars['DateTimeZ']['output'];
  /** 組織名稱 */
  name: Scalars['String']['output'];
  organizationID: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
};

export type OrganizationMap = {
  createdAt: Scalars['DateTimeZ']['output'];
  /** 外部品牌ID */
  extBrandID: Scalars['Int32']['output'];
  /** 外部組織ID */
  extOrganizationID: Scalars['UUID']['output'];
  /** 外部門市ID */
  extShopID: Scalars['Int32']['output'];
  /** 品牌ID */
  mbrandID: Scalars['Int32']['output'];
  /** 門市ID */
  mshopID: Scalars['Int32']['output'];
  /** 組織ID */
  organizationID: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
};

/** 實體裝置 (PDevice for Physical Device) */
export type PDevice = {
  Shop?: Maybe<Shop>;
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  deletedAt?: Maybe<Scalars['SoftDeleteZ']['output']>;
  /** 裝置編碼 */
  deviceCode: Scalars['UUID']['output'];
  isConnected: Scalars['Boolean']['output'];
  /** 裝置名稱 */
  name: Scalars['String']['output'];
  pDeviceEvents: Array<PDeviceEvent>;
  pDeviceID: Scalars['Int32']['output'];
  pPrinters?: Maybe<Array<PPrinter>>;
  shopID?: Maybe<Scalars['Int32']['output']>;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 實體裝置事件 */
export type PDeviceEvent = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 裝置資訊(會依不同裝置類型有所不同) */
  deviceInfo?: Maybe<Scalars['JSON']['output']>;
  eventID: Scalars['Int32']['output'];
  opUser?: Maybe<Employee>;
  /** 操作人員 */
  opUserID?: Maybe<Scalars['UUID']['output']>;
  /** 實體裝置事件類型 */
  pDeviceEventType: PDeviceEventType;
  pDeviceID: Scalars['Int32']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 實體裝置事件類型 */
export enum PDeviceEventType {
  Connected = 'Connected',
  Deleted = 'Deleted',
  Disconnected = 'Disconnected',
  LoggedIn = 'LoggedIn',
  LoggedOut = 'LoggedOut',
  UpdateInfo = 'UpdateInfo',
}

export type PDeviceKey = {
  brandID: Scalars['Int32']['input'];
  pDeviceID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

/** POS 菜單鍵盤模式 */
export enum PosMenuKeyboardMode {
  /** 一頁模式 */
  Inline = 'Inline',
  /** 彈出模式 */
  Popup = 'Popup',
}

/** 點餐預設樣式 */
export enum PosOrderStyle {
  /** 自定義金額樣式 */
  CustomAmount = 'CustomAmount',
  /** 一般樣式 */
  General = 'General',
  /** 秤重樣式 */
  Weight = 'Weight',
}

/** POS 更新模式 */
export enum PosUpdateMode {
  /** 每日指定時間自動更新 */
  AutoFixedTime = 'AutoFixedTime',
  /** 符合安全條件時立即自動更新 */
  AutoImmediate = 'AutoImmediate',
  /** 僅由店家手動更新 */
  Manual = 'Manual',
}

/** 實體印表機 */
export type PPrinter = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  /** 連線媒介（Network/Bluetooth） */
  connectMedia: ConnectMediaType;
  createdAt: Scalars['DateTimeZ']['output'];
  linkVPrinterPPrinters?: Maybe<Array<Maybe<LinkVPrinterPPrinter>>>;
  pDeviceID?: Maybe<Scalars['Int32']['output']>;
  pPrinterID: Scalars['Int32']['output'];
  printerBrand: Scalars['String']['output'];
  /** 例如 {"ip":"192.168.50.2","paperSize":"8cm"} */
  printerInfo: Scalars['JSON']['output'];
  printerModel?: Maybe<Scalars['String']['output']>;
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  vDevice?: Maybe<VDevice>;
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type PPrinterKey = {
  pPrinterID: Scalars['Int32']['input'];
  shopKey: ShopKey;
};

export enum ParticipantType {
  /** 所有門市 */
  All = 'All',
  /** 指定品牌 */
  SpecifyBrand = 'SpecifyBrand',
  /** 指定門市 */
  SpecifyShop = 'SpecifyShop',
}

/** AppStore 外部開發夥伴 */
export type Partner = {
  createdAt: Scalars['DateTimeZ']['output'];
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  partnerID: Scalars['UUID']['output'];
  state: PartnerState;
  updatedAt: Scalars['DateTimeZ']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

/** 合作開發夥伴狀態 */
export enum PartnerState {
  /** 停用 */
  Disabled = 'Disabled',
  /** 啟用 */
  Enabled = 'Enabled',
  /** 通過驗證 */
  Verified = 'Verified',
}

/** 支付 */
export type Payment = {
  /** 支付金額 */
  amount: Scalars['Decimal']['output'];
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  /** 品牌支付方式 ID */
  brandPaymentMethodID: Scalars['Int32']['output'];
  /** 品牌支付方式名稱 */
  brandPaymentMethodName: Scalars['String']['output'];
  /** 營業日 */
  businessDate: Scalars['Date']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  deletedAt?: Maybe<Scalars['SoftDeleteZ']['output']>;
  /** 機號 */
  deviceCode: Scalars['String']['output'];
  opUser?: Maybe<Employee>;
  /** 操作人員 */
  opUserID?: Maybe<Scalars['UUID']['output']>;
  order: Order;
  orderID: Scalars['UUID']['output'];
  /** 溢收金額 */
  overpayment?: Maybe<Scalars['Decimal']['output']>;
  /** 溢收找零金額 */
  overpaymentChange?: Maybe<Scalars['Decimal']['output']>;
  paymentID: Scalars['UUID']['output'];
  /** 支付序號 */
  paymentNo: Scalars['String']['output'];
  /** 支付狀態 */
  paymentStatus: PaymentStatus;
  /** 支付服務商的回應資訊(用於記錄支付處理的額外資訊，根據不同的 BrandPaymentMethod 定義對應的 JSON 結構) */
  providerResponse?: Maybe<Scalars['JSON']['output']>;
  /** 退款時間 */
  refundedAt?: Maybe<Scalars['DateTimeZ']['output']>;
  /** 退款來源支付 */
  refundedFrom?: Maybe<Payment>;
  /** 退款來源支付ID */
  refundedFromID?: Maybe<Scalars['UUID']['output']>;
  /** 退款來源訂單 */
  refundedFromOrder?: Maybe<Order>;
  /** 退款來源訂單ID */
  refundedFromOrderID?: Maybe<Scalars['UUID']['output']>;
  /** 退款來源交易 */
  refundedFromTransaction?: Maybe<Transaction>;
  /** 退款來源交易ID */
  refundedFromTransactionID?: Maybe<Scalars['UUID']['output']>;
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  /** 門市支付方式 */
  shopPaymentMethod: ShopPaymentMethod;
  /** 系統支付方式 */
  sysPaymentMethod: SysPaymentMethod;
  /** 系統支付方式 ID */
  sysPaymentMethodID: Scalars['String']['output'];
  transaction: Transaction;
  transactionID: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 輸入付款資料 */
export type PaymentInput = {
  /** 支付金額 */
  amount: Scalars['Decimal']['input'];
  /** 支付方式 ID */
  brandPaymentMethodID: Scalars['Int32']['input'];
  /** 品牌支付方式名稱 */
  brandPaymentMethodName: Scalars['String']['input'];
  /** 系統支付方式 ID(新增請帶 null) */
  paymentID?: InputMaybe<Scalars['UUID']['input']>;
  /** 系統支付方式 ID */
  sysPaymentMethodID: Scalars['String']['input'];
};

export type PaymentInvoiceColumnIndices = {
  /** 支付方式(名稱) */
  brandPaymentMethodName: Scalars['Int16']['input'];
};

export type PaymentKey = {
  brandID: Scalars['Int32']['input'];
  orderID: Scalars['UUID']['input'];
  paymentID: Scalars['UUID']['input'];
  shopID: Scalars['Int32']['input'];
  transactionID: Scalars['UUID']['input'];
  workspaceID: Scalars['UUID']['input'];
};

export type PaymentLog = {
  brandID: Scalars['Int32']['output'];
  httpReq: Scalars['JSON']['output'];
  httpResp: Scalars['JSON']['output'];
  operation: PaymentLogOperation;
  orderID: Scalars['String']['output'];
  requestTime: Scalars['DateTimeZ']['output'];
  responseTime: Scalars['DateTimeZ']['output'];
  shopID: Scalars['Int32']['output'];
  sysPaymentMethodID: Scalars['String']['output'];
  transactionID: Scalars['String']['output'];
  workspaceID: Scalars['UUID']['output'];
};

export enum PaymentLogOperation {
  GetPaymentInfo = 'GET_PAYMENT_INFO',
  PaymentReq = 'PAYMENT_REQ',
  PaymentStatusCheck = 'PAYMENT_STATUS_CHECK',
  Refund = 'REFUND',
}

export enum PaymentMethod {
  /** 信用卡 */
  CreditCard = 'CreditCard',
  /** 線下支付 */
  Offline = 'Offline',
}

/** 支付方式分類 */
export enum PaymentMethodCategory {
  /** 線下支付:合作串接 */
  Api = 'API',
  /** 線下支付:EDC信用卡機 */
  Edc = 'EDC',
  /** 線下支付:一般 */
  General = 'General',
  /** 線上支付 */
  OnlinePayment = 'OnlinePayment',
}

export type PaymentMethodMapping = {
  paymentMethod: PaymentMethod;
  paymentMethodID: Scalars['UUID']['output'];
};

/** 匯出支付csv欄位(Payment) */
export type PaymentOrderColumnIndices = {
  /** 支付方式(名稱) */
  brandPaymentMethodName: Scalars['Int16']['input'];
};

/** 支付狀態 */
export enum PaymentStatus {
  /** 已取消 */
  Cancelled = 'Cancelled',
  /** 已支付 */
  Completed = 'Completed',
  /** 進行中 */
  Processing = 'Processing',
  /** 已退款 */
  Refunded = 'Refunded',
}

export type PaymentTransactionColumnIndices = {
  /** 支付方式(名稱) */
  brandPaymentMethodName: Scalars['Int16']['input'];
};

/** 權限主表 */
export type Permission = {
  children?: Maybe<Array<Permission>>;
  childrenID?: Maybe<Array<Maybe<Scalars['UUID']['output']>>>;
  createdAt: Scalars['DateTimeZ']['output'];
  /** 顯示順序 */
  displayOrder: Scalars['Int16']['output'];
  isProfile: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  parent?: Maybe<Permission>;
  parentID?: Maybe<Scalars['UUID']['output']>;
  permissionDetails: Array<PermissionDetail>;
  permissionID: Scalars['UUID']['output'];
  slug: Scalars['String']['output'];
  system: System;
  systemID: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
};

/** 權限副表 */
export type PermissionDetail = {
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  description?: Maybe<Scalars['String']['output']>;
  permissionDetailID: Scalars['UUID']['output'];
  system: System;
  systemID: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
};

/** 權限/角色範圍（全域或工作區） */
export enum PermissionScope {
  Global = 'Global',
  Ws = 'WS',
}

export type Plan = {
  app: App;
  appID: Scalars['UUID']['output'];
  authorizationMode: AuthorizationMode;
  billingInterval?: Maybe<BillingInterval>;
  createdAt: Scalars['DateTimeZ']['output'];
  deletedAt?: Maybe<Scalars['SoftDeleteZ']['output']>;
  /** 方案描述 */
  description?: Maybe<Scalars['String']['output']>;
  /** 方案名稱 */
  name: Scalars['String']['output'];
  /** 方案編號 */
  planCode: Scalars['String']['output'];
  planDetails?: Maybe<Array<PlanDetail>>;
  planID: Scalars['UUID']['output'];
  price: Scalars['Decimal']['output'];
  pricingModel: PricingModel;
  /** 狀態 */
  status: PlanStatus;
  updatedAt: Scalars['DateTimeZ']['output'];
  usageApplicableCondition?: Maybe<UsageApplicableCondition>;
  usageBillingItem?: Maybe<UsageBillingItem>;
  usageBillingMethod?: Maybe<UsageBillingMethod>;
  usageFreeQuota?: Maybe<Scalars['Decimal']['output']>;
  usageRateType?: Maybe<UsageRateType>;
  usageRateValue?: Maybe<Scalars['Decimal']['output']>;
  usageSpecifiedPaymentMethod?: Maybe<Scalars['String']['output']>;
};

export type PlanDetail = {
  createdAt: Scalars['DateTimeZ']['output'];
  displayOrder: Scalars['Int16']['output'];
  /** 方案詳情名稱 */
  name: Scalars['String']['output'];
  plan: Plan;
  planDetailID: Scalars['UUID']['output'];
  planID: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
};

export enum PlanStatus {
  /** 關閉 */
  Closed = 'Closed',
  /** 開放 */
  Open = 'Open',
}

export type PlanSubscription = {
  amount: Scalars['Decimal']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  plan: Plan;
  planID: Scalars['UUID']['output'];
  planSubscriptionID: Scalars['UUID']['output'];
  quantity: Scalars['Int32']['output'];
  subscription: RecurringSubscription;
  subscriptionID: Scalars['UUID']['output'];
  unitPrice: Scalars['Decimal']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
};

export enum PointExpiryType {
  /** 天數 */
  InDays = 'InDays',
  /** 永久 */
  Never = 'Never',
}

export type PointInventory = {
  /** 是否作廢 */
  cancelled: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 到期日 */
  expiredOn?: Maybe<Scalars['DateTimeZ']['output']>;
  /** 初始點數 */
  initPoints: Scalars['Int32']['output'];
  inventoryID: Scalars['UUID']['output'];
  mbrand: Mbrand;
  mbrandID: Scalars['Int32']['output'];
  mshop: Mshop;
  mshopID: Scalars['Int32']['output'];
  organization: Organization;
  organizationID: Scalars['UUID']['output'];
  /** 剩餘點數 */
  remainingPoints: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  wallet: PointWallet;
  /** 錢包ID */
  walletID: Scalars['UUID']['output'];
};

export type PointLedger = {
  /** 操作後點數 */
  balanceAfter: Scalars['Int32']['output'];
  /** 操作前點數 */
  balanceBefore: Scalars['Int32']['output'];
  /** 內容細節 */
  content: Scalars['JSON']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 操作點數 */
  deltaPoints: Scalars['Int32']['output'];
  inventory?: Maybe<PointInventory>;
  /** 庫存ID */
  inventoryID?: Maybe<Scalars['UUID']['output']>;
  ledgerID: Scalars['UUID']['output'];
  mbrand?: Maybe<Mbrand>;
  mbrandID?: Maybe<Scalars['Int32']['output']>;
  mshop?: Maybe<Mshop>;
  mshopID?: Maybe<Scalars['Int32']['output']>;
  /** 操作類型 */
  operation: PointLedgerOperationType;
  organization: Organization;
  organizationID: Scalars['UUID']['output'];
  /** 錢包ID */
  walletID: Scalars['UUID']['output'];
};

export enum PointLedgerOperationType {
  /** 調整增加 */
  AdjustAdd = 'AdjustAdd',
  /** 調整減少 */
  AdjustSub = 'AdjustSub',
  /** 集點 */
  Earn = 'Earn',
  /** 過期 */
  Expired = 'Expired',
  /** 消費/兌點 */
  Redeem = 'Redeem',
  /** 退款 */
  Refund = 'Refund',
  /** 作廢 */
  Void = 'Void',
}

export enum PointUsageScope {
  /** 指定門市 */
  ShopLimited = 'ShopLimited',
  /** 通用 */
  Universal = 'Universal',
}

export type PointWallet = {
  /** 點數 */
  balance: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  inventories?: Maybe<Array<PointInventory>>;
  /** 會員 */
  member: Member;
  /** 會員ID */
  memberID: Scalars['UUID']['output'];
  /** 制度規則 */
  program: ConfLoyaltyProgram;
  /** 制度規則ID */
  programID: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  walletID: Scalars['UUID']['output'];
};

export type PointsHistoryData = {
  imageURL?: Maybe<Scalars['String']['output']>;
  permanentPoint: Scalars['Int']['output'];
  pointsLedger: Array<PointsLedger>;
  temporaryPoint: Scalars['Int']['output'];
};

export type PointsHistoryResponse = {
  data: PointsHistoryData;
  success: Scalars['Boolean']['output'];
};

export type PointsLedger = {
  balanceAfter: Scalars['Int']['output'];
  balanceBefore: Scalars['Int']['output'];
  brand: Scalars['String']['output'];
  content: PointsLedgerContent;
  createdAt: Scalars['DateTimeZ']['output'];
  deltaPoints: Scalars['Int']['output'];
  ledgerID: Scalars['UUID']['output'];
  mBrandID: Scalars['Int']['output'];
  mShopID: Scalars['Int']['output'];
  operation: PointLedgerOperationType;
  shop: Scalars['String']['output'];
  walletID: Scalars['UUID']['output'];
};

export type PointsLedgerContent = {
  items: Array<PointsLedgerItem>;
  orderAmount?: Maybe<Scalars['String']['output']>;
  orderID?: Maybe<Scalars['String']['output']>;
  orderNo?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  redeemInventoryIDAndValues?: Maybe<Scalars['JSON']['output']>;
  transactionID?: Maybe<Scalars['String']['output']>;
};

export type PointsLedgerItem = {
  itemCode: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  totalAmount: Scalars['String']['output'];
};

export type PortalCarouselImageInput = {
  /** 輪播圖顯示順序 */
  displayOrder: Scalars['Int16']['input'];
  /** 新增輪播圖檔案；既有圖片排序異動時不傳 */
  file?: InputMaybe<Scalars['Upload']['input']>;
  /** 既有輪播圖 imageID；新增圖片時不傳 */
  imageID?: InputMaybe<Scalars['Int32']['input']>;
};

/** 商品數量位置 */
export enum PositionItemQty {
  /** 商品名稱後 */
  AfterItem = 'AfterItem',
  /** 商品名稱前 */
  BeforeItem = 'BeforeItem',
}

export type PriceOptionButton = {
  keyButtonID: Scalars['Int32']['output'];
  name: Scalars['String']['output'];
};

export type PricePoint = {
  billingFrequency: BillingFrequency;
  createdAt: Scalars['DateTimeZ']['output'];
  description?: Maybe<Scalars['String']['output']>;
  externalID: Scalars['String']['output'];
  externalName: Scalars['String']['output'];
  internalName: Scalars['String']['output'];
  plan: Plan;
  planID: Scalars['UUID']['output'];
  price: Scalars['Decimal']['output'];
  pricePointID: Scalars['UUID']['output'];
  pricingModel: PricingModel;
  updatedAt: Scalars['DateTimeZ']['output'];
};

export enum PricingModel {
  /** 固定費用 */
  FlatFee = 'FlatFee',
  /** 一次性計價 */
  OneTime = 'OneTime',
  /** 使用量計費 */
  UsageBased = 'UsageBased',
}

export type PrintCustomizedPaperInput = {
  displayOrder: Scalars['Int16']['input'];
  needCut: Scalars['Boolean']['input'];
  ticketID: Scalars['Int32']['input'];
};

export type PrintItemInput = {
  itemID: Scalars['Int32']['input'];
  itemPriceOptionID: Scalars['Int32']['input'];
};

/** 樣式基本設定 (print_layout_base) */
export type PrintLayoutBase = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  /** 顧客姓名顯示樣式 (DEFAULT 'Complete') */
  consumerNameVisibility: ConsumerInfoVisibility;
  /** 顧客電話顯示樣式 (DEFAULT 'Complete') */
  consumerPhoneVisibility: ConsumerInfoVisibility;
  createdAt: Scalars['DateTimeZ']['output'];
  /** 貼紙用餐方式/單號樣式 (DEFAULT 'Fix') */
  diningOptionStickerInfoStyle: DiningOptionTicketInfo;
  /** 貼紙固定單號樣式 */
  diningOptionStickerInfoStyleFix?: Maybe<BlackWhiteStyle>;
  diningOptionStickerInfoStyleSpecify?: Maybe<
    Array<PrintLayoutBaseDiningOptionStickerNoStyle>
  >;
  /** 用餐方式/單號樣式 (DEFAULT 'Fix') */
  diningOptionTicketInfoStyle: DiningOptionTicketInfo;
  diningOptionTicketInfoStyleFix?: Maybe<BlackWhiteStyle>;
  diningOptionTicketInfoStyleSpecify?: Maybe<
    Array<PrintLayoutBaseDiningOptionTicketNoStyle>
  >;
  /** 隱藏商品單價 (DEFAULT false) */
  hideItemPrice: Scalars['Boolean']['output'];
  linkPrintLayoutBaseConsumerNameStyle?: Maybe<
    Array<LinkPrintLayoutBaseConsumerNameStyle>
  >;
  linkPrintLayoutBaseConsumerPhoneStyle?: Maybe<
    Array<LinkPrintLayoutBaseConsumerPhoneStyle>
  >;
  printLayoutBaseID: Scalars['Int32']['output'];
  printLayoutBaseLogo?: Maybe<Array<Maybe<PrintLayoutBaseLogo>>>;
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  /** 店家資訊 */
  shopInfo: Scalars['String']['output'];
  /** 店家資訊對齊方式 */
  shopInfoAlignStyle: ShopInfoAlignStyle;
  /** 店家資訊字體大小 (DEFAULT 'Medium') */
  shopInfoFontSize: FontSize;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 貼紙用餐方式/單號樣式 */
export type PrintLayoutBaseDiningOptionStickerNoStyle = {
  brand: Brand;
  brandDiningOptionID: Scalars['Int32']['output'];
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  printLayoutBaseID: Scalars['Int32']['output'];
  shop: Shop;
  shopDiningOption: ShopDiningOption;
  shopID: Scalars['Int32']['output'];
  /** 黑白樣式 */
  style: BlackWhiteStyle;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 用餐方式/單號樣式 */
export type PrintLayoutBaseDiningOptionTicketNoStyle = {
  brand: Brand;
  brandDiningOptionID: Scalars['Int32']['output'];
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  printLayoutBaseID: Scalars['Int32']['output'];
  shop: Shop;
  shopDiningOption: ShopDiningOption;
  shopID: Scalars['Int32']['output'];
  /** 黑白樣式 */
  style: BlackWhiteStyle;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type PrintLayoutBaseKey = {
  printLayoutBaseID: Scalars['Int32']['input'];
  shopKey: ShopKey;
};

/** 樣式基本設定：Logo */
export type PrintLayoutBaseLogo = {
  /** 檔案屬性：演算法（對應 SQL ImageHashAlg） */
  alg?: Maybe<Scalars['String']['output']>;
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 檔案大小 (>0) */
  fileSize: Scalars['Int32']['output'];
  /** 檔案屬性：雜湊值 */
  hash?: Maybe<Scalars['String']['output']>;
  /** 高度 (>0) */
  height: Scalars['Int16']['output'];
  /** 實際圖片 ID */
  imageID: Scalars['Int32']['output'];
  /** 檔案屬性：MIME（對應 SQL ImageMimeType） */
  mime?: Maybe<Scalars['String']['output']>;
  printLayoutBaseID: Scalars['Int32']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  /** Normal | Thumb */
  type: ImageType;
  updatedAt: Scalars['DateTimeZ']['output'];
  /** 寬度 (>0) */
  width: Scalars['Int16']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 商品顯示方式 */
export enum PrintMethodItem {
  /** 同品項合併 */
  Aggregate = 'Aggregate',
  /** 同品項分開 */
  Separate = 'Separate',
}

/** 標籤列印方式 */
export enum PrintMethodLabel {
  /** 合併於同一列 */
  OneRow = 'OneRow',
  /** 每項標籤一列 */
  Separate = 'Separate',
}

/** 單號列印依據 */
export enum PrintTicketNo {
  /** 用餐方式顯示 */
  DiningOption = 'DiningOption',
  /** 來源名稱顯示 */
  SourceName = 'SourceName',
}

/** 列印時機 */
export enum PrintTriggerMode {
  /** 換餐，用於Order, Kitchen, Sticker */
  Change = 'Change',
  /** 結帳，用於Checkout */
  Checkout = 'Checkout',
  /** 刪除餐點，用於Order, Kitchen */
  Delete = 'Delete',
  /** 手動列印，用於Checkout */
  Manual = 'Manual',
  /** 點餐，用於Order, Kitchen, Sticker */
  Order = 'Order',
  /** 線上訂單出單(未付款)，用於Checkout */
  UnpaidOnlineOrder = 'UnpaidOnlineOrder',
}

/** 交易明細列印 */
export enum PrintTxnDetails {
  NotPrint = 'NotPrint',
  Print = 'Print',
}

/** 出單機配對方式 */
export enum PrinterBindMethod {
  /** 配對 */
  Bind = 'Bind',
  /** 同步 */
  Sync = 'Sync',
}

export type PrinterDisplayOrderInput = {
  shopKey: ShopKey;
  /** 更新鍵盤順序 */
  updateOrder?: InputMaybe<Array<PrinterOrderInput>>;
};

export type PrinterInput = {
  /** 連線方式 */
  bindMethod: PrinterBindMethod;
  /** 裝置代碼ID */
  deviceCode?: InputMaybe<Scalars['String']['input']>;
  /** 出單機名稱 */
  name: Scalars['String']['input'];
  /** 紙張大小 */
  paperSize: PrinterPaperSize;
  /** 出單機類型 */
  type: PrinterType;
};

export type PrinterOrderInput = {
  displayOrder: Scalars['Int16']['input'];
  vPrinterID: Scalars['Int32']['input'];
};

export type PrinterPagination = {
  pageInfo: CursorPageInfo;
  vPrinters?: Maybe<Array<VPrinter>>;
};

/** 紙張尺寸 */
export enum PrinterPaperSize {
  /** 標籤貼紙 寬高 3.2 x 2.5 公分 */
  Ld_3_25 = 'LD_3_25',
  /** 標籤貼紙 寬高 4 x 2.5 公分 */
  Ld_4_25 = 'LD_4_25',
  /** 出單紙 寛 8.0 公分 */
  Rw_8 = 'RW_8',
  /** 出單紙 寛 5.8 公分 */
  Rw_58 = 'RW_58',
}

export type PrinterStyleBase = {
  name?: Maybe<Scalars['String']['output']>;
  printerStyle?: Maybe<Array<PrinterStyleRow>>;
  vPrinterID?: Maybe<Scalars['Int32']['output']>;
};

export type PrinterStyleRow = {
  displayOrder?: Maybe<Scalars['Int16']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  of?: Maybe<TicketOf>;
  printEnabled?: Maybe<Scalars['Boolean']['output']>;
  ticketID?: Maybe<Scalars['Int32']['output']>;
  vPrinterID?: Maybe<Scalars['Int32']['output']>;
};

/** 列印機型態 (v_printers) */
export enum PrinterType {
  /** 出單紙 */
  Paper = 'Paper',
  /** 標籤貼紙 */
  Sticker = 'Sticker',
}

/** 套餐列印方式 */
export enum PrintingMethodCombo {
  /** 套餐組顯示 */
  Combine = 'Combine',
  /** 單品分開顯示 */
  Separate = 'Separate',
}

/** 單品與套餐列印方式 */
export enum PrintingMethodComboOfKitchenSticker {
  /** 與單品混合顯示 */
  Mixed = 'Mixed',
  /** 分開獨立顯示 */
  Separate = 'Separate',
}

export enum PrintingMethodCustomizedNote {
  /** 不列印 */
  NotPrint = 'NotPrint',
  /** 隨機列印自定備註 */
  RandomNotes = 'RandomNotes',
  /** 指定列印自定備註 */
  SpecificNotes = 'SpecificNotes',
}

/** 列印商品設定 */
export enum PrintingTargetItemScope {
  /** 所有商品 */
  All = 'All',
  /** 指定商品分類 */
  SpecificItemCates = 'SpecificItemCates',
  /** 指定商品 */
  SpecificItemPrices = 'SpecificItemPrices',
}

/** 列印標籤設定 */
export enum PrintingTargetLabelScope {
  /** 所有標籤 */
  All = 'All',
  /** 指定標籤群組 */
  SpecificLabelGroups = 'SpecificLabelGroups',
  /** 指定標籤 */
  SpecificLabels = 'SpecificLabels',
}

export enum PriorityCategory {
  /** 商品優惠 - 現金折扣 */
  ItemCashReduction = 'ITEM_CASH_REDUCTION',
  /** 商品優惠 - 商品折扣 */
  ItemDiscount = 'ITEM_DISCOUNT',
  /** 整單優惠 - 現金折扣 */
  OrderCashReduction = 'ORDER_CASH_REDUCTION',
  /** 整單優惠 - 現金折扣服務費 */
  OrderCashReductionFee = 'ORDER_CASH_REDUCTION_FEE',
  /** 整單優惠 - 商品折扣 */
  OrderDiscount = 'ORDER_DISCOUNT',
}

export enum ProfitMode {
  /** 固定金額 */
  Amount = 'Amount',
  /** 百分比 */
  Percent = 'Percent',
}

/** AIWaiter提供者 */
export enum ProviderAiWaiter {
  Dudoo = 'Dudoo',
}

/** CDS提供者 */
export enum ProviderCds {
  Dudoo = 'Dudoo',
}

/** 電子發票提供者 */
export enum ProviderEinvoice {
  Panyu = 'Panyu',
  Pic = 'Pic',
  Sunpay = 'Sunpay',
}

/** 會員提供者 */
export enum ProviderMember {
  Dudoo = 'Dudoo',
}

/** 訂單提供者 */
export enum ProviderOrder {
  Dudoo = 'Dudoo',
  EightWay = 'EightWay',
  FoodPanda = 'FoodPanda',
  UberEats = 'UberEats',
}

/** POS提供者 */
export enum ProviderPos {
  Dudoo = 'Dudoo',
}

/** 支付提供者 */
export enum ProviderPayment {
  Edc = 'EDC',
  LinePay = 'LinePay',
  LinePayOnline = 'LinePayOnline',
  Stripe = 'Stripe',
  TapPay = 'TapPay',
}

/** 掃碼點餐提供者 */
export enum ProviderScanOrder {
  Dudoo = 'Dudoo',
}

/** 發佈狀態 */
export enum PublishStatus {
  /** 發佈失敗 */
  Failed = 'Failed',
  /** 待發佈 */
  Pending = 'Pending',
  /** 發佈中 */
  Publishing = 'Publishing',
  /** 發佈成功 */
  Success = 'Success',
}

/** 發佈任務 */
export type PublishTask = {
  /** 取消時間 */
  cancelTime?: Maybe<Scalars['DateTimeZ']['output']>;
  createdAt: Scalars['DateTimeZ']['output'];
  /** 版本說明 */
  description: Scalars['String']['output'];
  /** 生效時間 */
  effectiveTime: Scalars['DateTimeZ']['output'];
  /** 對應的 Git Commit hash */
  gitCommitHash: Scalars['String']['output'];
  /** 版本名稱 */
  name: Scalars['String']['output'];
  publishTaskID: Scalars['Int32']['output'];
  shopPublishTasks: Array<ShopPublishTask>;
  /** 發佈狀態 */
  status: PublishStatus;
  updatedAt: Scalars['DateTimeZ']['output'];
  /** 版本編號 (格式為 yyyyMMddHHmmss，例如：20240424153000 表示 2024年4月24日15時30分00秒) */
  version: Scalars['Int64']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type PublishTaskKey = {
  publishTaskID: Scalars['Int32']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 查詢系統發佈分頁結果 */
export type PublishTaskPagination = {
  pageInfo: CursorPageInfo;
  publishTasks?: Maybe<Array<PublishTask>>;
};

export type Purchase = {
  name: Scalars['String']['output'];
  purchaseRate: Scalars['Decimal']['output'];
};

export type PutAiWaiterVirtualHumanImageInput = {
  brandKey: BrandKey;
  file: Scalars['Upload']['input'];
  /** 決定 Provider 系統預設聲音的性別；僅接受 Male、Female，省略為 Female */
  gender?: InputMaybe<Gender>;
  /** 保留給既有 client；不接受任何值。虛擬人建立後不支援換圖，需換圖請建立新的虛擬人 */
  virtualHumanID?: InputMaybe<Scalars['UUID']['input']>;
};

export type PutAiWaiterVirtualHumanImageResponse = {
  alg: ImageHashAlg;
  fileSize: Scalars['Int32']['output'];
  hash: Scalars['String']['output'];
  height: Scalars['Int16']['output'];
  mime: ImageMimeType;
  providerStatus: Scalars['String']['output'];
  virtualHumanID: Scalars['UUID']['output'];
  width: Scalars['Int16']['output'];
};

export type PutAiWaiterVirtualHumanVoiceInput = {
  brandKey: BrandKey;
  file: Scalars['Upload']['input'];
  virtualHumanID: Scalars['UUID']['input'];
};

/** Custom 音檔預上傳結果；尚未建立正式 voice 資料或 Provider 狀態 */
export type PutAiWaiterVirtualHumanVoiceResponse = {
  uploadAlg: Scalars['String']['output'];
  uploadDurationInMs: Scalars['Int32']['output'];
  uploadFileSize: Scalars['Int32']['output'];
  uploadHash: Scalars['String']['output'];
  uploadMime: Scalars['String']['output'];
  virtualHumanID: Scalars['UUID']['output'];
};

export type PutItemImageResponse = {
  itemImage: ItemImage;
  itemImageThumbs: Array<ItemImageThumb>;
};

export type Query = {
  countShops: Array<BrandShopCount>;
  downloadSyncData: Array<DownloadSyncDataRes>;
  /** 匯出桌位掃碼點餐 QR Code ZIP */
  exportTableQRCodes: Scalars['String']['output'];
  /** 將網址轉換為 QR Code 圖片 (Base64) */
  generateQRCode: Scalars['String']['output'];
  /** 取得商品群組詳情 */
  getABundleDetail?: Maybe<Bundle>;
  /** 取得優惠細節 */
  getADiscount?: Maybe<Discount>;
  getAIWaiterSetting: AiWaiterSettingResponse;
  getAIWaiterVirtualHuman: AiWaiterVirtualHumanView;
  getAIWaiterVirtualHumans: Array<AiWaiterVirtualHumanView>;
  getAPrinter?: Maybe<VPrinter>;
  getAServiceFee: ServiceFee;
  getAShopDiscountRule: ShopDiscountRule;
  getAShopPOSSetting: ShopPosSetting;
  getATicket?: Maybe<Ticket>;
  /** 查詢 App 覆蓋範圍 */
  getAppCoverage: Array<AppInfo>;
  /** 查詢 App 訂閱設定值（bind/pos settings） */
  getAppFormatDetail?: Maybe<AppFormatDetail>;
  /** 查詢 App 綁定設定與 POS 設定 Schema */
  getAppSchemas: AppSchemas;
  /** 查詢門市可用 App 清單 */
  getAppsList: AppsPagination;
  /** 取得品牌 POS 更新策略 */
  getBrandPOSUpdatePolicy: BrandPosUpdatePolicy;
  /** 取得品牌入口頁設定 */
  getBrandPortalSetting: BrandPortalSetting;
  getBrandReasonTemplates?: Maybe<Array<ReasonTemplate>>;
  /** 取得品牌CDS設定 */
  getCDSBrandSetting: CdsBrandSettingWithAd;
  /** 透過會員ID取得卡號 */
  getCardNumberByMemberID: WorkspaceMember;
  /** 取得跨品牌入口頁設定 */
  getCrossBrandPortalSetting: CrossBrandPortalSetting;
  getCurrentShopPublishTask?: Maybe<PublishTask>;
  getDetailOfKeypad: DetailOfKeypadResponse;
  getDetailOfKeypadImproved: DetailOfKeypadResponse;
  getDetailOfKeypadItems: DetailOfKeypadItemsResponse;
  getDetailOfKeypadItemsImproved: DetailOfKeypadItemsResponse;
  /** 取得標籤群組詳情 */
  getDetailOfLabelGroup: DetailOfLabelGroupResponse;
  /** 取得各功能模組用餐方式設定 */
  getDiningOptions: DiningOption;
  getDiningReport: GetDiningReportResponse;
  getDiscountsOverviewReportBuckets: DiscountsOverview;
  getEmployee: GetEmployeeResponse;
  getFixedTransactionData: GetFixedTransactionDataResponse;
  getItemDetails?: Maybe<Item>;
  getItemWithItemPriceOptionList: Array<ItemListWithItemPriceOption>;
  getItemsOverviewReportBuckets: ItemsOverview;
  getLabelsOverviewReportBuckets: LabelsOverview;
  /** 取得會員(名稱與頭像) */
  getMember: Member;
  /** 取得會員詳細資訊 */
  getMemberDetails: MemberDetails;
  /** 取得會員制度 */
  getMembershipConfig: MembershipConfig;
  getMenuDetails: MenuDetails;
  /** 低消設定 */
  getMinChargeSetting?: Maybe<MinCharge>;
  getMultiShopShops: MultiShopShopsResult;
  getOnlineOrderList: OnlineOrderListPagination;
  /** 線上訂單概況-營業額、訂單量、線上/線下訂單占比(BigQuery) */
  getOnlineOrderOverview: GetOnlineOrderOverviewResponse;
  getOnlineOrderSetting: ShopO2OSettingWithBanner;
  getOnlineOrderTimeSetting: OnlineOrderTimeSetting;
  /** 取得訂單 */
  getOrder: Order;
  /** 取得訂單明細 */
  getOrderDetails: Array<OrderDetail>;
  getPaymentReport: GetPaymentReportResponse;
  getPrintLayoutBase: PrintLayoutBase;
  /** 取得退款訂單 */
  getRefundOrder: Order;
  getReservationMenuCalendar: ReservationMenuCalendar;
  getRevenueReport: GetRevenueReportResponse;
  getRolePermission: Array<PermissionDetail>;
  /** 取得掃碼點餐基本設定 */
  getScanOrderSetting?: Maybe<ScanOrderSettingBasic>;
  /** 取得掃碼內用點餐設定 */
  getScanOrderSettingDiningIn?: Maybe<ScanOrderSettingDiningInWithUrl>;
  /** 取得掃碼外帶點餐設定 */
  getScanOrderSettingTakeOut?: Maybe<ScanOrderSettingTakeOutWithUrl>;
  /** 取得品牌商品配件設定 */
  getServicewares: Array<Serviceware>;
  /** 取得區域資訊，包含桌位和裝飾資訊 */
  getShopAreaInfo: ShopAreaInfo;
  /** 取得區域列表，不包含桌位資訊，無分頁 */
  getShopAreas: Array<Maybe<ShopArea>>;
  getShopContainerWeightManagement: ShopContainerWeightManagement;
  getShopDetails: ShopDetails;
  getShopDiningOptions: Array<ShopDiningOption>;
  getShopOrderRemarkSetting: ShopOrderRemarkSetting;
  getShopReasonSettings?: Maybe<Array<ShopReasonSetting>>;
  /** 取得店家所有桌位 */
  getShopTable: Array<Maybe<ShopTable>>;
  /** 取得停售清單(商品、標籤) */
  getStopSaleList: StopSaleList;
  /** 取得同步資料 */
  getSyncedData: Array<Maybe<Scalars['SyncData']['output']>>;
  getTheVDeviceBoundByPDevice?: Maybe<VDevice>;
  getTransactionReport: GetTransactionReportResponse;
  /** 取得未同步資料 */
  getUnsyncData: Array<Maybe<Scalars['SyncData']['output']>>;
  getUsedKeypadItemIDs?: Maybe<Array<Scalars['Int32']['output']>>;
  getWorkspace: Workspace;
  hasPendingKeypadTasks: Scalars['Boolean']['output'];
  /** 檢查驗證碼 */
  inspectVerificationNumber: Scalars['Boolean']['output'];
  listAEodCloseReport?: Maybe<Scalars['JSON']['output']>;
  listAIWaiterLanguages: Array<Language>;
  listAIWaiterVoiceOptions: AiWaiterVirtualHumanVoiceOptions;
  listAShiftCloseReport?: Maybe<Scalars['JSON']['output']>;
  /** 查詢有效訂閱App（deprecated） */
  listActiveSubscription: Array<Maybe<ActiveSubscription>>;
  listAndSearchShopGroups: Array<ShopGroup>;
  /**
   * 查詢可新增為綁定設備的應用程式清單（即「設備類型」候選）。
   * 條件：該門市有生效中的訂閱，且 app.multipleBindSettingsEnabled 為 true，兩者須同時成立。
   * 設備類型於畫面上以 app.slug 呈現。
   */
  listBindableEquipmentApps: Array<App>;
  listBrandDiningOptions: Array<BrandDiningOption>;
  listBrandMemberTag: Array<Maybe<BrandMemberTag>>;
  listBrandPaymentMethods: Array<BrandPaymentMethod>;
  listBrandPaymentMethodsImproved: Array<BrandPaymentMethod>;
  listBrands: Array<Brand>;
  /** 取得品牌下所有商品群組 */
  listBundles: BundlePagination;
  listCashDrawers: CashDrawerPagination;
  listConfLoyalty: ListConfigLoyaltyResponse;
  /** 列出縣市（政府 NLSC API） */
  listCounties: Array<Region>;
  /** 取得國家地址格式 */
  listCountryAddressFormats: Scalars['JSON']['output'];
  listCustomer: CustomerPagination;
  listCustomizedPapers: Array<TicketCustomizedPaper>;
  listDeviceAssets: DeviceAssetPagination;
  listDevices: DevicePagination;
  /** 優惠列表 */
  listDiscounts: DiscountPagination;
  /** 此門市可使用的優惠列表 */
  listDiscountsOfKeypad: Array<Discount>;
  /** 優惠按鍵排序列表 */
  listDisplayOrdersOfDiscounts?: Maybe<Array<Discount>>;
  listEInvoiceSources: EInvoiceSourcesResp;
  listEmployees: EmployeePagination;
  listEodCloseReports: EodCloseReportsPagination;
  listInvoiceSetting: ListInvoiceSettingResp;
  /** 發票列表 */
  listInvoices: InvoicePagination;
  /** 品牌下所有商品分類 */
  listItemCategories: ItemCategoryPagination;
  /** 品牌下所有商品 */
  listItems: ItemPagination;
  listKeypads: KeypadPagination;
  /** 取得標籤群組 */
  listLabelGroups: LabelGroupPagination;
  /** 取得標籤 */
  listLabels: LabelPagination;
  listMemberPointHistory: PointsHistoryResponse;
  /** 會員來源列表 */
  listMemberSource: MemberSourceGroup;
  /** 會員列表 */
  listMembers: MemberPagination;
  listMenus: MenuListPagination;
  listMultiShopList: MultiShopPagePagination;
  /** 訂單列表 */
  listOrders: OrderPagination;
  listPOSDevices: DevicePagination;
  listPOSPermissions: Array<Permission>;
  listPPrinters: Array<PPrinter>;
  listPermissionBySlugs: Array<Permission>;
  listPrinterStyles: Array<PrinterStyleBase>;
  listPrinters: Array<VPrinter>;
  /** 優惠優先權列表 */
  listPrioritiesOfDiscounts?: Maybe<Array<Discount>>;
  /** 取得發佈檔清單 */
  listPublishTasks: PublishTaskPagination;
  listRolePermissions: Array<Permission>;
  listRoles: RolePagination;
  /** 分頁查詢品牌商品配件設定 */
  listServicewares: ServicewarePagination;
  listShiftCloseReports: ShiftClosePagination;
  listShopCustomPaymentMethods: Array<ShopPaymentMethod>;
  listShopDiningOptionsByType: Array<ShopDiningOption>;
  listShopMemberTag: Array<Maybe<ShopMemberTag>>;
  listShopPaymentMethods: ShopPaymentMethodsResponse;
  listShopPaymentMethodsImproved: ShopPaymentMethodsResponse;
  listShopPermissionVerifications: Array<ShopPermissionVerificationGroup>;
  listShops: Array<Shop>;
  listShopsOfBrand?: Maybe<Array<Shop>>;
  listShopsOfWorkspace?: Maybe<Array<Shop>>;
  listShopsWithShopGroups: ShopWithGroupsPagination;
  listSpendAnalysis: ListSpendAnalysisOutput;
  listStickerCustomizedNotes: Array<TicketStickerCustomizedNote>;
  listSubBrands: SubBrandListPayload;
  listSysPaymentMethods: Array<SysPaymentMethod>;
  listTaxGroupsOfWorkspace: Array<TaxGroup>;
  listTaxUnitsOfWorkspace: Array<TaxUnit>;
  /** 列出鄉鎮市區（政府 NLSC API） */
  listTowns: Array<Scalars['String']['output']>;
  /** 交易列表 */
  listTransactions: TransactionPagination;
  listTransactionsByMember?: Maybe<Array<Transaction>>;
  /** 查詢指定 POS 已綁定的外部設備清單 */
  listVDeviceEquipments: Array<VDeviceEquipment>;
  /** 線上訂單概況-營業額分析 */
  onlineOrderRevenueTrend: OnlineOrderRevenueTrendResponse;
  /** 線上訂單概況-訂單筆數分析 */
  onlineOrderVolumeTrend: OnlineOrderVolumeTrendResponse;
  /** 取得員工隸屬 */
  orgBelongs?: Maybe<Array<OrgBelong>>;
  searchShop: Array<Maybe<Shop>>;
  /** 取得區域列表，包含桌位資訊，有分頁 */
  shopAreaList: Array<Maybe<ShopAreaPagination>>;
  /** 取得版本資訊 */
  version: Version;
};

export type QueryCountShopsArgs = {
  workspaceID: Scalars['UUID']['input'];
};

export type QueryDownloadSyncDataArgs = {
  streamKey: Scalars['String']['input'];
  vDeviceID: Scalars['Int32']['input'];
};

export type QueryExportTableQrCodesArgs = {
  shopKey: ShopKey;
};

export type QueryGenerateQrCodeArgs = {
  url: Scalars['String']['input'];
};

export type QueryGetABundleDetailArgs = {
  brandKey: BrandKey;
  bundleID: Scalars['Int32']['input'];
};

export type QueryGetADiscountArgs = {
  discountKey: DiscountKey;
};

export type QueryGetAiWaiterSettingArgs = {
  input: GetAiWaiterSettingInput;
};

export type QueryGetAiWaiterVirtualHumanArgs = {
  input: GetAiWaiterVirtualHumanInput;
};

export type QueryGetAiWaiterVirtualHumansArgs = {
  input: GetAiWaiterVirtualHumansInput;
};

export type QueryGetAPrinterArgs = {
  pDeviceID?: InputMaybe<Scalars['Int32']['input']>;
  vPrinterKey: VPrinterKey;
};

export type QueryGetAServiceFeeArgs = {
  shopKey: ShopKey;
};

export type QueryGetAShopDiscountRuleArgs = {
  shopKey: ShopKey;
};

export type QueryGetAShopPosSettingArgs = {
  shopKey: ShopKey;
};

export type QueryGetATicketArgs = {
  ticketKey: TicketKey;
};

export type QueryGetAppCoverageArgs = {
  appType: Array<AppType>;
  at?: InputMaybe<Scalars['String']['input']>;
  brandID?: InputMaybe<Scalars['Int32']['input']>;
  providerCode?: InputMaybe<Scalars['String']['input']>;
  shopID?: InputMaybe<Scalars['Int32']['input']>;
  workspaceID: Scalars['UUID']['input'];
};

export type QueryGetAppFormatDetailArgs = {
  appID: Scalars['UUID']['input'];
  brandID: Scalars['Int32']['input'];
  shopID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

export type QueryGetAppSchemasArgs = {
  appID: Scalars['UUID']['input'];
};

export type QueryGetAppsListArgs = {
  pageInput: CursorPageInput;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  shopKey: ShopKey;
};

export type QueryGetBrandPosUpdatePolicyArgs = {
  brandKey: BrandKey;
};

export type QueryGetBrandPortalSettingArgs = {
  brandKey: BrandKey;
};

export type QueryGetBrandReasonTemplatesArgs = {
  brandKey: BrandKey;
  reasonType: ReasonType;
};

export type QueryGetCdsBrandSettingArgs = {
  brandKey: BrandKey;
};

export type QueryGetCardNumberByMemberIdArgs = {
  memberID: Scalars['UUID']['input'];
  memberSourceID: Scalars['UUID']['input'];
  workspaceID: Scalars['UUID']['input'];
};

export type QueryGetCrossBrandPortalSettingArgs = {
  pageID: Scalars['UUID']['input'];
  workspaceID: Scalars['UUID']['input'];
};

export type QueryGetCurrentShopPublishTaskArgs = {
  shopKey: ShopKey;
};

export type QueryGetDetailOfKeypadArgs = {
  keypadKey: KeypadKey;
};

export type QueryGetDetailOfKeypadImprovedArgs = {
  keypadKey: KeypadKey;
};

export type QueryGetDetailOfKeypadItemsArgs = {
  keypadKey: KeypadKey;
};

export type QueryGetDetailOfKeypadItemsImprovedArgs = {
  keypadKey: KeypadKey;
};

export type QueryGetDetailOfLabelGroupArgs = {
  key: LabelGroupKey;
};

export type QueryGetDiningOptionsArgs = {
  shopKey: ShopKey;
};

export type QueryGetDiningReportArgs = {
  input: GetTransactionReportInput;
};

export type QueryGetDiscountsOverviewReportBucketsArgs = {
  filter: ReportDiscountsOverviewInput;
};

export type QueryGetEmployeeArgs = {
  employeeID: Scalars['UUID']['input'];
  workspaceID: Scalars['UUID']['input'];
};

export type QueryGetFixedTransactionDataArgs = {
  input: GetTransactionReportInput;
};

export type QueryGetItemDetailsArgs = {
  brandKey: BrandKey;
  itemID: Scalars['Int32']['input'];
};

export type QueryGetItemWithItemPriceOptionListArgs = {
  brandKey: BrandKey;
  items: Array<ItemWithItemPriceOption>;
};

export type QueryGetItemsOverviewReportBucketsArgs = {
  filter: ReportItemsOverviewInput;
};

export type QueryGetLabelsOverviewReportBucketsArgs = {
  filter: ReportLabelsOverviewInput;
};

export type QueryGetMemberArgs = {
  brandKey: BrandKey;
  cardCode: Scalars['String']['input'];
  memberSourceID: Scalars['UUID']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetMemberDetailsArgs = {
  brandKey: BrandKey;
  cardCode: Scalars['String']['input'];
  memberSourceID: Scalars['UUID']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
};

export type QueryGetMembershipConfigArgs = {
  brandID?: InputMaybe<Scalars['Int32']['input']>;
  workspaceID: Scalars['UUID']['input'];
};

export type QueryGetMenuDetailsArgs = {
  brandKey: BrandKey;
  menuID: Scalars['Int32']['input'];
};

export type QueryGetMinChargeSettingArgs = {
  shopKey: ShopKey;
};

export type QueryGetMultiShopShopsArgs = {
  brandID?: InputMaybe<Scalars['Int32']['input']>;
  pageID?: InputMaybe<Scalars['UUID']['input']>;
  selectPage: Scalars['String']['input'];
  workspaceKey: WorkspaceKey;
};

export type QueryGetOnlineOrderListArgs = {
  pageInput: CursorPageInput;
  search?: InputMaybe<Scalars['String']['input']>;
  searchCondition?: InputMaybe<OnlineOrderSearchCondition>;
  searchParams: OnlineOrderSearchParams;
  shopKey: ShopKey;
};

export type QueryGetOnlineOrderOverviewArgs = {
  input: GetOnlineOrderOverviewInput;
};

export type QueryGetOnlineOrderSettingArgs = {
  shopKey: ShopKey;
};

export type QueryGetOnlineOrderTimeSettingArgs = {
  shopKey: ShopKey;
};

export type QueryGetOrderArgs = {
  orderKey: OrderKey;
};

export type QueryGetOrderDetailsArgs = {
  haveChanged: Scalars['Boolean']['input'];
  orderKey: OrderKey;
};

export type QueryGetPaymentReportArgs = {
  input: GetTransactionReportInput;
};

export type QueryGetPrintLayoutBaseArgs = {
  shopKey: ShopKey;
};

export type QueryGetRefundOrderArgs = {
  orderKey: OrderKey;
};

export type QueryGetReservationMenuCalendarArgs = {
  brandKey: BrandKey;
  endDate: Scalars['Date']['input'];
  menuID: Scalars['Int32']['input'];
  startDate: Scalars['Date']['input'];
};

export type QueryGetRevenueReportArgs = {
  input: GetTransactionReportInput;
};

export type QueryGetRolePermissionArgs = {
  roleTemplateID: Scalars['UUID']['input'];
};

export type QueryGetScanOrderSettingArgs = {
  shopKey: ShopKey;
};

export type QueryGetScanOrderSettingDiningInArgs = {
  shopKey: ShopKey;
};

export type QueryGetScanOrderSettingTakeOutArgs = {
  shopKey: ShopKey;
};

export type QueryGetServicewaresArgs = {
  brandKey: BrandKey;
};

export type QueryGetShopAreaInfoArgs = {
  shopAreaID: Scalars['Int32']['input'];
  shopKey: ShopKey;
};

export type QueryGetShopAreasArgs = {
  shopKey: ShopKey;
};

export type QueryGetShopContainerWeightManagementArgs = {
  shopKey: ShopKey;
};

export type QueryGetShopDetailsArgs = {
  brandID: Scalars['Int32']['input'];
  shopID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

export type QueryGetShopDiningOptionsArgs = {
  shopKey: ShopKey;
};

export type QueryGetShopOrderRemarkSettingArgs = {
  shopKey: ShopKey;
};

export type QueryGetShopReasonSettingsArgs = {
  reasonType: ReasonType;
  shopKey: ShopKey;
};

export type QueryGetShopTableArgs = {
  shopKey: ShopKey;
};

export type QueryGetStopSaleListArgs = {
  shopKey: ShopKey;
};

export type QueryGetSyncedDataArgs = {
  endTime: Scalars['DateTimeZ']['input'];
  shopKey: ShopKey;
  startTime: Scalars['DateTimeZ']['input'];
  vDeviceID: Scalars['Int32']['input'];
};

export type QueryGetTheVDeviceBoundByPDeviceArgs = {
  pDeviceKey: PDeviceKey;
};

export type QueryGetTransactionReportArgs = {
  input: GetTransactionReportInput;
};

export type QueryGetUnsyncDataArgs = {
  endTime: Scalars['DateTimeZ']['input'];
  shopKey: ShopKey;
  startTime: Scalars['DateTimeZ']['input'];
  vDeviceID: Scalars['Int32']['input'];
};

export type QueryGetUsedKeypadItemIDsArgs = {
  shopKey: ShopKey;
};

export type QueryGetWorkspaceArgs = {
  workspaceID: Scalars['UUID']['input'];
};

export type QueryHasPendingKeypadTasksArgs = {
  brandKey: BrandKey;
};

export type QueryInspectVerificationNumberArgs = {
  email: Scalars['String']['input'];
  verificationNumber: Scalars['String']['input'];
};

export type QueryListAEodCloseReportArgs = {
  reportKey: ReportKey;
};

export type QueryListAiWaiterVoiceOptionsArgs = {
  input: ListAiWaiterVoiceOptionsInput;
};

export type QueryListAShiftCloseReportArgs = {
  reportKey: ReportKey;
};

export type QueryListActiveSubscriptionArgs = {
  appType: AppType;
  brandID?: InputMaybe<Scalars['Int32']['input']>;
  shopID?: InputMaybe<Scalars['Int32']['input']>;
  workspaceID: Scalars['UUID']['input'];
};

export type QueryListAndSearchShopGroupsArgs = {
  brandID: Scalars['Int32']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  workspaceID: Scalars['UUID']['input'];
};

export type QueryListBindableEquipmentAppsArgs = {
  shopKey: ShopKey;
};

export type QueryListBrandDiningOptionsArgs = {
  brandID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

export type QueryListBrandMemberTagArgs = {
  brandKey: BrandKey;
};

export type QueryListBrandPaymentMethodsArgs = {
  brandKey: BrandKey;
  isGrouped?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryListBrandPaymentMethodsImprovedArgs = {
  brandKey: BrandKey;
  isGrouped?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryListBrandsArgs = {
  workspaceID: Scalars['UUID']['input'];
};

export type QueryListBundlesArgs = {
  brandKey: BrandKey;
  bundleType?: InputMaybe<BundleType>;
  excludeBundleItemID?: InputMaybe<Scalars['Int32']['input']>;
  pageInput: CursorPageInput;
  searchName?: InputMaybe<Scalars['String']['input']>;
};

export type QueryListCashDrawersArgs = {
  cashDrawerSearchParams: CashDrawerSearchParams;
  pageInput: CursorPageInput;
  shopKey: ShopKey;
};

export type QueryListConfLoyaltyArgs = {
  brandKey: BrandKey;
  cardCode: Scalars['String']['input'];
  memberSourceID: Scalars['UUID']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
};

export type QueryListCountiesArgs = {
  workspaceID: Scalars['UUID']['input'];
};

export type QueryListCountryAddressFormatsArgs = {
  workspaceID: Scalars['UUID']['input'];
};

export type QueryListCustomerArgs = {
  pageInput: CursorPageInput;
  search?: InputMaybe<Scalars['String']['input']>;
  searchCondition?: InputMaybe<CustomerSearchCondition>;
  searchParams?: InputMaybe<CustomerSearchParams>;
  shopKey: ShopKey;
};

export type QueryListCustomizedPapersArgs = {
  shopKey: ShopKey;
};

export type QueryListDeviceAssetsArgs = {
  deviceType?: InputMaybe<VDeviceType>;
  pageInput: CursorPageInput;
  shopKey: ShopKey;
};

export type QueryListDevicesArgs = {
  deviceType?: InputMaybe<VDeviceType>;
  pageInput: CursorPageInput;
  shopKey: ShopKey;
};

export type QueryListDiscountsArgs = {
  brandKey: BrandKey;
  filterStatus?: InputMaybe<Scalars['String']['input']>;
  filterType?: InputMaybe<Scalars['String']['input']>;
  pageInput: CursorPageInput;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type QueryListDiscountsOfKeypadArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  shopKey: ShopKey;
};

export type QueryListDisplayOrdersOfDiscountsArgs = {
  brandKey: BrandKey;
  sortInput?: InputMaybe<SortInput>;
};

export type QueryListEInvoiceSourcesArgs = {
  shopKey: ShopKey;
};

export type QueryListEmployeesArgs = {
  pageInput: CursorPageInput;
  searchParams: EmployeeSearchParams;
  workspaceID: Scalars['UUID']['input'];
};

export type QueryListEodCloseReportsArgs = {
  eodCloseSearchParams: EodCloseReportSearchParams;
  pageInput: CursorPageInput;
  shopKey: ShopKey;
};

export type QueryListInvoiceSettingArgs = {
  shopKey: ShopKey;
};

export type QueryListInvoicesArgs = {
  pageInput: CursorPageInput;
  search?: InputMaybe<Scalars['String']['input']>;
  searchCondition: InvoiceSearchCondition;
  searchParams: InvoiceSearchParams;
  shopKey: ShopKey;
};

export type QueryListItemCategoriesArgs = {
  brandKey: BrandKey;
  excludeItemBundleID?: InputMaybe<Scalars['Int32']['input']>;
  itemCategoryID?: InputMaybe<Scalars['Int32']['input']>;
  pageInput: CursorPageInput;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type QueryListItemsArgs = {
  brandKey: BrandKey;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  hasItemCategory?: InputMaybe<Scalars['Boolean']['input']>;
  itemCategoryIDs?: InputMaybe<Array<Scalars['Int32']['input']>>;
  itemKind?: InputMaybe<ItemKind>;
  pageInput: CursorPageInput;
  priceType?: InputMaybe<ItemPriceType>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  subBrandShop?: InputMaybe<SubBrandShop>;
};

export type QueryListKeypadsArgs = {
  pageInput: CursorPageInput;
  shopKey: ShopKey;
};

export type QueryListLabelGroupsArgs = {
  brandKey: BrandKey;
  pageInput: CursorPageInput;
  searchName?: InputMaybe<Scalars['String']['input']>;
  subBrandShop?: InputMaybe<SubBrandShop>;
};

export type QueryListLabelsArgs = {
  brandKey: BrandKey;
  pageInput: CursorPageInput;
  searchName?: InputMaybe<Scalars['String']['input']>;
};

export type QueryListMemberPointHistoryArgs = {
  brandKey: BrandKey;
  cardCode: Scalars['String']['input'];
  memberSourceID: Scalars['UUID']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
};

export type QueryListMemberSourceArgs = {
  brandKey: BrandKey;
};

export type QueryListMembersArgs = {
  brandKey: BrandKey;
  memberSourceID: Scalars['UUID']['input'];
  pageInput: CursorPageInput;
  search?: InputMaybe<Scalars['String']['input']>;
  searchCondition?: InputMaybe<MemberSearchCondition>;
  searchParams?: InputMaybe<MemberSearchParams>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type QueryListMenusArgs = {
  brandKey: BrandKey;
  menuType?: InputMaybe<MenuType>;
  pageInput: CursorPageInput;
  searchName?: InputMaybe<Scalars['String']['input']>;
  shopIDs?: InputMaybe<Array<Scalars['Int32']['input']>>;
  usedStatus: UsedStatus;
};

export type QueryListMultiShopListArgs = {
  pageInput: CursorPageInput;
  search?: InputMaybe<Scalars['String']['input']>;
  selectPage: Scalars['String']['input'];
  workspaceKey: WorkspaceKey;
};

export type QueryListOrdersArgs = {
  pageInput: CursorPageInput;
  search?: InputMaybe<Scalars['String']['input']>;
  searchCondition: OrderSearchCondition;
  searchParams: OrderSearchParams;
  shopKey: ShopKey;
};

export type QueryListPosDevicesArgs = {
  bindState?: InputMaybe<FilterBindState>;
  pageInput: CursorPageInput;
  shopKey: ShopKey;
};

export type QueryListPPrintersArgs = {
  pDeviceID?: InputMaybe<Scalars['Int32']['input']>;
  shopKey: ShopKey;
};

export type QueryListPermissionBySlugsArgs = {
  slugs: Array<Scalars['String']['input']>;
};

export type QueryListPrinterStylesArgs = {
  shopKey: ShopKey;
  type: PrinterType;
  vPrinterID?: InputMaybe<Scalars['Int32']['input']>;
};

export type QueryListPrintersArgs = {
  filterType?: InputMaybe<Scalars['String']['input']>;
  shopKey: ShopKey;
};

export type QueryListPrioritiesOfDiscountsArgs = {
  brandKey: BrandKey;
  filterPriorityCategory: PriorityCategory;
};

export type QueryListPublishTasksArgs = {
  brandKey: BrandKey;
  pageInput: CursorPageInput;
  shopID?: InputMaybe<Scalars['Int32']['input']>;
};

export type QueryListRolesArgs = {
  pageInput: CursorPageInput;
  searchParams: RoleSearchParams;
  workspaceID: Scalars['UUID']['input'];
};

export type QueryListServicewaresArgs = {
  brandKey: BrandKey;
  pageInput: CursorPageInput;
  searchParams?: InputMaybe<ServicewareSearchParams>;
};

export type QueryListShiftCloseReportsArgs = {
  pageInput: CursorPageInput;
  shiftCloseSearchParams: ShiftCloseReportSearchParams;
  shopKey: ShopKey;
};

export type QueryListShopCustomPaymentMethodsArgs = {
  shopKey: ShopKey;
};

export type QueryListShopDiningOptionsByTypeArgs = {
  diningOptionType: DiningOptionType;
  shopKey: ShopKey;
};

export type QueryListShopMemberTagArgs = {
  shopKey: ShopKey;
};

export type QueryListShopPaymentMethodsArgs = {
  shopKey: ShopKey;
};

export type QueryListShopPaymentMethodsImprovedArgs = {
  shopKey: ShopKey;
};

export type QueryListShopPermissionVerificationsArgs = {
  brandID: Scalars['Int32']['input'];
  shopID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

export type QueryListShopsArgs = {
  brandID: Scalars['Int32']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  shopID?: InputMaybe<Scalars['Int32']['input']>;
  sortField?: InputMaybe<ShopSortField>;
  sortOrder?: InputMaybe<SortOrder>;
  workspaceID: Scalars['UUID']['input'];
};

export type QueryListShopsOfBrandArgs = {
  brandKey: BrandKey;
};

export type QueryListShopsOfWorkspaceArgs = {
  brandID?: InputMaybe<Scalars['Int32']['input']>;
  shopID?: InputMaybe<Scalars['Int32']['input']>;
  workspaceID: Scalars['UUID']['input'];
};

export type QueryListShopsWithShopGroupsArgs = {
  brandID: Scalars['Int32']['input'];
  pageInput: CursorPageInput;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  shopGroupID?: InputMaybe<Scalars['Int32']['input']>;
  subBrandID?: InputMaybe<Scalars['Int32']['input']>;
  workspaceID: Scalars['UUID']['input'];
};

export type QueryListSpendAnalysisArgs = {
  brandKey: BrandKey;
  memberID: Scalars['UUID']['input'];
  memberSourceID: Scalars['UUID']['input'];
};

export type QueryListStickerCustomizedNotesArgs = {
  shopKey: ShopKey;
};

export type QueryListSubBrandsArgs = {
  brandID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

export type QueryListSysPaymentMethodsArgs = {
  brandKey?: InputMaybe<BrandKey>;
};

export type QueryListTaxGroupsOfWorkspaceArgs = {
  available?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceID: Scalars['UUID']['input'];
};

export type QueryListTaxUnitsOfWorkspaceArgs = {
  workspaceID: Scalars['UUID']['input'];
};

export type QueryListTownsArgs = {
  code: Scalars['String']['input'];
  workspaceID: Scalars['UUID']['input'];
};

export type QueryListTransactionsArgs = {
  pageInput: CursorPageInput;
  search?: InputMaybe<Scalars['String']['input']>;
  searchCondition: TransactionSearchCondition;
  searchParams: TransactionSearchParams;
  shopKey: ShopKey;
};

export type QueryListTransactionsByMemberArgs = {
  brandKey: BrandKey;
  memberID: Scalars['UUID']['input'];
  memberSourceID: Scalars['UUID']['input'];
};

export type QueryListVDeviceEquipmentsArgs = {
  vDeviceKey: VDeviceKey;
};

export type QueryOnlineOrderRevenueTrendArgs = {
  input: GetOnlineOrderOverviewInput;
};

export type QueryOnlineOrderVolumeTrendArgs = {
  input: GetOnlineOrderOverviewInput;
};

export type QuerySearchShopArgs = {
  brandID: Scalars['Int32']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  workspaceID: Scalars['UUID']['input'];
};

export type QueryShopAreaListArgs = {
  pageInput: CursorPageInput;
  search?: InputMaybe<Scalars['String']['input']>;
  shopKey: ShopKey;
};

export enum RankBy {
  Amount = 'Amount',
  Quantity = 'Quantity',
}

export type RankDetails = {
  amount: Scalars['Decimal']['output'];
  count: Scalars['Int32']['output'];
  name: Scalars['String']['output'];
  percentageAmount: Scalars['Decimal']['output'];
  percentageCount: Scalars['Decimal']['output'];
  rank: Scalars['Int32']['output'];
};

/** 品牌原因設定範本 */
export type ReasonTemplate = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  /** 開錢櫃原因編號 */
  cashDrawerReasonCode?: Maybe<Scalars['String']['output']>;
  /** 錢櫃交易類型 */
  cashDrawerTransactionType?: Maybe<CashDrawerTransactionType>;
  createdAt: Scalars['DateTimeZ']['output'];
  /** 停用 */
  disabled: Scalars['Boolean']['output'];
  /** 名稱 */
  name: Scalars['String']['output'];
  reasonTemplateID: Scalars['Int32']['output'];
  /** 原因類型 */
  reasonType: ReasonType;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type ReasonTemplateKey = {
  brandID: Scalars['Int32']['input'];
  reasonTemplateID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

/** 原因類型 */
export enum ReasonType {
  /** 招待 */
  Complimentary = 'Complimentary',
  /** 手動優惠 */
  ManualDiscount = 'ManualDiscount',
  /** O2O 取消 */
  O2oCancel = 'O2oCancel',
  /** O2O 退款 */
  O2oRefund = 'O2oRefund',
  /** 開錢櫃 */
  OpenCashDrawer = 'OpenCashDrawer',
  /** 退款作廢 */
  RefundVoid = 'RefundVoid',
  /** 退餐 */
  ReturnItem = 'ReturnItem',
}

export type RecurringSubscription = {
  /** 啟用備註 */
  activationNote?: Maybe<Scalars['String']['output']>;
  amount: Scalars['Decimal']['output'];
  brand?: Maybe<Brand>;
  brandID?: Maybe<Scalars['Int32']['output']>;
  contractUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeZ']['output'];
  endCond: SubscriptionEndCond;
  endDate?: Maybe<Scalars['Date']['output']>;
  instructionMode: InstructionMode;
  nextPaymentDate?: Maybe<Scalars['Date']['output']>;
  of: AuthorizationMode;
  paymentMethod: PaymentMethod;
  paymentMethodMapping: PaymentMethodMapping;
  planSubscriptions: Array<PlanSubscription>;
  shop?: Maybe<Shop>;
  shopID?: Maybe<Scalars['Int32']['output']>;
  specifiedEndCondValue?: Maybe<Scalars['Int16']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
  status: SubscriptionStatus;
  subscriptionCode: Scalars['String']['output'];
  subscriptionID: Scalars['UUID']['output'];
  subscriptionInstructions: Array<SubscriptionInstruction>;
  /** 訂閱類型 */
  subscriptionTypeID?: Maybe<Scalars['UUID']['output']>;
  /** 訂閱類型設定 */
  subscriptionTypeSetting?: Maybe<SubscriptionTypeSetting>;
  unifiedInstruction?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type RefreshGitTokenResponse = {
  gitToken: Scalars['String']['output'];
  /** 拉取 Gitlab 資料使用 */
  user: Scalars['String']['output'];
};

export type Region = {
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** 系統/營業日 */
export enum ReportCalendar {
  Business = 'Business',
  System = 'System',
}

export enum ReportDiscountGroupMode {
  /** 依品牌分類顯示 */
  Brand = 'Brand',
  /** 依折扣名稱顯示 */
  DiscountName = 'DiscountName',
  /** 依折扣類型顯示 */
  DiscountType = 'DiscountType',
  /** 不分組 */
  None = 'None',
  /** 依門市顯示 */
  Shop = 'Shop',
}

export enum ReportDiscountSearchField {
  /** 折扣編號 */
  DiscountCode = 'DiscountCode',
  /** 折扣名稱 */
  DiscountName = 'DiscountName',
}

export enum ReportDiscountSortField {
  BrandName = 'BrandName',
  DiningOptionName = 'DiningOptionName',
  DiscountAmount = 'DiscountAmount',
  DiscountCode = 'DiscountCode',
  DiscountName = 'DiscountName',
  DiscountQuantity = 'DiscountQuantity',
  DiscountType = 'DiscountType',
  EmployeeName = 'EmployeeName',
  ItemCode = 'ItemCode',
  ItemKind = 'ItemKind',
  ItemName = 'ItemName',
  ItemPriceOptionName = 'ItemPriceOptionName',
  None = 'None',
  ShopName = 'ShopName',
}

export type ReportDiscountsCsvInput = {
  /** 匯出csv欄位 */
  columnIndices: ReportDiscountsColumnIndices;
  discountsFilterInput: DiscountsFilterInput;
  /** 語系 */
  locale: Locales;
  shopKeys: Array<ShopKey>;
  sortField: ReportDiscountSortField;
  sortOrder: SortOrder;
  /** 時區 */
  timezone: Scalars['String']['input'];
};

export type ReportDiscountsColumnIndices = {
  /** 品牌分類 */
  brandName: Scalars['Int16']['input'];
  /** 用餐方式名稱 */
  diningOptionName: Scalars['Int16']['input'];
  /** 折扣金額 */
  discountAmount?: InputMaybe<Scalars['Int16']['input']>;
  /** 折扣金額百分比 */
  discountAmountPercent?: InputMaybe<Scalars['Int16']['input']>;
  /** 折扣編號 */
  discountCode: Scalars['Int16']['input'];
  /** 折扣名稱 */
  discountName: Scalars['Int16']['input'];
  /** 折扣數量 */
  discountQuantity?: InputMaybe<Scalars['Int16']['input']>;
  /** 折扣數量百分比 */
  discountQuantityPercent?: InputMaybe<Scalars['Int16']['input']>;
  /** 折扣類型 */
  discountType: Scalars['Int16']['input'];
  /** 操作人員 */
  employeeName: Scalars['Int16']['input'];
  /** 商品編號 */
  itemCode: Scalars['Int16']['input'];
  /** 商品類型 */
  itemKind: Scalars['Int16']['input'];
  /** 商品名稱 */
  itemName: Scalars['Int16']['input'];
  /** 價位名稱 */
  itemPriceOptionName: Scalars['Int16']['input'];
  /** 門市 */
  shopName: Scalars['Int16']['input'];
};

export type ReportDiscountsGroup = {
  discountAmount: Scalars['Decimal']['output'];
  discountAmountPercent: Scalars['Decimal']['output'];
  discountQuantity: Scalars['Int']['output'];
  discountQuantityPercent: Scalars['Decimal']['output'];
  key?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** 每個商品的彙總資料 */
  rows: Array<DiscountAggregate>;
};

export type ReportDiscountsOverviewInput = {
  discountsFilterInput: DiscountsFilterInput;
  groupBy: ReportDiscountGroupMode;
  rankBy: RankBy;
  sortField: ReportDiscountSortField;
  sortOrder: SortOrder;
};

export enum ReportItemGroupMode {
  /** 依品牌分類顯示 */
  Brand = 'Brand',
  /** 依商品顯示 */
  Item = 'Item',
  /** 依商品分類顯示 */
  ItemCategory = 'ItemCategory',
  /** 依商品主編號顯示 */
  ItemCode = 'ItemCode',
  /** 不分組 */
  None = 'None',
  /** 依門市顯示 */
  Shop = 'Shop',
}

export enum ReportItemSearchField {
  /** 商品主編號 */
  ItemCode = 'ItemCode',
  /** 商品名稱 */
  ItemName = 'ItemName',
}

export enum ReportItemSortField {
  BrandName = 'BrandName',
  Code = 'Code',
  ComplimentaryQuantity = 'ComplimentaryQuantity',
  DiningOptionName = 'DiningOptionName',
  DiscountAmount = 'DiscountAmount',
  ItemName = 'ItemName',
  ItemPrice = 'ItemPrice',
  ItemPriceOptionName = 'ItemPriceOptionName',
  ItemQuantity = 'ItemQuantity',
  /** 商品銷售類型(單品、套餐主項、套餐子項) */
  ItemSaleType = 'ItemSaleType',
  LabelAmount = 'LabelAmount',
  None = 'None',
  ShopName = 'ShopName',
  TotalAmountAfterDiscount = 'TotalAmountAfterDiscount',
  TotalAmountBeforeDiscount = 'TotalAmountBeforeDiscount',
}

export type ReportItemsCsvInput = {
  /** 匯出csv欄位 */
  columnIndices: ReportItemsColumnIndices;
  itemsFilterInput: ItemsFilterInput;
  /** 語系 */
  locale: Locales;
  /** 單品與套餐子項合併顯示 */
  mergeSinglesWithComboChildren: Scalars['Boolean']['input'];
  shopKeys: Array<ShopKey>;
  sortField: ReportItemSortField;
  sortOrder: SortOrder;
  /** 時區 */
  timezone: Scalars['String']['input'];
};

export type ReportItemsColumnIndices = {
  /** 品牌分類 */
  brandName: Scalars['Int16']['input'];
  /** 商品主編號 */
  code: Scalars['Int16']['input'];
  /** 招待數量 */
  complimentaryQuantity?: InputMaybe<Scalars['Int16']['input']>;
  /** 用餐方式名稱 */
  diningOptionName: Scalars['Int16']['input'];
  /** 單品折扣 */
  discountAmount?: InputMaybe<Scalars['Int16']['input']>;
  /** 商品名稱 */
  itemName: Scalars['Int16']['input'];
  /** 商品單價 */
  itemPrice?: InputMaybe<Scalars['Int16']['input']>;
  /** 價位名稱 */
  itemPriceOptionName: Scalars['Int16']['input'];
  /** 數量 */
  itemQuantity?: InputMaybe<Scalars['Int16']['input']>;
  /** 商品銷售類型(單品Single、套餐主項ComboMain、套餐子項ComboSub) */
  itemSaleType: Scalars['Int16']['input'];
  /** 商品數量百分比 */
  quantityPercent?: InputMaybe<Scalars['Int16']['input']>;
  /** 門市 */
  shopName: Scalars['Int16']['input'];
  /** 銷售金額(折扣後) */
  totalAmountAfterDiscount?: InputMaybe<Scalars['Int16']['input']>;
  /** 銷售金額(折扣後)百分比 */
  totalAmountAfterDiscountPercent?: InputMaybe<Scalars['Int16']['input']>;
  /** 銷售金額(折扣前) */
  totalAmountBeforeDiscount?: InputMaybe<Scalars['Int16']['input']>;
  /** 銷售金額(折扣前)百分比 */
  totalAmountBeforeDiscountPercent?: InputMaybe<Scalars['Int16']['input']>;
};

export type ReportItemsGroup = {
  itemQuantity: Scalars['Int']['output'];
  key?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  quantityPercent: Scalars['Decimal']['output'];
  /** 每個商品的彙總資料 */
  rows: Array<ItemAggregate>;
  totalAmountAfterDiscount: Scalars['Decimal']['output'];
  totalAmountAfterDiscountPercent: Scalars['Decimal']['output'];
  totalAmountBeforeDiscount: Scalars['Decimal']['output'];
  totalAmountBeforeDiscountPercent: Scalars['Decimal']['output'];
};

export type ReportItemsOverviewInput = {
  groupBy: ReportItemGroupMode;
  itemsFilterInput: ItemsFilterInput;
  mergeSinglesWithComboChildren: Scalars['Boolean']['input'];
  rankBy: RankBy;
  sortField: ReportItemSortField;
  sortOrder: SortOrder;
};

export type ReportKey = {
  brandID: Scalars['Int32']['input'];
  reportID: Scalars['UUID']['input'];
  shopID: Scalars['Int32']['input'];
  vDeviceID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

export enum ReportLabelGroupMode {
  /** 依品牌分類顯示 */
  Brand = 'Brand',
  /** 依標籤名稱顯示 */
  Label = 'Label',
  /** 依標籤群組顯示 */
  LabelGroup = 'LabelGroup',
  /** 不分組（等同按標籤列出） */
  None = 'None',
  /** 依門市顯示 */
  Shop = 'Shop',
}

export type ReportLabelsCsvInput = {
  /** 匯出csv欄位 */
  columnIndices: ReportLabelsColumnIndices;
  labelsFilterInput: LabelsFilterInput;
  /** 語系 */
  locale: Locales;
  shopKeys: Array<ShopKey>;
  sortField: LabelSortField;
  sortOrder: SortOrder;
  /** 時區 */
  timezone: Scalars['String']['input'];
};

export type ReportLabelsColumnIndices = {
  /** 標籤總金額 */
  amount?: InputMaybe<Scalars['Int16']['input']>;
  /** 品牌分類 */
  brandName: Scalars['Int16']['input'];
  /** 用餐方式名稱 */
  diningOptionName: Scalars['Int16']['input'];
  /** 商品編號 */
  itemCode: Scalars['Int16']['input'];
  /** 商品類型 */
  itemKind: Scalars['Int16']['input'];
  /** 商品名稱 */
  itemName: Scalars['Int16']['input'];
  /** 價位名稱 */
  itemPriceOptionName: Scalars['Int16']['input'];
  /** 標籤群組名稱 */
  labelGroupName: Scalars['Int16']['input'];
  /** 標籤名稱 */
  labelName: Scalars['Int16']['input'];
  /** 標籤售價 */
  labelPrice?: InputMaybe<Scalars['Int16']['input']>;
  /** 標籤數量 */
  labelQuantity?: InputMaybe<Scalars['Int16']['input']>;
  /** 標籤數量百分比 */
  quantityPercent?: InputMaybe<Scalars['Int16']['input']>;
  /** 門市 */
  shopName: Scalars['Int16']['input'];
};

export type ReportLabelsGroup = {
  amount: Scalars['Decimal']['output'];
  key?: Maybe<Scalars['String']['output']>;
  labelQuantity: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  quantityPercent: Scalars['Decimal']['output'];
  /** 每個標籤的彙總資料 */
  rows: Array<LabelAggregate>;
  totalLabelPrice: Scalars['Decimal']['output'];
};

export type ReportLabelsOverviewInput = {
  groupBy: ReportLabelGroupMode;
  labelsFilterInput: LabelsFilterInput;
  rankBy: RankBy;
  sortField: LabelSortField;
  sortOrder: SortOrder;
};

export type ReservationMenuCalendar = {
  businessDate: Scalars['Date']['output'];
  dates: Array<ReservationMenuCalendarDate>;
};

export type ReservationMenuCalendarDate = {
  mealSessions: Array<ReservationMenuCalendarMealSession>;
  readonly: Scalars['Boolean']['output'];
  saleDate: Scalars['Date']['output'];
};

export type ReservationMenuCalendarMealSession = {
  displayOrder: Scalars['Int16']['output'];
  endTime: Scalars['Time']['output'];
  mealSessionID: Scalars['Int32']['output'];
  name: Scalars['String']['output'];
  schedules: Array<ReservationMenuCalendarSchedule>;
  startTime: Scalars['Time']['output'];
};

export type ReservationMenuCalendarSchedule = {
  itemName: Scalars['String']['output'];
  menuItemID: Scalars['Int32']['output'];
  menuPreorderScheduleID: Scalars['Int32']['output'];
};

export type Revenue = {
  deliveryFee: Scalars['Decimal']['output'];
  discount: Scalars['Decimal']['output'];
  itemAmount: Scalars['Decimal']['output'];
  minCharge: Scalars['Decimal']['output'];
  nonRevenuePayment: Array<Maybe<NonRevenuePayment>>;
  refund: Scalars['Decimal']['output'];
  revenue: Scalars['Decimal']['output'];
  serviceCharge: Scalars['Decimal']['output'];
  tax: Scalars['Decimal']['output'];
};

export type RevenueReport = {
  revenue: Revenue;
  time: Scalars['DateTime']['output'];
};

/** 角色 */
export type Role = {
  activate: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  description?: Maybe<Scalars['String']['output']>;
  displayID: Scalars['String']['output'];
  of: PermissionScope;
  permissions: Array<Permission>;
  roleID: Scalars['Int32']['output'];
  roleTemplate: RoleTemplate;
  roleTemplateID: Scalars['UUID']['output'];
  system: System;
  systemID: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type RolePagination = {
  pageInfo: CursorPageInfo;
  roles: Array<RoleWithExtra>;
};

export type RoleSearchParams = {
  descr?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** 角色樣板 */
export type RoleTemplate = {
  activate: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  of: PermissionScope;
  roleTemplateID: Scalars['UUID']['output'];
  system: System;
  systemID: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  visibility: RoleVisibility;
  workspace?: Maybe<Workspace>;
  workspaceID?: Maybe<Scalars['UUID']['output']>;
};

/** 角色可見度 */
export enum RoleVisibility {
  Private = 'Private',
  Public = 'Public',
}

export type RoleWithExtra = {
  permissionCount: Scalars['Int']['output'];
  role: Role;
  usageCount: Scalars['Int']['output'];
};

/** 掃碼點餐接單方式 */
export enum ScanOrderAcceptanceMode {
  /** 自動接單 */
  Auto = 'Auto',
  /** 手動接單 */
  Manual = 'Manual',
}

/** 掃碼點餐結帳模式 */
export enum ScanOrderBillingMode {
  /** 後結帳 */
  PostPay = 'PostPay',
  /** 先結帳 */
  PrePay = 'PrePay',
}

/** 掃碼點餐QRCode類型 */
export enum ScanOrderQrCodeType {
  /** 開桌QRCode */
  Dynamic = 'Dynamic',
  /** 固定桌位QRCode */
  Fixed = 'Fixed',
  /** 通用QRCode */
  General = 'General',
}

/** 門市掃碼點餐設定 */
export type ScanOrderSettingBasic = {
  banners: Array<ShopScanOrderBanner>;
  brandID: Scalars['Int32']['output'];
  cashOnSiteActivate: Scalars['Boolean']['output'];
  cashOnSiteDiningIn: Scalars['Boolean']['output'];
  cashOnSiteTakeaway: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  creditCardActivate: Scalars['Boolean']['output'];
  creditCardOnDineIn: Scalars['Boolean']['output'];
  creditCardOnTakeAway: Scalars['Boolean']['output'];
  hideItemSpecialRequire: Scalars['Boolean']['output'];
  hideOrderNote: Scalars['Boolean']['output'];
  linePayActivate: Scalars['Boolean']['output'];
  linePayOnDineIn: Scalars['Boolean']['output'];
  linePayOnTakeAway: Scalars['Boolean']['output'];
  /** 會員登入要求 */
  memberLoginRequired: O2OMemberLoginRequiredType;
  /** 會員登入時機 */
  memberLoginTiming: O2OMemberLoginTimingType;
  /** 會員來源識別碼 */
  memberSourceID?: Maybe<Scalars['UUID']['output']>;
  menuType: MenuType;
  scanOrderActivate: Scalars['Boolean']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  showItemStock: Scalars['Boolean']['output'];
  stripeActivate: Scalars['Boolean']['output'];
  stripeOnDineIn: Scalars['Boolean']['output'];
  stripeOnTakeAway: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspaceID: Scalars['UUID']['output'];
};

export type ScanOrderSettingBasicInput = {
  cashOnSiteActivate: Scalars['Boolean']['input'];
  cashOnSiteDiningIn: Scalars['Boolean']['input'];
  cashOnSiteTakeaway: Scalars['Boolean']['input'];
  creditCardActivate: Scalars['Boolean']['input'];
  creditCardOnDineIn: Scalars['Boolean']['input'];
  creditCardOnTakeAway: Scalars['Boolean']['input'];
  hideItemSpecialRequire: Scalars['Boolean']['input'];
  hideOrderNote: Scalars['Boolean']['input'];
  linePayActivate: Scalars['Boolean']['input'];
  linePayOnDineIn: Scalars['Boolean']['input'];
  linePayOnTakeAway: Scalars['Boolean']['input'];
  /** 會員登入要求 */
  memberLoginRequired: O2OMemberLoginRequiredType;
  /** 會員登入時機 */
  memberLoginTiming: O2OMemberLoginTimingType;
  /** 會員來源識別碼 */
  memberSourceID?: InputMaybe<Scalars['UUID']['input']>;
  menuType: MenuType;
  scanOrderActivate: Scalars['Boolean']['input'];
  showItemStock: Scalars['Boolean']['input'];
};

/** 門市內用掃碼點餐設定 */
export type ScanOrderSettingDiningIn = {
  /** 已付款時，接單後是否自動完成結帳 */
  autoCheckoutAfterPaidOrderAcceptedActivate: Scalars['Boolean']['output'];
  /** 結帳模式 */
  billingMode: ScanOrderBillingMode;
  /** 品牌用餐方式 ID */
  brandDiningOptionID?: Maybe<Scalars['Int32']['output']>;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 是否限制用餐時間 */
  diningTimeLimitActivate: Scalars['Boolean']['output'];
  /** 用餐時間限制（分鐘） */
  diningTimeLimitInMinutes: Scalars['Int16']['output'];
  /** 是否限制點餐距離 */
  distanceLimitActivate: Scalars['Boolean']['output'];
  /** 限制距離（公尺） */
  distanceLimitInMeters?: Maybe<Scalars['Int32']['output']>;
  /** 隱藏點餐金額 */
  hideOrderAmount: Scalars['Boolean']['output'];
  /** 是否啟用最後加點時間限制 */
  lastOrderLimitActivate: Scalars['Boolean']['output'];
  /** 最後加點時間（用餐結束前 X 分鐘） */
  lastOrderLimitInMinutes: Scalars['Int16']['output'];
  /** 是否啟用最後加點提醒 */
  lastOrderReminderActivate: Scalars['Boolean']['output'];
  /** 最後加點提醒時間（用餐結束前 X 分鐘） */
  lastOrderReminderInMinutes: Scalars['Int16']['output'];
  /** 點餐注意事項 */
  notes?: Maybe<Scalars['String']['output']>;
  /** 已付款訂單接單方式 */
  paidOrderAcceptance: ScanOrderAcceptanceMode;
  /** 掃碼方式 */
  qrCodeType: ScanOrderQrCodeType;
  /** 是否啟用內用掃碼點餐 */
  scanOrderDiningInActivate: Scalars['Boolean']['output'];
  shopID: Scalars['Int32']['output'];
  /** 是否需要選擇桌位 */
  tableSelectionRequired: Scalars['Boolean']['output'];
  /** 未付款訂單接單方式 */
  unpaidOrderAcceptance: ScanOrderAcceptanceMode;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspaceID: Scalars['UUID']['output'];
};

export type ScanOrderSettingDiningInInput = {
  /** 已付款時，接單後是否自動完成結帳 */
  autoCheckoutAfterPaidOrderAcceptedActivate: Scalars['Boolean']['input'];
  /** 結帳模式 */
  billingMode: ScanOrderBillingMode;
  brandDiningOptionID: Scalars['Int32']['input'];
  /** 是否限制用餐時間 */
  diningTimeLimitActivate: Scalars['Boolean']['input'];
  /** 用餐時間限制（分鐘） */
  diningTimeLimitInMinutes: Scalars['Int16']['input'];
  /** 是否限制點餐距離 */
  distanceLimitActivate: Scalars['Boolean']['input'];
  /** 限制距離（公尺） */
  distanceLimitInMeters?: InputMaybe<Scalars['Int32']['input']>;
  /** 隱藏點餐金額 */
  hideOrderAmount: Scalars['Boolean']['input'];
  /** 是否啟用最後加點時間限制 */
  lastOrderLimitActivate: Scalars['Boolean']['input'];
  /** 最後加點時間（用餐結束前 X 分鐘） */
  lastOrderLimitInMinutes: Scalars['Int16']['input'];
  /** 是否啟用最後加點提醒 */
  lastOrderReminderActivate: Scalars['Boolean']['input'];
  /** 最後加點提醒時間（用餐結束前 X 分鐘） */
  lastOrderReminderInMinutes: Scalars['Int16']['input'];
  /** 點餐注意事項 */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** 已付款訂單接單方式 */
  paidOrderAcceptance: ScanOrderAcceptanceMode;
  /** 掃碼方式 */
  qrCodeType: ScanOrderQrCodeType;
  /** 是否啟用內用掃碼點餐 */
  scanOrderDiningInActivate: Scalars['Boolean']['input'];
  /** 是否需要選擇桌位 */
  tableSelectionRequired: Scalars['Boolean']['input'];
  /** 未付款訂單接單方式 */
  unpaidOrderAcceptance: ScanOrderAcceptanceMode;
};

export type ScanOrderSettingDiningInWithUrl = {
  scanOrderDiningInURL?: Maybe<Scalars['String']['output']>;
  scanOrderSettingDiningIn?: Maybe<ScanOrderSettingDiningIn>;
};

export type ScanOrderSettingInput = {
  deleteIDs?: InputMaybe<Array<Scalars['Int32']['input']>>;
  files?: InputMaybe<Array<Scalars['Upload']['input']>>;
  scanOrderSettingBasicInput: ScanOrderSettingBasicInput;
};

/** 門市外帶掃碼點餐設定 */
export type ScanOrderSettingTakeOut = {
  /** 已付款時，接單後是否自動完成結帳 */
  autoCheckoutAfterPaidOrderAcceptedActivate: Scalars['Boolean']['output'];
  /** 品牌用餐方式 ID */
  brandDiningOptionID?: Maybe<Scalars['Int32']['output']>;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 點餐注意事項 */
  notes?: Maybe<Scalars['String']['output']>;
  /** 已付款訂單接單方式 */
  paidOrderAcceptance: ScanOrderAcceptanceMode;
  /** 是否啟用外帶掃碼點餐 */
  scanOrderTakeOutActivate: Scalars['Boolean']['output'];
  shopID: Scalars['Int32']['output'];
  /** 未付款訂單接單方式 */
  unpaidOrderAcceptance: ScanOrderAcceptanceMode;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspaceID: Scalars['UUID']['output'];
};

export type ScanOrderSettingTakeOutInput = {
  /** 已付款時，接單後是否自動完成結帳 */
  autoCheckoutAfterPaidOrderAcceptedActivate: Scalars['Boolean']['input'];
  brandDiningOptionID: Scalars['Int32']['input'];
  /** 點餐注意事項 */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** 已付款訂單接單方式 */
  paidOrderAcceptance: ScanOrderAcceptanceMode;
  /** 是否啟用外帶掃碼點餐 */
  scanOrderTakeOutActivate: Scalars['Boolean']['input'];
  /** 未付款訂單接單方式 */
  unpaidOrderAcceptance: ScanOrderAcceptanceMode;
};

export type ScanOrderSettingTakeOutWithUrl = {
  scanOrderSettingTakeOut?: Maybe<ScanOrderSettingTakeOut>;
  scanOrderTakeOutURL: Scalars['String']['output'];
};

/** 要選擇的發佈品牌清單 */
export type SelectBrandLists = {
  /** 品牌 */
  brandID: Scalars['Int32']['input'];
  /** 要選擇的發佈店家清單 */
  shopsID: Array<Scalars['Int32']['input']>;
};

export type Service = {
  appServices: Array<AppService>;
  createdAt: Scalars['DateTimeZ']['output'];
  description?: Maybe<Scalars['String']['output']>;
  integrationMode: AppIntegrationMode;
  name: Scalars['String']['output'];
  serviceID: Scalars['UUID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTimeZ']['output'];
};

/** 結帳 - 服務費 */
export type ServiceFee = {
  /** 服務費進階顯示名稱(使用於 POS 端及消費者端介面的顯示。若有設定值，取代原「服務費」的顯示。) */
  advName: Scalars['String']['output'];
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 是否開啟服務費 */
  enabled: Scalars['Boolean']['output'];
  /** 服務費排除計算的商品 */
  exclItems: Array<ServiceFeeExclItem>;
  /** 服務費(%) */
  percentage: Scalars['Decimal']['output'];
  /** 小數進位規則 */
  roundingRule: DiscountRoundingRule;
  /** 服務費選擇用餐方式 */
  selDiningOptions: Array<ServiceFeeSelDiningOption>;
  shop: Shop;
  /** 選擇用餐方式 */
  shopDiningOptionApplyMode: ShopDiningOptionApplyMode;
  shopID: Scalars['Int32']['output'];
  /** 服務費稅別 */
  taxCategory: TaxCategory;
  taxGroup?: Maybe<TaxGroup>;
  /** 服務費稅金群組 */
  taxGroupID?: Maybe<Scalars['Int16']['output']>;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 服務費排除計算的商品 */
export type ServiceFeeExclItem = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  item: Item;
  /** 商品 */
  itemID: Scalars['Int32']['output'];
  serviceFee: ServiceFee;
  shopID: Scalars['Int32']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 服務費選擇用餐方式 */
export type ServiceFeeSelDiningOption = {
  /** 用餐方式 */
  brandDiningOptionID: Scalars['Int32']['output'];
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  serviceFee: ServiceFee;
  shopDiningOption: ShopDiningOption;
  shopID: Scalars['Int32']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 服務中心 */
export type ServiceHub = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  shop?: Maybe<Shop>;
  shopID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  vDeviceID: Scalars['Int32']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 商品配件 */
export type Serviceware = {
  /** 是否啟用 */
  activate: Scalars['Boolean']['output'];
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 顯示順序 */
  displayOrder: Scalars['Int16']['output'];
  /** 配件名稱 */
  name: Scalars['String']['output'];
  servicewareID: Scalars['UUID']['output'];
  servicewareItems?: Maybe<Array<ServicewareItem>>;
  servicewareLabels?: Maybe<Array<ServicewareLabel>>;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 商品配件關聯商品價位 */
export type ServicewareItem = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  itemID: Scalars['Int32']['output'];
  itemPriceOption: ItemPriceOption;
  itemPriceOptionID: Scalars['Int32']['output'];
  /** 配件數量 */
  quantity: Scalars['Int32']['output'];
  serviceware: Serviceware;
  servicewareID: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type ServicewareItemRelationInput = {
  /** 商品識別碼 */
  itemID: Scalars['Int32']['input'];
  /** 價位識別碼 */
  itemPriceOptionID: Scalars['Int32']['input'];
  /** 配件數量 */
  quantity: Scalars['Int32']['input'];
};

/** 商品配件關聯標籤 */
export type ServicewareLabel = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  label: Label;
  labelID: Scalars['Int32']['output'];
  serviceware: Serviceware;
  servicewareID: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type ServicewareLabelRelationInput = {
  /** 標籤識別碼 */
  labelID: Scalars['Int32']['input'];
};

export type ServicewarePagination = {
  pageInfo: CursorPageInfo;
  servicewares: Array<ListServicewareResponse>;
};

export type ServicewareSearchParams = {
  /** 配件名稱 */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type SetAiWaiterSettingInput = {
  activate: Scalars['Boolean']['input'];
  brandKey: BrandKey;
  selectedVirtualHumans: Array<AiWaiterVirtualHumanSelectionInput>;
};

/** 基本設定儲存成功回應 */
export type SetAiWaiterSettingResponse = {
  data?: Maybe<Scalars['JSON']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SetBrandDiningOptionInput = {
  brandDiningOptionKey: BrandDiningOptionKey;
  diningOptionType: DiningOptionType;
  disabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
};

export type ShiftCloseColumnIndices = {
  cashShortOver: Scalars['Float']['output'];
  countedCash: Scalars['Float']['output'];
  deviceName: Scalars['String']['output'];
  expectedCash: Scalars['Float']['output'];
  operatorName: Scalars['String']['output'];
  reportID?: Maybe<Scalars['String']['output']>;
  reserveCash: Scalars['Float']['output'];
  revenue: Scalars['Float']['output'];
  shiftCloseTime: Scalars['DateTimeZ']['output'];
  shiftStartTime: Scalars['DateTimeZ']['output'];
  totalVoidAmount: Scalars['Float']['output'];
  totalVoidCount: Scalars['Int']['output'];
  vDeviceID?: Maybe<Scalars['Int']['output']>;
};

export type ShiftClosePagination = {
  pageInfo: CursorPageInfo;
  shiftCloseReports?: Maybe<Array<ShiftCloseColumnIndices>>;
};

/** 小結報表 */
export type ShiftCloseReport = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  /** 營業日期 */
  businessDate: Scalars['Date']['output'];
  /** 現金短溢 */
  cashDiscrepancy?: Maybe<Scalars['Decimal']['output']>;
  /** 小結時清點的實際現金 */
  closingCash?: Maybe<Scalars['Decimal']['output']>;
  createdAt: Scalars['DateTimeZ']['output'];
  /** 裝置機號 */
  deviceCode: Scalars['String']['output'];
  deviceShift: DeviceShift;
  opUser?: Maybe<Employee>;
  /** 操作人員 */
  opUserID?: Maybe<Scalars['UUID']['output']>;
  /** 小結報表內容 */
  reportContent: Scalars['JSON']['output'];
  reportID: Scalars['UUID']['output'];
  /** 關聯的裝置班次 */
  shiftID: Scalars['UUID']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  /** 出單票據設定 */
  ticketSetting?: Maybe<Scalars['JSON']['output']>;
  vDevice: VDevice;
  vDeviceID: Scalars['Int32']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type ShiftCloseReportSearchParams = {
  businessDateRange?: InputMaybe<TimeRange>;
  createdAtRange?: InputMaybe<TimeRange>;
};

/** 班次類型 */
export enum ShiftType {
  /** 不開班直接點餐 */
  DirectOrder = 'DirectOrder',
  /** 開班 */
  Open = 'Open',
}

/** 門市 */
export type Shop = {
  address?: Maybe<Scalars['JSON']['output']>;
  /** 門市簡稱 */
  aliasName?: Maybe<Scalars['String']['output']>;
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  buildingFloor?: Maybe<Scalars['String']['output']>;
  businessHours?: Maybe<Array<ShopBusinessHour>>;
  cityCounty?: Maybe<Scalars['String']['output']>;
  /** 門市編號 */
  code?: Maybe<Scalars['String']['output']>;
  /** 門市電話 */
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeZ']['output'];
  /** 週間時間類型 */
  dayTimeType?: Maybe<DayTimeType>;
  /** 門市介紹 */
  description?: Maybe<Scalars['String']['output']>;
  /** 用餐方式選擇模式 */
  diningOptionSelectMode: DiningOptionSelectMode;
  /** 顯示順序 */
  displayOrder: Scalars['Int16']['output'];
  district?: Maybe<Scalars['String']['output']>;
  /** 門市地址 */
  doorNo?: Maybe<Scalars['String']['output']>;
  e164CountryCode?: Maybe<E164CountryCode>;
  landLine?: Maybe<Scalars['String']['output']>;
  language: Language;
  /** 語言 */
  languageID: Scalars['String']['output'];
  /** 緯度 */
  lat?: Maybe<Scalars['Decimal']['output']>;
  linkItemShops: Array<LinkItemShop>;
  linkShopLabelGroups: Array<LinkShopLabelGroup>;
  /** 經度 */
  lng?: Maybe<Scalars['Decimal']['output']>;
  /** 門市名稱 */
  name: Scalars['String']['output'];
  officialMaintainer: Employee;
  /** 官方維護人員 */
  officialMaintainerID: Scalars['UUID']['output'];
  presetBrandDiningOption?: Maybe<BrandDiningOption>;
  /** 預設用餐方式 */
  presetBrandDiningOptionID?: Maybe<Scalars['Int32']['output']>;
  road?: Maybe<Scalars['String']['output']>;
  shopAreas: Array<ShopArea>;
  /** 門市容器重量管理服務啟用狀態 */
  shopContainerSettings?: Maybe<ShopContainerSettings>;
  /** 門市容器重量設定 */
  shopContainers: Array<ShopContainer>;
  /** 門市用餐方式預設容器 */
  shopDiningOptionContainers: Array<ShopDiningOptionContainer>;
  shopDiningOptionTableSettings: Array<ShopDiningOptionTableSetting>;
  shopDiningOptions: Array<ShopDiningOption>;
  shopDisplayID: Scalars['String']['output'];
  shopID: Scalars['Int32']['output'];
  /** 門市形象圖片 */
  shopImages: Array<ShopImage>;
  /** 門市線上點餐設定 */
  shopO2OSetting?: Maybe<ShopO2OSetting>;
  shopOrderRemarkTitles: Array<ShopOrderRemarkTitle>;
  /** 門市 POS 設定 */
  shopPOSSetting?: Maybe<ShopPosSetting>;
  shopPublishTasks: Array<ShopPublishTask>;
  shopSubscriptionState: Scalars['String']['output'];
  /** 門市停售商品設定 */
  stopSaleItems: Array<StopSaleItem>;
  /** 門市停售標籤設定 */
  stopSaleLabels: Array<StopSaleLabel>;
  subBrand?: Maybe<SubBrand>;
  /** 品牌分類 */
  subBrandID?: Maybe<Scalars['Int32']['output']>;
  timezone: Timezone;
  /** 時區 */
  timezoneID: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
  zipCode?: Maybe<Scalars['String']['output']>;
};

/** 門市 */
export type ShopShopDiningOptionsArgs = {
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ShopApp = {
  app: App;
  appID: Scalars['UUID']['output'];
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  shopBindSettings: Scalars['JSON']['output'];
  shopID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 門市套用模式 */
export enum ShopApplyMode {
  /** 所有門市 */
  AllShops = 'AllShops',
  /** 指定門市 */
  SelectedShops = 'SelectedShops',
  /** 指定品牌分類 */
  SelectedSubBrands = 'SelectedSubBrands',
}

/** 桌位區域 */
export type ShopArea = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 顯示順序 */
  displayOrder: Scalars['Int16']['output'];
  /** 區域名稱 */
  name: Scalars['String']['output'];
  shopAreaDecorations: Array<ShopAreaDecoration>;
  shopAreaID: Scalars['Int32']['output'];
  shopID: Scalars['Int32']['output'];
  shopTables: Array<ShopTable>;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 桌位裝飾 */
export type ShopAreaDecoration = {
  brandID: Scalars['Int32']['output'];
  /** 文字內容 */
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeZ']['output'];
  /** 高度 */
  height: Scalars['Decimal']['output'];
  /** 旋轉角度 */
  rotation: Scalars['Decimal']['output'];
  shopAreaDecorationID: Scalars['Int32']['output'];
  shopAreaID: Scalars['Int32']['output'];
  shopID: Scalars['Int32']['output'];
  /** 裝飾類型 */
  type: ShopTableDecorationType;
  updatedAt: Scalars['DateTimeZ']['output'];
  /** 寬度 */
  width: Scalars['Decimal']['output'];
  workspaceID: Scalars['UUID']['output'];
  /** 座標 X */
  x: Scalars['Decimal']['output'];
  /** 座標 Y */
  y: Scalars['Decimal']['output'];
  /** Z 軸順序 */
  zOrder: Scalars['Int16']['output'];
};

export type ShopAreaDecorationInput = {
  /** 文字內容 */
  content?: InputMaybe<Scalars['String']['input']>;
  /** 顯示順序 */
  displayOrder: Scalars['Int16']['input'];
  /** 高度 */
  height: Scalars['Decimal']['input'];
  /** 旋轉角度 */
  rotation: Scalars['Decimal']['input'];
  shopAreaDecorationID?: InputMaybe<Scalars['Int32']['input']>;
  /** 裝飾類型 */
  type: ShopTableDecorationType;
  /** 寬度 */
  width: Scalars['Decimal']['input'];
  /** 座標 X */
  x: Scalars['Decimal']['input'];
  /** 座標 Y */
  y: Scalars['Decimal']['input'];
  /** Z軸順序 */
  zOrder: Scalars['Int16']['input'];
};

export type ShopAreaInfo = {
  shopAreaDecorations: Array<Maybe<ShopAreaDecoration>>;
  shopTables: Array<Maybe<ShopTable>>;
};

export type ShopAreaInput = {
  /** 顯示順序 */
  displayOrder: Scalars['Int16']['input'];
  /** 區域名稱 */
  name: Scalars['String']['input'];
  shopAreaID?: InputMaybe<Scalars['Int32']['input']>;
};

export type ShopAreaPagination = {
  pageInfo: CursorPageInfo;
  shopAreas: Array<Maybe<ShopArea>>;
};

/** 門市營業時間 */
export type ShopBusinessHour = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  endTime: Scalars['Time']['output'];
  shop: Shop;
  shopBusinessHoursID: Scalars['Int32']['output'];
  shopID: Scalars['Int32']['output'];
  startTime: Scalars['Time']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  /** 星期幾: (0: 星期日, 1: 星期一, 2: 星期二, 3: 星期三, 4: 星期四, 5: 星期五, 6: 星期六, 7: 每天) */
  weekDay: Scalars['Int16']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 門市容器重量設定 */
export type ShopContainer = {
  /** 開啟/關閉 */
  activate: Scalars['Boolean']['output'];
  brandID: Scalars['Int32']['output'];
  containerID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 排序 */
  displayOrder: Scalars['Int16']['output'];
  /** 顯示名稱 */
  name: Scalars['String']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  /** 重量 */
  weight?: Maybe<Scalars['Decimal']['output']>;
  /** 單位 */
  weightUnit: WeightUnit;
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 門市容器重量管理服務啟用狀態 */
export type ShopContainerSettings = {
  /** 服務啟用狀態 */
  activate: Scalars['Boolean']['output'];
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type ShopContainerWeightManagement = {
  shopContainerSettings?: Maybe<ShopContainerSettings>;
  shopContainers: Array<ShopContainer>;
  shopDiningOptionContainers: Array<ShopDiningOptionContainer>;
};

export type ShopDetails = {
  shop: Shop;
  shopBusinessHours: Array<ShopBusinessHour>;
  shopGroups: Array<ShopGroup>;
  shopImages: Array<ShopImage>;
};

/** 門市用餐方式設定 */
export type ShopDiningOption = {
  brandDiningOption: BrandDiningOption;
  brandDiningOptionID: Scalars['Int32']['output'];
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 停用 */
  disabled: Scalars['Boolean']['output'];
  /** 顯示順序 */
  displayOrder: Scalars['Int16']['output'];
  /** 預設備註識別碼 */
  orderRemarkTitleID?: Maybe<Scalars['UUID']['output']>;
  /** 叫餐備註是否必填 */
  orderRemarkTitleRequired: Scalars['Boolean']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  shopOrderRemarkTitle?: Maybe<ShopOrderRemarkTitle>;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 選擇用餐方式 */
export enum ShopDiningOptionApplyMode {
  /** 所有用餐方式 */
  All = 'All',
  /** 指定用餐方式 */
  Specified = 'Specified',
}

/** 門市用餐方式預設容器 */
export type ShopDiningOptionContainer = {
  brandDiningOptionID: Scalars['Int32']['output'];
  brandID: Scalars['Int32']['output'];
  containerID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  shopContainer: ShopContainer;
  shopDiningOption: ShopDiningOption;
  shopID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type ShopDiningOptionInput = {
  brandDiningOptionID: Scalars['Int32']['input'];
  diningOptionType: Scalars['String']['input'];
  disabled: Scalars['Boolean']['input'];
  displayOrder: Scalars['Int16']['input'];
  shopDiningOptionTableSettingInput?: InputMaybe<ShopDiningOptionTableSettingInput>;
};

export type ShopDiningOptionKey = {
  brandDiningOptionID: Scalars['Int32']['input'];
  brandID: Scalars['Int32']['input'];
  shopID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

/** 用餐方式桌位設定 */
export type ShopDiningOptionTableSetting = {
  /** 啟用桌位管理 */
  activate: Scalars['Boolean']['output'];
  brandDiningOptionID: Scalars['Int32']['output'];
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 啟用用餐時間警示 */
  mealTimeAlertEnabled: Scalars['Boolean']['output'];
  /** 用餐時間限制 (分鐘) */
  mealTimeLimitMinutes: Scalars['Int16']['output'];
  shopID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspaceID: Scalars['UUID']['output'];
};

export type ShopDiningOptionTableSettingInput = {
  /** 是否啟用桌位管理功能 */
  active: Scalars['Boolean']['input'];
  /** 用餐時間警示 */
  mealTimeAlertEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** 用餐時間限制，單位為分鐘 */
  mealTimeLimitMinutes?: InputMaybe<Scalars['Int16']['input']>;
};

/** 結帳 - 優惠計算 */
export type ShopDiscountRule = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 標籤套用方式 */
  discountLabelApplyMode: DiscountLabelApplyMode;
  /** 商品優惠(指定商品、單件商品) */
  manualCombineItemEnabled: Scalars['Boolean']['output'];
  /** 整筆訂單優惠 */
  manualCombineOrderEnabled: Scalars['Boolean']['output'];
  /** 單品優惠計算規則 */
  manualItemDiscountCalcMethod: DiscountCalcMethod;
  /** 整單優惠計算規則 */
  manualOrderDiscountCalcMethod: DiscountCalcMethod;
  /** 整單優惠計算規則-現金折扣-可抵低消費用 */
  manualOrderDiscountMinChargeEnabled: Scalars['Boolean']['output'];
  /** 整單優惠計算規則-現金折扣-可抵服務費 */
  manualOrderDiscountServiceFeeEnabled: Scalars['Boolean']['output'];
  /** 小數進位規則 */
  roundingRule: DiscountRoundingRule;
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type ShopDisplayOrderInput = {
  displayOrder: Scalars['Int16']['input'];
  shopID: Scalars['Int32']['input'];
};

/** 門市群組 */
export type ShopGroup = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 門市群組描述 */
  description?: Maybe<Scalars['String']['output']>;
  /** 顯示順序 */
  displayOrder: Scalars['Int16']['output'];
  groupID: Scalars['Int32']['output'];
  /** 門市群組名稱 */
  name: Scalars['String']['output'];
  /** 門市群組多語系名稱 */
  nameLang: Scalars['JSON']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type ShopGroupInput = {
  displayOrder?: InputMaybe<Scalars['Int16']['input']>;
  groupID?: InputMaybe<Scalars['Int32']['input']>;
  name: Scalars['String']['input'];
  nameLang: Scalars['JSON']['input'];
};

export type ShopGroupName = {
  groupID: Scalars['Int32']['output'];
  name: Scalars['String']['output'];
  nameLang: Scalars['JSON']['output'];
};

export type ShopGroupSelectionInput = {
  groupID?: InputMaybe<Scalars['Int32']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameLang?: InputMaybe<Scalars['JSON']['input']>;
};

/** 門市形象圖片 */
export type ShopImage = {
  alg: ImageHashAlg;
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 顯示順序 */
  displayOrder: Scalars['Int16']['output'];
  /** 檔案大小 */
  fileSize: Scalars['Int32']['output'];
  hash: Scalars['String']['output'];
  /** 高度 */
  height: Scalars['Int16']['output'];
  imageID: Scalars['Int32']['output'];
  mime: ImageMimeType;
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  /** 寬度 <= 1200px */
  width: Scalars['Int16']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export enum ShopInfoAlignStyle {
  /** 靠左 */
  Left = 'Left',
  /** 居中 */
  Middle = 'Middle',
}

/** 發票設定 */
export type ShopInvoiceSetting = {
  /** 啟用電子發票 */
  activate: Scalars['Boolean']['output'];
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  /** 營業人登記名稱 */
  businessEntityName: Scalars['String']['output'];
  /** 營業人統一編號 */
  businessIDNumber: Scalars['String']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 字軌來源 */
  einvoiceSourceID: Scalars['UUID']['output'];
  /** 每次取號本數 */
  fetchNumberOfGroup: Scalars['Int16']['output'];
  invoiceReason?: Maybe<SysInvoiceReason>;
  /** 發票理由 */
  invoiceReasonID?: Maybe<Scalars['Int16']['output']>;
  invoiceTaxType: SysInvoiceTaxType;
  /** 發票稅別 */
  invoiceTaxTypeID: Scalars['Int16']['output'];
  /** 發票張數低於安全數量提醒 */
  lowStockAlertEnabled: Scalars['Boolean']['output'];
  /** 發票安全字軌數量 */
  safeQty: Scalars['Int16']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  shopInvoiceSettingID: Scalars['Int32']['output'];
  sysInvoiceTaxTypeReasonRate?: Maybe<SysInvoiceTaxTypeReasonRate>;
  taxRate: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type ShopKey = {
  brandID: Scalars['Int32']['input'];
  shopID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

/** 門市會員標籤 */
export type ShopMemberTag = {
  brandID: Scalars['Int32']['output'];
  brandMemberTag: BrandMemberTag;
  brandMemberTagID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 停用 */
  disabled: Scalars['Boolean']['output'];
  /** 顯示順序 */
  displayOrder: Scalars['Int16']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type ShopMenuServiceAvailabilityInput = {
  dayOfWeek: Scalars['String']['input'];
  timePeriods: Array<ShopMenuServiceTimePeriodInput>;
};

export type ShopMenuServiceTimePeriodInput = {
  endTime: Scalars['Time']['input'];
  startTime: Scalars['Time']['input'];
};

/** 門市菜單同步 */
export type ShopMenuSync = {
  brandID: Scalars['Int32']['output'];
  content: Scalars['JSON']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  menu: Menu;
  menuID: Scalars['Int32']['output'];
  menuVersion: Scalars['String']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  status: ShopMenuSyncStatus;
  syncID: Scalars['Int32']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 門市菜單同步狀態 */
export enum ShopMenuSyncStatus {
  /** 同步失敗 */
  Failed = 'Failed',
  /** 尚未同步 */
  Pending = 'Pending',
  /** 完成同步 */
  Success = 'Success',
  /** 同步中 */
  Syncing = 'Syncing',
}

/** 門市 O2O 廣告輪播圖 */
export type ShopO2OBanner = {
  alg: ImageHashAlg;
  bannerID: Scalars['Int32']['output'];
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  fileSize: Scalars['Int32']['output'];
  hash: Scalars['String']['output'];
  height: Scalars['Int16']['output'];
  mime: ImageMimeType;
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  width: Scalars['Int16']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 門市 O2O 公休日 */
export type ShopO2OOffDay = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  offDay: Scalars['Date']['output'];
  offDayID: Scalars['Int32']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 門市 O2O 點餐時段 */
export type ShopO2OOrderingHour = {
  activate: Scalars['Boolean']['output'];
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  endTime: Scalars['Time']['output'];
  hourID: Scalars['Int32']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  startTime: Scalars['Time']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  weekDay: Scalars['Int16']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 門市 O2O 設定 */
export type ShopO2OSetting = {
  announcement?: Maybe<Scalars['String']['output']>;
  bagItemID?: Maybe<Scalars['Int32']['output']>;
  bagItemPriceOptionID?: Maybe<Scalars['Int32']['output']>;
  brandID: Scalars['Int32']['output'];
  bufferTimeInMin: Scalars['Int16']['output'];
  cashDelivery: Scalars['Boolean']['output'];
  cashOnSiteActivate: Scalars['Boolean']['output'];
  cashPickup: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  creditCardActivate: Scalars['Boolean']['output'];
  creditCardDelivery: Scalars['Boolean']['output'];
  creditCardPickup: Scalars['Boolean']['output'];
  deliverMethod?: Maybe<Scalars['String']['output']>;
  deliveryActivate: Scalars['Boolean']['output'];
  deliveryDistanceMaxKm?: Maybe<Scalars['Int32']['output']>;
  deliveryDistanceRule?: Maybe<O2ODeliveryDistanceRule>;
  deliveryFeeAmount?: Maybe<Scalars['Decimal']['output']>;
  deliveryFeeCalcMode: O2ODeliveryFeeCalcMode;
  deliveryFeeRule?: Maybe<O2ODeliveryFeeRule>;
  deliveryPrepareMealTimeInMin?: Maybe<Scalars['Int16']['output']>;
  deliveryTimeInMin?: Maybe<Scalars['Int16']['output']>;
  extraBagMessage?: Maybe<Scalars['String']['output']>;
  hideItemSpecialRequire: Scalars['Boolean']['output'];
  hideOrderNote: Scalars['Boolean']['output'];
  immediateOrderActivate: Scalars['Boolean']['output'];
  linePayActivate: Scalars['Boolean']['output'];
  linePayDelivery: Scalars['Boolean']['output'];
  linePayPickup: Scalars['Boolean']['output'];
  /** 點餐會員登入模式 */
  memberLoginRequired: O2OMemberLoginRequiredType;
  /** 會員登入時機 */
  memberLoginTiming: O2OMemberLoginTimingType;
  memberSourceID?: Maybe<Scalars['UUID']['output']>;
  menuSource: MenuType;
  needAskingExtraBag: Scalars['Boolean']['output'];
  needAskingUtensil: Scalars['Boolean']['output'];
  onlineOrderActivate: Scalars['Boolean']['output'];
  onlineOrderUrl?: Maybe<Scalars['String']['output']>;
  orderingHoursType?: Maybe<O2OOrderingHoursType>;
  pickupActivate: Scalars['Boolean']['output'];
  pickupMethod?: Maybe<Scalars['String']['output']>;
  pickupPrepareMealTimeInMin?: Maybe<Scalars['Int16']['output']>;
  preorderAcceptanceRangeBegin: Scalars['Int16']['output'];
  preorderAcceptanceRangeExtra: Scalars['Int16']['output'];
  preorderActivate: Scalars['Boolean']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  stripeActivate: Scalars['Boolean']['output'];
  stripeDelivery: Scalars['Boolean']['output'];
  stripePickup: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  utensilMessage?: Maybe<Scalars['String']['output']>;
  workspaceID: Scalars['UUID']['output'];
};

export type ShopO2OSettingInput = {
  announcement?: InputMaybe<Scalars['String']['input']>;
  bagItemID?: InputMaybe<Scalars['Int32']['input']>;
  bagItemPriceOptionID?: InputMaybe<Scalars['Int32']['input']>;
  bufferTimeInMin: Scalars['Int16']['input'];
  cashDelivery: Scalars['Boolean']['input'];
  cashOnSiteActivate: Scalars['Boolean']['input'];
  cashPickup: Scalars['Boolean']['input'];
  creditCardActivate: Scalars['Boolean']['input'];
  creditCardDelivery: Scalars['Boolean']['input'];
  creditCardPickup: Scalars['Boolean']['input'];
  extraBagMessage?: InputMaybe<Scalars['String']['input']>;
  hideItemSpecialRequire: Scalars['Boolean']['input'];
  hideOrderNote: Scalars['Boolean']['input'];
  immediateOrderActivate: Scalars['Boolean']['input'];
  linePayActivate: Scalars['Boolean']['input'];
  linePayDelivery: Scalars['Boolean']['input'];
  linePayPickup: Scalars['Boolean']['input'];
  /** 點餐會員登入模式 */
  memberLoginRequired: O2OMemberLoginRequiredType;
  /** 會員登入時機 */
  memberLoginTiming: O2OMemberLoginTimingType;
  /** 點餐連結會員來源 */
  memberSourceID?: InputMaybe<Scalars['UUID']['input']>;
  menuSource: MenuType;
  /** 塑膠袋 */
  needAskingExtraBag: Scalars['Boolean']['input'];
  /** 餐具 */
  needAskingUtensil: Scalars['Boolean']['input'];
  onlineOrderActivate: Scalars['Boolean']['input'];
  preorderAcceptanceRangeBegin: Scalars['Int16']['input'];
  preorderAcceptanceRangeExtra: Scalars['Int16']['input'];
  preorderActivate: Scalars['Boolean']['input'];
  utensilMessage?: InputMaybe<Scalars['String']['input']>;
};

export type ShopO2OSettingWithBanner = {
  onlineOrderUrl?: Maybe<Scalars['String']['output']>;
  shopO2OBanner?: Maybe<Array<Maybe<ShopO2OBanner>>>;
  shopO2OSetting?: Maybe<ShopO2OSetting>;
};

export type ShopOrderRemarkSetting = {
  /** 叫餐備註功能啟用 */
  orderRemarkEnabled: Scalars['Boolean']['output'];
  /** 門市用餐方式設定 */
  shopDiningOptions: Array<ShopDiningOption>;
  /** 門市叫餐備註名稱設定 */
  shopOrderRemarkTitles: Array<ShopOrderRemarkTitle>;
};

/** 門市叫餐備註名稱設定 */
export type ShopOrderRemarkTitle = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 是否停用 */
  disabled: Scalars['Boolean']['output'];
  /** 顯示順序 */
  displayOrder: Scalars['Int16']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  /** 備註名稱 */
  title: Scalars['String']['output'];
  /** 備註識別碼 */
  titleID: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 門市 POS 線上訂單依來源設定 */
export type ShopPosOnlineOrderSourceSetting = {
  /** 線上訂單自動接單 */
  autoAcceptOnlineOrder: Scalars['Boolean']['output'];
  /** 線上訂單已付款，於接單後開立發票 */
  autoIssueInvoiceAfterAcceptPaidOnlineOrder: Scalars['Boolean']['output'];
  /** 線上訂單自動出單 */
  autoIssueOnlineOrder: Scalars['Boolean']['output'];
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 預約單於取餐時間前幾分鐘自動出單 */
  preorderAutoIssueBeforeMinutes: Scalars['Int16']['output'];
  /** 指定預約單自動出單時機 */
  preorderAutoIssueTimingEnabled: Scalars['Boolean']['output'];
  /** 線上訂單已付款，出單時列印交易明細 */
  printPaidOnlineOrder: Scalars['Boolean']['output'];
  shopID: Scalars['Int32']['output'];
  shopPOSSetting: ShopPosSetting;
  sourceApp: App;
  /** 訂單來源 App ID */
  sourceAppID: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 門市 POS 設定 */
export type ShopPosSetting = {
  /** 可調整品項是否收服務費 */
  adjustServiceFee: Scalars['Boolean']['output'];
  /** 取消關帳 */
  allowCancelClose: Scalars['Boolean']['output'];
  /** 線上訂單自動接單： 收到訂單後自動進行接單 */
  autoAcceptOnlineOrder: Scalars['Boolean']['output'];
  /** 自動清除桌單 */
  autoClearTable: Scalars['Boolean']['output'];
  /** 線上訂單已付款，於接單後開立發票 */
  autoIssueInvoiceAfterAcceptPaidOnlineOrder: Scalars['Boolean']['output'];
  /** 線上訂單自動出單 */
  autoIssueOnlineOrder: Scalars['Boolean']['output'];
  /** 自動鎖屏時間啟用 */
  autoLockEnabled: Scalars['Boolean']['output'];
  /** 自動鎖屏時間(秒) */
  autoLockTime: Scalars['Int16']['output'];
  /** 同步出單 */
  autoPrint: Scalars['Boolean']['output'];
  /** 點餐列印送出後，自動返回桌位管理畫面 */
  autoReturnTable: Scalars['Boolean']['output'];
  /** 金額條碼連結商品ID */
  barcodeAmountItemID?: Maybe<Scalars['Int32']['output']>;
  barcodeAmountItemPriceOption?: Maybe<ItemPriceOption>;
  /** 金額條碼連結商品價位ID */
  barcodeAmountItemPriceOptionID?: Maybe<Scalars['Int32']['output']>;
  /** 金額條碼掃描 */
  barcodeAmountScanEnabled: Scalars['Boolean']['output'];
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  /** 找零提醒 */
  changeReminder: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 裝置資料保留天數 */
  deviceDataRetentionDays: Scalars['Int16']['output'];
  /** 訂單顯示商品稅率資訊 */
  displayTaxInfo: Scalars['Boolean']['output'];
  /** 訂單成立後無法離開 */
  lockTableAfterOrder: Scalars['Boolean']['output'];
  /** 手動折扣 */
  manualDiscountEnabled: Scalars['Boolean']['output'];
  /** 手動排除優惠折扣衝突 */
  manualResolveDiscountConflict: Scalars['Boolean']['output'];
  /** 線上訂單設定套用範圍 */
  onlineOrderSettingsScope: OnlineOrderSettingsScope;
  /** 依訂單來源設定 */
  onlineOrderSourceSettings: Array<ShopPosOnlineOrderSourceSetting>;
  /** 點餐模式 */
  orderCodeMode: OrderCodeMode;
  /** 叫餐備註功能啟用 */
  orderRemarkEnabled: Scalars['Boolean']['output'];
  /** 預約單於取餐時間前幾分鐘自動出單 */
  preorderAutoIssueBeforeMinutes: Scalars['Int16']['output'];
  /** 指定預約單自動出單時機 */
  preorderAutoIssueTimingEnabled: Scalars['Boolean']['output'];
  /** 短溢時無法關帳或小結 */
  preventCloseOnShortage: Scalars['Boolean']['output'];
  /** 有顧客未結帳時無法關帳 */
  preventCloseOnUnpaidOrders: Scalars['Boolean']['output'];
  /** 結束交易強制列印刪除單 */
  printDeleteSlip: Scalars['Boolean']['output'];
  /** 線上訂單已付款，出單時列印交易明細 */
  printPaidOnlineOrder: Scalars['Boolean']['output'];
  /** 列印退餐理由 */
  printReturnReason: Scalars['Boolean']['output'];
  /** 打卡限制需有完整上下班 */
  punchCardRequireCompleteShift: Scalars['Boolean']['output'];
  /** 快速結帳 */
  quickCheckout: Scalars['Boolean']['output'];
  /** 紀錄招待理由 */
  recordComplimentary: Scalars['Boolean']['output'];
  /** 作廢交易或發票需進行檢核驗證 */
  requireVerificationOnVoid: Scalars['Boolean']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  /** POS 按鈕顯示商品價格 */
  showItemPriceOnButton: Scalars['Boolean']['output'];
  /** 交易明細顯示金額加總 */
  showTransactionAmountSummary: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 門市支付方式 */
export type ShopPaymentMethod = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  brandPaymentMethod: BrandPaymentMethod;
  brandPaymentMethodID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  deletedAt?: Maybe<Scalars['SoftDeleteZ']['output']>;
  /** 顯示順序 */
  displayOrder: Scalars['Int16']['output'];
  /** 擴充設定 */
  extendSetting?: Maybe<Scalars['JSON']['output']>;
  /** 串接參數 */
  paramSetting?: Maybe<Scalars['JSON']['output']>;
  /** 是否選擇 */
  selected: Scalars['Boolean']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type ShopPaymentMethodKey = {
  brandID: Scalars['Int32']['input'];
  brandPaymentMethodID: Scalars['Int32']['input'];
  shopID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

export type ShopPaymentMethodsResponse = {
  shopPaymentMethod: Array<ShopPaymentMethod>;
  shopPaymentSetting: ShopPaymentSetting;
};

/** 門市支付設定 */
export type ShopPaymentSetting = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  defaultPaymentMethod?: Maybe<ShopPaymentMethod>;
  /** 結帳預設支付方式類型 */
  defaultPaymentMethodID?: Maybe<Scalars['Int32']['output']>;
  /** 需輸入金額才能結帳(當結帳預設支付方式為現金或自訂支付時，才參考此值) */
  needInputAmount: Scalars['Boolean']['output'];
  quickDefaultPaymentMethod?: Maybe<ShopPaymentMethod>;
  /** 快速結帳預設支付方式類型 */
  quickDefaultPaymentMethodID?: Maybe<Scalars['Int32']['output']>;
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 門市權限驗證設定: 記錄門市POS需要卡控功能, check 時加入Record, 移除時刪除Record */
export type ShopPermissionVerification = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  linkPermissionDetailsPermission: LinkPermissionDetailsPermission;
  permissionDetailID: Scalars['UUID']['output'];
  permissionID: Scalars['UUID']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspaceID: Scalars['UUID']['output'];
};

export type ShopPermissionVerificationGroup = {
  permission: Permission;
  permissionDetails: Array<PermissionDetail>;
  permissionID: Scalars['UUID']['output'];
};

export type ShopPermissionVerificationInput = {
  permissionDetailID: Scalars['UUID']['input'];
  permissionID: Scalars['UUID']['input'];
};

/** 門市權限 */
export type ShopPinPolicy = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  policies: Scalars['JSON']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 門市發佈任務 */
export type ShopPublishTask = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 目前是否為已經生效，作用中的狀態 */
  isActive: Scalars['Boolean']['output'];
  publishTask: PublishTask;
  publishTaskID: Scalars['Int32']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  /** 門市更新狀態 */
  updateStatus: ShopUpdateStatus;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type ShopPublishTaskKey = {
  brandID: Scalars['Int32']['output'];
  publishTaskID: Scalars['Int32']['output'];
  shopID: Scalars['Int32']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 門市設定原因 */
export type ShopReasonSetting = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 顯示順序 */
  displayOrder: Scalars['Int16']['output'];
  reasonTemplate: ReasonTemplate;
  reasonTemplateID: Scalars['Int32']['output'];
  /** 是否選擇 */
  selected: Scalars['Boolean']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type ShopReasonSettingInput = {
  displayOrder: Scalars['Int16']['input'];
  reasonTemplateID: Scalars['Int32']['input'];
  selected: Scalars['Boolean']['input'];
};

/** 門市掃碼點餐廣告輪播圖 */
export type ShopScanOrderBanner = {
  alg: ImageHashAlg;
  bannerID: Scalars['Int32']['output'];
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  fileSize: Scalars['Int32']['output'];
  hash: Scalars['String']['output'];
  height: Scalars['Int16']['output'];
  mime: ImageMimeType;
  shopID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  width: Scalars['Int16']['output'];
  workspaceID: Scalars['UUID']['output'];
};

export enum ShopSortField {
  /** 依照品牌分類排序 */
  BrandCategory = 'BrandCategory',
  /** 依照門市名稱排序 */
  Name = 'Name',
  /** 依照門市編號排序 */
  ShopCode = 'ShopCode',
  /** 依照門市建立時間排序 */
  ShopCreatedAt = 'ShopCreatedAt',
  ShopGroupName = 'ShopGroupName',
  /** 依照門市更新時間排序 */
  ShopUpdatedAt = 'ShopUpdatedAt',
}

/** 桌位 */
export type ShopTable = {
  brandID: Scalars['Int32']['output'];
  /** 容納人數 */
  capacity: Scalars['Int16']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 顯示順序 */
  displayOrder: Scalars['Int16']['output'];
  /** 高度 */
  height: Scalars['Decimal']['output'];
  /** 桌位名稱 */
  name: Scalars['String']['output'];
  /** 位置 */
  position: ShopTablePosition;
  /** 旋轉角度 */
  rotation: Scalars['Decimal']['output'];
  /** 形狀 */
  shape: ShopTableShape;
  shopAreaID: Scalars['Int32']['output'];
  shopID: Scalars['Int32']['output'];
  shopTableID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  /** 寬度 */
  width: Scalars['Decimal']['output'];
  workspaceID: Scalars['UUID']['output'];
  /** 座標 X */
  x: Scalars['Decimal']['output'];
  /** 座標 Y */
  y: Scalars['Decimal']['output'];
  /** Z 軸順序 */
  zOrder: Scalars['Int16']['output'];
};

/** 桌位裝飾類型 */
export enum ShopTableDecorationType {
  /** 自訂區塊 */
  CustomBlock = 'CustomBlock',
  /** 文字 */
  Text = 'Text',
}

export type ShopTableInput = {
  /** 容納人數 */
  capacity: Scalars['Int16']['input'];
  /** 顯示順序 */
  displayOrder: Scalars['Int16']['input'];
  /** 高度 */
  height: Scalars['Decimal']['input'];
  /** 桌位名稱 */
  name: Scalars['String']['input'];
  /** 位置 */
  position: ShopTablePosition;
  /** 旋轉角度 */
  rotation: Scalars['Decimal']['input'];
  /** 形狀 */
  shape: ShopTableShape;
  shopTableID?: InputMaybe<Scalars['Int32']['input']>;
  /** 寬度 */
  width: Scalars['Decimal']['input'];
  /** 座標 X */
  x: Scalars['Decimal']['input'];
  /** 座標 Y */
  y: Scalars['Decimal']['input'];
  /** Z軸順序 */
  zOrder: Scalars['Int16']['input'];
};

/** 桌位位置 */
export enum ShopTablePosition {
  /** 畫布 */
  Canvas = 'Canvas',
  /** 側邊欄 */
  Sidebar = 'Sidebar',
}

/** 桌位形狀 */
export enum ShopTableShape {
  /** 長方形 */
  Rectangle = 'Rectangle',
  /** 圓形 */
  Round = 'Round',
  /** 正方形 */
  Square = 'Square',
}

export type ShopTag = {
  disabled: Scalars['Boolean']['input'];
  displayOrder: Scalars['Int16']['input'];
  tagID: Scalars['Int16']['input'];
};

/** 門市更新狀態 */
export enum ShopUpdateStatus {
  /** 未更新 */
  NotUpdated = 'NotUpdated',
  /** 已更新 */
  Updated = 'Updated',
}

export type ShopWithGroups = {
  address?: Maybe<Scalars['String']['output']>;
  brandID: Scalars['Int32']['output'];
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTimeZ']['output']>;
  displayOrder: Scalars['Int16']['output'];
  e164CountryCode?: Maybe<Scalars['String']['output']>;
  landLine?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  shopGroups?: Maybe<Array<ShopGroupName>>;
  shopID: Scalars['Int32']['output'];
  subBrandID?: Maybe<Scalars['Int32']['output']>;
  subBrandName?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTimeZ']['output']>;
  workspaceID: Scalars['UUID']['output'];
};

export type ShopWithGroupsPagination = {
  pageInfo: CursorPageInfo;
  shops: Array<ShopWithGroups>;
};

/** 單台出單機複製模式 */
export enum SingleCopyMode {
  /** 於目標門市新增出單機（需提供 destShopKey + printerInput） */
  NewPrinter = 'NewPrinter',
  /** 複製到現有出單機（不覆蓋既有樣式） */
  ToExistingNoOverride = 'ToExistingNoOverride',
  /** 複製到現有出單機並覆蓋所有樣式 */
  ToExistingOverride = 'ToExistingOverride',
}

export enum SortDevice {
  LatestPDeviceEvent = 'LatestPDeviceEvent',
  PDeviceName = 'PDeviceName',
  VDeviceName = 'VDeviceName',
}

export type SortInput = {
  /** 排序欄位名稱 */
  fieldName: Scalars['String']['input'];
  /** 排序方向 */
  order: SortOrder;
};

/** 商品排序方式 */
export enum SortItemMethod {
  /** 依同品項排序 */
  ByItem = 'ByItem',
  /** 依商品分類排序 */
  ByItemCate = 'ByItemCate',
  /** 依點餐順序 */
  ByOrdering = 'ByOrdering',
}

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC',
}

export enum SortPosDevice {
  LatestPDeviceEvent = 'LatestPDeviceEvent',
  VDeviceBoundAt = 'VDeviceBoundAt',
  VDeviceName = 'VDeviceName',
}

export type SpecifyShopInput = {
  ShopIDs?: InputMaybe<Array<Scalars['Int32']['input']>>;
  SubBrandIDs?: InputMaybe<Array<Scalars['Int32']['input']>>;
};

export type SpectaQlOption = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

/** 金額拆帳：交易明細開立方式 */
export enum SplitDetailIssuedMethod {
  /** 子單各別開一張 */
  PerChild = 'PerChild',
  /** 整筆訂單開一張 */
  Whole = 'Whole',
}

/** 金額拆帳：發票開立方式 */
export enum SplitInvoiceIssuedMethod {
  /** 子單各別開一張 */
  PerChild = 'PerChild',
  /** 整筆訂單開一張 */
  Whole = 'Whole',
}

/** 一般小數進位規則 */
export enum StandardRoundingRule {
  /** 無條件捨去 */
  RoundDown = 'RoundDown',
  /** 四捨五入 */
  RoundHalfUp = 'RoundHalfUp',
  /** 無條件進位 */
  RoundUp = 'RoundUp',
}

/** 貼紙樣式 */
export enum StickerLayoutMode {
  /** 精簡資訊 */
  Compact = 'Compact',
  /** 完整資訊 */
  Complete = 'Complete',
  /** 整張訂單 */
  Order = 'Order',
}

export enum StopSaleAction {
  Resume = 'Resume',
  Stop = 'Stop',
}

/** 門市停售商品設定 */
export type StopSaleItem = {
  /** 營業日結後自動移除 */
  autoRemoveAfterEod: Scalars['Boolean']['output'];
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 包含在套餐內的該單品也一併停售 */
  includeItemInBundles: Scalars['Boolean']['output'];
  item: Item;
  itemID: Scalars['Int32']['output'];
  itemPriceOption: ItemPriceOption;
  itemPriceOptionID: Scalars['Int32']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type StopSaleItemInput = {
  /** 營業日結後自動移除 */
  autoRemoveAfterEod: Scalars['Boolean']['input'];
  /** 包含在套餐內的該單品也一併停售 */
  includeItemInBundles: Scalars['Boolean']['input'];
  itemID: Scalars['Int32']['input'];
  itemPriceOptionID: Scalars['Int32']['input'];
};

/** 門市停售標籤設定 */
export type StopSaleLabel = {
  /** 營業日結後自動移除 */
  autoRemoveAfterEod: Scalars['Boolean']['output'];
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  label: Label;
  labelID: Scalars['Int32']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type StopSaleLabelInput = {
  /** 營業日結後自動移除 */
  autoRemoveAfterEod: Scalars['Boolean']['input'];
  labelID: Scalars['Int32']['input'];
};

export type StopSaleList = {
  stopSaleItems: Array<Maybe<StopSaleItem>>;
  stopSaleLabels: Array<Maybe<StopSaleLabel>>;
};

/** 品牌分類 */
export type SubBrand = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 顯示順序 */
  displayOrder: Scalars['Int16']['output'];
  linkItemSubBrands: Array<LinkItemSubBrand>;
  linkSubBrandLabelGroups: Array<LinkSubBrandLabelGroup>;
  /** 品牌分類名稱 */
  name: Scalars['String']['output'];
  shops: Array<Shop>;
  subBrandID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type SubBrandKey = {
  brandID: Scalars['Int32']['input'];
  subBrandID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

export type SubBrandListPayload = {
  subBrands: Array<SubBrand>;
  uncategorizedShops: Array<Shop>;
};

export type SubBrandShop = {
  shopIDs: Array<Scalars['Int32']['input']>;
  subBrandIDs: Array<Scalars['Int32']['input']>;
};

export type SubscriberSetting = {
  /** 串接參數值；App.multipleBindSettingsEnabled 為 false 時為單一 object（既有行為不變），為 true 時為帶 id 的 object 陣列，可設定多組 */
  bindSettings: Scalars['JSON']['output'];
  brand?: Maybe<Brand>;
  brandID?: Maybe<Scalars['Int32']['output']>;
  createdAt: Scalars['DateTimeZ']['output'];
  planSubscription: PlanSubscription;
  planSubscriptionID: Scalars['UUID']['output'];
  posSettings: Scalars['JSON']['output'];
  shop?: Maybe<Shop>;
  shopID?: Maybe<Scalars['Int32']['output']>;
  subscriberSettingID: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type SubscriptionBill = {
  amount: Scalars['Decimal']['output'];
  billCode: Scalars['String']['output'];
  billPeriodDate: Scalars['Date']['output'];
  billUrl?: Maybe<Scalars['String']['output']>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeZ']['output'];
  status: SubscriptionBillStatus;
  subscription: RecurringSubscription;
  subscriptionBillID: Scalars['UUID']['output'];
  subscriptionID: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
};

export enum SubscriptionBillStatus {
  /** 已取消 */
  Cancelled = 'Cancelled',
  /** 已付款 */
  Paid = 'Paid',
  /** 未付款 */
  Unpaid = 'Unpaid',
}

export enum SubscriptionEndCond {
  /** 永久 */
  Forever = 'Forever',
  /** 固定週期 */
  SpecifyCycle = 'SpecifyCycle',
}

export type SubscriptionInstruction = {
  brand?: Maybe<Brand>;
  createdAt: Scalars['DateTimeZ']['output'];
  instructionContent?: Maybe<Scalars['String']['output']>;
  shop?: Maybe<Shop>;
  subscription: RecurringSubscription;
  subscriptionID: Scalars['UUID']['output'];
  subscriptionInstructionID: Scalars['UUID']['output'];
  targetBrandID?: Maybe<Scalars['Int32']['output']>;
  targetShopID?: Maybe<Scalars['Int32']['output']>;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspaceID: Scalars['UUID']['output'];
};

export type SubscriptionShop = {
  brand?: Maybe<Brand>;
  createdAt: Scalars['DateTimeZ']['output'];
  shop?: Maybe<Shop>;
  subscription: RecurringSubscription;
  subscriptionID: Scalars['UUID']['output'];
  subscriptionShopID: Scalars['UUID']['output'];
  targetBrandID?: Maybe<Scalars['Int32']['output']>;
  targetShopID?: Maybe<Scalars['Int32']['output']>;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspaceID: Scalars['UUID']['output'];
};

export enum SubscriptionStatus {
  /** 上線中 */
  Active = 'Active',
  /** 已取消 */
  Cancelled = 'Cancelled',
  /** 已刪除 */
  Deleted = 'Deleted',
  /** 已到期 */
  Expired = 'Expired',
  /** 即將開始 */
  Future = 'Future',
  /** 待開通 */
  Wait = 'Wait',
}

export type SubscriptionTypeSetting = {
  createdAt: Scalars['DateTimeZ']['output'];
  deletedAt?: Maybe<Scalars['SoftDeleteZ']['output']>;
  name: Scalars['String']['output'];
  subscriptionTypeID: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
};

export type SunPaySetting = {
  credit: Scalars['String']['output'];
  payPassWord: Scalars['String']['output'];
  wallet?: Maybe<Scalars['String']['output']>;
};

export type SunPaySettingInput = {
  credit: Scalars['String']['input'];
  payPassWord: Scalars['String']['input'];
  wallet?: InputMaybe<Scalars['String']['input']>;
};

/** 同步狀態 */
export enum SyncDataStatus {
  /** 同步失敗 */
  Failed = 'Failed',
  /** 同步成功 */
  Succeed = 'Succeed',
}

export enum SyncDataUrlAction {
  Get = 'GET',
  Post = 'POST',
}

export type SyncDataUrlSource = {
  action: SyncDataUrlAction;
  /** 同步 API 識別碼（在 MQTT 事件接收時用以識別哪一次的API來源並供 POS 辨識） */
  apiID: Scalars['String']['input'];
  hasData: Scalars['Boolean']['input'];
  id: Scalars['String']['input'];
  path: Scalars['String']['input'];
  status: SyncDataStatus;
  synced: Scalars['Boolean']['input'];
  type: SyncDataUrlType;
  url: Scalars['String']['input'];
};

export enum SyncDataUrlType {
  Gcs = 'GCS',
  GraphQl = 'GraphQL',
}

export type SyncShopMenuInput = {
  appID: Scalars['UUID']['input'];
  keys: Array<ShopKey>;
  menus: Array<SyncShopMenuItemInput>;
};

export type SyncShopMenuItemInput = {
  menuID: Scalars['Int32']['input'];
  serviceAvailability?: InputMaybe<Array<ShopMenuServiceAvailabilityInput>>;
  syncDate: Scalars['Boolean']['input'];
};

/** 系統-國家設定 */
export type SysCountrySetting = {
  country: Country;
  countryID: Scalars['String']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  currency: Currency;
  currencyID: Scalars['String']['output'];
  language: Language;
  languageID: Scalars['String']['output'];
  timezone: Timezone;
  timezoneID: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
};

export enum SysGeneralSettingKey {
  /** 門市權限 */
  ShopPinPolicy = 'ShopPinPolicy',
}

export type SysGeneralSettingTemplate = {
  createdAt: Scalars['DateTimeZ']['output'];
  /** 設定描述 */
  description: Scalars['String']['output'];
  /** 設定鍵 */
  key: SysGeneralSettingKey;
  /** 設定值範本 */
  schema: Scalars['JSON']['output'];
  templateID: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
};

/** 系統發票原因 */
export type SysInvoiceReason = {
  /** 原因內容 */
  code: Scalars['String']['output'];
  country: Country;
  countryID: Scalars['String']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  invoiceReasonID: Scalars['Int16']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
};

/** 系統發票稅別 */
export type SysInvoiceTaxType = {
  country: Country;
  countryID: Scalars['String']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  invoiceTaxTypeID: Scalars['Int16']['output'];
  /** 名稱 */
  name: Scalars['String']['output'];
  /** 官方代碼 */
  officialCode: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
};

/** 系統發票稅別理由對應稅率 */
export type SysInvoiceTaxTypeReasonRate = {
  createdAt: Scalars['DateTimeZ']['output'];
  invoiceReason?: Maybe<SysInvoiceReason>;
  invoiceReasonID?: Maybe<Scalars['Int16']['output']>;
  invoiceTaxType: SysInvoiceTaxType;
  invoiceTaxTypeID: Scalars['Int16']['output'];
  taxRate: Scalars['String']['output'];
  taxTypeReasonRateID: Scalars['Int16']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
};

/** 系統支付方式 */
export type SysPaymentMethod = {
  /** 是否啟用 */
  activate: Scalars['Boolean']['output'];
  country: SysCountrySetting;
  /** 國家 */
  countryID: Scalars['String']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  deletedAt?: Maybe<Scalars['SoftDeleteZ']['output']>;
  /** 支付方式說明 */
  description: Scalars['String']['output'];
  /** 擴充設定規格 */
  extendSettingSchema?: Maybe<Scalars['JSON']['output']>;
  /** 一般設定規格 */
  generalSettingSchema: Scalars['JSON']['output'];
  /** 支付方式名稱 */
  name: Scalars['String']['output'];
  /** 串接參數規格 */
  paramSettingSchema?: Maybe<Scalars['JSON']['output']>;
  /** 支付方式分類 */
  paymentMethodCategory: PaymentMethodCategory;
  sysPaymentMethodID: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
};

export type SysPaymentMethodKey = {
  sysPaymentMethodID: Scalars['String']['input'];
};

/** 系統稅金群組 */
export type SysTaxGroup = {
  /** 計算方式 */
  calculationMethod: TaxGroupCalculationMethod;
  country: Country;
  countryID: Scalars['String']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 稅金群組名稱 */
  name: Scalars['String']['output'];
  sysTaxGroupID: Scalars['Int16']['output'];
  sysTaxUnits: Array<SysTaxUnit>;
  updatedAt: Scalars['DateTimeZ']['output'];
};

/** 系統稅金 */
export type SysTaxUnit = {
  country: Country;
  countryID: Scalars['String']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 顯示後綴 */
  displaySuffix: Scalars['String']['output'];
  /** 稅金名稱 */
  name: Scalars['String']['output'];
  /** 稅率 % */
  rate: Scalars['Decimal']['output'];
  /** 進位方式 */
  roundingRule: StandardRoundingRule;
  sysTaxID: Scalars['Int16']['output'];
  /** 稅金計算方式 */
  taxMethod: TaxMethod;
  updatedAt: Scalars['DateTimeZ']['output'];
};

/** 子系統 */
export type System = {
  code: Scalars['String']['output'];
  countryID: Scalars['String']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  region: InfraRegion;
  systemID: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
};

/** 系統類型 */
export enum SystemType {
  Admin = 'Admin',
  Console = 'Console',
  /**
   * 總部管理系統
   * @deprecated Use Console instead
   */
  Dd3Console = 'DD3_Console',
  /**
   * 店家管理系統
   * @deprecated Use Admin instead
   */
  Dd3Server = 'DD3_Server',
  /** OpenAPI */
  OpenApi = 'OpenAPI',
  /** POS */
  Pos = 'POS',
}

export type Tag = {
  brandMemberTagID: Scalars['Int32']['input'];
  content: Scalars['String']['input'];
  disabled: Scalars['Boolean']['input'];
};

/** 稅金類別 */
export enum TaxCategory {
  /** 免稅 */
  Exempt = 'Exempt',
  /** 未設定 */
  None = 'None',
  /** 應稅 */
  Taxable = 'Taxable',
}

/** 稅金群組 */
export type TaxGroup = {
  /** 計算方式 */
  calculationMethod: TaxGroupCalculationMethod;
  createdAt: Scalars['DateTimeZ']['output'];
  /** 啟用依用餐方式預設稅金 */
  enableDiningOptionDefaultTax: Scalars['Boolean']['output'];
  /** 稅金群組名稱 */
  name: Scalars['String']['output'];
  taxGroupID: Scalars['Int16']['output'];
  taxGroupUnits: Array<TaxGroupUnit>;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceDiningOptionDefaultTaxes: Array<WorkspaceDiningOptionDefaultTax>;
  workspaceID: Scalars['UUID']['output'];
};

/** 稅金群組計算方式 */
export enum TaxGroupCalculationMethod {
  /** 擇一 */
  ChooseOne = 'ChooseOne',
  /** 累加 */
  Cumulative = 'Cumulative',
}

export type TaxGroupInput = {
  calculationMethod: TaxGroupCalculationMethod;
  /** 啟用依用餐方式預設稅金 */
  enableDiningOptionDefaultTax: Scalars['Boolean']['input'];
  /** 群組名稱 */
  name: Scalars['String']['input'];
  taxUnitIDs: Array<Scalars['Int16']['input']>;
};

export type TaxGroupKey = {
  taxGroupID: Scalars['Int16']['input'];
  workspaceID: Scalars['UUID']['input'];
};

/** 稅金群組關聯 */
export type TaxGroupUnit = {
  createdAt: Scalars['DateTimeZ']['output'];
  taxGroup: TaxGroup;
  taxGroupID: Scalars['Int16']['output'];
  taxID: Scalars['Int16']['output'];
  taxUnit: TaxUnit;
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type TaxGroupUnitKey = {
  taxGroupID: Scalars['Int16']['input'];
  taxID: Scalars['Int16']['input'];
  workspaceID: Scalars['UUID']['input'];
};

/** 稅金計算方式 */
export enum TaxMethod {
  /** 外加 */
  Exclusive = 'Exclusive',
  /** 含稅 */
  Inclusive = 'Inclusive',
}

/** 稅金 */
export type TaxUnit = {
  createdAt: Scalars['DateTimeZ']['output'];
  /** 顯示後綴 */
  displaySuffix: Scalars['String']['output'];
  /** 稅金名稱 */
  name: Scalars['String']['output'];
  /** 稅率 % */
  rate: Scalars['Decimal']['output'];
  /** 進位方式 */
  roundingRule: StandardRoundingRule;
  taxID: Scalars['Int16']['output'];
  /** 稅金計算方式 */
  taxMethod: TaxMethod;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type TaxUnitInput = {
  /** 顯示後綴 */
  displaySuffix: Scalars['String']['input'];
  /** 稅金名稱 */
  name: Scalars['String']['input'];
  /** 稅率 % */
  rate: Scalars['Decimal']['input'];
  /** 進位方式 */
  roundingRule: StandardRoundingRule;
  /** 稅金計算方式 */
  taxMethod: TaxMethod;
};

export type TaxUnitKey = {
  taxID: Scalars['Int16']['input'];
  workspaceID: Scalars['UUID']['input'];
};

export type Taxation = {
  code: Scalars['String']['output'];
  invoiceReasons?: Maybe<Array<Maybe<InvoiceReason>>>;
  invoiceTaxTypeID: Scalars['Int16']['output'];
  name: Scalars['String']['output'];
  taxRate?: Maybe<Scalars['String']['output']>;
};

export type Ticket =
  | TicketCheckout
  | TicketEodClose
  | TicketInvoice
  | TicketKitchen
  | TicketOrder
  | TicketQueue
  | TicketScanOrder
  | TicketShiftClose
  | TicketSticker;

/** 出單樣式：結帳單 */
export type TicketCheckout = {
  /** 'Amt' | 'AmtChk' | 'QR' */
  barcodeType?: Maybe<BarcodeType>;
  /** 內容（需 <= barcodeValueMaxChars */
  barcodeValue?: Maybe<Scalars['String']['output']>;
  /** 允許的最大字數 (DEFAULT 20) */
  barcodeValueMaxChars: Scalars['Int16']['output'];
  beeperEnabled: Scalars['Boolean']['output'];
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  clipperBlank: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  fontSize: FontSize;
  /** 套餐基本價為0元時, 不顯示套餐名稱 */
  hideNameWhenPriceZero: Scalars['Boolean']['output'];
  /** 單價為 0 不列印 */
  notPrintItemOfPriceZero: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  positionItemQty: PositionItemQty;
  /** 條碼/顯示 */
  printAmountBarcode: Scalars['Boolean']['output'];
  printCustomizedPapers?: Maybe<Array<TicketCheckoutTicketCustomizedPaper>>;
  printEnabled: Scalars['Boolean']['output'];
  printItemCategories?: Maybe<Array<LinkTicketCheckoutItemCategory>>;
  printItemPriceOptions?: Maybe<Array<LinkTicketCheckoutItemPriceOption>>;
  printItemStats: Scalars['Boolean']['output'];
  printLoyaltyDetail: Scalars['Boolean']['output'];
  printMethodItem: PrintMethodItem;
  printMethodLabel: PrintMethodLabel;
  printServicewareStats: Scalars['Boolean']['output'];
  /** 例：{"Checkout":true,"MANUAL":true,"UNPAID_ONLINE_ORDER":true} */
  printTrigger: Scalars['JSON']['output'];
  printTxnBarcode: Scalars['Boolean']['output'];
  /** 例：[{"brandDiningOption_id": 1, "name": "內用", "areas": ["1F", "3F"]}, {"brandDiningOption_id": 2, "name": "FoodPanda"}] */
  printingDiningOptionArea: Scalars['JSON']['output'];
  printingMethodCombo: PrintingMethodCombo;
  /** 列印張數 (DEFAULT 1) */
  printingNumber: Scalars['Int16']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  sortItemMethod: SortItemMethod;
  targetItems: PrintingTargetItemScope;
  ticketID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type TicketCheckoutInput = {
  barcodeType?: InputMaybe<BarcodeType>;
  barcodeValue?: InputMaybe<Scalars['String']['input']>;
  barcodeValueMaxChars: Scalars['Int16']['input'];
  beeperEnabled: Scalars['Boolean']['input'];
  clipperBlank: Scalars['Boolean']['input'];
  fontSize: FontSize;
  hideNameWhenPriceZero: Scalars['Boolean']['input'];
  itemCategoryIDs?: InputMaybe<Array<InputMaybe<Scalars['Int32']['input']>>>;
  notPrintItemOfPriceZero: Scalars['Boolean']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  positionItemQty: PositionItemQty;
  printAmountBarcode: Scalars['Boolean']['input'];
  printCustomizedPapers?: InputMaybe<
    Array<InputMaybe<PrintCustomizedPaperInput>>
  >;
  printEnabled: Scalars['Boolean']['input'];
  printItemInputs?: InputMaybe<Array<InputMaybe<PrintItemInput>>>;
  printItemStats: Scalars['Boolean']['input'];
  printLoyaltyDetail: Scalars['Boolean']['input'];
  printMethodItem: PrintMethodItem;
  printMethodLabel: PrintMethodLabel;
  printServicewareStats: Scalars['Boolean']['input'];
  printTrigger: Scalars['JSON']['input'];
  printTxnBarcode: Scalars['Boolean']['input'];
  printingDiningOptionArea: Scalars['JSON']['input'];
  printingMethodCombo: PrintingMethodCombo;
  printingNumber: Scalars['Int16']['input'];
  sortItemMethod: SortItemMethod;
  targetItems: PrintingTargetItemScope;
};

/** 結帳單 x 客製紙張 對應 */
export type TicketCheckoutTicketCustomizedPaper = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  displayOrder: Scalars['Int16']['output'];
  needCut: Scalars['Boolean']['output'];
  shopID: Scalars['Int32']['output'];
  ticketCheckoutID: Scalars['Int32']['output'];
  ticketCustomizedPaper: TicketCustomizedPaper;
  ticketCustomizedPaperID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspaceID: Scalars['UUID']['output'];
};

export type TicketCustomized =
  | TicketCustomizedPaper
  | TicketStickerCustomizedNote;

export type TicketCustomizedNoteInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  maxChars: Scalars['Int16']['input'];
};

/** 出單樣式：自訂出單 */
export type TicketCustomizedPaper = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeZ']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** 自訂出單 QRCode (DEFAULT 'NotPrint') */
  qrcode: CustomizedPaperQrCode;
  qrcodeContent?: Maybe<Scalars['String']['output']>;
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  ticketCustomizedPaperImages?: Maybe<Array<Maybe<TicketCustomizedPaperImage>>>;
  ticketID: Scalars['Int32']['output'];
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 自訂出單樣式圖片 */
export type TicketCustomizedPaperImage = {
  alg?: Maybe<Scalars['String']['output']>;
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 顯示順序 */
  displayOrder: Scalars['Int16']['output'];
  /** 檔案大小可為 NULL，若有值需 >= 0 */
  fileSize?: Maybe<Scalars['Int32']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int16']['output']>;
  imageID: Scalars['Int32']['output'];
  mime?: Maybe<Scalars['String']['output']>;
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  ticketID: Scalars['Int32']['output'];
  type: ImageType;
  updatedAt: Scalars['DateTimeZ']['output'];
  /** width/height 可為 NULL，若有值需 > 0 */
  width?: Maybe<Scalars['Int16']['output']>;
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type TicketCustomizedPaperInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  deleteIDs?: InputMaybe<Array<Scalars['Int32']['input']>>;
  files?: InputMaybe<Array<Scalars['Upload']['input']>>;
  name: Scalars['String']['input'];
  qrcode: CustomizedPaperQrCode;
  qrcodeContent?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum TicketCustomizedType {
  Paper = 'Paper',
  StickerNote = 'StickerNote',
}

export type TicketDisplayOrderInput = {
  /** 更新鍵盤順序 */
  updateOrder?: InputMaybe<Array<TicketSortOrderInput>>;
  vPrinterKey: VPrinterKey;
};

/** 出單樣式：關帳 */
export type TicketEodClose = {
  beeperEnabled: Scalars['Boolean']['output'];
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  exclItems?: Maybe<Array<TicketEodCloseExcludeItem>>;
  printEnabled: Scalars['Boolean']['output'];
  printEodStats: Scalars['Boolean']['output'];
  printSaleRecords: Scalars['Boolean']['output'];
  printSaleRecordsWithoutDetails: Scalars['Boolean']['output'];
  /** 列印張數 (DEFAULT 1) */
  printingNumber: Scalars['Int16']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  ticketID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 出單：日結關帳 x 排除品項 */
export type TicketEodCloseExcludeItem = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  item: Item;
  itemID: Scalars['Int32']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  ticketID: Scalars['Int32']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type TicketEodCloseInput = {
  beeperEnabled: Scalars['Boolean']['input'];
  exclItemIDs?: InputMaybe<Array<InputMaybe<Scalars['Int32']['input']>>>;
  printEnabled: Scalars['Boolean']['input'];
  printEodStats: Scalars['Boolean']['input'];
  printSaleRecords: Scalars['Boolean']['input'];
  printSaleRecordsWithoutDetails: Scalars['Boolean']['input'];
  printingNumber: Scalars['Int16']['input'];
};

export type TicketInput = {
  /** 貼紙模板 */
  layoutMode?: InputMaybe<StickerLayoutMode>;
  /** 出單機類型 */
  ticketOf: TicketOf;
};

/** 出單樣式：發票 */
export type TicketInvoice = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 是否於交易明細處切紙 */
  cutMethodTxnDetail: Scalars['Boolean']['output'];
  /** 套餐基本價為0元時, 不顯示套餐名稱 */
  hideNameWhenPriceZero: Scalars['Boolean']['output'];
  positionItemQty: PositionItemQty;
  printCustomizedPapers?: Maybe<Array<TicketInvoiceTicketCustomizedPaper>>;
  printMethodLabel: PrintMethodLabel;
  printTxnDetails: PrintTxnDetails;
  printingMethodCombo: PrintingMethodCombo;
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  sortItemMethod: SortItemMethod;
  ticketID: Scalars['Int32']['output'];
  txnDetailFontSize: FontSize;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type TicketInvoiceInput = {
  cutMethodTxnDetail: Scalars['Boolean']['input'];
  hideNameWhenPriceZero: Scalars['Boolean']['input'];
  positionItemQty: PositionItemQty;
  printCustomizedPapers?: InputMaybe<
    Array<InputMaybe<PrintCustomizedPaperInput>>
  >;
  printMethodLabel: PrintMethodLabel;
  printTxnDetails: PrintTxnDetails;
  printingMethodCombo: PrintingMethodCombo;
  sortItemMethod: SortItemMethod;
  txnDetailFontSize: FontSize;
};

/** 發票 x 客製紙張 對應 */
export type TicketInvoiceTicketCustomizedPaper = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  displayOrder: Scalars['Int16']['output'];
  needCut: Scalars['Boolean']['output'];
  shopID: Scalars['Int32']['output'];
  ticketCustomizedPaper: TicketCustomizedPaper;
  ticketCustomizedPaperID: Scalars['Int32']['output'];
  ticketInvoiceID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspaceID: Scalars['UUID']['output'];
};

export type TicketKey = {
  shopKey: ShopKey;
  ticketID: Scalars['Int32']['input'];
  ticketOf: TicketOf;
  vPrinterID: Scalars['Int32']['input'];
};

/** 出單樣式：廚房單 */
export type TicketKitchen = {
  beeperEnabled: Scalars['Boolean']['output'];
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  /** 例：{"CHANGE":true,"COMBINE_SEPARATE":true} */
  changingTableRemind?: Maybe<Scalars['JSON']['output']>;
  clipperBlank: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 切紙方式 */
  cutMethod: CutMethod;
  /** 合單切紙 */
  cutMethodMergeCombo: Scalars['Boolean']['output'];
  fontSize: FontSize;
  note?: Maybe<Scalars['String']['output']>;
  positionItemQty: PositionItemQty;
  printConsumerNumber: Scalars['Boolean']['output'];
  printEnabled: Scalars['Boolean']['output'];
  printItemCategories?: Maybe<Array<LinkTicketKitchenItemCategory>>;
  printItemPriceOptions?: Maybe<Array<LinkTicketKitchenItemPriceOption>>;
  printLabelGroups?: Maybe<Array<LinkTicketKitchenLabelGroup>>;
  printLabels?: Maybe<Array<LinkTicketKitchenLabel>>;
  printMethodItem: PrintMethodItem;
  printMethodLabel: PrintMethodLabel;
  /** 例：{"ORDER":true,"DELETE":true,"CHANGE":true} */
  printTrigger: Scalars['JSON']['output'];
  /** 例：[{"brandDiningOption_id": 1, "name": "內用", "areas": ["1F", "3F"]}, {"brandDiningOption_id": 2, "name": "FoodPanda"}] */
  printingDiningOptionArea: Scalars['JSON']['output'];
  printingMethodCombo: PrintingMethodComboOfKitchenSticker;
  /** 列印張數 (DEFAULT 1) */
  printingNumber: Scalars['Int16']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  sortItemMethod: SortItemMethod;
  /** 列印商品 */
  targetItems: PrintingTargetItemScope;
  /** 列印標籤 */
  targetLabels: PrintingTargetLabelScope;
  ticketID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type TicketKitchenInput = {
  beeperEnabled: Scalars['Boolean']['input'];
  changingTableRemind?: InputMaybe<Scalars['JSON']['input']>;
  clipperBlank: Scalars['Boolean']['input'];
  cutMethod: CutMethod;
  cutMethodMergeCombo: Scalars['Boolean']['input'];
  fontSize: FontSize;
  itemCategoryIDs?: InputMaybe<Array<InputMaybe<Scalars['Int32']['input']>>>;
  labelGroupIDs?: InputMaybe<Array<InputMaybe<Scalars['Int32']['input']>>>;
  labelIDs?: InputMaybe<Array<InputMaybe<Scalars['Int32']['input']>>>;
  note?: InputMaybe<Scalars['String']['input']>;
  positionItemQty: PositionItemQty;
  printConsumerNumber: Scalars['Boolean']['input'];
  printEnabled: Scalars['Boolean']['input'];
  printItemInputs?: InputMaybe<Array<InputMaybe<PrintItemInput>>>;
  printMethodItem: PrintMethodItem;
  printMethodLabel: PrintMethodLabel;
  printTrigger: Scalars['JSON']['input'];
  printingDiningOptionArea: Scalars['JSON']['input'];
  printingMethodCombo: PrintingMethodComboOfKitchenSticker;
  printingNumber: Scalars['Int16']['input'];
  sortItemMethod: SortItemMethod;
  targetItems: PrintingTargetItemScope;
  targetLabels: PrintingTargetLabelScope;
};

/** v_printer 與 ticket 對應 */
export enum TicketOf {
  /** 結帳單 */
  Checkout = 'Checkout',
  /** 關帳單 */
  EodClose = 'EodClose',
  /** 發票 */
  Invoice = 'Invoice',
  /** 廚房單 */
  Kitchen = 'Kitchen',
  /** 點餐單 */
  Order = 'Order',
  /** 號碼牌 */
  Queue = 'Queue',
  /** 掃碼點餐單 */
  ScanOrder = 'ScanOrder',
  /** 小結單 */
  ShiftClose = 'ShiftClose',
  /** 貼紙 */
  Sticker = 'Sticker',
}

/** 出單樣式：點餐單 */
export type TicketOrder = {
  beeperEnabled: Scalars['Boolean']['output'];
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  /** 例：{"CHANGED":true,"COMBINE_SEPARATED":true} */
  changingTableRemind?: Maybe<Scalars['JSON']['output']>;
  clipperBlank: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  fontSize: FontSize;
  /** 套餐基本價為0元時, 不顯示套餐名稱 */
  hideNameWhenPriceZero: Scalars['Boolean']['output'];
  note?: Maybe<Scalars['String']['output']>;
  positionItemQty: PositionItemQty;
  printAdditionalOrderAmount: Scalars['Boolean']['output'];
  printCustomizedPapers?: Maybe<Array<TicketOrderTicketCustomizedPaper>>;
  printEnabled: Scalars['Boolean']['output'];
  printItemCategories?: Maybe<Array<LinkTicketOrderItemCategory>>;
  printItemPriceOptions?: Maybe<Array<LinkTicketOrderItemPriceOption>>;
  printItemStats: Scalars['Boolean']['output'];
  printMethodItem: PrintMethodItem;
  printMethodLabel: PrintMethodLabel;
  printServicewareStats: Scalars['Boolean']['output'];
  /** 例：{"ORDER":true,"DELETE":true,"CHANGE":true} */
  printTrigger: Scalars['JSON']['output'];
  printTxnBarcode: Scalars['Boolean']['output'];
  /** 例：[{"brandDiningOption_id": 1, "name": "內用", "areas": ["1F", "3F"]}, {"brandDiningOption_id": 2, "name": "FoodPanda"}] */
  printingDiningOptionArea: Scalars['JSON']['output'];
  printingMethodCombo: PrintingMethodCombo;
  /** 列印張數 (DEFAULT 1) */
  printingNumber: Scalars['Int16']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  sortItemMethod: SortItemMethod;
  targetItems: PrintingTargetItemScope;
  ticketID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type TicketOrderInput = {
  beeperEnabled: Scalars['Boolean']['input'];
  changingTableRemind?: InputMaybe<Scalars['JSON']['input']>;
  clipperBlank: Scalars['Boolean']['input'];
  fontSize: FontSize;
  hideNameWhenPriceZero: Scalars['Boolean']['input'];
  itemCategoryIDs?: InputMaybe<Array<InputMaybe<Scalars['Int32']['input']>>>;
  note?: InputMaybe<Scalars['String']['input']>;
  positionItemQty: PositionItemQty;
  printAdditionalOrderAmount: Scalars['Boolean']['input'];
  printCustomizedPapers?: InputMaybe<
    Array<InputMaybe<PrintCustomizedPaperInput>>
  >;
  printEnabled: Scalars['Boolean']['input'];
  printItemInputs?: InputMaybe<Array<InputMaybe<PrintItemInput>>>;
  printItemStats: Scalars['Boolean']['input'];
  printMethodItem: PrintMethodItem;
  printMethodLabel: PrintMethodLabel;
  printServicewareStats: Scalars['Boolean']['input'];
  printTrigger: Scalars['JSON']['input'];
  printTxnBarcode: Scalars['Boolean']['input'];
  printingDiningOptionArea: Scalars['JSON']['input'];
  printingMethodCombo: PrintingMethodCombo;
  printingNumber: Scalars['Int16']['input'];
  sortItemMethod: SortItemMethod;
  targetItems: PrintingTargetItemScope;
};

/** 點餐單 x 客製紙張 對應 */
export type TicketOrderTicketCustomizedPaper = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  displayOrder: Scalars['Int16']['output'];
  needCut: Scalars['Boolean']['output'];
  shopID: Scalars['Int32']['output'];
  ticketCustomizedPaper: TicketCustomizedPaper;
  ticketCustomizedPaperID: Scalars['Int32']['output'];
  ticketOrderID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspaceID: Scalars['UUID']['output'];
};

export type TicketPagination = {
  pageInfo: CursorPageInfo;
  printerTickets?: Maybe<Array<VPrinterTicket>>;
};

/** 出單樣式：號碼牌 */
export type TicketQueue = {
  beeperEnabled: Scalars['Boolean']['output'];
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  clipperBlank: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  note?: Maybe<Scalars['String']['output']>;
  printEnabled: Scalars['Boolean']['output'];
  printTrigger: Scalars['JSON']['output'];
  /** 列印張數 (DEFAULT 1) */
  printingNumber: Scalars['Int16']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  ticketID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type TicketQueueInput = {
  beeperEnabled: Scalars['Boolean']['input'];
  clipperBlank: Scalars['Boolean']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  printEnabled: Scalars['Boolean']['input'];
  printingNumber: Scalars['Int16']['input'];
};

/** 出單樣式：掃碼點餐單 */
export type TicketScanOrder = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  note?: Maybe<Scalars['String']['output']>;
  printCustomizedPapers?: Maybe<Array<TicketScanOrderTicketCustomizedPaper>>;
  printEnabled: Scalars['Boolean']['output'];
  /** 列印內容：店名 (DEFAULT true) */
  printShopName: Scalars['Boolean']['output'];
  /** 列印內容：桌號 (DEFAULT true) */
  printTableNo: Scalars['Boolean']['output'];
  /** 例：[{"brandDiningOption_id": 1, "name": "內用", "areas": ["1F", "3F"]}, {"brandDiningOption_id": 2, "name": "FoodPanda"}] */
  printingDiningOptionArea: Scalars['JSON']['output'];
  /** 列印張數 (DEFAULT 1) */
  printingNumber: Scalars['Int16']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  ticketID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type TicketScanOrderInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  printCustomizedPapers?: InputMaybe<
    Array<InputMaybe<PrintCustomizedPaperInput>>
  >;
  printEnabled: Scalars['Boolean']['input'];
  /** 列印內容：店名 (DEFAULT true) */
  printShopName: Scalars['Boolean']['input'];
  /** 列印內容：桌號 (DEFAULT true) */
  printTableNo: Scalars['Boolean']['input'];
  printingDiningOptionArea: Scalars['JSON']['input'];
  /** 列印張數 (DEFAULT 1) */
  printingNumber: Scalars['Int16']['input'];
};

/** 掃碼點餐單 × 客製紙張 對應 */
export type TicketScanOrderTicketCustomizedPaper = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  /** 顯示順序 */
  displayOrder: Scalars['Int16']['output'];
  /** 切紙 */
  needCut: Scalars['Boolean']['output'];
  shopID: Scalars['Int32']['output'];
  ticketCustomizedPaper: TicketCustomizedPaper;
  ticketCustomizedPaperID: Scalars['Int32']['output'];
  ticketScanOrderID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspaceID: Scalars['UUID']['output'];
};

/** 出單樣式：小結 */
export type TicketShiftClose = {
  beeperEnabled: Scalars['Boolean']['output'];
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  printEnabled: Scalars['Boolean']['output'];
  printSaleRecords: Scalars['Boolean']['output'];
  printSaleRecordsWithoutDetails: Scalars['Boolean']['output'];
  /** 列印張數 (DEFAULT 1) */
  printingNumber: Scalars['Int16']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  ticketID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type TicketShiftCloseInput = {
  beeperEnabled: Scalars['Boolean']['input'];
  printEnabled: Scalars['Boolean']['input'];
  printSaleRecords: Scalars['Boolean']['input'];
  printSaleRecordsWithoutDetails: Scalars['Boolean']['input'];
  printingNumber: Scalars['Int16']['input'];
};

export type TicketSortOrderInput = {
  displayOrder: Scalars['Int16']['input'];
  ticketID: Scalars['Int32']['input'];
  ticketOf: TicketOf;
};

/** 出單樣式：貼紙 */
export type TicketSticker = {
  beeperEnabled: Scalars['Boolean']['output'];
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  cutMethod: CutMethod;
  fontSize: FontSize;
  /** 標籤樣式 (DEFAULT 'Complete') */
  layoutMode: StickerLayoutMode;
  note?: Maybe<Scalars['String']['output']>;
  /** 貼紙備註 */
  printCustomizedNotes?: Maybe<Array<LinkTicketStickerCustomizedNote>>;
  printEnabled: Scalars['Boolean']['output'];
  printItemCategories?: Maybe<Array<LinkTicketStickerItemCategory>>;
  printItemPriceOptions?: Maybe<Array<LinkTicketStickerItemPriceOption>>;
  printLabelGroups?: Maybe<Array<LinkTicketStickerLabelGroup>>;
  printLabels?: Maybe<Array<LinkTicketStickerLabel>>;
  printMethodItem: PrintMethodItem;
  /** 單號顯示方式 (DEFAULT 'DiningOption') */
  printTicketNo: PrintTicketNo;
  /** 觸發條件（例：{"ORDER": true, "CHANGE": true}） */
  printTrigger: Scalars['JSON']['output'];
  /** 例：[{"brandDiningOption_id": 1, "name": "內用", "areas": ["1F", "3F"]}, {"brandDiningOption_id": 2, "name": "FoodPanda"}] */
  printingDiningOptionArea: Scalars['JSON']['output'];
  printingMethodCombo?: Maybe<PrintingMethodComboOfKitchenSticker>;
  printingMethodCustomizedNote: PrintingMethodCustomizedNote;
  /** 列印張數(DEFAULT 1) */
  printingNumber: Scalars['Int16']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  sortItemMethod: SortItemMethod;
  /** 列印商品 */
  targetItems: PrintingTargetItemScope;
  /** 列印標籤 */
  targetLabels: PrintingTargetLabelScope;
  ticketID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 貼紙自訂備註 */
export type TicketStickerCustomizedNote = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  /** 內容（需 <= maxChars） */
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeZ']['output'];
  /** 允許的最大字數 (DEFAULT 20) */
  maxChars: Scalars['Int16']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  ticketID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type TicketStickerInput = {
  beeperEnabled: Scalars['Boolean']['input'];
  cutMethod: CutMethod;
  fontSize: FontSize;
  itemCategoryIDs?: InputMaybe<Array<InputMaybe<Scalars['Int32']['input']>>>;
  labelGroupIDs?: InputMaybe<Array<InputMaybe<Scalars['Int32']['input']>>>;
  labelIDs?: InputMaybe<Array<InputMaybe<Scalars['Int32']['input']>>>;
  layoutMode: StickerLayoutMode;
  note?: InputMaybe<Scalars['String']['input']>;
  printEnabled: Scalars['Boolean']['input'];
  printItemInputs?: InputMaybe<Array<InputMaybe<PrintItemInput>>>;
  printMethodItem: PrintMethodItem;
  printNoteIDs?: InputMaybe<Array<InputMaybe<Scalars['Int32']['input']>>>;
  printTicketNo: PrintTicketNo;
  printTrigger: Scalars['JSON']['input'];
  printingDiningOptionArea: Scalars['JSON']['input'];
  printingMethodCombo?: InputMaybe<PrintingMethodComboOfKitchenSticker>;
  printingMethodCustomizedNote: PrintingMethodCustomizedNote;
  printingNumber: Scalars['Int16']['input'];
  sortItemMethod: SortItemMethod;
  targetItems: PrintingTargetItemScope;
  targetLabels: PrintingTargetLabelScope;
};

/** 時間範圍 */
export type TimeRange = {
  endTime: Scalars['DateTimeZ']['input'];
  startTime: Scalars['DateTimeZ']['input'];
};

/** 時區 */
export type Timezone = {
  /** 時區縮寫 */
  abbr: Scalars['String']['output'];
  /** 時區名稱 */
  name: Scalars['String']['output'];
  timezoneID: Scalars['String']['output'];
  /** UTC 偏移量 */
  utcOffset: Scalars['String']['output'];
};

export type TotalOrderRatioDetail = {
  /** 總訂單筆數 */
  count: Scalars['Int32']['output'];
  /** 線下點餐筆數明細 */
  offlineOrder: OrderRatioDetail;
  /** 線上點餐筆數明細 */
  onlineOrder: OrderRatioDetail;
  /** 總筆數百分比 */
  percentage: Scalars['Decimal']['output'];
  /** 掃碼點餐筆數明細 */
  scanOrder: OrderRatioDetail;
};

/** 交易 */
export type Transaction = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  /** 營業日 */
  businessDate: Scalars['Date']['output'];
  businessSession?: Maybe<BusinessSession>;
  /** 取消時間 */
  cancelledAt?: Maybe<Scalars['DateTimeZ']['output']>;
  createdAt: Scalars['DateTimeZ']['output'];
  /** 交易列表顯示用發票，保留換開歷程並排除退款反向紀錄 */
  currentInvoices: Array<Invoice>;
  deletedAt?: Maybe<Scalars['SoftDeleteZ']['output']>;
  /** 外送費金額 */
  deliveryFeeAmount?: Maybe<Scalars['Decimal']['output']>;
  /** 交易明細顯示方式(父單切換目前子單的品項顯示方式，預設為「同品項分拆」) */
  detailDisplayMethod: TransactionDetailDisplayMethod;
  /** 機號 */
  deviceCode: Scalars['String']['output'];
  /** 折扣金額 */
  discountAmount: Scalars['Decimal']['output'];
  /** 外加稅 */
  exclusiveTaxAmount: Scalars['Decimal']['output'];
  /** 發票 */
  invoices?: Maybe<Array<Invoice>>;
  /** 低消金額 */
  minChargeAmount: Scalars['Decimal']['output'];
  opUser?: Maybe<Employee>;
  /** 操作人員 */
  opUserID?: Maybe<Scalars['UUID']['output']>;
  order: Order;
  orderID: Scalars['UUID']['output'];
  /** 裝置名稱 */
  pDeviceName: Scalars['String']['output'];
  /** 父交易(拆帳子單歸屬的父單) */
  parent?: Maybe<Transaction>;
  /** 父交易ID(拆帳子單歸屬的父單) */
  parentID?: Maybe<Scalars['UUID']['output']>;
  /** 支付 */
  payments: Array<Payment>;
  /** 未稅額 */
  preTaxAmount: Scalars['Decimal']['output'];
  /** 平台服務費 */
  processingFeeAmount: Scalars['Decimal']['output'];
  /** 退款時間 */
  refundedAt?: Maybe<Scalars['DateTimeZ']['output']>;
  /** 退款來源交易 */
  refundedFrom?: Maybe<Transaction>;
  /** 退款來源交易ID */
  refundedFromID?: Maybe<Scalars['UUID']['output']>;
  /** 退款來源訂單 */
  refundedFromOrder?: Maybe<Order>;
  /** 退款來源訂單ID */
  refundedFromOrderID?: Maybe<Scalars['UUID']['output']>;
  /** 結帳差額(交易金額因結帳收款進位規則計算所得，與原訂單銷售總額的差異：Order.totalAmount - Transaction.totalAmount) */
  roundingDiff: Scalars['Decimal']['output'];
  /** 服務費金額 */
  serviceFeeAmount: Scalars['Decimal']['output'];
  /** 關聯的營業時段 (用於識別 Transaction 屬於哪次關帳) */
  sessionID?: Maybe<Scalars['UUID']['output']>;
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  /** 金額拆帳：交易明細開立方式 */
  splitDetailIssuedMethod: SplitDetailIssuedMethod;
  /** 金額拆帳：發票開立方式 */
  splitInvoiceIssuedMethod: SplitInvoiceIssuedMethod;
  /** 拆帳方式 */
  splitMethod: TransactionSplitMethod;
  /** 商品金額 = Order.subtotalAmount */
  subtotalAmount: Scalars['Decimal']['output'];
  /** 稅額 */
  taxAmount: Scalars['Decimal']['output'];
  /** 交易總金額(含稅)。未折帳時，等於 Order.totalAmount。折帳時，為每一次拆帳分配的金額 */
  totalAmount: Scalars['Decimal']['output'];
  /** 交易單號(從 orderCode 帶入，若為子單，附加 -<序號>) */
  transactionCode: Scalars['String']['output'];
  transactionDetails: Array<TransactionDetail>;
  transactionID: Scalars['UUID']['output'];
  /** 交易序號 */
  transactionNo: Scalars['String']['output'];
  /** 交易狀態 */
  transactionStatus: TransactionStatus;
  /** 交易類型 */
  transactionType: TransactionType;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 交易明細 */
export type TransactionDetail = {
  /** 拆帳主單商品分配到的外加稅。 */
  allocatedExclusiveTaxAmount: Scalars['Decimal']['output'];
  /** 拆帳主單商品分配到的稅金。 */
  allocatedTaxAmount: Scalars['Decimal']['output'];
  /** 拆帳主單分配到的整筆訂單權重金額。 */
  allocatedTotalAmountWeight: Scalars['Decimal']['output'];
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  deletedAt?: Maybe<Scalars['SoftDeleteZ']['output']>;
  /** 折扣資訊(JSON 格式組成一個 Array，每個元素為一個 Object，包含「折扣名稱」、「折扣金額」、「攤提分配金額」) */
  discountInfo?: Maybe<Scalars['JSON']['output']>;
  /** 費用資訊(JSON 格式組成一個 Object，鍵值為費用類型，值為一個 Object，包含「費用金額」、「攤提分配金額」) */
  feeInfo?: Maybe<Scalars['JSON']['output']>;
  /** 子單拆分來源父單交易明細ID */
  fromTransactionDetailID?: Maybe<Scalars['UUID']['output']>;
  /** 是否為招待 */
  isComplimentary: Scalars['Boolean']['output'];
  /** 套餐內容組合資訊(JSON 格式組成一個 Array，每個元素為一個 Object，包含階層下對應的「套餐細項的商品資訊) */
  itemBundleInfo?: Maybe<Scalars['JSON']['output']>;
  /** 商品分類ID */
  itemCategoryID?: Maybe<Scalars['Int32']['output']>;
  /** 商品ID */
  itemID: Scalars['Int32']['output'];
  /** 商品名稱 */
  itemName: Scalars['String']['output'];
  /** 商品單價 */
  itemPrice: Scalars['Decimal']['output'];
  /** 商品價位名稱 */
  itemPriceOptionName: Scalars['String']['output'];
  /** 商品數量 */
  itemQuantity: Scalars['Int16']['output'];
  /** 商品拆分狀態 */
  itemSplitState: ItemSplitState;
  /** 標籤資訊(JSON 格式組成一個 Array，每個元素為一個 Object，包含「標籤名稱」、「標籤價格」、「標籤數量」、「標籤順序」、「標籤顏色」) */
  labelInfo?: Maybe<Scalars['JSON']['output']>;
  order: Order;
  orderID: Scalars['UUID']['output'];
  /** 父單商品原始單價 */
  originalPrice: Scalars['Decimal']['output'];
  /** 父單商品原始數量 */
  originalQuantity: Scalars['Int16']['output'];
  /** 父單商品未拆分剩餘數量(父單交易明細拆分記錄的剩餘數量) */
  remainingQuantity: Scalars['Int16']['output'];
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  /** 子單商品拆分份數 */
  splitCount: Scalars['Int16']['output'];
  /** 子單商品拆分單價 */
  splitPrice: Scalars['Decimal']['output'];
  /** 父單商品拆分子單記錄(JSON 格式組成一個 Array，每個元素為一個 Object，包含 groupID、transactionDetailIDs、splitTotal、splitCount、splitPrice) */
  splitRecords?: Maybe<Scalars['JSON']['output']>;
  /** 子單商品拆分總數 */
  splitTotal: Scalars['Int16']['output'];
  /** 商品金額 = OrderDetail.subtotalAmount */
  subtotalAmount: Scalars['Decimal']['output'];
  /** 稅額 */
  taxAmount: Scalars['Decimal']['output'];
  /** 交易明細總金額 = OrderDetail.totalAmount */
  totalAmount: Scalars['Decimal']['output'];
  transaction: Transaction;
  /** 交易明細ID */
  transactionDetailID: Scalars['UUID']['output'];
  transactionID: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  /** 重量 */
  weight?: Maybe<Scalars['Decimal']['output']>;
  /** 單價基準量 */
  weightBaseQuantity?: Maybe<Scalars['Decimal']['output']>;
  /** 重量單位 */
  weightUnit?: Maybe<WeightUnit>;
  /** 單位售價 */
  weightUnitPrice?: Maybe<Scalars['Decimal']['output']>;
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 交易明細顯示方式 */
export enum TransactionDetailDisplayMethod {
  /** 同品項合併 */
  SameItemMerge = 'SameItemMerge',
  /** 同品項分拆 */
  SameItemSplit = 'SameItemSplit',
}

/** 輸入交易資料 */
export type TransactionInput = {
  /** 輸入付款資料 */
  payments: Array<PaymentInput>;
  /** 交易紀錄 ID */
  transactionID: Scalars['UUID']['input'];
};

export type TransactionInvoiceColumnIndices = {
  /** 交易時間 */
  createdAt: Scalars['Int16']['input'];
  /** 支付 */
  payments: PaymentInvoiceColumnIndices;
  /** 交易金額 */
  totalAmount: Scalars['Int16']['input'];
  /** 交易序號 */
  transactionNo: Scalars['Int16']['input'];
};

export type TransactionKey = {
  brandID: Scalars['Int32']['input'];
  orderID: Scalars['UUID']['input'];
  shopID: Scalars['Int32']['input'];
  transactionID: Scalars['UUID']['input'];
  workspaceID: Scalars['UUID']['input'];
};

/** 匯出訂單csv欄位(Transaction) */
export type TransactionOrderColumnIndices = {
  /** 交易時間 */
  createdAt: Scalars['Int16']['input'];
  /** 發票 */
  invoices: InvoiceOrderColumnIndices;
  /** 支付 */
  payments: PaymentOrderColumnIndices;
  /** 交易序號 */
  transactionNo: Scalars['Int16']['input'];
};

/** 交易分頁 */
export type TransactionPagination = {
  pageInfo: CursorPageInfo;
  transactions?: Maybe<Array<Transaction>>;
};

export type TransactionReport = {
  invalidTransactionAmount: Scalars['Decimal']['output'];
  invalidTransactionNum: Scalars['Int32']['output'];
  totalTransactionAmount: Scalars['Decimal']['output'];
  totalTransactionNum: Scalars['Int32']['output'];
  transactionAmount: Scalars['Decimal']['output'];
  transactionNum: Scalars['Int32']['output'];
};

/** 搜尋關鍵字 */
export enum TransactionSearchCondition {
  /** 發票號碼 */
  InvoiceNo = 'INVOICE_NO',
  /** 訂單序號 */
  OrderNo = 'ORDER_NO',
  /** 交易序號 */
  TransactionNo = 'TRANSACTION_NO',
}

/** 搜尋交易列表(篩選條件) */
export type TransactionSearchParams = {
  /** 支付方式 */
  brandPaymentMethodName?: InputMaybe<Scalars['String']['input']>;
  /** 營業日範圍 */
  businessDateRange?: InputMaybe<TimeRange>;
  /** 系統日範圍 */
  createdAtRange?: InputMaybe<TimeRange>;
  /** 營業日範圍（訂單） */
  orderBusinessDateRange?: InputMaybe<TimeRange>;
  /** 系統日範圍（訂單） */
  orderCreatedAtRange?: InputMaybe<TimeRange>;
  /** 交易狀態 */
  transactionStatus?: InputMaybe<Array<TransactionStatus>>;
  /** 交易類型 */
  transactionType?: InputMaybe<TransactionType>;
};

/** 交易拆帳方式 */
export enum TransactionSplitMethod {
  /** 金額 */
  Amount = 'Amount',
  /** 品項 */
  Item = 'Item',
  /** 未拆帳 */
  None = 'None',
}

/** 交易狀態 */
export enum TransactionStatus {
  /** 已取消 */
  Cancelled = 'Cancelled',
  /** 已完成 */
  Completed = 'Completed',
  /** 已開立完開票 */
  InvoiceReady = 'InvoiceReady',
  /** 已完成支付 */
  PaymentReady = 'PaymentReady',
  /** 進行中 */
  Processing = 'Processing',
  /** 已退款 */
  Refunded = 'Refunded',
}

/** 交易類型 */
export enum TransactionType {
  /** 一般 */
  General = 'General',
  /** 退款 */
  Refund = 'Refund',
}

export type TransactionsCsvInput = {
  /** 匯出訂單csv欄位 */
  columnIndices: TransactionsColumnIndices;
  /** 語系 */
  locale: Locales;
  /** 搜尋 */
  search?: InputMaybe<Scalars['String']['input']>;
  /** 搜尋關鍵字 */
  searchCondition: TransactionSearchCondition;
  /** 搜尋訂單列表(篩選條件) */
  searchParams: TransactionSearchParams;
  shopKey: ShopKey;
  /** 排序 (欄位) */
  sortField: Scalars['String']['input'];
  /** 排序 (升/降) */
  sortOrder: SortOrder;
  /** 時區 */
  timezone: Scalars['String']['input'];
};

/** 匯出訂單csv欄位(Transaction) */
export type TransactionsColumnIndices = {
  /** 交易營業日 */
  businessDate: Scalars['Int16']['input'];
  /** 交易時間 */
  createdAt: Scalars['Int16']['input'];
  /** 交易折扣金額 */
  discountAmount: Scalars['Int16']['input'];
  employee?: InputMaybe<EmployeeTransactionColumnIndices>;
  /** 發票 */
  invoices: InvoiceTransactionColumnIndices;
  /** 交易員工資訊 */
  opUserID?: InputMaybe<Scalars['Int16']['input']>;
  /** 訂單 */
  order: OrderTransactionColumnIndices;
  /** 支付 */
  payments: PaymentTransactionColumnIndices;
  /** 交易服務費 */
  serviceFeeAmount: Scalars['Int16']['input'];
  /** 交易金額 */
  totalAmount: Scalars['Int16']['input'];
  /** 交易序號 */
  transactionNo: Scalars['Int16']['input'];
  /** 交易狀態 */
  transactionStatus: Scalars['Int16']['input'];
  /** 交易類型 */
  transactionType: Scalars['Int16']['input'];
};

export type Type = {
  categories?: Maybe<Array<Category>>;
  createdAt: Scalars['DateTimeZ']['output'];
  description?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  typeID: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
};

export type UpdateABrandReasonTemplateInput = {
  brandKey: BrandKey;
  reasonType: ReasonType;
  updateReasonTemplate?: InputMaybe<Array<UpdateReasonTemplateInput>>;
};

export type UpdateAGroupOfBrandPaymentMethodsInput = {
  brandPaymentMethodKey: BrandPaymentMethodKey;
  name: Scalars['String']['input'];
  updateOrder?: InputMaybe<Array<BrandPaymentMethodOrderInput>>;
};

export type UpdateAPrintLayoutBaseInput = {
  /** 顧客姓名隱碼選擇用餐方式 */
  consumerNameSelDiningOptionIDs?: InputMaybe<Array<Scalars['Int32']['input']>>;
  /** 顧客姓名顯示樣式 (DEFAULT 'Complete') */
  consumerNameVisibility: ConsumerInfoVisibility;
  /** 顧客電話隱碼選擇用餐方式 */
  consumerPhoneSelDiningOptionIDs?: InputMaybe<
    Array<Scalars['Int32']['input']>
  >;
  /** 顧客電話顯示樣式 (DEFAULT 'Complete') */
  consumerPhoneVisibility: ConsumerInfoVisibility;
  /** 貼紙用餐方式/單號樣式 (DEFAULT 'Fix') */
  diningOptionStickerInfoStyle: DiningOptionTicketInfo;
  /** 貼紙固定單號樣式 */
  diningOptionStickerInfoStyleFix?: InputMaybe<BlackWhiteStyle>;
  /** 區分貼紙用餐方式的單號樣式 */
  diningOptionStickerInfoStyleSpecify?: InputMaybe<
    Array<DiningOptionTicketNoStyleInput>
  >;
  /** 用餐方式/單號樣式 (DEFAULT 'Fix') */
  diningOptionTicketInfoStyle: DiningOptionTicketInfo;
  diningOptionTicketInfoStyleFix?: InputMaybe<BlackWhiteStyle>;
  /** 區分用餐方式的單號樣式 */
  diningOptionTicketInfoStyleSpecify?: InputMaybe<
    Array<DiningOptionTicketNoStyleInput>
  >;
  /** 隱藏商品單價 (DEFAULT false) */
  hideItemPrice: Scalars['Boolean']['input'];
  printLayoutBaseID: Scalars['Int32']['input'];
  /** 店家資訊 */
  shopInfo?: InputMaybe<Scalars['String']['input']>;
  /** 店家資訊對齊方式 */
  shopInfoAlignStyle: ShopInfoAlignStyle;
  /** 店家資訊字體大小 (DEFAULT 'Medium') */
  shopInfoFontSize: FontSize;
  shopKey: ShopKey;
};

export type UpdateAServiceFeeInput = {
  /** 服務費進階名稱 */
  advName: Scalars['String']['input'];
  /** 是否開啟服務費 */
  enabled: Scalars['Boolean']['input'];
  /** 服務費排除計算的商品 */
  exclItemIDs: Array<Scalars['Int32']['input']>;
  /** 服務費(%) */
  percentage: Scalars['Decimal']['input'];
  /** 小數進位規則 */
  roundingRule: DiscountRoundingRule;
  /** 服務費選擇用餐方式 */
  selDiningOptionIDs: Array<Scalars['Int32']['input']>;
  /** 選擇用餐方式 */
  shopDiningOptionApplyMode: ShopDiningOptionApplyMode;
  shopKey: ShopKey;
  /** 服務費稅別 */
  taxCategory: TaxCategory;
  taxGroupID?: InputMaybe<Scalars['Int16']['input']>;
};

export type UpdateAShopDiscountRuleInput = {
  discountLabelApplyMode?: InputMaybe<DiscountLabelApplyMode>;
  manualCombineItemEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  manualCombineOrderEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  manualItemDiscountCalcMethod?: InputMaybe<DiscountCalcMethod>;
  manualOrderDiscountCalcMethod?: InputMaybe<DiscountCalcMethod>;
  manualOrderDiscountMinChargeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  manualOrderDiscountServiceFeeEnabled?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  roundingRule?: InputMaybe<DiscountRoundingRule>;
  shopKey: ShopKey;
};

export type UpdateAShopPosSettingInput = {
  /** 可調整品項是否收服務費 */
  adjustServiceFee?: InputMaybe<Scalars['Boolean']['input']>;
  /** 取消關帳 */
  allowCancelClose?: InputMaybe<Scalars['Boolean']['input']>;
  /** 線上訂單自動接單 */
  autoAcceptOnlineOrder?: InputMaybe<Scalars['Boolean']['input']>;
  /** 自動清除桌單 */
  autoClearTable?: InputMaybe<Scalars['Boolean']['input']>;
  /** 線上訂單已付款，於接單後開立發票 */
  autoIssueInvoiceAfterAcceptPaidOnlineOrder?: InputMaybe<
    Scalars['Boolean']['input']
  >;
  /** 線上訂單自動出單 */
  autoIssueOnlineOrder?: InputMaybe<Scalars['Boolean']['input']>;
  /** 自動鎖屏時間啟用 */
  autoLockEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** 自動鎖屏時間(秒) */
  autoLockTime?: InputMaybe<Scalars['Int16']['input']>;
  /** 同步出單 */
  autoPrint?: InputMaybe<Scalars['Boolean']['input']>;
  /** 點餐列印送出後，自動返回桌位管理畫面 */
  autoReturnTable?: InputMaybe<Scalars['Boolean']['input']>;
  /** 金額條碼連結商品ID */
  barcodeAmountItemID?: InputMaybe<Scalars['Int32']['input']>;
  /** 金額條碼連結商品價位ID */
  barcodeAmountItemPriceOptionID?: InputMaybe<Scalars['Int32']['input']>;
  /** 金額條碼掃描 */
  barcodeAmountScanEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** 找零提醒 */
  changeReminder?: InputMaybe<Scalars['Boolean']['input']>;
  /** 裝置資料保留天數 */
  deviceDataRetentionDays?: InputMaybe<Scalars['Int16']['input']>;
  /** 訂單顯示商品稅率資訊 */
  displayTaxInfo: Scalars['Boolean']['input'];
  /** 訂單成立後無法離開 */
  lockTableAfterOrder?: InputMaybe<Scalars['Boolean']['input']>;
  /** 手動折扣 */
  manualDiscountEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** 手動排除優惠折扣衝突 */
  manualResolveDiscountConflict?: InputMaybe<Scalars['Boolean']['input']>;
  /** 線上訂單取號方式 */
  onlineOrderNumberingMode?: InputMaybe<OnlineOrderNumberingMode>;
  /** 線上訂單設定套用範圍 */
  onlineOrderSettingsScope?: InputMaybe<OnlineOrderSettingsScope>;
  /** 依訂單來源設定 */
  onlineOrderSourceSettings?: InputMaybe<
    Array<UpdateShopPosOnlineOrderSourceSettingInput>
  >;
  /** 點餐模式 */
  orderCodeMode?: InputMaybe<OrderCodeMode>;
  /** 預約單於取餐時間前幾分鐘自動出單 */
  preorderAutoIssueBeforeMinutes?: InputMaybe<Scalars['Int16']['input']>;
  /** 指定預約單自動出單時機 */
  preorderAutoIssueTimingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** 短溢時無法關帳或小結 */
  preventCloseOnShortage?: InputMaybe<Scalars['Boolean']['input']>;
  /** 有顧客未結帳時無法關帳 */
  preventCloseOnUnpaidOrders?: InputMaybe<Scalars['Boolean']['input']>;
  /** 結束交易強制列印刪除單 */
  printDeleteSlip?: InputMaybe<Scalars['Boolean']['input']>;
  /** 線上訂單已付款，出單時列印交易明細 */
  printPaidOnlineOrder?: InputMaybe<Scalars['Boolean']['input']>;
  /** 列印退餐理由 */
  printReturnReason?: InputMaybe<Scalars['Boolean']['input']>;
  /** 打卡限制需有完整上下班 */
  punchCardRequireCompleteShift?: InputMaybe<Scalars['Boolean']['input']>;
  /** 快速結帳 */
  quickCheckout?: InputMaybe<Scalars['Boolean']['input']>;
  /** 紀錄招待理由 */
  recordComplimentary?: InputMaybe<Scalars['Boolean']['input']>;
  /** 作廢交易或發票需進行檢核驗證 */
  requireVerificationOnVoid?: InputMaybe<Scalars['Boolean']['input']>;
  shopKey: ShopKey;
  /** POS 按鈕顯示商品價格 */
  showItemPriceOnButton?: InputMaybe<Scalars['Boolean']['input']>;
  /** 交易明細顯示金額加總 */
  showTransactionAmountSummary?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateAShopPaymentMethodInput = {
  extendSetting?: InputMaybe<Scalars['JSON']['input']>;
  paramSetting?: InputMaybe<Scalars['JSON']['input']>;
  shopPaymentMethodKey: ShopPaymentMethodKey;
};

export type UpdateAShopReasonSettingInput = {
  reasonType: ReasonType;
  shopKey: ShopKey;
  shopReasonSettingInput: Array<ShopReasonSettingInput>;
};

export type UpdateAWorkspaceInput = {
  /** 計算小數位數 */
  calcDecimalPlaces: Scalars['Int16']['input'];
  /** 計算進位方式 */
  calcRoundingRule: StandardRoundingRule;
  /** 結帳小數位數 */
  checkoutDecimalPlaces: Scalars['Int16']['input'];
  /** 結帳進位方式 */
  checkoutRoundingRule: StandardRoundingRule;
  /** 折扣顯示格式 */
  discountDisplayFormat: DiscountDisplayFormat;
  /** 語言 */
  languageID: Scalars['String']['input'];
  /** 總部工作區名稱 */
  name: Scalars['String']['input'];
  /** 時區 */
  timezoneID: Scalars['String']['input'];
  workspaceKey: WorkspaceKey;
};

/** 輸入付款資料 */
export type UpdateAnOrderInput = {
  /** 大人 */
  adult: Scalars['Int16']['input'];
  /** 小孩 */
  child: Scalars['Int16']['input'];
  /** 用餐方式(名稱) */
  diningOptionName: Scalars['String']['input'];
  /** 用餐方式 */
  diningOptionType: DiningOptionType;
  /** 交易 */
  transactions: Array<TransactionInput>;
};

export type UpdateBrandOrderInput = {
  brandOrders: Array<BrandOrderInput>;
  workspaceID: Scalars['UUID']['input'];
};

/** 更新品牌 POS 更新策略輸入 */
export type UpdateBrandPosUpdatePolicyInput = {
  brandKey: BrandKey;
  /** 每日指定更新時間；只有 AutoFixedTime 模式需要 */
  fixedTime?: InputMaybe<Scalars['Time']['input']>;
  mode: PosUpdateMode;
};

export type UpdateBrandPortalSettingInput = {
  brandKey: BrandKey;
  brandPortalSettingInput: BrandPortalSettingInput;
};

export type UpdateCrossBrandPortalSettingInput = {
  crossBrandPortalSettingInput: CrossBrandPortalSettingInput;
  pageID?: InputMaybe<Scalars['UUID']['input']>;
  workspaceID: Scalars['UUID']['input'];
};

export type UpdateCustomizedTicketPayload = {
  note?: InputMaybe<TicketCustomizedNoteInput>;
  paper?: InputMaybe<TicketCustomizedPaperInput>;
};

export type UpdateEmployeeInput = {
  employeeCode?: InputMaybe<Scalars['String']['input']>;
  employeeID?: InputMaybe<Scalars['UUID']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  oldRole?: InputMaybe<Scalars['Int32']['input']>;
  orgBelongKeys?: InputMaybe<Array<InputOrgBelongKey>>;
  pin?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['Int32']['input']>;
  workspaceID: Scalars['UUID']['input'];
};

/** 編輯商品進階價位 */
export type UpdateItemAdvPriceInput = {
  /** 品牌用餐方式 */
  brandDiningOptionID?: InputMaybe<Scalars['Int32']['input']>;
  brandID: Scalars['Int32']['input'];
  itemAdvPriceID?: InputMaybe<Scalars['Int32']['input']>;
  /** createItem時不帶itemID，updateItem時必填 */
  itemID?: InputMaybe<Scalars['Int32']['input']>;
  itemPriceOptionID?: InputMaybe<Scalars['Int32']['input']>;
  /** 原價 */
  originPrice: Scalars['Decimal']['input'];
  /** 售價 */
  price: Scalars['Decimal']['input'];
  /** 兌換所需點數 */
  redeemPoint?: InputMaybe<Scalars['Int32']['input']>;
  /** 品牌分類 */
  subBrandID?: InputMaybe<Scalars['Int32']['input']>;
  workspaceID: Scalars['UUID']['input'];
};

export type UpdateItemCategoryInput = {
  addItemIDs?: InputMaybe<Array<Scalars['Int32']['input']>>;
  code: Scalars['String']['input'];
  delItemIDs?: InputMaybe<Array<Scalars['Int32']['input']>>;
  itemCategoryKey: ItemCategoryKey;
  name: Scalars['String']['input'];
};

export type UpdateItemCategoryOrderInput = {
  brandID: Scalars['Int32']['input'];
  updateOrder?: InputMaybe<Array<ItemCategoryOrderInput>>;
  workspaceID: Scalars['UUID']['input'];
};

/** 新增/編輯商品 */
export type UpdateItemInput = {
  /** 是否可手動更改稅率 */
  allowChangeTaxRate: Scalars['Boolean']['input'];
  brandID: Scalars['Int32']['input'];
  /** 編號(主) */
  code: Scalars['String']['input'];
  /** 按鍵顏色 */
  color: Scalars['String']['input'];
  /** 預設稅金 (用於擇一計算方式) */
  defaultTaxID?: InputMaybe<Scalars['Int16']['input']>;
  /** 停用 */
  disabled: Scalars['Boolean']['input'];
  /** 商品簡介 */
  intro: Scalars['String']['input'];
  /** 商品簡介(多語系) */
  introLang: MultiLangInput;
  itemAdvNames: Array<ItemAdvNameInput>;
  itemBundles?: InputMaybe<Array<ItemBundleInput>>;
  /** 商品分類 */
  itemCategory?: InputMaybe<ItemCategoryNameInput>;
  /** createItem時不帶itemID，updateItem時必填 */
  itemID?: InputMaybe<Scalars['Int32']['input']>;
  /** 商品種類(單品|套餐) */
  itemKind: ItemKind;
  itemLabelGroups?: InputMaybe<Array<ItemLabelGroupInput>>;
  itemPriceOptions: Array<UpdateItemPriceOptionInput>;
  linkItemShops: Array<LinkItemShopInput>;
  linkItemSubBrands: Array<LinkItemSubBrandInput>;
  /** 商品名稱 */
  name: Scalars['String']['input'];
  /** 商品名稱(多語系) */
  nameLang: MultiLangInput;
  /** 不列入報表統計 */
  noStatistic: Scalars['Boolean']['input'];
  /** 只在 POS 使用 */
  posOnly: Scalars['Boolean']['input'];
  /** 下架時間 */
  saleEndTime: Scalars['DateTime']['input'];
  /** 上架時間 */
  saleStartTime: Scalars['DateTime']['input'];
  /** 門市套用模式 (販售地點) */
  shopApplyMode: ShopApplyMode;
  /** 商品稅別 */
  taxCategory: TaxCategory;
  /** 商品稅金群組 */
  taxGroupID?: InputMaybe<Scalars['Int16']['input']>;
  workspaceID: Scalars['UUID']['input'];
};

/** 編輯商品價位規格 */
export type UpdateItemPriceOptionInput = {
  /** 條碼 */
  barcode?: InputMaybe<Scalars['String']['input']>;
  brandID: Scalars['Int32']['input'];
  /** 商品價位可招待 */
  complimentary: Scalars['Boolean']['input'];
  /** 成本 */
  cost?: InputMaybe<Scalars['Decimal']['input']>;
  /** 預設選取 */
  defaultSelect?: InputMaybe<Scalars['Boolean']['input']>;
  /** 顯示順序 */
  displayOrder: Scalars['Int16']['input'];
  itemAdvPrices?: InputMaybe<Array<UpdateItemAdvPriceInput>>;
  /** 編號(子) */
  itemCode?: InputMaybe<Scalars['String']['input']>;
  /** createItem時不帶itemID，updateItem時必填 */
  itemID?: InputMaybe<Scalars['Int32']['input']>;
  itemPriceOptionID?: InputMaybe<Scalars['Int32']['input']>;
  /** 價位名稱 */
  name: Scalars['String']['input'];
  /** 價位名稱(多語系) */
  nameLang: MultiLangInput;
  /** 原價 */
  originPrice: Scalars['Decimal']['input'];
  /** 售價 */
  price: Scalars['Decimal']['input'];
  /** 價位類型 */
  priceType: ItemPriceType;
  /** 計價方式 */
  pricingMethod: ItemPricingMethod;
  /** 兌換所需點數 */
  redeemPoint?: InputMaybe<Scalars['Int32']['input']>;
  /** 單價基準量 */
  weightBaseQuantity?: InputMaybe<Scalars['Decimal']['input']>;
  /** 重量單位 */
  weightUnit?: InputMaybe<WeightUnit>;
  /** 單位售價 */
  weightUnitPrice?: InputMaybe<Scalars['Decimal']['input']>;
  workspaceID: Scalars['UUID']['input'];
};

export type UpdateKeypadInput = {
  /** 鍵盤使用商品 */
  itemIDs?: InputMaybe<Array<Scalars['Int32']['input']>>;
  keypadKey: KeypadKey;
  /** 鍵盤名稱 */
  name: Scalars['String']['input'];
};

export type UpdateLinkShopMenusInput = {
  brandID: Scalars['Int32']['input'];
  menuID: Scalars['Int32']['input'];
  shopIDs: Array<Scalars['Int32']['input']>;
  workspaceID: Scalars['UUID']['input'];
};

export type UpdateMemberInput = {
  /** 生日 */
  birthday?: InputMaybe<Scalars['Date']['input']>;
  /** 公司名稱 */
  companyName?: InputMaybe<Scalars['String']['input']>;
  /** 國碼 */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** 電子郵件 */
  email?: InputMaybe<Scalars['String']['input']>;
  /** 姓名 */
  fullName?: InputMaybe<Scalars['String']['input']>;
  /** 性別 */
  gender?: InputMaybe<Gender>;
  /** 電話 */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** 會員載具/捐贈/統編 */
  preferences?: InputMaybe<MemberPreferencesInput>;
};

export type UpdateMenuCategoryInput = {
  brandID: Scalars['Int32']['input'];
  displayOrder: Scalars['Int16']['input'];
  menuCategoryID: Scalars['Int32']['input'];
  menuID: Scalars['Int32']['input'];
  name: Scalars['String']['input'];
  nameLang?: InputMaybe<MultiLangInput>;
  workspaceID: Scalars['UUID']['input'];
};

export type UpdateMenuInput = {
  brandID: Scalars['Int32']['input'];
  menuID: Scalars['Int32']['input'];
  /** 菜單類型 */
  menuType: MenuType;
  /** 菜單名稱 */
  name: Scalars['String']['input'];
  /** 菜單名稱(多語系) */
  nameLang?: InputMaybe<MultiLangInput>;
  /** POS 菜單格數：欄 */
  posGridCols?: InputMaybe<Scalars['Int16']['input']>;
  /** POS 菜單格數：列 */
  posGridRows?: InputMaybe<Scalars['Int16']['input']>;
  /** POS 菜單鍵盤模式 */
  posKeyboardMode?: InputMaybe<PosMenuKeyboardMode>;
  /** 預約菜單所屬門市 */
  preorderShopID?: InputMaybe<Scalars['Int32']['input']>;
  /** 新增/更新/刪除菜單商品 */
  updateMenuItems: Array<UpdateMenuItemInput>;
  workspaceID: Scalars['UUID']['input'];
};

export type UpdateMenuItemInput = {
  brandID: Scalars['Int32']['input'];
  itemID: Scalars['Int32']['input'];
  /** 菜單分類商品 */
  menuCategoryMenuItems: Array<MenuCategoryMenuItemInput>;
  menuID: Scalars['Int32']['input'];
  /** createMenuItem時不帶menuItemID，updateMenuItem時必填 */
  menuItemID?: InputMaybe<Scalars['Int32']['input']>;
  /** 已選品牌用餐方式 */
  selectedBrandDiningOptions: Array<LinkMenuItemBrandDiningOptionInput>;
  /** 已選商品價位 */
  selectedItemPriceOptions: Array<LinkMenuItemItemPriceOptionInput>;
  workspaceID: Scalars['UUID']['input'];
};

export type UpdateMenuOffDaysInput = {
  brandID: Scalars['Int32']['input'];
  menuID: Scalars['Int32']['input'];
  /** 公休日 */
  menuOffDays: Array<MenuOffDayInput>;
  workspaceID: Scalars['UUID']['input'];
};

export type UpdateMenuSupplyHoursInput = {
  brandID: Scalars['Int32']['input'];
  menuID: Scalars['Int32']['input'];
  /** 菜單供應時段 */
  menuSupplyHours: Array<MenuSupplyHourInput>;
  /** 菜單供應時段類型 */
  supplyHours: MenuSupplyHourType;
  workspaceID: Scalars['UUID']['input'];
};

export type UpdateOnlineOrderPickupSettingInput = {
  deliverMethod?: InputMaybe<Scalars['String']['input']>;
  deliveryActivate: Scalars['Boolean']['input'];
  deliveryDistanceMaxKm?: InputMaybe<Scalars['Int32']['input']>;
  deliveryDistanceRule?: InputMaybe<O2ODeliveryDistanceRule>;
  deliveryFeeAmount?: InputMaybe<Scalars['Decimal']['input']>;
  deliveryFeeCalcMode: O2ODeliveryFeeCalcMode;
  deliveryFeeRule?: InputMaybe<O2ODeliveryFeeRule>;
  deliveryPrepareMealTimeInMin?: InputMaybe<Scalars['Int16']['input']>;
  deliveryTimeInMin?: InputMaybe<Scalars['Int16']['input']>;
  pickupActivate: Scalars['Boolean']['input'];
  pickupMethod?: InputMaybe<Scalars['String']['input']>;
  pickupPrepareMealTimeInMin?: InputMaybe<Scalars['Int16']['input']>;
  shopKey: ShopKey;
};

export type UpdateOnlineOrderTimeSettingInput = {
  offDays: Array<OnlineOrderOffDayInput>;
  orderingHours: Array<OnlineOrderOrderingHourInput>;
  shopKey: ShopKey;
};

export type UpdatePDeviceInfoResponse = {
  boundVDevice: Scalars['Boolean']['output'];
  isCDS: Scalars['Boolean']['output'];
  serviceHubExists: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
};

export type UpdatePPrinterInfoInput = {
  connectMedia: ConnectMediaType;
  pDeviceID?: InputMaybe<Scalars['Int32']['input']>;
  printerBrand: Scalars['String']['input'];
  printerInfo: Scalars['JSON']['input'];
  printerModel?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateReasonTemplateInput = {
  cashDrawerReasonCode?: InputMaybe<Scalars['String']['input']>;
  cashDrawerTransactionType?: InputMaybe<CashDrawerTransactionType>;
  disabled: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  reasonTemplateID?: InputMaybe<Scalars['Int32']['input']>;
};

export type UpdateRoleInput = {
  descr?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  roleID: Scalars['Int32']['input'];
  workspaceID?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdateRolePermissionInput = {
  linkPermissions: Array<LinkRolePermissionInput>;
  roleTemplateID: Scalars['UUID']['input'];
};

export type UpdateServicewareRelationInput = {
  activate: Scalars['Boolean']['input'];
  /** 使用商品價位 */
  items: Array<ServicewareItemRelationInput>;
  /** 使用標籤 */
  labels: Array<ServicewareLabelRelationInput>;
  /** 配件識別碼 */
  servicewareID: Scalars['UUID']['input'];
};

export type UpdateServicewareRelationsInput = {
  brandKey: BrandKey;
  servicewares: Array<UpdateServicewareRelationInput>;
};

export type UpdateShopContainerWeightManagementInput = {
  /** 服務啟用狀態 */
  activate: Scalars['Boolean']['input'];
  /** 用餐方式預設容器 */
  shopDiningOptionContainers: Array<UpdateShopDiningOptionContainerInput>;
  shopKey: ShopKey;
};

export type UpdateShopDiningOptionContainerInput = {
  brandDiningOptionID: Scalars['Int32']['input'];
  containerID: Scalars['Int32']['input'];
};

export type UpdateShopDiningOptionInput = {
  diningOptionSelectMode: DiningOptionSelectMode;
  presetBrandDiningOptionID?: InputMaybe<Scalars['Int32']['input']>;
  shopDiningOptionInput: Array<ShopDiningOptionInput>;
  shopKey: Array<ShopKey>;
};

export type UpdateShopDiningOptionOrderRemarkInput = {
  /** 品牌用餐方式識別碼 */
  brandDiningOptionID: Scalars['Int32']['input'];
  /** 預設備註識別碼 */
  orderRemarkTitleID?: InputMaybe<Scalars['UUID']['input']>;
  /** 叫餐備註是否必填 */
  orderRemarkTitleRequired?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateShopDisplayOrderInput = {
  brandID: Scalars['Int32']['input'];
  shopDisplayOrders: Array<ShopDisplayOrderInput>;
  workspaceID: Scalars['UUID']['input'];
};

export type UpdateShopInput = {
  brandID: Scalars['Int32']['input'];
  shopIDs: Array<InputMaybe<Scalars['Int32']['input']>>;
  subBrandID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

export type UpdateShopMemberTagInput = {
  shopKey: ShopKey;
  tags: Array<InputMaybe<ShopTag>>;
};

export type UpdateShopOrderRemarkSettingInput = {
  /** 叫餐備註功能啟用 */
  orderRemarkEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** 門市用餐方式叫餐備註設定 */
  shopDiningOptions?: InputMaybe<Array<UpdateShopDiningOptionOrderRemarkInput>>;
  shopKey: ShopKey;
};

export type UpdateShopOrderRemarkTitleInput = {
  /** 是否停用 */
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** 顯示順序 */
  displayOrder?: InputMaybe<Scalars['Int16']['input']>;
  /** 備註名稱 */
  title: Scalars['String']['input'];
  /** 備註識別碼；新增時不帶 */
  titleID?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdateShopOrderRemarkTitlesInput = {
  shopKey: ShopKey;
  /** 門市叫餐備註名稱設定；未帶 titleID 為新增，未出現在清單中的既有資料會刪除 */
  shopOrderRemarkTitles: Array<UpdateShopOrderRemarkTitleInput>;
};

export type UpdateShopPosOnlineOrderSourceSettingInput = {
  /** 線上訂單自動接單 */
  autoAcceptOnlineOrder: Scalars['Boolean']['input'];
  /** 線上訂單已付款，於接單後開立發票 */
  autoIssueInvoiceAfterAcceptPaidOnlineOrder: Scalars['Boolean']['input'];
  /** 線上訂單自動出單 */
  autoIssueOnlineOrder: Scalars['Boolean']['input'];
  /** 預約單於取餐時間前幾分鐘自動出單 */
  preorderAutoIssueBeforeMinutes: Scalars['Int16']['input'];
  /** 指定預約單自動出單時機 */
  preorderAutoIssueTimingEnabled: Scalars['Boolean']['input'];
  /** 線上訂單已付款，出單時列印交易明細 */
  printPaidOnlineOrder: Scalars['Boolean']['input'];
  /** 訂單來源 App ID */
  sourceAppID: Scalars['UUID']['input'];
};

export type UpdateShopPaymentSettingInput = {
  defaultPaymentMethodID?: InputMaybe<Scalars['Int32']['input']>;
  deselectedPaymentIDs?: InputMaybe<Array<Scalars['Int32']['input']>>;
  needInputAmount?: InputMaybe<Scalars['Boolean']['input']>;
  quickDefaultPaymentMethodID?: InputMaybe<Scalars['Int32']['input']>;
  selectedPaymentIDs?: InputMaybe<Array<Scalars['Int32']['input']>>;
  shopKey: ShopKey;
};

export type UpdateShopPermissionVerificationsInput = {
  brandID: Scalars['Int32']['input'];
  shopID: Scalars['Int32']['input'];
  verifications: Array<ShopPermissionVerificationInput>;
  workspaceID: Scalars['UUID']['input'];
};

export type UpdateTicketInput = {
  payload: UpdateTicketPayload;
  ticketKey: TicketKey;
};

/** 僅能出現其中一種；若環境尚不支援 @oneOf，可先拿掉但在後端做檢查 */
export type UpdateTicketPayload = {
  checkout?: InputMaybe<TicketCheckoutInput>;
  eodClose?: InputMaybe<TicketEodCloseInput>;
  invoice?: InputMaybe<TicketInvoiceInput>;
  kitchen?: InputMaybe<TicketKitchenInput>;
  order?: InputMaybe<TicketOrderInput>;
  queue?: InputMaybe<TicketQueueInput>;
  scanOrder?: InputMaybe<TicketScanOrderInput>;
  shiftClose?: InputMaybe<TicketShiftCloseInput>;
  sticker?: InputMaybe<TicketStickerInput>;
};

export type UploadSyncDataResponse = {
  /** 同步 API 識別碼（在 MQTT 事件接收時用以識別哪一次的API來源並供 POS 辨識） */
  apiID: Scalars['String']['output'];
  uploadSyncDataStatus: Array<UploadSyncDataStatus>;
};

export type UploadSyncDataStatus = {
  status: Array<SyncDataStatus>;
  table: Scalars['String']['output'];
};

export type UpsertAiWaiterVirtualHumanInput = {
  brandKey: BrandKey;
  /** 僅新建 Custom 虛擬人時必填；必須是 putAIWaiterVirtualHumanVoice 回傳的 uploadHash */
  customVoiceUploadHash?: InputMaybe<Scalars['String']['input']>;
  formality: AiWaiterFormality;
  /** 新增時必填；必須是先前 putAIWaiterVirtualHumanImage 回傳圖片的 hash */
  imageHash?: InputMaybe<Scalars['String']['input']>;
  languageIDs?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  nameLang: Scalars['JSON']['input'];
  responseLength: AiWaiterResponseLength;
  speechRate: Scalars['Decimal']['input'];
  virtualHumanID: Scalars['UUID']['input'];
  voiceType?: InputMaybe<AiWaiterVoiceType>;
};

export type UpsertBrandInput = {
  brandID?: InputMaybe<Scalars['Int32']['input']>;
  businessDayCutoffTime?: InputMaybe<Scalars['Time']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  displayOrder?: InputMaybe<Scalars['Int16']['input']>;
  name: Scalars['String']['input'];
  subBrands?: InputMaybe<Array<InputMaybe<UpsertSubBrandInput>>>;
  workspaceID: Scalars['UUID']['input'];
};

export type UpsertBrandMemberTagInput = {
  brandKey: BrandKey;
  tags: Array<InputMaybe<Tag>>;
};

export type UpsertInvoiceSettingInput = {
  activate: Scalars['Boolean']['input'];
  bindSettings?: InputMaybe<Scalars['JSON']['input']>;
  businessEntityName: Scalars['String']['input'];
  businessIDNumber: Scalars['String']['input'];
  eInvoiceSourceID?: InputMaybe<Scalars['UUID']['input']>;
  fetchNumberOfGroup?: InputMaybe<Scalars['Int']['input']>;
  invoiceReasonID?: InputMaybe<Scalars['Int']['input']>;
  invoiceTaxTypeID: Scalars['Int']['input'];
  lowStockAlertEnabled: Scalars['Boolean']['input'];
  safeQty?: InputMaybe<Scalars['Int']['input']>;
  shopKey: ShopKey;
  taxRate: Scalars['String']['input'];
};

export type UpsertServicewareDetailInput = {
  /** 顯示順序 */
  displayOrder: Scalars['Int16']['input'];
  /** 配件名稱 */
  name: Scalars['String']['input'];
  /** 配件識別碼；新增時不帶 */
  servicewareID?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpsertServicewareInput = {
  brandKey: BrandKey;
  servicewares: Array<UpsertServicewareDetailInput>;
};

export type UpsertShopBusinessHourInput = {
  endTime: Scalars['Time']['input'];
  shopBusinessHoursID?: InputMaybe<Scalars['Int']['input']>;
  startTime: Scalars['Time']['input'];
  weekDay: Scalars['Int16']['input'];
};

export type UpsertShopContainerInput = {
  activate: Scalars['Boolean']['input'];
  containerID?: InputMaybe<Scalars['Int32']['input']>;
  displayOrder: Scalars['Int16']['input'];
  name: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Decimal']['input']>;
  weightUnit: WeightUnit;
};

export type UpsertShopContainersInput = {
  shopContainers: Array<UpsertShopContainerInput>;
  shopKey: ShopKey;
};

export type UpsertShopDetailsInput = {
  brandID: Scalars['Int32']['input'];
  shop: UpsertShopInput;
  shopBusinessHours?: InputMaybe<Array<UpsertShopBusinessHourInput>>;
  shopGroups?: InputMaybe<Array<ShopGroupSelectionInput>>;
  shopID: Scalars['Int32']['input'];
  subBrandID?: InputMaybe<Scalars['Int32']['input']>;
  workspaceID: Scalars['UUID']['input'];
};

export type UpsertShopGroupInput = {
  brandID: Scalars['Int32']['input'];
  shopGroups: Array<ShopGroupInput>;
  workspaceID: Scalars['UUID']['input'];
};

export type UpsertShopInput = {
  aliasName?: InputMaybe<Scalars['String']['input']>;
  buildingFloor?: InputMaybe<Scalars['String']['input']>;
  cityCounty?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  dayTimeType?: InputMaybe<DayTimeType>;
  description?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  doorNo?: InputMaybe<Scalars['String']['input']>;
  e164CountryCode?: InputMaybe<Scalars['String']['input']>;
  landLine?: InputMaybe<Scalars['String']['input']>;
  languageID: Scalars['String']['input'];
  name: Scalars['String']['input'];
  road?: InputMaybe<Scalars['String']['input']>;
  timezoneID: Scalars['String']['input'];
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertSubBrandInput = {
  displayOrder?: InputMaybe<Scalars['Int16']['input']>;
  name: Scalars['String']['input'];
  subBrandID?: InputMaybe<Scalars['Int32']['input']>;
};

/**
 * 新增／編輯 POS 時一併同步綁定設備的輸入。
 * equipmentID 有值 = 更新既有這筆（appID 唯讀不可變更，忽略此欄位）；
 * equipmentID 省略/null = 新增一筆（appID 必填）。
 * 新增 POS 時（createAPOSWithEquipments）尚無既有設備，equipmentID 必須省略/null。
 */
export type UpsertVDeviceEquipmentInput = {
  appID?: InputMaybe<Scalars['UUID']['input']>;
  bindSettingID: Scalars['UUID']['input'];
  equipmentID?: InputMaybe<Scalars['Int32']['input']>;
  /**
   * 已棄用：顯示名稱一律衍生自 bindSettingID 對應的 settingName，傳入值不再生效，仍為必填只是為了相容既有呼叫端。
   * @deprecated 顯示名稱改為衍生自 bind setting 的 settingName，傳入值不再生效
   */
  name?: Scalars['String']['input'];
};

export enum UsageApplicableCondition {
  /** 所有訂單 */
  All = 'All',
  /** 指定支付方式 */
  SpecificPayment = 'SpecificPayment',
}

export enum UsageBillingItem {
  /** API次數 */
  ApiCall = 'ApiCall',
  /** 每筆訂單金額 */
  OrderAmount = 'OrderAmount',
  /** 分店數 */
  ShopCount = 'ShopCount',
}

export enum UsageBillingMethod {
  /** 每單位 */
  PerUnit = 'PerUnit',
  /** 階梯式 */
  Tiered = 'Tiered',
}

export enum UsageRateType {
  /** 固定金額 */
  Amount = 'Amount',
  /** 百分比 */
  Percent = 'Percent',
}

export enum UsedStatus {
  All = 'all',
  Unused = 'unused',
  Used = 'used',
}

/** 使用者 */
export type User = {
  createdAt: Scalars['DateTimeZ']['output'];
  deletedAt?: Maybe<Scalars['SoftDeleteZ']['output']>;
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  employees?: Maybe<Array<Employee>>;
  lastActivity?: Maybe<UserActivity>;
  lastSendMailVerificationAt?: Maybe<Scalars['DateTimeZ']['output']>;
  passwordHash: Scalars['String']['output'];
  pendingEmail?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTimeZ']['output'];
  userID: Scalars['UUID']['output'];
  validated: Scalars['Boolean']['output'];
  verifiedNumber?: Maybe<Scalars['String']['output']>;
  verifiedNumberExpiredAt?: Maybe<Scalars['DateTimeZ']['output']>;
};

/** 使用者活動紀錄 */
export type UserActivity = {
  activities: Scalars['JSON']['output'];
  activityID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  email?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  userID: Scalars['UUID']['output'];
};

/** 虛擬裝置 (VDevice for Virtual Device) */
export type VDevice = {
  /** 於POS點擊確認按鈕後直接結帳 */
  autoCheckoutOnConfirm?: Maybe<Scalars['Boolean']['output']>;
  /** 實體裝置綁定時間 */
  boundAt?: Maybe<Scalars['DateTimeZ']['output']>;
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  deletedAt?: Maybe<Scalars['SoftDeleteZ']['output']>;
  /** 機號 */
  deviceCode: Scalars['String']['output'];
  /** 裝置類型 */
  deviceType: VDeviceType;
  /** 此裝置目前綁定的外部設備清單 */
  equipments: Array<VDeviceEquipment>;
  /** 是否綁定 */
  isBound: Scalars['Boolean']['output'];
  /** 是否為結帳櫃台 (結帳功能) */
  isCashier: Scalars['Boolean']['output'];
  /** 是否為 CDS */
  isCds?: Maybe<Scalars['Boolean']['output']>;
  isServiceHub: Scalars['Boolean']['output'];
  /** 裝置名稱 */
  name: Scalars['String']['output'];
  /** 實體裝置 */
  pDevice?: Maybe<PDevice>;
  /** 實體裝置ID */
  pDeviceID?: Maybe<Scalars['Int32']['output']>;
  /** 點餐預設樣式 */
  posOrderStyle?: Maybe<PosOrderStyle>;
  /** 是否為服務中心 */
  serviceHub?: Maybe<ServiceHub>;
  shop?: Maybe<Shop>;
  shopID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  vDeviceID: Scalars['Int32']['output'];
  vPrinters?: Maybe<Array<VPrinter>>;
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** POS 綁定設備 */
export type VDeviceEquipment = {
  app?: Maybe<App>;
  /** 設備對應的應用程式；設備類型即以 app.slug 呈現 */
  appID: Scalars['UUID']['output'];
  /** 指向 appstore.subscriber_settings.bind_settings 陣列元素的 id */
  bindSettingID: Scalars['UUID']['output'];
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  deletedAt?: Maybe<Scalars['SoftDeleteZ']['output']>;
  equipmentID: Scalars['Int32']['output'];
  /**
   * 設備名稱（已棄用，實際顯示值請以所綁定 bind setting（appstore.subscriber_settings.
   * bind_settings[].settingName）為準；此欄位僅供過渡期相容，值可能已過期，將於後續
   * migration 移除，請勿再依賴此欄位存的值）
   * @deprecated 改用衍生自 bind setting 的 settingName，此欄位即將移除
   */
  name: Scalars['String']['output'];
  shop?: Maybe<Shop>;
  shopID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  /** 所屬虛擬裝置 */
  vDevice?: Maybe<VDevice>;
  vDeviceID: Scalars['Int32']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 虛擬裝置事件 */
export type VDeviceEvent = {
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  eventID: Scalars['Int32']['output'];
  opUser?: Maybe<Employee>;
  /** 操作人員 */
  opUserID?: Maybe<Scalars['UUID']['output']>;
  pDevice?: Maybe<PDevice>;
  /** 實體裝置ID */
  pDeviceID?: Maybe<Scalars['Int32']['output']>;
  shop?: Maybe<Shop>;
  shopID: Scalars['Int32']['output'];
  /** 虛擬裝置事件類型 */
  vDeviceEventType: VDeviceEventType;
  vDeviceID: Scalars['Int32']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

/** 虛擬裝置事件類型 */
export enum VDeviceEventType {
  Created = 'Created',
  Deleted = 'Deleted',
  PDeviceBound = 'PDeviceBound',
  PDeviceUnbind = 'PDeviceUnbind',
  ServiceHubBound = 'ServiceHubBound',
  ServiceHubUnbind = 'ServiceHubUnbind',
}

export type VDeviceKey = {
  brandID: Scalars['Int32']['input'];
  shopID: Scalars['Int32']['input'];
  vDeviceID: Scalars['Int32']['input'];
  workspaceID: Scalars['UUID']['input'];
};

/** 虛擬裝置類型列舉 */
export enum VDeviceType {
  Kds = 'KDS',
  Pos = 'POS',
  Printer = 'Printer',
}

/** 虛擬印表機（邏輯列印機） */
export type VPrinter = {
  /** 配對方式 */
  bindMethod: PrinterBindMethod;
  brand: Brand;
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  deviceCode?: Maybe<Scalars['String']['output']>;
  displayOrder: Scalars['Int16']['output'];
  linkVPrinterPPrinters?: Maybe<Array<Maybe<LinkVPrinterPPrinter>>>;
  name?: Maybe<Scalars['String']['output']>;
  /** 紙張尺寸 */
  paperSize?: Maybe<PrinterPaperSize>;
  shop: Shop;
  shopID: Scalars['Int32']['output'];
  tickets?: Maybe<Array<Maybe<VPrinterTicket>>>;
  /** 印表機型態（出單紙/標籤） */
  type: PrinterType;
  updatedAt: Scalars['DateTimeZ']['output'];
  vPrinterID: Scalars['Int32']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type VPrinterKey = {
  shopKey: ShopKey;
  vPrinterID: Scalars['Int32']['input'];
};

/** 虛擬印表機 與 各類票據對應（ticket_*） */
export type VPrinterTicket = {
  brandID: Scalars['Int32']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  displayOrder: Scalars['Int16']['output'];
  of: TicketOf;
  shopID: Scalars['Int32']['output'];
  ticket?: Maybe<Ticket>;
  /** 指向對應 ticket_* 表（依 of 決定），此處不設外鍵 */
  ticketID: Scalars['Int32']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  vPrinterID: Scalars['Int32']['output'];
  workspaceID: Scalars['UUID']['output'];
};

export type Version = {
  buildTime: Scalars['String']['output'];
  gitCommit: Scalars['String']['output'];
  goVersion: Scalars['String']['output'];
  name: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

/** 影片 Hash 演算法 */
export enum VideoHashAlg {
  Sha1 = 'Sha1',
}

/** 影片媒體類型 */
export enum VideoMimeType {
  Mp4 = 'MP4',
  Webm = 'WEBM',
}

/** 作廢方式 */
export enum VoidMethod {
  /** 跨日作廢 (帳務歸屬於作廢日) */
  CrossDayVoid = 'CROSS_DAY_VOID',
  /** 交易日作廢 (帳務歸屬於交易日) */
  TransactionDayVoid = 'TRANSACTION_DAY_VOID',
}

/** 重量單位 */
export enum WeightUnit {
  /** 台斤 */
  Catty = 'Catty',
  /** 公克 */
  Gram = 'Gram',
  /** 公斤 */
  Kilogram = 'Kilogram',
  /** 盎司 */
  Ounce = 'Ounce',
  /** 磅 */
  Pound = 'Pound',
  /** 台兩 */
  Tael = 'Tael',
}

/** 總部工作區 */
export type Workspace = {
  brandCount: Scalars['Int']['output'];
  brands: Array<Brand>;
  /** 計算小數位數 */
  calcDecimalPlaces: Scalars['Int16']['output'];
  /** 計算進位方式 */
  calcRoundingRule: StandardRoundingRule;
  /** 結帳小數位數 */
  checkoutDecimalPlaces: Scalars['Int16']['output'];
  /** 結帳進位方式 */
  checkoutRoundingRule: StandardRoundingRule;
  /** 總部代碼-Unique */
  code: Scalars['String']['output'];
  country: Country;
  /** 國家 */
  countryID: Scalars['String']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  crossBrandPortalSettings: Array<CrossBrandPortalSetting>;
  currency: Currency;
  /** 貨幣 */
  currencyID: Scalars['String']['output'];
  /** 折扣顯示格式 */
  discountDisplayFormat: DiscountDisplayFormat;
  language: Language;
  /** 語言 */
  languageID: Scalars['String']['output'];
  /** 總部工作區名稱 */
  name: Scalars['String']['output'];
  shopCount: Scalars['Int']['output'];
  shops: Array<Shop>;
  timezone: Timezone;
  /** 時區 */
  timezoneID: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  /** 總部依用餐方式預設稅金 */
  workspaceDiningOptionDefaultTaxes: Array<WorkspaceDiningOptionDefaultTax>;
  workspaceID: Scalars['UUID']['output'];
  /** 總部ID */
  wsCode: Scalars['String']['output'];
};

/** 總部依用餐方式預設稅金 */
export type WorkspaceDiningOptionDefaultTax = {
  createdAt: Scalars['DateTimeZ']['output'];
  diningOptionType: DiningOptionType;
  taxGroup: TaxGroup;
  taxGroupID: Scalars['Int16']['output'];
  taxID: Scalars['Int16']['output'];
  taxUnit: TaxUnit;
  updatedAt: Scalars['DateTimeZ']['output'];
  workspace: Workspace;
  workspaceID: Scalars['UUID']['output'];
};

export type WorkspaceDiningOptionDefaultTaxInput = {
  diningOptionType: DiningOptionType;
  taxID: Scalars['Int16']['input'];
};

export type WorkspaceKey = {
  workspaceID: Scalars['UUID']['input'];
};

export type WorkspaceMember = {
  /** 會員卡號 */
  cardNumber: Scalars['String']['output'];
  createdAt: Scalars['DateTimeZ']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  memberID: Scalars['UUID']['output'];
  /** 會員來源 */
  memberSourceID: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspaceID: Scalars['UUID']['output'];
};

export type WorkspaceMemberTag = {
  createdAt: Scalars['DateTimeZ']['output'];
  memberID: Scalars['UUID']['output'];
  memberSourceID: Scalars['UUID']['output'];
  /** 標籤 */
  tag: Scalars['String']['output'];
  tagID: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTimeZ']['output'];
  workspaceID: Scalars['UUID']['output'];
};

export type WorkspacePermission = {
  permissions: Array<PermissionDetail>;
  roles: Array<LoginRole>;
  workspaceID: Scalars['UUID']['output'];
};

export type ListCountryAddressFormatsQueryVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
}>;

export type ListCountryAddressFormatsQuery = {
  listCountryAddressFormats: Record<string, unknown>;
};

export type ListCountiesQueryVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
}>;

export type ListCountiesQuery = {
  listCounties: Array<{ code: string; name: string }>;
};

export type ListTownsQueryVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
  code: Scalars['String']['input'];
}>;

export type ListTownsQuery = { listTowns: Array<string> };

export type GetAiWaiterSettingQueryVariables = Exact<{
  input: GetAiWaiterSettingInput;
}>;

export type GetAiWaiterSettingQuery = {
  getAIWaiterSetting: {
    setting: { activate: boolean };
    virtualHumans: Array<{
      selected: boolean;
      displayOrder?: number | null;
      virtualHuman: {
        virtualHumanID: string;
        name: string;
        disabled: boolean;
        image?: { hash: string } | null;
      };
    }>;
  };
};

export type SetAiWaiterSettingMutationVariables = Exact<{
  input: SetAiWaiterSettingInput;
}>;

export type SetAiWaiterSettingMutation = {
  setAIWaiterSetting: {
    success: boolean;
    data?: Record<string, unknown> | null;
  };
};

export type GetAiWaiterVirtualHumansQueryVariables = Exact<{
  input: GetAiWaiterVirtualHumansInput;
}>;

export type GetAiWaiterVirtualHumansQuery = {
  getAIWaiterVirtualHumans: Array<{
    selected: boolean;
    displayOrder?: number | null;
    virtualHuman: {
      virtualHumanID: string;
      name: string;
      nameLang: Record<string, unknown>;
      disabled: boolean;
      formality: AiWaiterFormality;
      responseLength: AiWaiterResponseLength;
      speechRate: number;
      currentVoiceID?: string | null;
      image?: { hash: string } | null;
      languages: Array<{ languageID: string }>;
      voices: Array<{
        voiceID: string;
        source: AiWaiterVoiceSource;
        status: AiWaiterVoiceStatus;
        voiceType: AiWaiterVoiceType;
        uploadHash?: string | null;
        providerVoiceReference?: string | null;
      }>;
    };
    previewVideo: {
      status: AiWaiterPreviewVideoStatus;
      video?: { hash: string } | null;
    };
  }>;
};

export type PutAiWaiterVirtualHumanImageMutationVariables = Exact<{
  input: PutAiWaiterVirtualHumanImageInput;
}>;

export type PutAiWaiterVirtualHumanImageMutation = {
  putAIWaiterVirtualHumanImage: {
    virtualHumanID: string;
    hash: string;
    providerStatus: string;
  };
};

export type PutAiWaiterVirtualHumanVoiceMutationVariables = Exact<{
  input: PutAiWaiterVirtualHumanVoiceInput;
}>;

export type PutAiWaiterVirtualHumanVoiceMutation = {
  putAIWaiterVirtualHumanVoice: { virtualHumanID: string; uploadHash: string };
};

export type UpsertAiWaiterVirtualHumanMutationVariables = Exact<{
  input: UpsertAiWaiterVirtualHumanInput;
}>;

export type UpsertAiWaiterVirtualHumanMutation = {
  upsertAIWaiterVirtualHuman: {
    virtualHumanID: string;
    name: string;
    speechRate: number;
    formality: AiWaiterFormality;
    responseLength: AiWaiterResponseLength;
    languages: Array<{
      virtualHumanID: string;
      languageID: string;
      createdAt: string;
    }>;
  };
};

export type GetAppsListQueryVariables = Exact<{
  shopKey: ShopKey;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  pageInput: CursorPageInput;
}>;

export type GetAppsListQuery = {
  getAppsList: {
    apps: Array<{
      hasSettingsSchema: boolean;
      app: {
        appID: string;
        name: string;
        appType: AppType;
        slug?: string | null;
        logo?: string | null;
        isPublished: boolean;
        multipleBindSettingsEnabled?: boolean | null;
        createdAt: string;
        updatedAt: string;
      };
    }>;
    pageInfo: { prevCursor?: string | null; nextCursor?: string | null };
  };
};

export type GetAppSchemasQueryVariables = Exact<{
  appID: Scalars['UUID']['input'];
}>;

export type GetAppSchemasQuery = {
  getAppSchemas: {
    bindSettingsSchema?: Record<string, unknown> | null;
    posSettingsSchema: Record<string, unknown>;
  };
};

export type GetAppFormatDetailQueryVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
  brandID: Scalars['Int32']['input'];
  shopID: Scalars['Int32']['input'];
  appID: Scalars['UUID']['input'];
}>;

export type GetAppFormatDetailQuery = {
  getAppFormatDetail?: {
    bindSettings: Record<string, unknown>;
    posSettings: Record<string, unknown>;
  } | null;
};

export type ListShopCustomPaymentMethodsQueryVariables = Exact<{
  shopKey: ShopKey;
}>;

export type ListShopCustomPaymentMethodsQuery = {
  listShopCustomPaymentMethods: Array<{
    brandPaymentMethodID: number;
    brandPaymentMethod: { name: string };
  }>;
};

export type UpdateSubscriberSettingsMutationVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
  brandID: Scalars['Int32']['input'];
  shopID: Scalars['Int32']['input'];
  appID: Scalars['UUID']['input'];
  bindSettings?: InputMaybe<Scalars['JSON']['input']>;
  posSettings?: InputMaybe<Scalars['JSON']['input']>;
}>;

export type UpdateSubscriberSettingsMutation = {
  updateSubscriberSettings: boolean;
};

export type ListSubBrandsQueryVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
  brandID: Scalars['Int32']['input'];
}>;

export type ListSubBrandsQuery = {
  listSubBrands: {
    subBrands: Array<{
      subBrandID: number;
      brandID: number;
      name: string;
      displayOrder: number;
      shops: Array<{
        brandID: number;
        subBrandID?: number | null;
        shopID: number;
        name: string;
        code?: string | null;
        timezoneID: string;
      }>;
    }>;
    uncategorizedShops: Array<{
      brandID: number;
      subBrandID?: number | null;
      shopID: number;
      name: string;
      code?: string | null;
      timezoneID: string;
    }>;
  };
};

export type ListBrandsQueryVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
}>;

export type ListBrandsQuery = {
  listBrands: Array<{
    brandID: number;
    name: string;
    code: string;
    displayOrder: number;
    businessDayCutoffTime: string;
    subBrands: Array<{
      subBrandID: number;
      name: string;
      displayOrder: number;
    }>;
  }>;
};

export type CountShopsQueryVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
}>;

export type CountShopsQuery = {
  countShops: Array<{ brandID: number; count: number }>;
};

export type BrandPageListShopsQueryVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
  brandID: Scalars['Int32']['input'];
}>;

export type BrandPageListShopsQuery = {
  listShops: Array<{
    shopID: number;
    name: string;
    code?: string | null;
    subBrandID?: number | null;
  }>;
};

export type UpdateShopsMutationVariables = Exact<{
  input: UpdateShopInput;
}>;

export type UpdateShopsMutation = { updateShops: boolean };

export type UpdateBrandDisplayOrderMutationVariables = Exact<{
  input: UpdateBrandOrderInput;
}>;

export type UpdateBrandDisplayOrderMutation = {
  updateBrandDisplayOrder: boolean;
};

export type UpsertBrandMutationVariables = Exact<{
  input: UpsertBrandInput;
}>;

export type UpsertBrandMutation = { upsertBrand: boolean };

export type BrandShopListQueryVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
}>;

export type BrandShopListQuery = {
  listBrands: Array<{
    brandID: number;
    name: string;
    subBrands: Array<{
      subBrandID: number;
      name: string;
      shops: Array<{ name: string; shopID: number; code?: string | null }>;
    }>;
    uncategorizedShops: Array<{
      name: string;
      shopID: number;
      code?: string | null;
    }>;
  }>;
};

export type ListBundlesQueryVariables = Exact<{
  brandKey: BrandKey;
  bundleType?: InputMaybe<BundleType>;
  searchName?: InputMaybe<Scalars['String']['input']>;
  pageInput: CursorPageInput;
}>;

export type ListBundlesQuery = {
  listBundles: {
    bundles?: Array<{
      bundleID: number;
      bundleType: BundleType;
      name: string;
      id: number;
      bundleItems: Array<{ itemID: number }>;
      itemBundles?: Array<{ itemID: number }> | null;
    }> | null;
    pageInfo: { nextCursor?: string | null; prevCursor?: string | null };
  };
};

export type DeleteBundlesMutationVariables = Exact<{
  brandKey: BrandKey;
  bundleIDs: Array<Scalars['Int32']['input']> | Scalars['Int32']['input'];
}>;

export type DeleteBundlesMutation = { deleteBundles: boolean };

export type GetABundleDetailQueryVariables = Exact<{
  brandKey: BrandKey;
  bundleID: Scalars['Int32']['input'];
}>;

export type GetABundleDetailQuery = {
  getABundleDetail?: {
    name: string;
    bundleID: number;
    bundleType: BundleType;
    selectableMinCount: number;
    selectableMaxCount: number;
    sameItemSelectableMaxCount: number;
    updatedAt: string;
    bundleItems: Array<{
      bundleID: number;
      itemID: number;
      displayOrder: number;
      item: { itemID: number; name: string; itemKind: ItemKind };
      bundleItemItemPriceOptions: Array<{
        price: number;
        itemPriceOptionID: number;
        defaultSelectCount: number;
        displayOrder: number;
        itemPriceOption: { name: string };
      }>;
    }>;
  } | null;
};

export type BundleListItemCategoriesQueryVariables = Exact<{
  brandKey: BrandKey;
  pageInput: CursorPageInput;
  itemCategoryID?: InputMaybe<Scalars['Int32']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  itemKind?: InputMaybe<ItemKind>;
  includeUncategorized: Scalars['Boolean']['input'];
}>;

export type BundleListItemCategoriesQuery = {
  listItemCategories: {
    itemCategories?: Array<{
      itemCategoryID: number;
      name: string;
      code: string;
      id: number;
      items: Array<{
        itemID: number;
        name: string;
        code: string;
        itemKind: ItemKind;
        id: number;
        itemPriceOptions: Array<{
          itemPriceOptionID: number;
          name: string;
          itemCode: string;
          price: number;
          priceType: ItemPriceType;
          displayOrder: number;
        }>;
        itemCategory?: { name: string } | null;
      }>;
    }> | null;
    uncategorizedItems?: Array<{
      itemID: number;
      name: string;
      code: string;
      itemKind: ItemKind;
      id: number;
      itemImages: Array<{
        hash: string;
        itemImageThumbs: Array<{ hash: string }>;
      }>;
      itemPriceOptions: Array<{
        itemPriceOptionID: number;
        name: string;
        itemCode: string;
        price: number;
        priceType: ItemPriceType;
        displayOrder: number;
      }>;
    }> | null;
    pageInfo: { nextCursor?: string | null; prevCursor?: string | null };
  };
};

export type DuplicateABundleMutationVariables = Exact<{
  bundleKey: BundleKey;
}>;

export type DuplicateABundleMutation = { duplicateABundle: boolean };

export type UpdateABundleMutationVariables = Exact<{
  bundleKey: BundleKey;
  bundleInput: BundleInput;
}>;

export type UpdateABundleMutation = { updateABundle: boolean };

export type CreateABundleMutationVariables = Exact<{
  brandKey: BrandKey;
  bundleInput: BundleInput;
}>;

export type CreateABundleMutation = { createABundle: { bundleID: number } };

export type ListCashDrawersQueryVariables = Exact<{
  shopKey: ShopKey;
  cashDrawerSearchParams: CashDrawerSearchParams;
  pageInput: CursorPageInput;
}>;

export type ListCashDrawersQuery = {
  listCashDrawers: {
    cashDrawerTransactions?: Array<{
      createdAt: string;
      opUserID?: string | null;
      transactionType: CashDrawerTransactionType;
      openReason?: string | null;
      amount: number;
      opUser?: { firstName?: string | null; lastName?: string | null } | null;
      vDevice: { name: string };
    }> | null;
    pageInfo: { nextCursor?: string | null; prevCursor?: string | null };
  };
};

export type ExportCashDrawerTransactionsMutationVariables = Exact<{
  input: ExportCashDrawerTransactionsInput;
}>;

export type ExportCashDrawerTransactionsMutation = {
  exportCashDrawerTransactions: string;
};

export type CategoryListItemCategoriesQueryVariables = Exact<{
  brandKey: BrandKey;
  itemCategoryID?: InputMaybe<Scalars['Int32']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  pageInput: CursorPageInput;
}>;

export type CategoryListItemCategoriesQuery = {
  listItemCategories: {
    itemCategories?: Array<{
      itemCategoryID: number;
      name: string;
      displayOrder: number;
      code: string;
      id: number;
      items: Array<{ itemID: number; id?: number | null }>;
    }> | null;
    pageInfo: { nextCursor?: string | null; prevCursor?: string | null };
  };
};

export type UpdateItemCategoryDisplayOrderMutationVariables = Exact<{
  input: UpdateItemCategoryOrderInput;
}>;

export type UpdateItemCategoryDisplayOrderMutation = {
  updateItemCategoryDisplayOrder: boolean;
};

export type ListItemCategoriesOrderQueryVariables = Exact<{
  brandKey: BrandKey;
  itemCategoryID?: InputMaybe<Scalars['Int32']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  pageInput: CursorPageInput;
}>;

export type ListItemCategoriesOrderQuery = {
  listItemCategories: {
    itemCategories?: Array<{
      itemCategoryID: number;
      name: string;
      displayOrder: number;
      code: string;
      id: number;
    }> | null;
  };
};

export type DeleteItemCategoriesMutationVariables = Exact<{
  input: DeleteItemCategoriesInput;
}>;

export type DeleteItemCategoriesMutation = { deleteItemCategories: boolean };

export type ListDiscountItemCategoriesQueryVariables = Exact<{
  brandKey: BrandKey;
  itemCategoryID?: InputMaybe<Scalars['Int32']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  pageInput: CursorPageInput;
}>;

export type ListDiscountItemCategoriesQuery = {
  listItemCategories: {
    itemCategories?: Array<{
      itemCategoryID: number;
      name: string;
      code: string;
      id: number;
    }> | null;
    pageInfo: { nextCursor?: string | null; prevCursor?: string | null };
  };
};

export type CategoryEditListItemCategoriesQueryVariables = Exact<{
  brandKey: BrandKey;
  itemCategoryID?: InputMaybe<Scalars['Int32']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  pageInput: CursorPageInput;
}>;

export type CategoryEditListItemCategoriesQuery = {
  listItemCategories: {
    itemCategories?: Array<{
      itemCategoryID: number;
      name: string;
      code: string;
      updatedAt: string;
      id: number;
      items: Array<{
        itemID: number;
        name: string;
        code: string;
        id: number;
        itemPriceOptions: Array<{ itemCode: string }>;
      }>;
    }> | null;
  };
};

export type CategoryEditListItemsQueryVariables = Exact<{
  brandKey: BrandKey;
  itemCategoryIDs?: InputMaybe<
    Array<Scalars['Int32']['input']> | Scalars['Int32']['input']
  >;
  itemKind?: InputMaybe<ItemKind>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  hasItemCategory?: InputMaybe<Scalars['Boolean']['input']>;
  subBrandShop?: InputMaybe<SubBrandShop>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  pageInput: CursorPageInput;
}>;

export type CategoryEditListItemsQuery = {
  listItems: {
    items: Array<{
      itemID: number;
      name: string;
      code: string;
      itemCategoryID?: number | null;
      itemKind: ItemKind;
      itemPriceOptions: Array<{ itemCode: string; price: number }>;
    }>;
    pageInfo: { nextCursor?: string | null; prevCursor?: string | null };
  };
};

export type UpdateItemCategoryMutationVariables = Exact<{
  input: UpdateItemCategoryInput;
}>;

export type UpdateItemCategoryMutation = { updateItemCategory: boolean };

export type CreateItemCategoryMutationVariables = Exact<{
  input: CreateItemCategoryInput;
}>;

export type CreateItemCategoryMutation = { createItemCategory?: number | null };

export type GetCdsBrandSettingQueryVariables = Exact<{
  brandKey: BrandKey;
}>;

export type GetCdsBrandSettingQuery = {
  getCDSBrandSetting: {
    cdsBrandSetting?: {
      displayMode: CdsDisplayMode;
      carouselDuration: number;
      showWhenOrdering: boolean;
      showOrderDetail: boolean;
      orderDetailSort: CdsOrderDetailSort;
      orderDetailDisplayStyle: CdsOrderDetailDisplayStyle;
      notDisplayComposeNameWhenZeroPrice: boolean;
    } | null;
    cdsFixedAd?: Array<{
      workspaceID: string;
      brandID: number;
      adID: number;
      name: string;
      hash: string;
      alg: string;
      mime: string;
      width: number;
      height: number;
      fileSize: number;
      displayOrder: number;
      effectiveStartTime?: string | null;
      effectiveEndTime?: string | null;
      shopApplyMode: ShopApplyMode;
      linkCDSFixedAdShop: Array<{ shopID: number }>;
    } | null> | null;
    cdsCarouselAd?: Array<{
      workspaceID: string;
      brandID: number;
      adID: number;
      name: string;
      hash: string;
      alg: string;
      mime: string;
      width: number;
      height: number;
      fileSize: number;
      duration: number;
      displayOrder: number;
      effectiveStartTime?: string | null;
      effectiveEndTime?: string | null;
      shopApplyMode: ShopApplyMode;
      linkCDSCarouselAdShop: Array<{ shopID: number }>;
    } | null> | null;
  };
};

export type SaveCdsBrandSettingMutationVariables = Exact<{
  brandKey: BrandKey;
  cdsBrandSettingInput: CdsBrandSettingInput;
  mainPageCDSCarouselAdInput?: InputMaybe<
    | Array<InputMaybe<MainPageCdsCarouselAdInput>>
    | InputMaybe<MainPageCdsCarouselAdInput>
  >;
  mainPageCDSFixedAdInput?: InputMaybe<
    | Array<InputMaybe<MainPageCdsFixedAdInput>>
    | InputMaybe<MainPageCdsFixedAdInput>
  >;
}>;

export type SaveCdsBrandSettingMutation = { saveCDSBrandSetting: boolean };

export type UploadCdsFixedAdMutationVariables = Exact<{
  brandKey: BrandKey;
  cdsFixedAdWithFileInput: CdsFixedAdWithFileInput;
}>;

export type UploadCdsFixedAdMutation = { uploadCDSFixedAd: number };

export type UploadCdsCarouselAdMutationVariables = Exact<{
  brandKey: BrandKey;
  cdsCarouselAdWithFileInput: CdsCarouselAdWithFileInput;
}>;

export type UploadCdsCarouselAdMutation = { uploadCDSCarouselAd: number };

export type DeleteCdsAdMutationVariables = Exact<{
  brandKey: BrandKey;
  cdsFixedAdID?: InputMaybe<
    | Array<InputMaybe<Scalars['Int32']['input']>>
    | InputMaybe<Scalars['Int32']['input']>
  >;
  cdsCarouselAdID?: InputMaybe<
    | Array<InputMaybe<Scalars['Int32']['input']>>
    | InputMaybe<Scalars['Int32']['input']>
  >;
}>;

export type DeleteCdsAdMutation = { deleteCDSAd: boolean };

export type UpdateCdsFixedAdMutationVariables = Exact<{
  brandKey: BrandKey;
  cdsFixedAdWithFileInput: CdsFixedAdWithFileInput;
}>;

export type UpdateCdsFixedAdMutation = { updateCDSFixedAd: boolean };

export type UpdateCdsCarouselAdMutationVariables = Exact<{
  brandKey: BrandKey;
  cdsCarouselAdWithFileInput: CdsCarouselAdWithFileInput;
}>;

export type UpdateCdsCarouselAdMutation = { updateCDSCarouselAd: boolean };

export type ListAShiftCloseReportQueryVariables = Exact<{
  reportKey: ReportKey;
}>;

export type ListAShiftCloseReportQuery = {
  listAShiftCloseReport?: Record<string, unknown> | null;
};

export type ListAEodCloseReportQueryVariables = Exact<{
  reportKey: ReportKey;
}>;

export type ListAEodCloseReportQuery = {
  listAEodCloseReport?: Record<string, unknown> | null;
};

export type ExportAShiftCloseReportCsvFileMutationVariables = Exact<{
  input: ExportAShiftCloseReportCsvFileInput;
}>;

export type ExportAShiftCloseReportCsvFileMutation = {
  exportAShiftCloseReportCSVFile: string;
};

export type ExportAEodReportCsvFileMutationVariables = Exact<{
  input: ExportAEodReportCsvFileInput;
}>;

export type ExportAEodReportCsvFileMutation = {
  exportAEodReportCSVFile: string;
};

export type ListShiftCloseReportsQueryVariables = Exact<{
  shopKey: ShopKey;
  shiftCloseSearchParams: ShiftCloseReportSearchParams;
  pageInput: CursorPageInput;
}>;

export type ListShiftCloseReportsQuery = {
  listShiftCloseReports: {
    shiftCloseReports?: Array<{
      shiftStartTime: string;
      shiftCloseTime: string;
      operatorName: string;
      deviceName: string;
      revenue: number;
      totalVoidCount: number;
      totalVoidAmount: number;
      reserveCash: number;
      countedCash: number;
      expectedCash: number;
      cashShortOver: number;
      reportID?: string | null;
      vDeviceID?: number | null;
    }> | null;
    pageInfo: { nextCursor?: string | null; prevCursor?: string | null };
  };
};

export type ListEodCloseReportsQueryVariables = Exact<{
  shopKey: ShopKey;
  eodCloseSearchParams: EodCloseReportSearchParams;
  pageInput: CursorPageInput;
}>;

export type ListEodCloseReportsQuery = {
  listEodCloseReports: {
    eodCloseReports?: Array<{
      businessCloseTime: string;
      operatorName: string;
      deviceName: string;
      closeStatus: string;
      revenue: number;
      orderNet: number;
      offline: number;
      online: number;
      totalVoidCount: number;
      totalVoidAmount: number;
      reportID?: string | null;
      vDeviceID?: number | null;
    }> | null;
    pageInfo: { nextCursor?: string | null; prevCursor?: string | null };
  };
};

export type ExportShiftCloseReportsCsvFileMutationVariables = Exact<{
  input: ExportShiftCloseReportsCsvInput;
}>;

export type ExportShiftCloseReportsCsvFileMutation = {
  exportShiftCloseReportsCSVFile: string;
};

export type ExportEodReportsCsvFileMutationVariables = Exact<{
  input: ExportEodReportsCsvFileInput;
}>;

export type ExportEodReportsCsvFileMutation = {
  exportEodReportsCSVFile: string;
};

export type GetShopContainerWeightManagementQueryVariables = Exact<{
  shopKey: ShopKey;
}>;

export type GetShopContainerWeightManagementQuery = {
  getShopContainerWeightManagement: {
    shopContainerSettings?: { activate: boolean } | null;
    shopContainers: Array<{
      containerID: number;
      name: string;
      weight?: number | null;
      weightUnit: WeightUnit;
      displayOrder: number;
      activate: boolean;
    }>;
    shopDiningOptionContainers: Array<{
      brandDiningOptionID: number;
      containerID: number;
      shopContainer: {
        containerID: number;
        name: string;
        weight?: number | null;
        weightUnit: WeightUnit;
      };
      shopDiningOption: {
        brandDiningOption: {
          brandDiningOptionID: number;
          name: string;
          diningOptionType: DiningOptionType;
        };
      };
    }>;
  };
};

export type GetShopDiningOptionsForContainerWeightQueryVariables = Exact<{
  shopKey: ShopKey;
}>;

export type GetShopDiningOptionsForContainerWeightQuery = {
  getShopDiningOptions: Array<{
    disabled: boolean;
    displayOrder: number;
    brandDiningOptionID: number;
    brandDiningOption: {
      brandDiningOptionID: number;
      disabled: boolean;
      name: string;
      diningOptionType: DiningOptionType;
    };
  }>;
};

export type UpsertShopContainersMutationVariables = Exact<{
  input: UpsertShopContainersInput;
}>;

export type UpsertShopContainersMutation = { upsertShopContainers: boolean };

export type UpdateShopContainerWeightManagementMutationVariables = Exact<{
  input: UpdateShopContainerWeightManagementInput;
}>;

export type UpdateShopContainerWeightManagementMutation = {
  updateShopContainerWeightManagement: boolean;
};

export type ListDevicesQueryVariables = Exact<{
  shopKey: ShopKey;
  deviceType?: InputMaybe<VDeviceType>;
  pageInput: CursorPageInput;
}>;

export type ListDevicesQuery = {
  listDevices: {
    boughtNum: number;
    boundNum: number;
    vDevices?: Array<{
      shopID: number;
      vDeviceID: number;
      name: string;
      deviceType: VDeviceType;
      deviceCode: string;
      isBound: boolean;
      isCds?: boolean | null;
      isCashier: boolean;
      posOrderStyle?: PosOrderStyle | null;
      autoCheckoutOnConfirm?: boolean | null;
      isServiceHub: boolean;
      boundAt?: string | null;
      pDevice?: {
        name: string;
        deviceCode: string;
        pDeviceEvents: Array<{
          deviceInfo?: Record<string, unknown> | null;
          createdAt: string;
        }>;
      } | null;
    }> | null;
    pageInfo: { nextCursor?: string | null; prevCursor?: string | null };
  };
};

export type UnregisterTheServiceHubMutationVariables = Exact<{
  vDeviceKey: VDeviceKey;
}>;

export type UnregisterTheServiceHubMutation = {
  unregisterTheServiceHub: boolean;
};

export type UnbindTheVDeviceMutationVariables = Exact<{
  vDeviceKey: VDeviceKey;
}>;

export type UnbindTheVDeviceMutation = { unbindTheVDevice: boolean };

export type ListBindableEquipmentAppsQueryVariables = Exact<{
  shopKey: ShopKey;
}>;

export type ListBindableEquipmentAppsQuery = {
  listBindableEquipmentApps: Array<{
    appID: string;
    name: string;
    slug?: string | null;
  }>;
};

export type ListVDeviceEquipmentsQueryVariables = Exact<{
  vDeviceKey: VDeviceKey;
}>;

export type ListVDeviceEquipmentsQuery = {
  listVDeviceEquipments: Array<{
    equipmentID: number;
    name: string;
    appID: string;
    bindSettingID: string;
    app?: { appID: string; name: string; slug?: string | null } | null;
  }>;
};

export type DiningOptionListShopsQueryVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
  brandID: Scalars['Int32']['input'];
}>;

export type DiningOptionListShopsQuery = {
  listShops: Array<{ shopID: number; name: string }>;
};

export type DiningOptionListBrandDiningOptionsQueryVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
  brandID: Scalars['Int32']['input'];
}>;

export type DiningOptionListBrandDiningOptionsQuery = {
  listBrandDiningOptions: Array<{
    brandDiningOptionID: number;
    disabled: boolean;
    diningOptionType: DiningOptionType;
    name: string;
    createdAt: string;
    id: number;
  }>;
};

export type AddBrandDiningOptionsMutationVariables = Exact<{
  input: Array<AddBrandDiningOptionInput> | AddBrandDiningOptionInput;
}>;

export type AddBrandDiningOptionsMutation = {
  addBrandDiningOptions: Array<{
    brandDiningOptionID: number;
    disabled: boolean;
    diningOptionType: DiningOptionType;
    name: string;
  }>;
};

export type DelBrandDiningOptionsMutationVariables = Exact<{
  input: DelBrandDiningOptionsInput;
}>;

export type DelBrandDiningOptionsMutation = { delBrandDiningOptions: boolean };

export type SetBrandDiningOptionsMutationVariables = Exact<{
  input: Array<SetBrandDiningOptionInput> | SetBrandDiningOptionInput;
}>;

export type SetBrandDiningOptionsMutation = {
  setBrandDiningOptions: Array<{
    brandDiningOptionID: number;
    disabled: boolean;
    diningOptionType: DiningOptionType;
    name: string;
  }>;
};

export type ListShopsDetailQueryVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
  brandID: Scalars['Int32']['input'];
  shopID?: InputMaybe<Scalars['Int32']['input']>;
}>;

export type ListShopsDetailQuery = {
  listShops: Array<{
    shopID: number;
    name: string;
    diningOptionSelectMode: DiningOptionSelectMode;
    presetBrandDiningOptionID?: number | null;
    id: number;
    presetBrandDiningOption?: {
      name: string;
      brandDiningOptionID: number;
    } | null;
    shopDiningOptions: Array<{
      displayOrder: number;
      disabled: boolean;
      brandDiningOption: {
        brandDiningOptionID: number;
        name: string;
        diningOptionType: DiningOptionType;
        disabled: boolean;
        id: number;
      };
    }>;
    shopDiningOptionTableSettings: Array<{
      brandDiningOptionID: number;
      activate: boolean;
      mealTimeAlertEnabled: boolean;
      mealTimeLimitMinutes: number;
    }>;
  }>;
};

export type UpdateShopDiningOptionsMutationVariables = Exact<{
  input: UpdateShopDiningOptionInput;
}>;

export type UpdateShopDiningOptionsMutation = {
  updateShopDiningOptions: boolean;
};

export type GetDiningOptionsQueryVariables = Exact<{
  shopKey: ShopKey;
}>;

export type GetDiningOptionsQuery = {
  getDiningOptions: {
    shopO2OSetting?: {
      pickupActivate: boolean;
      deliveryActivate: boolean;
      pickupMethod?: string | null;
      deliverMethod?: string | null;
    } | null;
    scanOrderSettingDiningIn?: {
      scanOrderDiningInActivate: boolean;
      brandDiningOptionID?: number | null;
    } | null;
    scanOrderSettingTakeOut?: {
      scanOrderTakeOutActivate: boolean;
      brandDiningOptionID?: number | null;
    } | null;
  };
};

export type ListDiscountsQueryVariables = Exact<{
  brandKey: BrandKey;
  filterStatus?: InputMaybe<Scalars['String']['input']>;
  filterType?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  pageInput: CursorPageInput;
}>;

export type ListDiscountsQuery = {
  listDiscounts: {
    discounts?: Array<{
      discountID: number;
      type: DiscountType;
      name: string;
      code: string;
      barcode: string;
      color: string;
      status: DiscountStatus;
      startTime: string;
      endTime: string;
      exec: {
        method: DiscountExecMethod;
        apiSource?: DiscountExecApiSource | null;
        promoCode?: string | null;
      };
      selChannels?: Array<{ channel: DiscountChannel }> | null;
    }> | null;
    pageInfo: { nextCursor?: string | null; prevCursor?: string | null };
  };
};

export type UpdateStatusOfDiscountsMutationVariables = Exact<{
  brandKey: BrandKey;
  discountIDs: Array<Scalars['Int32']['input']> | Scalars['Int32']['input'];
  op: DiscountOp;
}>;

export type UpdateStatusOfDiscountsMutation = {
  updateStatusOfDiscounts: boolean;
};

export type ListPrioritiesOfDiscountsQueryVariables = Exact<{
  brandKey: BrandKey;
  filterPriorityCategory: PriorityCategory;
}>;

export type ListPrioritiesOfDiscountsQuery = {
  listPrioritiesOfDiscounts?: Array<{
    discountID: number;
    name: string;
    code: string;
    type: DiscountType;
    priority: number;
  }> | null;
};

export type UpdatePrioritiesOfDiscountsMutationVariables = Exact<{
  brandKey: BrandKey;
  filterPriorityCategory: PriorityCategory;
  discountPriorityList: Array<IdValuePairInput> | IdValuePairInput;
}>;

export type UpdatePrioritiesOfDiscountsMutation = {
  updatePrioritiesOfDiscounts: boolean;
};

export type ListDisplayOrdersOfDiscountsQueryVariables = Exact<{
  brandKey: BrandKey;
  sortInput?: InputMaybe<SortInput>;
}>;

export type ListDisplayOrdersOfDiscountsQuery = {
  listDisplayOrdersOfDiscounts?: Array<{
    discountID: number;
    type: DiscountType;
    name: string;
    code: string;
    displayOrder: number;
  }> | null;
};

export type UpdateDisplayOrdersOfDiscountsMutationVariables = Exact<{
  brandKey: BrandKey;
  discountDisplayOrderList: Array<IdValuePairInput> | IdValuePairInput;
}>;

export type UpdateDisplayOrdersOfDiscountsMutation = {
  updateDisplayOrdersOfDiscounts: boolean;
};

export type UpsertDiscountMutationVariables = Exact<{
  brandKey: BrandKey;
  baseInfo: DiscountBaseInfoInput;
  advNames?: InputMaybe<Array<DiscountAdvNameInput> | DiscountAdvNameInput>;
  criteria: DiscountCriteriaInput;
  content: DiscountContentInput;
  selItems?: InputMaybe<Array<DiscountSelItemInput> | DiscountSelItemInput>;
  selItemCategoryIDs?: InputMaybe<
    | Array<InputMaybe<Scalars['Int32']['input']>>
    | InputMaybe<Scalars['Int32']['input']>
  >;
  giftItems?: InputMaybe<Array<DiscountSelItemInput> | DiscountSelItemInput>;
  giftItemCategoryIDs?: InputMaybe<
    | Array<InputMaybe<Scalars['Int32']['input']>>
    | InputMaybe<Scalars['Int32']['input']>
  >;
  exec: DiscountExecInput;
  dayTimes?: InputMaybe<Array<DiscountDayTimeInput> | DiscountDayTimeInput>;
  selShopDiningOptions?: InputMaybe<
    Array<DiscountSelShopDiningOptionInput> | DiscountSelShopDiningOptionInput
  >;
  selShopIDs?: InputMaybe<
    | Array<InputMaybe<Scalars['Int32']['input']>>
    | InputMaybe<Scalars['Int32']['input']>
  >;
  selSubBrandIDs?: InputMaybe<
    | Array<InputMaybe<Scalars['Int32']['input']>>
    | InputMaybe<Scalars['Int32']['input']>
  >;
  selChannels: Array<DiscountSelChannelInput> | DiscountSelChannelInput;
  deliveryFeeDistanceTiers?: InputMaybe<
    | Array<DiscountDeliveryFeeDistanceTierInput>
    | DiscountDeliveryFeeDistanceTierInput
  >;
}>;

export type UpsertDiscountMutation = { upsertDiscount?: number | null };

export type GetADiscountQueryVariables = Exact<{
  discountKey: DiscountKey;
}>;

export type GetADiscountQuery = {
  getADiscount?: {
    discountID: number;
    activate: boolean;
    status: DiscountStatus;
    type: DiscountType;
    name: string;
    code: string;
    barcode: string;
    color: string;
    shopDiningOptionApplyMode: ShopDiningOptionApplyMode;
    targetType: DiscountTargetType;
    calcMethod: DiscountCalcMethod;
    discountServiceFeeEnabled: boolean;
    discountMinChargeEnabled: boolean;
    specifiedDayTimeEnabled: boolean;
    dayTimeType?: DiscountDayTimeType | null;
    shopApplyMode: ShopApplyMode;
    startTime: string;
    endTime: string;
    updatedAt: string;
    id: number;
    advNames?: Array<{ advNameType: DiscountAdvNameType; name: string }> | null;
    criteria: {
      amountRequired?: boolean | null;
      amountThreshold?: number | null;
      otherFeeIncluded?: boolean | null;
      quantityRequired?: boolean | null;
      quantityThreshold?: number | null;
      itemMinPriceLimited?: boolean | null;
      itemMinPrice?: number | null;
      crossDayRefundDisabled: boolean;
      itemLimitType?: DiscountItemLimitType | null;
      combineOrderEnabled: boolean;
      combineItemEnabled: boolean;
      deliveryFeeConditionType?: DiscountDeliveryFeeConditionType | null;
    };
    content: {
      type: DiscountContentType;
      method?: DiscountMethod | null;
      giftItemCount?: number | null;
      specifiedItemCount?: number | null;
      maxUsagePerOrderEnabled?: boolean | null;
      maxUsagePerOrder?: number | null;
      value?: number | null;
      deliveryFeeDiscountAmount?: number | null;
    };
    deliveryFeeDistanceTiers?: Array<{
      tierID: number;
      startDistanceKm?: number | null;
      endDistanceKm: number;
      minOrderAmount: number;
    }> | null;
    selItems?: Array<{
      itemID: number;
      itemPriceOptionID: number;
      postDiscountPrice: number;
      item: { name: string };
      itemPriceOption: { price: number; name: string; displayOrder: number };
    }> | null;
    selItemCategories?: Array<{
      itemCategoryID: number;
      itemCategory: { name: string; code: string };
    }> | null;
    giftItems?: Array<{
      itemID: number;
      itemPriceOptionID: number;
      item: { name: string };
      itemPriceOption: { price: number; name: string; displayOrder: number };
    }> | null;
    giftItemCategories?: Array<{
      itemCategoryID: number;
      itemCategory: { name: string; code: string };
    }> | null;
    exec: {
      method: DiscountExecMethod;
      applyMode?: DiscountExecApplyMode | null;
      applyPriority?: DiscountExecApplyPriority | null;
      onlineOrderApplyPriority?: OnlineOrderDiscountExecApplyPriority | null;
      apiSource?: DiscountExecApiSource | null;
      offlineStaffDiscountSelectionEnabled?: boolean | null;
      promoCode?: string | null;
      promoCodeUsageLimitEnabled?: boolean | null;
      promoCodeUsageLimit?: number | null;
    };
    selChannels?: Array<{ channel: DiscountChannel }> | null;
    selShops?: Array<{ shopID: number }> | null;
    selSubBrands?: Array<{ subBrandID: number }> | null;
    selShopDiningOptions?: Array<{
      shopID: number;
      brandDiningOptionID: number;
    }> | null;
    dayTimes?: Array<{
      timeID: number;
      weekDay?: number | null;
      startTime: string;
      endTime: string;
    }> | null;
  } | null;
};

export type CloneADiscountMutationVariables = Exact<{
  discountKey: DiscountKey;
}>;

export type CloneADiscountMutation = { cloneADiscount: boolean };

export type GetDiscountsOverviewReportBucketsQueryVariables = Exact<{
  filter: ReportDiscountsOverviewInput;
}>;

export type GetDiscountsOverviewReportBucketsQuery = {
  getDiscountsOverviewReportBuckets: {
    groupBy: ReportDiscountGroupMode;
    totalAmount: string;
    totalQuantity: number;
    amountPercentOfAll: Array<{ discountName: string; percent: number }>;
    quantityPercentOfAll: Array<{ discountName: string; percent: number }>;
    groups: Array<{
      key?: string | null;
      name?: string | null;
      discountQuantity: number;
      discountQuantityPercent: number;
      discountAmount: number;
      discountAmountPercent: number;
      itemData: Array<{
        rank: number;
        discountID: number;
        discountName: string;
        discountCode: string;
        discountType: string;
        diningOptionName: string;
        diningOptionType: string;
        discountQuantity: number;
        discountQuantityPercent: number;
        discountAmount: number;
        discountAmountPercent: number;
        itemName: string;
        itemCode: string;
        itemKind: string;
        itemPriceOptionID?: number | null;
        itemPriceOptionName: string;
        brandName: string;
        shopName: string;
        employeeName: string;
      }>;
    }>;
  };
};

export type ExportDiscountsOverviewCsvMutationVariables = Exact<{
  filter: ReportDiscountsCsvInput;
}>;

export type ExportDiscountsOverviewCsvMutation = {
  exportDiscountsOverviewCSV: string;
};

export type DiscountAnalysisListEmployeesQueryVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
  searchParams: EmployeeSearchParams;
  pageInput: CursorPageInput;
}>;

export type DiscountAnalysisListEmployeesQuery = {
  listEmployees: {
    employees: Array<{
      employeeID: string;
      id: string;
      user?: { displayName: string } | null;
    }>;
    pageInfo: { nextCursor?: string | null; prevCursor?: string | null };
  };
};

export type GetAShopDiscountRuleQueryVariables = Exact<{
  shopKey: ShopKey;
}>;

export type GetAShopDiscountRuleQuery = {
  getAShopDiscountRule: {
    roundingRule: DiscountRoundingRule;
    discountLabelApplyMode: DiscountLabelApplyMode;
    manualOrderDiscountCalcMethod: DiscountCalcMethod;
    manualOrderDiscountServiceFeeEnabled: boolean;
    manualOrderDiscountMinChargeEnabled: boolean;
    manualItemDiscountCalcMethod: DiscountCalcMethod;
    manualCombineOrderEnabled: boolean;
    manualCombineItemEnabled: boolean;
  };
};

export type UpdateAShopDiscountRuleMutationVariables = Exact<{
  input: UpdateAShopDiscountRuleInput;
}>;

export type UpdateAShopDiscountRuleMutation = {
  updateAShopDiscountRule: boolean;
};

export type ListCustomerQueryVariables = Exact<{
  shopKey: ShopKey;
  searchParams?: InputMaybe<CustomerSearchParams>;
  searchCondition?: InputMaybe<CustomerSearchCondition>;
  search?: InputMaybe<Scalars['String']['input']>;
  pageInput: CursorPageInput;
}>;

export type ListCustomerQuery = {
  listCustomer: {
    customers: Array<{
      customerID?: string | null;
      name?: string | null;
      phone?: string | null;
      address?: string | null;
      createdAt?: string | null;
      brandName?: string | null;
      shopName?: string | null;
    }>;
    pageInfo: { nextCursor?: string | null; prevCursor?: string | null };
  };
};

export type ExportCustomerListCsvMutationVariables = Exact<{
  input: CustomerCsvInput;
}>;

export type ExportCustomerListCsvMutation = { exportCustomerListCSV: string };

export type GetAppCoverageQueryVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
  brandID?: InputMaybe<Scalars['Int32']['input']>;
  appType: Array<AppType> | AppType;
}>;

export type GetAppCoverageQuery = {
  getAppCoverage: Array<{
    __typename: 'AppInfo';
    appID: string;
    name: string;
    providerCode?: string | null;
  }>;
};

export type GenerateQrCodeQueryVariables = Exact<{
  url: Scalars['String']['input'];
}>;

export type GenerateQrCodeQuery = { generateQRCode: string };

export type ListActiveSubscriptionQueryVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
  brandID?: InputMaybe<Scalars['Int32']['input']>;
  shopID?: InputMaybe<Scalars['Int32']['input']>;
  appType: AppType;
}>;

export type ListActiveSubscriptionQuery = {
  listActiveSubscription: Array<{
    appID: string;
    name: string;
    providerCode: string;
  } | null>;
};

export type ListInvoicesQueryVariables = Exact<{
  shopKey: ShopKey;
  searchParams: InvoiceSearchParams;
  searchCondition: InvoiceSearchCondition;
  search?: InputMaybe<Scalars['String']['input']>;
  pageInput: CursorPageInput;
}>;

export type ListInvoicesQuery = {
  listInvoices: {
    invoices?: Array<{
      invoiceID: string;
      createdAt: string;
      invoiceStatus: InvoiceStatus;
      invoiceNo: string;
      carrierCode?: string | null;
      donationCode?: string | null;
      taxID?: string | null;
      voidedAt?: string | null;
      amount: number;
      preTaxAmount: number;
      taxAmount: number;
      transaction: {
        transactionNo: string;
        createdAt: string;
        totalAmount: number;
        payments: Array<{ amount: number; brandPaymentMethodName: string }>;
      };
      order: { orderID: string; createdAt: string; orderNo: string };
    }> | null;
    pageInfo: { nextCursor?: string | null; prevCursor?: string | null };
  };
};

export type ExportInvoicesCsvFileMutationVariables = Exact<{
  input: InvoicesCsvInput;
}>;

export type ExportInvoicesCsvFileMutation = { exportInvoicesCSVFile: string };

export type ListInvoiceSettingQueryVariables = Exact<{
  shopKey: ShopKey;
}>;

export type ListInvoiceSettingQuery = {
  listInvoiceSetting: {
    shopInvoiceSetting?: {
      activate: boolean;
      businessEntityName: string;
      businessIDNumber: string;
      invoiceTaxTypeID: number;
      taxRate: string;
      invoiceReasonID?: number | null;
      safeQty: number;
      lowStockAlertEnabled: boolean;
      fetchNumberOfGroup: number;
    } | null;
    subscriberSetting?: {
      bindSettings: Record<string, unknown>;
      planSubscription: { plan: { appID: string } };
    } | null;
    taxation: Array<{
      invoiceTaxTypeID: number;
      code: string;
      name: string;
      taxRate?: string | null;
      invoiceReasons?: Array<{
        invoiceReasonID: number;
        code: string;
        taxRate: string;
      } | null> | null;
    } | null>;
  };
};

export type ListEInvoiceSourcesQueryVariables = Exact<{
  shopKey: ShopKey;
}>;

export type ListEInvoiceSourcesQuery = {
  listEInvoiceSources: {
    eInvoiceSource: Array<{
      name: string;
      bindSetting: Record<string, unknown>;
      eInvoiceSourceID: string;
    } | null>;
  };
};

export type UpsertInvoiceSettingMutationVariables = Exact<{
  upsertInvoiceSettingInput: UpsertInvoiceSettingInput;
}>;

export type UpsertInvoiceSettingMutation = { upsertInvoiceSetting: boolean };

export type ItemListItemsQueryVariables = Exact<{
  brandKey: BrandKey;
  itemCategoryIDs?: InputMaybe<
    Array<Scalars['Int32']['input']> | Scalars['Int32']['input']
  >;
  itemKind?: InputMaybe<ItemKind>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  hasItemCategory?: InputMaybe<Scalars['Boolean']['input']>;
  subBrandShop?: InputMaybe<SubBrandShop>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  pageInput: CursorPageInput;
}>;

export type ItemListItemsQuery = {
  listItems: {
    items: Array<{
      itemID: number;
      name: string;
      code: string;
      itemKind: ItemKind;
      itemCategoryID?: number | null;
      disabled: boolean;
      shopApplyMode: ShopApplyMode;
      id: number;
      itemCategory?: { name: string } | null;
      itemImages: Array<{ itemImageThumbs: Array<{ hash: string }> }>;
      linkItemSubBrands: Array<{ subBrandID: number }>;
      linkItemShops: Array<{ shopID: number }>;
      itemPriceOptions: Array<{
        priceType: ItemPriceType;
        pricingMethod: ItemPricingMethod;
        weightUnit?: WeightUnit | null;
        weightBaseQuantity?: number | null;
        weightUnitPrice?: number | null;
        price: number;
        itemAdvPrices: Array<{ price: number }>;
      }>;
    }>;
    pageInfo: { nextCursor?: string | null; prevCursor?: string | null };
  };
};

export type ItemListItemCategoriesQueryVariables = Exact<{
  brandKey: BrandKey;
  itemCategoryID?: InputMaybe<Scalars['Int32']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  pageInput: CursorPageInput;
}>;

export type ItemListItemCategoriesQuery = {
  listItemCategories: {
    itemCategories?: Array<{
      itemCategoryID: number;
      name: string;
      code: string;
    }> | null;
  };
};

export type ExportItemsCsvFileMutationVariables = Exact<{
  input: ExportItemsCsvInput;
}>;

export type ExportItemsCsvFileMutation = { exportItemsCSVFile: string };

export type ImportItemsCsvFileMutationVariables = Exact<{
  input: ImportItemsCsvInput;
}>;

export type ImportItemsCsvFileMutation = {
  importItemsCSVFile: { filePath: string };
};

export type GetItemsOverviewReportBucketsQueryVariables = Exact<{
  filter: ReportItemsOverviewInput;
}>;

export type GetItemsOverviewReportBucketsQuery = {
  getItemsOverviewReportBuckets: {
    groupBy: ReportItemGroupMode;
    totalAmount: string;
    totalQuantity: number;
    amountPercentOfAll: Array<{ itemName: string; percent: number }>;
    quantityPercentOfAll: Array<{ itemName: string; percent: number }>;
    groups: Array<{
      key?: string | null;
      name?: string | null;
      itemQuantity: number;
      quantityPercent: number;
      itemData: Array<{
        rank: number;
        itemID: number;
        itemName: string;
        code: string;
        itemPriceOptionName: string;
        itemSaleType: string;
        itemPrice: number;
        discountAmount: number;
        itemQuantity: number;
        quantityPercent: number;
        totalAmountBeforeDiscount: number;
        totalAmountBeforeDiscountPercent: number;
        totalAmountAfterDiscount: number;
        totalAmountAfterDiscountPercent: number;
        complimentaryQuantity: number;
        diningOptionName: string;
        diningOptionType: string;
        brandName: string;
        shopName: string;
      }>;
    }>;
  };
};

export type ExportItemsOverviewCsvMutationVariables = Exact<{
  filter: ReportItemsCsvInput;
}>;

export type ExportItemsOverviewCsvMutation = { exportItemsOverviewCSV: string };

export type GetItemDetailsQueryVariables = Exact<{
  brandKey: BrandKey;
  itemID: Scalars['Int32']['input'];
}>;

export type GetItemDetailsQuery = {
  getItemDetails?: {
    itemID: number;
    itemKind: ItemKind;
    disabled: boolean;
    name: string;
    intro: string;
    itemCategoryID?: number | null;
    taxCategory: TaxCategory;
    code: string;
    color: string;
    posOnly: boolean;
    noStatistic: boolean;
    saleStartTime: string;
    saleEndTime: string;
    shopApplyMode: ShopApplyMode;
    updatedAt: string;
    taxGroupID?: number | null;
    defaultTaxID?: number | null;
    allowChangeTaxRate: boolean;
    itemAdvNames?: Array<{
      itemAdvNameType: ItemAdvNameType;
      name: string;
    }> | null;
    itemCategory?: { name: string } | null;
    itemImages: Array<{ itemImageThumbs: Array<{ hash: string }> }>;
    itemPriceOptions: Array<{
      name: string;
      itemPriceOptionID: number;
      priceType: ItemPriceType;
      displayOrder: number;
      originPrice: number;
      price: number;
      cost: number;
      redeemPoint: number;
      pricingMethod: ItemPricingMethod;
      weightUnit?: WeightUnit | null;
      weightBaseQuantity?: number | null;
      weightUnitPrice?: number | null;
      itemCode: string;
      barcode: string;
      complimentary: boolean;
      defaultSelect: boolean;
      itemAdvPrices: Array<{
        subBrandID?: number | null;
        brandDiningOptionID?: number | null;
        redeemPoint: number;
        itemAdvPriceID: number;
        originPrice: number;
        price: number;
      }>;
    }>;
    itemLabelGroups: Array<{
      displayOrder: number;
      labelGroup: { labelGroupID: number; name: string };
    }>;
    linkItemSubBrands: Array<{ subBrandID: number }>;
    linkItemShops: Array<{ shopID: number }>;
    itemBundles: Array<{
      bundleID: number;
      displayOrder: number;
      bundle: {
        name: string;
        bundleType: BundleType;
        selectableMinCount: number;
        selectableMaxCount: number;
        bundleItems: Array<{ itemID: number }>;
      };
    }>;
  } | null;
};

export type ItemEditListItemCategoriesQueryVariables = Exact<{
  brandKey: BrandKey;
  itemCategoryID?: InputMaybe<Scalars['Int32']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  pageInput: CursorPageInput;
}>;

export type ItemEditListItemCategoriesQuery = {
  listItemCategories: {
    itemCategories?: Array<{
      itemCategoryID: number;
      name: string;
      id: number;
    }> | null;
  };
};

export type UpdateItemMutationVariables = Exact<{
  input: UpdateItemInput;
}>;

export type UpdateItemMutation = { updateItem: boolean };

export type CreateItemMutationVariables = Exact<{
  input: UpdateItemInput;
}>;

export type CreateItemMutation = { createItem?: number | null };

export type DelItemImagesMutationVariables = Exact<{
  itemKey: ItemKey;
}>;

export type DelItemImagesMutation = { delItemImages: boolean };

export type PutItemImageMutationVariables = Exact<{
  itemKey: ItemKey;
  file: Scalars['Upload']['input'];
}>;

export type PutItemImageMutation = {
  putItemImage: {
    itemImage: { itemID: number; hash: string };
    itemImageThumbs: Array<{ itemID: number; hash: string }>;
  };
};

export type DuplicateItemsMutationVariables = Exact<{
  brandKey: BrandKey;
  itemIDs: Array<Scalars['Int32']['input']> | Scalars['Int32']['input'];
}>;

export type DuplicateItemsMutation = { duplicateItems: Array<number> };

export type DeleteItemsMutationVariables = Exact<{
  brandKey: BrandKey;
  itemIDs: Array<Scalars['Int32']['input']> | Scalars['Int32']['input'];
}>;

export type DeleteItemsMutation = { deleteItems: boolean };

export type DisableItemsMutationVariables = Exact<{
  brandKey: BrandKey;
  itemIDs: Array<Scalars['Int32']['input']> | Scalars['Int32']['input'];
  disabled: Scalars['Boolean']['input'];
}>;

export type DisableItemsMutation = { disableItems: boolean };

export type ItemEditGetABundleDetailQueryVariables = Exact<{
  brandKey: BrandKey;
  bundleID: Scalars['Int32']['input'];
}>;

export type ItemEditGetABundleDetailQuery = {
  getABundleDetail?: {
    bundleItems: Array<{
      itemID: number;
      displayOrder: number;
      item: { name: string; itemKind: ItemKind };
      bundleItemItemPriceOptions: Array<{
        itemPriceOptionID: number;
        price: number;
        defaultSelectCount: number;
        itemPriceOption: { name: string };
      }>;
    }>;
  } | null;
};

export type ItemEditlistBundlesQueryVariables = Exact<{
  brandKey: BrandKey;
  bundleType?: InputMaybe<BundleType>;
  searchName?: InputMaybe<Scalars['String']['input']>;
  pageInput: CursorPageInput;
  excludeBundleItemID?: InputMaybe<Scalars['Int32']['input']>;
}>;

export type ItemEditlistBundlesQuery = {
  listBundles: {
    bundles?: Array<{
      bundleID: number;
      name: string;
      selectableMinCount: number;
      selectableMaxCount: number;
      id: number;
      bundleItems: Array<{ itemID: number }>;
    }> | null;
  };
};

export type ItemEditGetDetailOfLabelGroupQueryVariables = Exact<{
  key: LabelGroupKey;
}>;

export type ItemEditGetDetailOfLabelGroupQuery = {
  getDetailOfLabelGroup: {
    labelGroup: {
      selectableMinCount: number;
      selectableMaxCount: number;
      sameLabelSelectableMaxCount: number;
      labelGroupLabels: Array<{
        labelID: number;
        price: number;
        displayOrder: number;
        label: { name: string };
      }>;
    };
  };
};

export type ItemEditListLabelGroupsQueryVariables = Exact<{
  brandKey: BrandKey;
  subBrandShop?: InputMaybe<SubBrandShop>;
  searchName?: InputMaybe<Scalars['String']['input']>;
  pageInput: CursorPageInput;
}>;

export type ItemEditListLabelGroupsQuery = {
  listLabelGroups: {
    labelGroups?: Array<{
      labelGroupID: number;
      name: string;
      displayOrder: number;
    }> | null;
  };
};

export type ItemEditListBrandDiningOptionsQueryVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
  brandID: Scalars['Int32']['input'];
}>;

export type ItemEditListBrandDiningOptionsQuery = {
  listBrandDiningOptions: Array<{ brandDiningOptionID: number; name: string }>;
};

export type ItemFieldsFragment = {
  itemID: number;
  name: string;
  color: string;
  code: string;
  itemKind: ItemKind;
  hasNestedBundle?: boolean | null;
  id: number;
  itemImages: Array<{ hash: string; itemImageThumbs: Array<{ hash: string }> }>;
  itemPriceOptions: Array<{
    itemPriceOptionID: number;
    name: string;
    price: number;
    priceType: ItemPriceType;
    itemCode: string;
  }>;
  itemCategory?: { name: string } | null;
};

export type ListItemCategoriesQueryVariables = Exact<{
  brandKey: BrandKey;
  pageInput: CursorPageInput;
  itemCategoryID?: InputMaybe<Scalars['Int32']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  itemKind?: InputMaybe<ItemKind>;
  includeUncategorized: Scalars['Boolean']['input'];
}>;

export type ListItemCategoriesQuery = {
  listItemCategories: {
    itemCategories?: Array<{
      itemCategoryID: number;
      name: string;
      code: string;
      id: number;
      items: Array<{
        itemID: number;
        name: string;
        color: string;
        code: string;
        itemKind: ItemKind;
        hasNestedBundle?: boolean | null;
        id: number;
        itemImages: Array<{
          hash: string;
          itemImageThumbs: Array<{ hash: string }>;
        }>;
        itemPriceOptions: Array<{
          itemPriceOptionID: number;
          name: string;
          price: number;
          priceType: ItemPriceType;
          itemCode: string;
        }>;
        itemCategory?: { name: string } | null;
      }>;
    }> | null;
    uncategorizedItems?: Array<{
      itemID: number;
      name: string;
      color: string;
      code: string;
      itemKind: ItemKind;
      hasNestedBundle?: boolean | null;
      id: number;
      itemImages: Array<{
        hash: string;
        itemImageThumbs: Array<{ hash: string }>;
      }>;
      itemPriceOptions: Array<{
        itemPriceOptionID: number;
        name: string;
        price: number;
        priceType: ItemPriceType;
        itemCode: string;
      }>;
      itemCategory?: { name: string } | null;
    }> | null;
    pageInfo: { nextCursor?: string | null; prevCursor?: string | null };
  };
};

export type ListPriceItemCategoriesQueryVariables = Exact<{
  brandKey: BrandKey;
  pageInput: CursorPageInput;
  itemCategoryID?: InputMaybe<Scalars['Int32']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  itemKind?: InputMaybe<ItemKind>;
  includeUncategorized: Scalars['Boolean']['input'];
  excludeItemBundleID?: InputMaybe<Scalars['Int32']['input']>;
}>;

export type ListPriceItemCategoriesQuery = {
  listItemCategories: {
    itemCategories?: Array<{
      itemCategoryID: number;
      name: string;
      code: string;
      id: number;
      items: Array<{
        itemID: number;
        name: string;
        code: string;
        itemKind: ItemKind;
        hasNestedBundle?: boolean | null;
        id: number;
        itemPriceOptions: Array<{
          itemPriceOptionID: number;
          name: string;
          itemCode: string;
          price: number;
          priceType: ItemPriceType;
          displayOrder: number;
        }>;
        itemCategory?: { name: string } | null;
      }>;
    }> | null;
    uncategorizedItems?: Array<{
      itemID: number;
      name: string;
      code: string;
      itemKind: ItemKind;
      hasNestedBundle?: boolean | null;
      id: number;
      itemPriceOptions: Array<{
        itemPriceOptionID: number;
        name: string;
        itemCode: string;
        price: number;
        priceType: ItemPriceType;
        displayOrder: number;
      }>;
    }> | null;
    pageInfo: { nextCursor?: string | null; prevCursor?: string | null };
  };
};

export type ListKeypadsQueryVariables = Exact<{
  shopKey: ShopKey;
  pageInput: CursorPageInput;
}>;

export type ListKeypadsQuery = {
  listKeypads: {
    keypads?: Array<{
      available: boolean;
      keypad: {
        workspaceID: string;
        brandID: number;
        shopID: number;
        keypadID: number;
        name: string;
        createdAt: string;
        updatedAt: string;
        linkKeypadItems: Array<{ itemID: number }>;
      };
    }> | null;
    pageInfo: { nextCursor?: string | null; prevCursor?: string | null };
  };
};

export type GetDetailOfKeypadItemsQueryVariables = Exact<{
  keypadKey: KeypadKey;
}>;

export type GetDetailOfKeypadItemsQuery = {
  getDetailOfKeypadItems: {
    itemCategories?: Array<{
      itemCategoryID: number;
      name: string;
      code: string;
      items: Array<{
        itemID: number;
        itemKind: ItemKind;
        name: string;
        code: string;
        itemPriceOptions: Array<{
          itemPriceOptionID: number;
          itemCode: string;
          price: number;
        }>;
      }>;
    }> | null;
    uncategorizedItems?: Array<{
      itemID: number;
      itemKind: ItemKind;
      name: string;
      code: string;
      itemPriceOptions: Array<{
        itemPriceOptionID: number;
        itemCode: string;
        price: number;
      }>;
    }> | null;
  };
};

export type CopyApplyKeypadToShopsMutationVariables = Exact<{
  shopKey: ShopKey;
  shopIDs: Array<Scalars['Int32']['input']> | Scalars['Int32']['input'];
}>;

export type CopyApplyKeypadToShopsMutation = {
  copyApplyKeypadToShops: boolean;
};

export type UpdateKeypadDisplayOrderMutationVariables = Exact<{
  input: KeypadDisplayOrderInput;
}>;

export type UpdateKeypadDisplayOrderMutation = {
  updateKeypadDisplayOrder: boolean;
};

export type CreateKeypadWItemMutationVariables = Exact<{
  input: CreateKeypadInput;
}>;

export type CreateKeypadWItemMutation = { createKeypadWItem?: number | null };

export type UpdateKeypadWItemMutationVariables = Exact<{
  input: UpdateKeypadInput;
}>;

export type UpdateKeypadWItemMutation = { updateKeypadWItem: boolean };

export type DeleteKeypadMutationVariables = Exact<{
  shopKey: ShopKey;
  keypadIDs: Array<Scalars['Int32']['input']> | Scalars['Int32']['input'];
}>;

export type DeleteKeypadMutation = { deleteKeypad: boolean };

export type GetUsedKeypadItemIDsQueryVariables = Exact<{
  shopKey: ShopKey;
}>;

export type GetUsedKeypadItemIDsQuery = {
  getUsedKeypadItemIDs?: Array<number> | null;
};

export type EditListKeypadsQueryVariables = Exact<{
  shopKey: ShopKey;
}>;

export type EditListKeypadsQuery = {
  listKeypads: {
    keypads?: Array<{
      available: boolean;
      keypad: {
        workspaceID: string;
        shopID: number;
        keypadID: number;
        name: string;
      };
    }> | null;
  };
};

export type GetDetailOfKeypadQueryVariables = Exact<{
  keypadKey: KeypadKey;
}>;

export type GetDetailOfKeypadQuery = {
  getDetailOfKeypad: {
    keypad: {
      workspaceID: string;
      shopID: number;
      keypadID: number;
      name: string;
      updatedAt: string;
      keyButtons: Array<{
        keyButtonID: number;
        name: string;
        row: number;
        col: number;
        rowSpan: number;
        colSpan: number;
        color: string;
        type: KeyButtonType;
        labelGroupID?: number | null;
        labelID?: number | null;
        id: number;
        linkKeybuttonDiscount?: {
          discountID: number;
          discount: {
            discountID: number;
            name: string;
            code: string;
            type: DiscountType;
          };
        } | null;
        labelGroupLabel?: {
          labelGroupID: number;
          labelID: number;
          price: number;
        } | null;
      }>;
      linkKeypadItems: Array<{ itemID: number }>;
    };
    keyButtonList: {
      priceOptions?: Array<{ keyButtonID: number; name: string }> | null;
      labelButtonGroups?: Array<{
        labelGroup: { labelGroupID: number; name: string };
        labelButtons?: Array<{
          keyButtonID: number;
          labelGroupLabel: {
            labelGroupID: number;
            labelID: number;
            price: number;
            label: { name: string };
          };
        }> | null;
      }> | null;
    };
  };
};

export type ListDiscountsOfKeypadQueryVariables = Exact<{
  shopKey: ShopKey;
  search?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListDiscountsOfKeypadQuery = {
  listDiscountsOfKeypad: Array<{
    discountID: number;
    name: string;
    code: string;
    type: DiscountType;
    status: DiscountStatus;
    activate: boolean;
    color: string;
    displayOrder: number;
    shopApplyMode: ShopApplyMode;
    startTime: string;
    endTime: string;
  }>;
};

export type UpsertKeyButtonsOfKeypadMutationVariables = Exact<{
  input: KeyButtonsOfKeypadInput;
}>;

export type UpsertKeyButtonsOfKeypadMutation = {
  upsertKeyButtonsOfKeypad: boolean;
};

export type LabelListLabelsQueryVariables = Exact<{
  brandKey: BrandKey;
  searchName?: InputMaybe<Scalars['String']['input']>;
  pageInput: CursorPageInput;
}>;

export type LabelListLabelsQuery = {
  listLabels: {
    labels?: Array<{
      labelID: number;
      name: string;
      code: string;
      price: number;
      posOnly: boolean;
      displayOrder: number;
      id: number;
      labelGroupLabels?: Array<{ labelGroupID: number }> | null;
    }> | null;
    pageInfo: { nextCursor?: string | null; prevCursor?: string | null };
  };
};

export type UpdateALabelMutationVariables = Exact<{
  brandKey?: InputMaybe<BrandKey>;
  labelID: Scalars['Int32']['input'];
  input: LabelInput;
}>;

export type UpdateALabelMutation = { updateALabel: boolean };

export type CreateALabelMutationVariables = Exact<{
  brandKey: BrandKey;
  input: LabelInput;
}>;

export type CreateALabelMutation = {
  createALabel?: {
    labelID: number;
    name: string;
    code: string;
    price: number;
    posOnly: boolean;
    id: number;
  } | null;
};

export type DeleteLabelsMutationVariables = Exact<{
  brandKey?: InputMaybe<BrandKey>;
  labelIDs: Array<Scalars['Int32']['input']> | Scalars['Int32']['input'];
}>;

export type DeleteLabelsMutation = { deleteLabels: boolean };

export type GetLabelsOverviewReportBucketsQueryVariables = Exact<{
  filter: ReportLabelsOverviewInput;
}>;

export type GetLabelsOverviewReportBucketsQuery = {
  getLabelsOverviewReportBuckets: {
    groupBy: ReportLabelGroupMode;
    totalAmount: string;
    totalQuantity: number;
    amountPercentOfAll: Array<{ labelName: string; percent: number }>;
    quantityPercentOfAll: Array<{ labelName: string; percent: number }>;
    groups: Array<{
      key?: string | null;
      name?: string | null;
      amount: number;
      labelQuantity: number;
      totalLabelPrice: number;
      quantityPercent: number;
      labelData: Array<{
        rank: number;
        labelID: number;
        labelName?: string | null;
        itemID: number;
        itemName?: string | null;
        labelQuantity: number;
        quantityPercent: number;
        labelPrice: number;
        amount: number;
        labelGroupID: number;
        labelGroupName?: string | null;
        itemKind?: string | null;
        itemCode?: string | null;
        itemPriceOptionID: number;
        itemPriceOptionName?: string | null;
        diningOptionType?: string | null;
        diningOptionName?: string | null;
        brandName?: string | null;
        shopName?: string | null;
      }>;
    }>;
  };
};

export type LabelsAnalysisListLabelsQueryVariables = Exact<{
  brandKey: BrandKey;
  searchName?: InputMaybe<Scalars['String']['input']>;
  pageInput: CursorPageInput;
}>;

export type LabelsAnalysisListLabelsQuery = {
  listLabels: {
    labels?: Array<{ labelID: number; name: string; id: number }> | null;
    pageInfo: { nextCursor?: string | null; prevCursor?: string | null };
  };
};

export type LabelsAnalysisLabelGroupListLabelGroupsQueryVariables = Exact<{
  brandKey: BrandKey;
  pageInput: CursorPageInput;
}>;

export type LabelsAnalysisLabelGroupListLabelGroupsQuery = {
  listLabelGroups: {
    labelGroups?: Array<{
      labelGroupID: number;
      name: string;
      id: number;
    }> | null;
  };
};

export type ExportLabelsOverviewCsvMutationVariables = Exact<{
  filter: ReportLabelsCsvInput;
}>;

export type ExportLabelsOverviewCsvMutation = {
  exportLabelsOverviewCSV: string;
};

export type LabelGroupListLabelGroupsQueryVariables = Exact<{
  brandKey: BrandKey;
  subBrandShop?: InputMaybe<SubBrandShop>;
  searchName?: InputMaybe<Scalars['String']['input']>;
  pageInput: CursorPageInput;
}>;

export type LabelGroupListLabelGroupsQuery = {
  listLabelGroups: {
    labelGroups?: Array<{
      labelGroupID: number;
      name: string;
      selectableMinCount: number;
      selectableMaxCount: number;
      sameLabelSelectableMaxCount: number;
      posOnly: boolean;
      noStatistic: boolean;
      shopApplyMode: ShopApplyMode;
      id: number;
      labelGroupLabels: Array<{
        displayOrder: number;
        label: { labelID: number; name: string; id: number };
      }>;
      itemLabelGroups?: Array<{ itemID: number }> | null;
      linkSubBrandLabelGroups: Array<{ subBrandID: number }>;
      linkShopLabelGroups: Array<{ shopID: number }>;
    }> | null;
    pageInfo: { nextCursor?: string | null; prevCursor?: string | null };
  };
};

export type LabelGroupListItemCategoriesQueryVariables = Exact<{
  brandKey: BrandKey;
  pageInput: CursorPageInput;
  itemCategoryID?: InputMaybe<Scalars['Int32']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  itemKind?: InputMaybe<ItemKind>;
  includeUncategorized: Scalars['Boolean']['input'];
}>;

export type LabelGroupListItemCategoriesQuery = {
  listItemCategories: {
    itemCategories?: Array<{
      itemCategoryID: number;
      name: string;
      id: number;
      items: Array<{
        itemID: number;
        name: string;
        color: string;
        id: number;
        itemImages: Array<{
          hash: string;
          itemImageThumbs: Array<{ hash: string }>;
        }>;
        itemPriceOptions: Array<{
          itemPriceOptionID: number;
          name: string;
          price: number;
          priceType: ItemPriceType;
        }>;
        itemCategory?: { name: string } | null;
      }>;
    }> | null;
    uncategorizedItems?: Array<{
      itemID: number;
      name: string;
      color: string;
      id: number;
      itemImages: Array<{
        hash: string;
        itemImageThumbs: Array<{ hash: string }>;
      }>;
      itemPriceOptions: Array<{
        itemPriceOptionID: number;
        name: string;
        price: number;
        priceType: ItemPriceType;
      }>;
      itemCategory?: { name: string } | null;
    }> | null;
    pageInfo: { nextCursor?: string | null; prevCursor?: string | null };
  };
};

export type ItemGroupEditGetDetailOfLabelGroupQueryVariables = Exact<{
  key: LabelGroupKey;
}>;

export type ItemGroupEditGetDetailOfLabelGroupQuery = {
  getDetailOfLabelGroup: {
    labelGroup: {
      labelGroupID: number;
      name: string;
      selectableMinCount: number;
      selectableMaxCount: number;
      sameLabelSelectableMaxCount: number;
      posOnly: boolean;
      noStatistic: boolean;
      shopApplyMode: ShopApplyMode;
      updatedAt: string;
      id: number;
      labelGroupLabels: Array<{
        labelID: number;
        displayOrder: number;
        defaultSelect: boolean;
        price: number;
        id: number;
        label: { name: string; price: number };
      }>;
    };
    subBrands?: Array<{ subBrandID: number }> | null;
    shops?: Array<{ subBrandID?: number | null; shopID: number }> | null;
  };
};

export type UpdateALabelGroupMutationVariables = Exact<{
  brandKey: BrandKey;
  labelGroupID: Scalars['Int32']['input'];
  input: LabelGroupInput;
}>;

export type UpdateALabelGroupMutation = { updateALabelGroup: boolean };

export type CreateALabelGroupMutationVariables = Exact<{
  brandKey: BrandKey;
  input: LabelGroupInput;
}>;

export type CreateALabelGroupMutation = {
  createALabelGroup: { labelGroupID: number };
};

export type LabelGroupEditListLabelsQueryVariables = Exact<{
  brandKey: BrandKey;
  searchName?: InputMaybe<Scalars['String']['input']>;
  pageInput: CursorPageInput;
}>;

export type LabelGroupEditListLabelsQuery = {
  listLabels: {
    labels?: Array<{
      labelID: number;
      name: string;
      code: string;
      price: number;
      id: number;
    }> | null;
    pageInfo: { nextCursor?: string | null; prevCursor?: string | null };
  };
};

export type DeleteLabelGroupsMutationVariables = Exact<{
  brandKey: BrandKey;
  labelGroupIDs: Array<Scalars['Int32']['input']> | Scalars['Int32']['input'];
}>;

export type DeleteLabelGroupsMutation = { deleteLabelGroups: boolean };

export type DuplicateALabelGroupMutationVariables = Exact<{
  brandKey: BrandKey;
  labelGroupID: Scalars['Int32']['input'];
}>;

export type DuplicateALabelGroupMutation = { duplicateALabelGroup: boolean };

export type GetWorkspaceQueryVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
}>;

export type GetWorkspaceQuery = {
  getWorkspace: {
    workspaceID: string;
    name: string;
    code: string;
    countryID: string;
    currencyID: string;
    languageID: string;
    timezoneID: string;
    checkoutDecimalPlaces: number;
    checkoutRoundingRule: StandardRoundingRule;
    calcDecimalPlaces: number;
    calcRoundingRule: StandardRoundingRule;
    discountDisplayFormat: DiscountDisplayFormat;
    id: string;
    currency: { symbol: string; decimalPlaces: number };
  };
};

export type UpdateAWorkspaceMutationVariables = Exact<{
  input: UpdateAWorkspaceInput;
}>;

export type UpdateAWorkspaceMutation = { updateAWorkspace: boolean };

export type GetWorkspaceDiscountDisplayFormatQueryVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
}>;

export type GetWorkspaceDiscountDisplayFormatQuery = {
  getWorkspace: { discountDisplayFormat: DiscountDisplayFormat; id: string };
};

export type LoginMutationVariables = Exact<{
  source: LoginSource;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;

export type LoginMutation = {
  login: Array<{
    workspaceID: string;
    permissions: Array<{
      permissionDetailID: string;
      systemID: string;
      code: string;
    }>;
    roles: Array<{
      roleID: number;
      roleTemplateID: string;
      displayID: string;
      name?: string | null;
      of: PermissionScope;
    }>;
  }>;
};

export type RecoveryPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;

export type RecoveryPasswordMutation = { recoveryPassword: boolean };

export type SendEmailVerificationMutationVariables = Exact<{
  email: Scalars['String']['input'];
  type: EmailVerificationType;
}>;

export type SendEmailVerificationMutation = { sendEmailVerification: boolean };

export type ResetPasswordMutationVariables = Exact<{
  verificationNumber: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;

export type ResetPasswordMutation = { resetPassword: boolean };

export type InitPasswordMutationVariables = Exact<{
  verificationNumber: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;

export type InitPasswordMutation = { initPassword: boolean };

export type InspectVerificationNumberQueryVariables = Exact<{
  email: Scalars['String']['input'];
  verificationNumber: Scalars['String']['input'];
}>;

export type InspectVerificationNumberQuery = {
  inspectVerificationNumber: boolean;
};

export type OrgBelongsQueryVariables = Exact<{ [key: string]: never }>;

export type OrgBelongsQuery = {
  orgBelongs?: Array<{
    of: OrgBelongOf;
    workspaceID: string;
    brandID?: number | null;
    shopID?: number | null;
    employeeID: string;
    workspace?: { workspaceID: string; name: string; countryID: string } | null;
    brand?: { brandID: number; name: string } | null;
    shop?: { shopID: number; name: string } | null;
    employee: {
      firstName?: string | null;
      lastName?: string | null;
      user?: { email: string } | null;
      employeePortraits?: Array<{ hash: string }> | null;
    };
  }> | null;
};

export type ListBrandIDsQueryVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
}>;

export type ListBrandIDsQuery = { listBrands: Array<{ brandID: number }> };

export type WorkspaceListBrandsQueryVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
}>;

export type WorkspaceListBrandsQuery = {
  listBrands: Array<{
    brandID: number;
    name: string;
    displayOrder: number;
    subBrands: Array<{ shops: Array<{ name: string; shopID: number }> }>;
    uncategorizedShops: Array<{ name: string; shopID: number }>;
  }>;
};

export type VersionQueryVariables = Exact<{ [key: string]: never }>;

export type VersionQuery = {
  version: {
    version: string;
    goVersion: string;
    name: string;
    buildTime: string;
    gitCommit: string;
  };
};

export type GetMemberQueryVariables = Exact<{
  brandKey: BrandKey;
  cardCode: Scalars['String']['input'];
  memberSourceID: Scalars['UUID']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetMemberQuery = {
  getMember: {
    portraitUrl?: string | null;
    fullName?: string | null;
    source: string;
    card?: { cardCode: string; activate: boolean } | null;
    workspaceMember?: {
      workspaceID: string;
      memberID: string;
      memberSourceID: string;
      cardNumber: string;
      displayName?: string | null;
    } | null;
  };
};

export type CreateMemberMutationVariables = Exact<{
  brandKey: BrandKey;
  source?: InputMaybe<Scalars['String']['input']>;
  memberSourceID: Scalars['UUID']['input'];
  input: CreateMemberInput;
}>;

export type CreateMemberMutation = {
  createMember: {
    memberID: string;
    fullName?: string | null;
    phone: string;
    email?: string | null;
  };
};

export type UpdateMemberInfoMutationVariables = Exact<{
  brandKey: BrandKey;
  cardCode: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  memberSourceID: Scalars['UUID']['input'];
  input: UpdateMemberInput;
}>;

export type UpdateMemberInfoMutation = {
  updateMemberInfo: {
    memberID: string;
    fullName?: string | null;
    phone: string;
    email?: string | null;
  };
};

export type GetMemberDetailsQueryVariables = Exact<{
  brandKey: BrandKey;
  cardCode: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  memberSourceID: Scalars['UUID']['input'];
}>;

export type GetMemberDetailsQuery = {
  getMemberDetails: {
    member: {
      memberID: string;
      countryCode?: string | null;
      phone: string;
      email?: string | null;
      activate: boolean;
      birthday?: string | null;
      fullName?: string | null;
      gender: Gender;
      preferences?: Record<string, unknown> | null;
      serviceCompanyName?: string | null;
      note?: string | null;
      updatedAt: string;
      workspaceMember?: { displayName?: string | null } | null;
      card?: { cardCode: string; activate: boolean } | null;
    };
    addressViews: Array<{
      addressID: string;
      fields: Array<{
        key: string;
        label: string;
        value: string;
        placeholder: string;
      }>;
    }>;
    workspaceMemberTags: Array<{ tagID: string; tag: string }>;
  };
};

export type ListTransactionsByMemberQueryVariables = Exact<{
  brandKey: BrandKey;
  memberSourceID: Scalars['UUID']['input'];
  memberID: Scalars['UUID']['input'];
}>;

export type ListTransactionsByMemberQuery = {
  listTransactionsByMember?: Array<{
    orderID: string;
    brandID: number;
    shopID: number;
    transactionType: TransactionType;
    createdAt: string;
    totalAmount: number;
    brand: { brandID: number; name: string };
    shop: { shopID: number; name: string };
  }> | null;
};

export type ListConfLoyaltyQueryVariables = Exact<{
  brandKey: BrandKey;
  cardCode: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  memberSourceID: Scalars['UUID']['input'];
}>;

export type ListConfLoyaltyQuery = {
  listConfLoyalty: {
    success: boolean;
    data: {
      confLoyaltyProgram?: { name: string; bgHash?: string | null } | null;
    };
  };
};

export type ListMemberPointHistoryQueryVariables = Exact<{
  brandKey: BrandKey;
  cardCode: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  memberSourceID: Scalars['UUID']['input'];
}>;

export type ListMemberPointHistoryQuery = {
  listMemberPointHistory: {
    success: boolean;
    data: {
      permanentPoint: number;
      temporaryPoint: number;
      pointsLedger: Array<{
        ledgerID: string;
        operation: PointLedgerOperationType;
        deltaPoints: number;
        createdAt: string;
        brand: string;
        shop: string;
        content: { orderNo?: string | null; orderAmount?: string | null };
      }>;
    };
  };
};

export type ActivateMemberCardMutationVariables = Exact<{
  brandKey: BrandKey;
  cardCode: Scalars['String']['input'];
  activate: Scalars['Boolean']['input'];
}>;

export type ActivateMemberCardMutation = { activateMemberCard: boolean };

export type UpsertMemberAddressesMutationVariables = Exact<{
  memberID: Scalars['UUID']['input'];
  inputs: Array<MemberAddressInput> | MemberAddressInput;
}>;

export type UpsertMemberAddressesMutation = { upsertMemberAddresses: boolean };

export type DeleteMemberAddressesMutationVariables = Exact<{
  memberID: Scalars['UUID']['input'];
  addressIDs: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;

export type DeleteMemberAddressesMutation = { deleteMemberAddresses: boolean };

export type SaveTagsAndNotesMutationVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
  memberID: Scalars['UUID']['input'];
  memberSourceID: Scalars['UUID']['input'];
  tags: Array<Scalars['String']['input']> | Scalars['String']['input'];
  note: Scalars['String']['input'];
}>;

export type SaveTagsAndNotesMutation = { saveTagsAndNotes: boolean };

export type ListMemberPointInfoQueryVariables = Exact<{
  brandKey: BrandKey;
  cardCode: Scalars['String']['input'];
  memberSourceID: Scalars['UUID']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListMemberPointInfoQuery = {
  getMember: {
    memberID: string;
    wallet?: {
      balance: number;
      inventories?: Array<{
        remainingPoints: number;
        expiredOn?: string | null;
      }> | null;
    } | null;
  };
  listMemberPointHistory: {
    success: boolean;
    data: {
      permanentPoint: number;
      temporaryPoint: number;
      pointsLedger: Array<{
        ledgerID: string;
        operation: PointLedgerOperationType;
        deltaPoints: number;
        createdAt: string;
        brand: string;
        shop: string;
        content: { orderNo?: string | null; orderAmount?: string | null };
      }>;
    };
  };
};

export type ListShopMemberTagQueryVariables = Exact<{
  shopKey: ShopKey;
}>;

export type ListShopMemberTagQuery = {
  listShopMemberTag: Array<{
    workspaceID: string;
    brandID: number;
    shopID: number;
    brandMemberTagID: number;
    disabled: boolean;
    displayOrder: number;
    brandMemberTag: { name: string };
  } | null>;
};

export type UpdateShopMemberTagMutationVariables = Exact<{
  input: UpdateShopMemberTagInput;
}>;

export type UpdateShopMemberTagMutation = { updateShopMemberTag: boolean };

export type ListBrandMemberTagQueryVariables = Exact<{
  brandKey: BrandKey;
}>;

export type ListBrandMemberTagQuery = {
  listBrandMemberTag: Array<{
    workspaceID: string;
    brandID: number;
    brandMemberTagID: number;
    name: string;
    disabled: boolean;
  } | null>;
};

export type UpsertBrandMemberTagMutationVariables = Exact<{
  input: UpsertBrandMemberTagInput;
}>;

export type UpsertBrandMemberTagMutation = { upsertBrandMemberTag: boolean };

export type SetMemberCardTypeMutationVariables = Exact<{
  input: MemberCardTypeInput;
}>;

export type SetMemberCardTypeMutation = { setMemberCardType: boolean };

export type GetMemberCardTypeQueryVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
  brandID?: InputMaybe<Scalars['Int32']['input']>;
}>;

export type GetMemberCardTypeQuery = {
  getMembershipConfig: {
    memberCardTypeSetting?: { cardType: MemberCardType } | null;
  };
};

export type GetMembershipConfigQueryVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
  brandID?: InputMaybe<Scalars['Int32']['input']>;
}>;

export type GetMembershipConfigQuery = {
  getMembershipConfig: {
    memberCardTypeSetting?: { cardType: MemberCardType } | null;
    memberCardSetting?: {
      memberCardSettingID: string;
      memberSourceID: string;
      allowedRegisterByPos: boolean;
      showPrivacyTermsOnRegister: boolean;
      privacyTerms: string;
    } | null;
    confLoyaltyProgram?: {
      programID: string;
      name: string;
      issuanceLevel: IssuanceLevel;
      participantType: ParticipantType;
      logoHash?: string | null;
      bgHash?: string | null;
      manualAdjustPoints: boolean;
      pointUsageScope: PointUsageScope;
      registerUrls?: Record<string, unknown> | null;
    } | null;
    confProgramRedeemItem?: {
      activate: boolean;
      viaPos: boolean;
      viaOnlineOrder: boolean;
      viaScanOrder: boolean;
    } | null;
    confProgramPointEarnRule?: {
      activate: boolean;
      aPointPerPurchaseAmount: number;
      pointExpiryType: PointExpiryType;
      pointExpiryInDays?: number | null;
      diningOptionDineIn: boolean;
      diningOptionTakeout: boolean;
      diningOptionDelivery: boolean;
      diningOptionPickup: boolean;
    } | null;
    confPointEarnExtraItem?: Array<{
      itemCode: string;
      givePointPerItem: number;
    } | null> | null;
    confPointRedeemDiscount?: {
      activate: boolean;
      pointRedeemAmount: number;
      pointDiscountAmount: number;
      pointDiscountViaPos: boolean;
      pointDiscountViaOnlineOrder: boolean;
      exclusiveItemCodes?: Record<string, unknown> | null;
    } | null;
    confProgramParticipant?: Array<{
      mbrandID?: number | null;
      mshopID?: number | null;
    } | null> | null;
  };
};

export type SetMembershipConfigMutationVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
  brandID?: InputMaybe<Scalars['Int32']['input']>;
  input: MembershipConfigInput;
}>;

export type SetMembershipConfigMutation = { setMembershipConfig: boolean };

export type GetItemWithItemPriceOptionListQueryVariables = Exact<{
  brandKey: BrandKey;
  items: Array<ItemWithItemPriceOption> | ItemWithItemPriceOption;
}>;

export type GetItemWithItemPriceOptionListQuery = {
  getItemWithItemPriceOptionList: Array<{
    itemID: number;
    itemName: string;
    options: Array<{ itemPriceOptionID: number; name: string; price: number }>;
  }>;
};

export type GetBrandShopQueryVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
  brandID?: InputMaybe<Scalars['Int32']['input']>;
  shopID?: InputMaybe<Scalars['Int32']['input']>;
  appType: Array<AppType> | AppType;
  at?: InputMaybe<Scalars['String']['input']>;
}>;

export type GetBrandShopQuery = {
  getAppCoverage: Array<{
    appID: string;
    name: string;
    providerCode?: string | null;
    coverage: { brands: Array<{ brandID: number; shops: Array<number> }> };
  }>;
};

export type ListMemberSourceQueryVariables = Exact<{
  brandKey: BrandKey;
}>;

export type ListMemberSourceQuery = {
  listMemberSource: {
    cardType: MemberCardType;
    sources: Array<{
      memberSourceID: string;
      displayName: string;
      providerCode: string;
      activate: boolean;
    }>;
  };
};

export type ExportMemberListCsvMutationVariables = Exact<{
  memberCSVInput: MemberCsvInput;
}>;

export type ExportMemberListCsvMutation = { exportMemberListCSV: string };

export type ExportMemberImportTemplateCsvMutationVariables = Exact<{
  locale: Locales;
}>;

export type ExportMemberImportTemplateCsvMutation = {
  exportMemberImportTemplateCSV: string;
};

export type ImportMembersCsvFileMutationVariables = Exact<{
  brandKey: BrandKey;
  file: Scalars['Upload']['input'];
}>;

export type ImportMembersCsvFileMutation = {
  importMembersCSVFile: {
    filePath: string;
    memberResult: {
      createdCardIDs: Array<string>;
      createdMemberIDs: Array<string>;
      skippedCount: number;
      source: string;
    };
  };
};

export type ListMembersQueryVariables = Exact<{
  brandKey: BrandKey;
  source?: InputMaybe<Scalars['String']['input']>;
  memberSourceID: Scalars['UUID']['input'];
  searchParams?: InputMaybe<MemberSearchParams>;
  searchCondition?: InputMaybe<MemberSearchCondition>;
  search?: InputMaybe<Scalars['String']['input']>;
  pageInput: CursorPageInput;
}>;

export type ListMembersQuery = {
  listMembers: {
    members: Array<{
      memberID: string;
      memberCode: string;
      countryCode?: string | null;
      fullName?: string | null;
      phone: string;
      email?: string | null;
      activate: boolean;
      source: string;
      preferences?: Record<string, unknown> | null;
      createdAt: string;
      wallet?: { balance: number; updatedAt: string } | null;
      card?: { cardCode: string; activate: boolean } | null;
      workspaceMember?: {
        memberSourceID: string;
        displayName?: string | null;
      } | null;
    }>;
    pageInfo: { nextCursor?: string | null; prevCursor?: string | null };
  };
};

export type GetMinChargeSettingQueryVariables = Exact<{
  shopKey: ShopKey;
}>;

export type GetMinChargeSettingQuery = {
  getMinChargeSetting?: {
    enabled: boolean;
    advName: string;
    includeAdult: boolean;
    includeChild: boolean;
    taxCategory: TaxCategory;
    taxGroupID?: number | null;
    shopDiningOptionApplyMode: ShopDiningOptionApplyMode;
    minChargeMode: MinChargeMode;
    minChargeUnifiedThresholdAmount?: number | null;
    minChargeSingleItemOffsetMode?: MinChargeSingleItemOffsetMode | null;
    minChargeSingleItemThresholdAmount?: number | null;
    minChargeAchieveMethod: MinChargeAchieveMethod;
    minChargeUnmetAction: MinChargeUnmetAction;
    minChargeUnmetFixedAmount?: number | null;
    selDiningOptions: Array<{ brandDiningOptionID: number }>;
    exclItems: Array<{
      itemID: number;
      item: {
        name: string;
        code: string;
        itemPriceOptions: Array<{ itemCode: string }>;
      };
    }>;
  } | null;
};

export type SetMinChargeSettingMutationVariables = Exact<{
  shopKey: ShopKey;
  minChargeInput: MinChargeInput;
}>;

export type SetMinChargeSettingMutation = { setMinChargeSetting: boolean };

export type ListMultiShopBrandListQueryVariables = Exact<{
  workspaceKey: WorkspaceKey;
  search: Scalars['String']['input'];
  pageInput: CursorPageInput;
}>;

export type ListMultiShopBrandListQuery = {
  listMultiShopList: {
    pages: Array<{
      workspaceID: string;
      brandID?: number | null;
      webURL: string;
      lineOAURL?: string | null;
      brandName?: string | null;
      selectedShopsCount: number;
    }>;
    pageInfo: { prevCursor?: string | null; nextCursor?: string | null };
  };
};

export type ListMultiShopGroupListQueryVariables = Exact<{
  workspaceKey: WorkspaceKey;
  search: Scalars['String']['input'];
  pageInput: CursorPageInput;
}>;

export type ListMultiShopGroupListQuery = {
  listMultiShopList: {
    pages: Array<{
      workspaceID: string;
      webURL: string;
      pageID?: string | null;
      pageName?: string | null;
      selectedShopsCount: number;
    }>;
    pageInfo: { prevCursor?: string | null; nextCursor?: string | null };
  };
};

export type GetMultiShopShopsQueryVariables = Exact<{
  workspaceKey: WorkspaceKey;
  selectPage: Scalars['String']['input'];
  brandID?: InputMaybe<Scalars['Int32']['input']>;
  pageID?: InputMaybe<Scalars['UUID']['input']>;
}>;

export type GetMultiShopShopsQuery = {
  getMultiShopShops: {
    brands?: Array<{
      brandID: number;
      brandName: string;
      subBrands: Array<{
        subBrandID?: number | null;
        subBrandName: string;
        shops: Array<{ shopID: number; name: string }>;
      }>;
    }> | null;
    subBrands?: Array<{
      subBrandID?: number | null;
      subBrandName: string;
      shops: Array<{ shopID: number; name: string }>;
    }> | null;
  };
};

export type GetBrandPortalSettingQueryVariables = Exact<{
  brandKey: BrandKey;
}>;

export type GetBrandPortalSettingQuery = {
  getBrandPortalSetting: {
    showDescription: boolean;
    showAddress: boolean;
    showDistance: boolean;
    showPhone: boolean;
    showDiningOption: boolean;
    showBusinessHours: boolean;
    notes: string;
    brandImageHash?: string | null;
    shopApplyMode: ShopApplyMode;
    updatedAt: string;
    brand: { name: string };
    carouselImages: Array<{
      imageID: number;
      hash: string;
      displayOrder: number;
    }>;
    selectedShops: Array<{ brandID: number; shopID: number }>;
  };
};

export type UpdateBrandPortalSettingMutationVariables = Exact<{
  input: UpdateBrandPortalSettingInput;
}>;

export type UpdateBrandPortalSettingMutation = {
  updateBrandPortalSetting: { workspaceID: string; brandID: number };
};

export type GetCrossBrandPortalSettingQueryVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
  pageID: Scalars['UUID']['input'];
}>;

export type GetCrossBrandPortalSettingQuery = {
  getCrossBrandPortalSetting: {
    pageName: string;
    showBrandFilter: boolean;
    showDescription: boolean;
    showAddress: boolean;
    showDistance: boolean;
    showPhone: boolean;
    showDiningOption: boolean;
    showBusinessHours: boolean;
    notes: string;
    brandImageHash?: string | null;
    shopApplyMode: ShopApplyMode;
    updatedAt: string;
    carouselImages: Array<{
      imageID: number;
      hash: string;
      displayOrder: number;
    }>;
    selectedShops: Array<{ brandID: number; shopID: number }>;
  };
};

export type UpdateCrossBrandPortalSettingMutationVariables = Exact<{
  input: UpdateCrossBrandPortalSettingInput;
}>;

export type UpdateCrossBrandPortalSettingMutation = {
  updateCrossBrandPortalSetting: { workspaceID: string; pageID: string };
};

export type MultiShopGetEmployeeQueryVariables = Exact<{
  employeeID: Scalars['UUID']['input'];
  workspaceID: Scalars['UUID']['input'];
}>;

export type MultiShopGetEmployeeQuery = {
  getEmployee: {
    employee: { orgBelongs: Array<{ brandID?: number | null }> };
    role?: { of: PermissionScope } | null;
  };
};

export type DeleteCrossBrandPortalSettingMutationVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
  pageID: Scalars['UUID']['input'];
}>;

export type DeleteCrossBrandPortalSettingMutation = {
  deleteCrossBrandPortalSetting: boolean;
};

export type GetOnlineOrderSettingQueryVariables = Exact<{
  shopKey: ShopKey;
}>;

export type GetOnlineOrderSettingQuery = {
  getOnlineOrderSetting: {
    onlineOrderUrl?: string | null;
    shopO2OSetting?: {
      onlineOrderActivate: boolean;
      cashOnSiteActivate: boolean;
      cashDelivery: boolean;
      cashPickup: boolean;
      linePayActivate: boolean;
      linePayDelivery: boolean;
      linePayPickup: boolean;
      creditCardActivate: boolean;
      creditCardDelivery: boolean;
      creditCardPickup: boolean;
      announcement?: string | null;
      hideItemSpecialRequire: boolean;
      hideOrderNote: boolean;
      menuSource: MenuType;
      memberLoginRequired: O2OMemberLoginRequiredType;
      memberLoginTiming: O2OMemberLoginTimingType;
      memberSourceID?: string | null;
      needAskingUtensil: boolean;
      utensilMessage?: string | null;
      needAskingExtraBag: boolean;
      extraBagMessage?: string | null;
      bagItemID?: number | null;
      bagItemPriceOptionID?: number | null;
      immediateOrderActivate: boolean;
      preorderActivate: boolean;
      bufferTimeInMin: number;
      preorderAcceptanceRangeBegin: number;
      preorderAcceptanceRangeExtra: number;
    } | null;
    shopO2OBanner?: Array<{ hash: string; bannerID: number } | null> | null;
  };
};

export type SetOnlineOrderSettingMutationVariables = Exact<{
  shopKey: ShopKey;
  onlineOrderSettingInput: OnlineOrderSettingInput;
}>;

export type SetOnlineOrderSettingMutation = { setOnlineOrderSetting: boolean };

export type ListShopDiningOptionsByTypeQueryVariables = Exact<{
  shopKey: ShopKey;
  diningOptionType: DiningOptionType;
}>;

export type ListShopDiningOptionsByTypeQuery = {
  listShopDiningOptionsByType: Array<{
    workspaceID: string;
    brandID: number;
    shopID: number;
    disabled: boolean;
    brandDiningOptionID: number;
    brandDiningOption: { name: string };
  }>;
};

export type GetOnlineOrderSettingMealTakeMethodQueryVariables = Exact<{
  shopKey: ShopKey;
}>;

export type GetOnlineOrderSettingMealTakeMethodQuery = {
  getOnlineOrderSetting: {
    shopO2OSetting?: {
      workspaceID: string;
      brandID: number;
      shopID: number;
      pickupActivate: boolean;
      pickupMethod?: string | null;
      pickupPrepareMealTimeInMin?: number | null;
      deliveryActivate: boolean;
      deliverMethod?: string | null;
      deliveryPrepareMealTimeInMin?: number | null;
      deliveryTimeInMin?: number | null;
      deliveryDistanceRule?: O2ODeliveryDistanceRule | null;
      deliveryDistanceMaxKm?: number | null;
      deliveryFeeRule?: O2ODeliveryFeeRule | null;
      deliveryFeeAmount?: number | null;
      deliveryFeeCalcMode: O2ODeliveryFeeCalcMode;
    } | null;
  };
};

export type UpdateOnlineOrderPickupSettingMutationVariables = Exact<{
  input: UpdateOnlineOrderPickupSettingInput;
}>;

export type UpdateOnlineOrderPickupSettingMutation = {
  updateOnlineOrderPickupSetting: boolean;
};

export type GetOnlineOrderTimeSettingQueryVariables = Exact<{
  shopKey: ShopKey;
}>;

export type GetOnlineOrderTimeSettingQuery = {
  getOnlineOrderTimeSetting: {
    orderingHours: Array<{
      hourID: number;
      weekDay: number;
      startTime: string;
      endTime: string;
    }>;
    offDays: Array<{ offDayID: number; offDay: string }>;
  };
};

export type UpdateOnlineOrderTimeSettingMutationVariables = Exact<{
  input: UpdateOnlineOrderTimeSettingInput;
}>;

export type UpdateOnlineOrderTimeSettingMutation = {
  updateOnlineOrderTimeSetting: boolean;
};

export type GetOnlineOrderOverviewQueryVariables = Exact<{
  input: GetOnlineOrderOverviewInput;
}>;

export type GetOnlineOrderOverviewQuery = {
  getOnlineOrderOverview: {
    revenue: {
      totalRevenue: number;
      onlineOrder: {
        amount: number;
        percentage: number;
        details?: Array<{
          source: string;
          amount: number;
          percentage: number;
        }> | null;
      };
      scanOrder: {
        amount: number;
        percentage: number;
        details?: Array<{
          source: string;
          amount: number;
          percentage: number;
        }> | null;
      };
    };
    volume: {
      totalVolume: number;
      onlineOrder: {
        count: number;
        percentage: number;
        details?: Array<{
          source: string;
          count: number;
          percentage: number;
        }> | null;
      };
      scanOrder: {
        count: number;
        percentage: number;
        details?: Array<{
          source: string;
          count: number;
          percentage: number;
        }> | null;
      };
    };
    ratio: {
      percentageExcludeOffline: number;
      totalOrders: {
        count: number;
        percentage: number;
        offlineOrder: { count: number; percentage: number };
        onlineOrder: { count: number; percentage: number };
        scanOrder: { count: number; percentage: number };
      };
    };
  };
};

export type OnlineOrderRevenueTrendQueryVariables = Exact<{
  input: GetOnlineOrderOverviewInput;
}>;

export type OnlineOrderRevenueTrendQuery = {
  onlineOrderRevenueTrend: {
    acceptTimeUnit: Array<string>;
    yRange: Array<number>;
    revenueTrends: Array<{
      time: string;
      totalRevenue: number;
      onlineOrder: number;
      scanOrder: number;
      onlineOrderDetails?: Array<{
        source: string;
        amount: number;
        percentage: number;
      }> | null;
      scanOrderDetails?: Array<{
        source: string;
        amount: number;
        percentage: number;
      }> | null;
    }>;
  };
};

export type OnlineOrderVolumeTrendQueryVariables = Exact<{
  input: GetOnlineOrderOverviewInput;
}>;

export type OnlineOrderVolumeTrendQuery = {
  onlineOrderVolumeTrend: {
    acceptTimeUnit: Array<string>;
    yRange: Array<number>;
    volumeTrends: Array<{
      time: string;
      totalVolume: number;
      onlineOrder: number;
      scanOrder: number;
      onlineOrderDetails?: Array<{
        source: string;
        count: number;
        percentage: number;
      }> | null;
      scanOrderDetails?: Array<{
        source: string;
        count: number;
        percentage: number;
      }> | null;
    }>;
  };
};

export type GetOnlineOrderListQueryVariables = Exact<{
  shopKey: ShopKey;
  searchParams: OnlineOrderSearchParams;
  searchCondition?: InputMaybe<OnlineOrderSearchCondition>;
  search?: InputMaybe<Scalars['String']['input']>;
  pageInput: CursorPageInput;
}>;

export type GetOnlineOrderListQuery = {
  getOnlineOrderList: {
    onlineOrders: Array<{
      orderID: string;
      createdAt: string;
      orderNo: string;
      refundedOrderNo?: string | null;
      orderCode: string;
      externalOrderNo?: string | null;
      externalOrderCode?: string | null;
      orderType: string;
      orderStatus: string;
      orderSubStatus?: string | null;
      subtotalAmount: number;
      discountAmount: number;
      serviceFeeAmount: number;
      totalAmount: number;
      platformServiceFeeAmount: number;
      appropriationAmount: number;
      deliveryFeeAmount: number;
      exclusiveTaxAmount: number;
      orderSource: string;
      paymentTime: Array<string>;
      onlineOrderPayments: Array<{ name: string; amount: number }>;
    }>;
    pageInfo: { nextCursor?: string | null; prevCursor?: string | null };
  };
};

export type ExportOnlineOrderListCsvMutationVariables = Exact<{
  input: OnlineOrderListCsvInput;
}>;

export type ExportOnlineOrderListCsvMutation = {
  exportOnlineOrderListCSV: string;
};

export type ListOrdersQueryVariables = Exact<{
  shopKey: ShopKey;
  searchParams: OrderSearchParams;
  searchCondition: OrderSearchCondition;
  search?: InputMaybe<Scalars['String']['input']>;
  pageInput: CursorPageInput;
}>;

export type ListOrdersQuery = {
  listOrders: {
    orders?: Array<{
      orderID: string;
      createdAt: string;
      orderNo: string;
      orderCode: string;
      diningOptionName: string;
      orderType: OrderType;
      orderStatus: OrderStatus;
      subtotalAmount: number;
      discountAmount: number;
      serviceFeeAmount: number;
      totalAmount: number;
      businessDate: string;
      reservedAt?: string | null;
      externalOrderNo?: string | null;
      tableNo?: string | null;
      adult: number;
      child: number;
      taxAmount: number;
      orderSource: OrderSource;
      deviceCode: string;
      opUser?: { lastName?: string | null; firstName?: string | null } | null;
      transactions: Array<{
        createdAt: string;
        transactionNo: string;
        payments: Array<{
          sysPaymentMethodID: string;
          brandPaymentMethodName: string;
          amount: number;
        }>;
        invoices?: Array<{ invoiceNo: string }> | null;
      }>;
    }> | null;
    pageInfo: { nextCursor?: string | null; prevCursor?: string | null };
  };
};

export type ExportOrdersCsvFileMutationVariables = Exact<{
  input: OrdersCsvInput;
}>;

export type ExportOrdersCsvFileMutation = { exportOrdersCSVFile: string };

export type GetOrderQueryVariables = Exact<{
  orderKey: OrderKey;
}>;

export type GetOrderQuery = {
  order: {
    orderID: string;
    brandID: number;
    refundedFromID?: string | null;
    createdAt: string;
    orderType: OrderType;
    orderStatus: OrderStatus;
    statusLog?: Record<string, unknown> | null;
    orderNo: string;
    orderCode: string;
    diningOptionName: string;
    diningOptionType: DiningOptionType;
    tableNo?: string | null;
    adult: number;
    child: number;
    babyChair: number;
    externalOrderNo?: string | null;
    externalOrderCode?: string | null;
    shopID: number;
    orderSource: OrderSource;
    note?: string | null;
    subtotalAmount: number;
    discountAmount: number;
    serviceFeeAmount: number;
    taxAmount: number;
    preTaxAmount: number;
    totalAmount: number;
    taxInfo?: Record<string, unknown> | null;
    contactName?: string | null;
    contactPhone?: string | null;
    contactAddress?: string | null;
    reservedAt?: string | null;
    orderSourceApp?: { appType: AppType; slug?: string | null } | null;
    transactions: Array<{
      transactionID: string;
      parentID?: string | null;
      transactionNo: string;
      createdAt: string;
      transactionStatus: TransactionStatus;
      totalAmount: number;
      splitMethod: TransactionSplitMethod;
      transactionCode: string;
      businessDate: string;
      transactionType: TransactionType;
      deviceCode: string;
      pDeviceName: string;
      splitInvoiceIssuedMethod: SplitInvoiceIssuedMethod;
      subtotalAmount: number;
      serviceFeeAmount: number;
      invoices?: Array<{
        amount: number;
        invoiceNo: string;
        invoiceStatus: InvoiceStatus;
        createdAt: string;
        voidedAt?: string | null;
        carrierCode?: string | null;
        donationCode?: string | null;
        taxID?: string | null;
        preTaxAmount: number;
        taxAmount: number;
      }> | null;
      opUser?: { lastName?: string | null; firstName?: string | null } | null;
      payments: Array<{
        brandPaymentMethodID: number;
        amount: number;
        brandPaymentMethodName: string;
        createdAt: string;
        paymentID: string;
      }>;
      transactionDetails: Array<{
        itemName: string;
        splitPrice: number;
        splitCount: number;
        labelInfo?: Record<string, unknown> | null;
        itemBundleInfo?: Record<string, unknown> | null;
        isComplimentary: boolean;
        discountInfo?: Record<string, unknown> | null;
      }>;
    }>;
    orderDiscounts?: Array<{
      discountName: string;
      discountAmount: number;
    }> | null;
  };
};

export type GetRefundOrderQueryVariables = Exact<{
  orderKey: OrderKey;
}>;

export type GetRefundOrderQuery = {
  order: {
    orderID: string;
    brandID: number;
    refundedFromID?: string | null;
    createdAt: string;
    orderType: OrderType;
    orderStatus: OrderStatus;
    statusLog?: Record<string, unknown> | null;
    orderNo: string;
    orderCode: string;
    diningOptionName: string;
    diningOptionType: DiningOptionType;
    tableNo?: string | null;
    adult: number;
    child: number;
    babyChair: number;
    externalOrderNo?: string | null;
    externalOrderCode?: string | null;
    shopID: number;
    orderSource: OrderSource;
    note?: string | null;
    subtotalAmount: number;
    discountAmount: number;
    serviceFeeAmount: number;
    taxAmount: number;
    preTaxAmount: number;
    totalAmount: number;
    contactName?: string | null;
    contactPhone?: string | null;
    contactAddress?: string | null;
    reservedAt?: string | null;
    orderSourceApp?: { appType: AppType; slug?: string | null } | null;
    transactions: Array<{
      transactionID: string;
      parentID?: string | null;
      transactionNo: string;
      createdAt: string;
      transactionStatus: TransactionStatus;
      totalAmount: number;
      splitMethod: TransactionSplitMethod;
      transactionCode: string;
      businessDate: string;
      transactionType: TransactionType;
      deviceCode: string;
      pDeviceName: string;
      splitInvoiceIssuedMethod: SplitInvoiceIssuedMethod;
      subtotalAmount: number;
      serviceFeeAmount: number;
      invoices?: Array<{
        amount: number;
        invoiceNo: string;
        invoiceStatus: InvoiceStatus;
        createdAt: string;
        voidedAt?: string | null;
        carrierCode?: string | null;
        donationCode?: string | null;
        taxID?: string | null;
        preTaxAmount: number;
        taxAmount: number;
      }> | null;
      opUser?: { lastName?: string | null; firstName?: string | null } | null;
      payments: Array<{
        brandPaymentMethodID: number;
        amount: number;
        brandPaymentMethodName: string;
        createdAt: string;
        paymentID: string;
      }>;
      transactionDetails: Array<{
        itemName: string;
        splitPrice: number;
        splitCount: number;
        labelInfo?: Record<string, unknown> | null;
        itemBundleInfo?: Record<string, unknown> | null;
        isComplimentary: boolean;
        discountInfo?: Record<string, unknown> | null;
      }>;
    }>;
    orderDiscounts?: Array<{
      discountName: string;
      discountAmount: number;
    }> | null;
  };
};

export type GetOrderDetailsQueryVariables = Exact<{
  orderKey: OrderKey;
  haveChanged: Scalars['Boolean']['input'];
}>;

export type GetOrderDetailsQuery = {
  getOrderDetails: Array<{
    orderDetailID: string;
    parentID?: string | null;
    itemID: number;
    itemKind: ItemKind;
    itemName: string;
    itemPriceOptionID: number;
    itemPriceOptionName: string;
    itemPrice: number;
    itemQuantity: number;
    isComplimentary: boolean;
    totalAmount: number;
    orderDetailLabels: Array<{
      labelID: number;
      labelName: string;
      labelPrice: number;
      labelQuantity: number;
      displayOrder: number;
    }>;
    orderDetailDiscounts?: Array<{
      discountID?: number | null;
      discountName: string;
      discountAmount: number;
    }> | null;
  }>;
};

export type OrderDetailListShopsQueryVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
  brandID: Scalars['Int32']['input'];
  shopID?: InputMaybe<Scalars['Int32']['input']>;
}>;

export type OrderDetailListShopsQuery = {
  listShops: Array<{ shopID: number; name: string; id: number }>;
};

export type GetShopDiningOptionsQueryVariables = Exact<{
  shopKey: ShopKey;
}>;

export type GetShopDiningOptionsQuery = {
  getShopDiningOptions: Array<{
    disabled: boolean;
    displayOrder: number;
    brandDiningOption: {
      brandDiningOptionID: number;
      disabled: boolean;
      diningOptionType: DiningOptionType;
      name: string;
    };
  }>;
};

export type OrderDetailListShopPaymentMethodsQueryVariables = Exact<{
  shopKey: ShopKey;
}>;

export type OrderDetailListShopPaymentMethodsQuery = {
  listShopPaymentMethods: {
    shopPaymentMethod: Array<{
      brandPaymentMethodID: number;
      selected: boolean;
      displayOrder: number;
      brandPaymentMethod: {
        sysPaymentMethodID?: string | null;
        name: string;
        displayOrder: number;
        parentID?: number | null;
      };
    }>;
  };
};

export type OrderDetailGetShopReasonSettingsQueryVariables = Exact<{
  shopKey: ShopKey;
  reasonType: ReasonType;
}>;

export type OrderDetailGetShopReasonSettingsQuery = {
  getShopReasonSettings?: Array<{
    reasonTemplateID: number;
    selected: boolean;
    displayOrder: number;
    reasonTemplate: { name: string; disabled: boolean };
  }> | null;
};

export type RefundAnOrderMutationVariables = Exact<{
  orderKey: OrderKey;
  method: VoidMethod;
  reason: Scalars['String']['input'];
}>;

export type RefundAnOrderMutation = { refundAnOrder: boolean };

export type UpdateAnOrderMutationVariables = Exact<{
  orderKey: OrderKey;
  input: UpdateAnOrderInput;
}>;

export type UpdateAnOrderMutation = { updateAnOrder: boolean };

export type GetShopOrderRemarkSettingQueryVariables = Exact<{
  shopKey: ShopKey;
}>;

export type GetShopOrderRemarkSettingQuery = {
  getShopOrderRemarkSetting: {
    orderRemarkEnabled: boolean;
    shopOrderRemarkTitles: Array<{
      titleID: string;
      title: string;
      disabled: boolean;
      displayOrder: number;
    }>;
    shopDiningOptions: Array<{
      brandDiningOptionID: number;
      disabled: boolean;
      displayOrder: number;
      orderRemarkTitleID?: string | null;
      orderRemarkTitleRequired: boolean;
      brandDiningOption: { name: string };
    }>;
  };
};

export type UpdateShopOrderRemarkSettingMutationVariables = Exact<{
  input: UpdateShopOrderRemarkSettingInput;
}>;

export type UpdateShopOrderRemarkSettingMutation = {
  updateShopOrderRemarkSetting: boolean;
};

export type UpdateShopOrderRemarkTitlesMutationVariables = Exact<{
  input: UpdateShopOrderRemarkTitlesInput;
}>;

export type UpdateShopOrderRemarkTitlesMutation = {
  updateShopOrderRemarkTitles: boolean;
};

export type ListSysPaymentMethodsQueryVariables = Exact<{
  brandKey?: InputMaybe<BrandKey>;
}>;

export type ListSysPaymentMethodsQuery = {
  listSysPaymentMethods: Array<{
    sysPaymentMethodID: string;
    name: string;
    description: string;
    paymentMethodCategory: PaymentMethodCategory;
    generalSettingSchema: Record<string, unknown>;
    extendSettingSchema?: Record<string, unknown> | null;
  }>;
};

export type ListShopPaymentMethodsQueryVariables = Exact<{
  shopKey: ShopKey;
}>;

export type ListShopPaymentMethodsQuery = {
  listShopPaymentMethods: {
    shopPaymentSetting: {
      defaultPaymentMethodID?: number | null;
      needInputAmount: boolean;
      quickDefaultPaymentMethodID?: number | null;
    };
    shopPaymentMethod: Array<{
      brandPaymentMethodID: number;
      selected: boolean;
      displayOrder: number;
      brandPaymentMethod: {
        sysPaymentMethodID?: string | null;
        name: string;
        code: string;
        displayOrder: number;
        parentID?: number | null;
        sysPaymentMethod?: {
          name: string;
          description: string;
          generalSettingSchema: Record<string, unknown>;
          extendSettingSchema?: Record<string, unknown> | null;
          paramSettingSchema?: Record<string, unknown> | null;
        } | null;
      };
    }>;
  };
};

export type ListBrandPaymentMethodsQueryVariables = Exact<{
  brandKey: BrandKey;
  isGrouped?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ListBrandPaymentMethodsQuery = {
  listBrandPaymentMethods: Array<{
    brandPaymentMethodID: number;
    parentID?: number | null;
    name: string;
    disabled: boolean;
    displayOrder: number;
    code: string;
    sysPaymentMethodID?: string | null;
    createdAt: string;
    sysPaymentMethod?: {
      paymentMethodCategory: PaymentMethodCategory;
      generalSettingSchema: Record<string, unknown>;
      extendSettingSchema?: Record<string, unknown> | null;
    } | null;
  }>;
};

export type DisableBrandPaymentMethodsMutationVariables = Exact<{
  input: DisableBrandPaymentMethods;
}>;

export type DisableBrandPaymentMethodsMutation = {
  disableBrandPaymentMethods: boolean;
};

export type CreateABrandPaymentMethodMutationVariables = Exact<{
  input: BrandPaymentMethodInput;
}>;

export type CreateABrandPaymentMethodMutation = {
  createABrandPaymentMethod?: number | null;
};

export type UpdateABrandPaymentMethodMutationVariables = Exact<{
  input: BrandPaymentMethodInput;
}>;

export type UpdateABrandPaymentMethodMutation = {
  updateABrandPaymentMethod: boolean;
};

export type DeleteABrandPaymentMethodMutationVariables = Exact<{
  brandPaymentMethodKey: BrandPaymentMethodKey;
}>;

export type DeleteABrandPaymentMethodMutation = {
  deleteABrandPaymentMethod: boolean;
};

export type UngrounpListBrandPaymentMethodsQueryVariables = Exact<{
  brandKey: BrandKey;
  isGrouped?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type UngrounpListBrandPaymentMethodsQuery = {
  listBrandPaymentMethods: Array<{
    brandPaymentMethodID: number;
    name: string;
    sysPaymentMethodID?: string | null;
    sysPaymentMethod?: { name: string; description: string } | null;
  }>;
};

export type CreateAGroupOfBrandPaymentMethodsMutationVariables = Exact<{
  input: CreateAGroupOfBrandPaymentMethodsInput;
}>;

export type CreateAGroupOfBrandPaymentMethodsMutation = {
  createAGroupOfBrandPaymentMethods?: number | null;
};

export type UpdateAGroupOfBrandPaymentMethodsMutationVariables = Exact<{
  input: UpdateAGroupOfBrandPaymentMethodsInput;
}>;

export type UpdateAGroupOfBrandPaymentMethodsMutation = {
  updateAGroupOfBrandPaymentMethods: boolean;
};

export type DisbandAGroupOfBrandPaymentMethodsMutationVariables = Exact<{
  brandPaymentMethodKey: BrandPaymentMethodKey;
}>;

export type DisbandAGroupOfBrandPaymentMethodsMutation = {
  disbandAGroupOfBrandPaymentMethods: boolean;
};

export type UpdateShopPaymentMethodDisplayOrderMutationVariables = Exact<{
  shopKey: ShopKey;
  updateOrder?: InputMaybe<
    Array<BrandPaymentMethodOrderInput> | BrandPaymentMethodOrderInput
  >;
}>;

export type UpdateShopPaymentMethodDisplayOrderMutation = {
  updateShopPaymentMethodDisplayOrder: boolean;
};

export type UpdateAShopPaymentMethodMutationVariables = Exact<{
  input: UpdateAShopPaymentMethodInput;
}>;

export type UpdateAShopPaymentMethodMutation = {
  updateAShopPaymentMethod: boolean;
};

export type UpdateShopPaymentSettingMutationVariables = Exact<{
  input: UpdateShopPaymentSettingInput;
}>;

export type UpdateShopPaymentSettingMutation = {
  updateShopPaymentSetting: boolean;
};

export type GetRevenueReportQueryVariables = Exact<{
  input: GetTransactionReportInput;
}>;

export type GetRevenueReportQuery = {
  getRevenueReport: {
    acceptTimeUnit: Array<string>;
    yRange: Array<number>;
    revenueReports: Array<{
      time: string;
      revenue: {
        revenue: number;
        itemAmount: number;
        serviceCharge: number;
        deliveryFee: number;
        minCharge: number;
        discount: number;
        refund: number;
        tax: number;
      };
    }>;
  };
};

export type GetTransactionReportQueryVariables = Exact<{
  input: GetTransactionReportInput;
}>;

export type GetTransactionReportQuery = {
  getTransactionReport: {
    customersNum: number;
    transactionNum: number;
    avgCost: number;
    avgCostPerPerson: number;
    acceptTimeUnit: Array<string>;
    yRange: Array<number>;
    costReports: Array<{ time: string; avgCostPerPerson: number }>;
  };
};

export type GetFixedTransactionDataQueryVariables = Exact<{
  input: GetTransactionReportInput;
}>;

export type GetFixedTransactionDataQuery = {
  getFixedTransactionData: {
    revenue: {
      revenue: number;
      itemAmount: number;
      serviceCharge: number;
      deliveryFee: number;
      minCharge: number;
      discount: number;
      refund: number;
      tax: number;
      nonRevenuePayment: Array<{
        sysPaymentMethodID: string;
        brandPaymentMethodName: string;
        paymentAmount: number;
      } | null>;
    };
    transaction: {
      transactionNum: number;
      totalTransactionNum: number;
      invalidTransactionNum: number;
      transactionAmount: number;
      totalTransactionAmount: number;
      invalidTransactionAmount: number;
    };
    itemRank: {
      totalAmount: number;
      details: Array<{ name: string; count: number; rank: number }>;
    };
  };
};

export type GetPaymentRankForDoughnutQueryVariables = Exact<{
  input: GetTransactionReportInput;
}>;

export type GetPaymentRankForDoughnutQuery = {
  getPaymentReport: {
    totalAmount: number;
    totalCount: number;
    paymentRanks: Array<{
      name: string;
      amount: number;
      count: number;
      percentageAmount: number;
      percentageCount: number;
    }>;
  };
};

export type GetDiningRankForDoughnutQueryVariables = Exact<{
  input: GetTransactionReportInput;
}>;

export type GetDiningRankForDoughnutQuery = {
  getDiningReport: {
    totalAmount: number;
    totalCount: number;
    diningRank: Array<{
      name: string;
      amount: number;
      count: number;
      percentageAmount: number;
      percentageCount: number;
    }>;
  };
};

export type UpdateEmployeeNameByEmployeeIdMutationVariables = Exact<{
  employeeID: Scalars['UUID']['input'];
  lastName: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
}>;

export type UpdateEmployeeNameByEmployeeIdMutation = {
  updateEmployeeNameByEmployeeID: boolean;
};

export type ChangeUserPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;

export type ChangeUserPasswordMutation = { changeUserPassword: boolean };

export type ListPosDevicesQueryVariables = Exact<{
  shopKey: ShopKey;
  bindState?: InputMaybe<FilterBindState>;
  pageInput: CursorPageInput;
}>;

export type ListPosDevicesQuery = {
  listPOSDevices: {
    boughtNum: number;
    boundNum: number;
    vDevices?: Array<{
      shopID: number;
      vDeviceID: number;
      name: string;
      deviceType: VDeviceType;
      deviceCode: string;
      isBound: boolean;
      isCds?: boolean | null;
      isCashier: boolean;
      posOrderStyle?: PosOrderStyle | null;
      autoCheckoutOnConfirm?: boolean | null;
      isServiceHub: boolean;
      boundAt?: string | null;
      equipments: Array<{
        equipmentID: number;
        name: string;
        bindSettingID: string;
        app?: { appID: string; name: string; slug?: string | null } | null;
      }>;
      pDevice?: {
        name: string;
        deviceCode: string;
        pDeviceEvents: Array<{
          deviceInfo?: Record<string, unknown> | null;
          createdAt: string;
        }>;
        pPrinters?: Array<{
          pPrinterID: number;
          printerBrand: string;
          printerModel?: string | null;
          printerInfo: Record<string, unknown>;
          connectMedia: ConnectMediaType;
          linkVPrinterPPrinters?: Array<{
            vPrinter: {
              vPrinterID: number;
              name?: string | null;
              paperSize?: PrinterPaperSize | null;
              type: PrinterType;
            };
          } | null> | null;
        }> | null;
      } | null;
    }> | null;
    pageInfo: { nextCursor?: string | null; prevCursor?: string | null };
  };
};

export type CreateAposWithEquipmentsMutationVariables = Exact<{
  shopKey: ShopKey;
  name: Scalars['String']['input'];
  deviceCode: Scalars['String']['input'];
  isCashier: Scalars['Boolean']['input'];
  posOrderStyle: PosOrderStyle;
  autoCheckoutOnConfirm?: InputMaybe<Scalars['Boolean']['input']>;
  equipments?: InputMaybe<
    Array<UpsertVDeviceEquipmentInput> | UpsertVDeviceEquipmentInput
  >;
}>;

export type CreateAposWithEquipmentsMutation = {
  createAPOSWithEquipments: boolean;
};

export type UpdateTheVDeviceMutationVariables = Exact<{
  vDeviceKey: VDeviceKey;
  name: Scalars['String']['input'];
  code: Scalars['String']['input'];
  isCashier?: InputMaybe<Scalars['Boolean']['input']>;
  disableCDS?: InputMaybe<Scalars['Boolean']['input']>;
  posOrderStyle?: InputMaybe<PosOrderStyle>;
  autoCheckoutOnConfirm?: InputMaybe<Scalars['Boolean']['input']>;
  equipments?: InputMaybe<
    Array<UpsertVDeviceEquipmentInput> | UpsertVDeviceEquipmentInput
  >;
}>;

export type UpdateTheVDeviceMutation = { updateTheVDevice: boolean };

export type DeleteTheVDeviceMutationVariables = Exact<{
  vDeviceKey: VDeviceKey;
}>;

export type DeleteTheVDeviceMutation = { deleteTheVDevice: boolean };

export type GetAShopPosSettingQueryVariables = Exact<{
  shopKey: ShopKey;
}>;

export type GetAShopPosSettingQuery = {
  getAShopPOSSetting: {
    orderCodeMode: OrderCodeMode;
    showItemPriceOnButton: boolean;
    autoReturnTable: boolean;
    adjustServiceFee: boolean;
    manualDiscountEnabled: boolean;
    manualResolveDiscountConflict: boolean;
    quickCheckout: boolean;
    autoPrint: boolean;
    changeReminder: boolean;
    autoClearTable: boolean;
    lockTableAfterOrder: boolean;
    barcodeAmountScanEnabled: boolean;
    barcodeAmountItemID?: number | null;
    barcodeAmountItemPriceOptionID?: number | null;
    preventCloseOnShortage: boolean;
    preventCloseOnUnpaidOrders: boolean;
    printPaidOnlineOrder: boolean;
    autoIssueOnlineOrder: boolean;
    autoAcceptOnlineOrder: boolean;
    autoIssueInvoiceAfterAcceptPaidOnlineOrder: boolean;
    onlineOrderSettingsScope: OnlineOrderSettingsScope;
    preorderAutoIssueTimingEnabled: boolean;
    preorderAutoIssueBeforeMinutes: number;
    requireVerificationOnVoid: boolean;
    recordComplimentary: boolean;
    printReturnReason: boolean;
    printDeleteSlip: boolean;
    autoLockEnabled: boolean;
    autoLockTime: number;
    punchCardRequireCompleteShift: boolean;
    showTransactionAmountSummary: boolean;
    deviceDataRetentionDays: number;
    barcodeAmountItemPriceOption?: {
      item: { itemID: number; name: string };
    } | null;
    onlineOrderSourceSettings: Array<{
      sourceAppID: string;
      autoAcceptOnlineOrder: boolean;
      autoIssueOnlineOrder: boolean;
      autoIssueInvoiceAfterAcceptPaidOnlineOrder: boolean;
      preorderAutoIssueTimingEnabled: boolean;
      preorderAutoIssueBeforeMinutes: number;
      printPaidOnlineOrder: boolean;
      sourceApp: { appID: string; name: string };
    }>;
  };
};

export type PosSettingListItemsQueryVariables = Exact<{
  brandKey: BrandKey;
  itemCategoryIDs?: InputMaybe<
    Array<Scalars['Int32']['input']> | Scalars['Int32']['input']
  >;
  itemKind?: InputMaybe<ItemKind>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  priceType?: InputMaybe<ItemPriceType>;
  hasItemCategory?: InputMaybe<Scalars['Boolean']['input']>;
  subBrandShop?: InputMaybe<SubBrandShop>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  pageInput: CursorPageInput;
}>;

export type PosSettingListItemsQuery = {
  listItems: {
    items: Array<{
      itemID: number;
      name: string;
      code: string;
      itemPriceOptions: Array<{ itemPriceOptionID: number }>;
    }>;
    pageInfo: { nextCursor?: string | null; prevCursor?: string | null };
  };
};

export type UpdateAShopPosSettingMutationVariables = Exact<{
  input: UpdateAShopPosSettingInput;
}>;

export type UpdateAShopPosSettingMutation = { updateAShopPOSSetting: boolean };

export type GetBrandPosUpdatePolicyQueryVariables = Exact<{
  brandKey: BrandKey;
}>;

export type GetBrandPosUpdatePolicyQuery = {
  getBrandPOSUpdatePolicy: { mode: PosUpdateMode; fixedTime?: string | null };
};

export type UpdateBrandPosUpdatePolicyMutationVariables = Exact<{
  input: UpdateBrandPosUpdatePolicyInput;
}>;

export type UpdateBrandPosUpdatePolicyMutation = {
  updateBrandPOSUpdatePolicy: {
    mode: PosUpdateMode;
    fixedTime?: string | null;
  };
};

export type GetPrintLayoutBaseQueryVariables = Exact<{
  shopKey: ShopKey;
}>;

export type GetPrintLayoutBaseQuery = {
  getPrintLayoutBase: {
    printLayoutBaseID: number;
    diningOptionTicketInfoStyle: DiningOptionTicketInfo;
    diningOptionTicketInfoStyleFix?: BlackWhiteStyle | null;
    diningOptionStickerInfoStyle: DiningOptionTicketInfo;
    diningOptionStickerInfoStyleFix?: BlackWhiteStyle | null;
    consumerNameVisibility: ConsumerInfoVisibility;
    consumerPhoneVisibility: ConsumerInfoVisibility;
    shopInfoFontSize: FontSize;
    shopInfo: string;
    shopInfoAlignStyle: ShopInfoAlignStyle;
    hideItemPrice: boolean;
    printLayoutBaseLogo?: Array<{ hash?: string | null } | null> | null;
    diningOptionTicketInfoStyleSpecify?: Array<{
      style: BlackWhiteStyle;
      brandDiningOptionID: number;
    }> | null;
    diningOptionStickerInfoStyleSpecify?: Array<{
      brandDiningOptionID: number;
      style: BlackWhiteStyle;
    }> | null;
    linkPrintLayoutBaseConsumerNameStyle?: Array<{
      brandDiningOptionID: number;
    }> | null;
    linkPrintLayoutBaseConsumerPhoneStyle?: Array<{
      brandDiningOptionID: number;
    }> | null;
  };
};

export type UpdateAPrintLayoutBaseMutationVariables = Exact<{
  input: UpdateAPrintLayoutBaseInput;
}>;

export type UpdateAPrintLayoutBaseMutation = {
  updateAPrintLayoutBase: boolean;
};

export type PutPrinterLogoImageMutationVariables = Exact<{
  printLayoutBaseKey: PrintLayoutBaseKey;
  file: Scalars['Upload']['input'];
}>;

export type PutPrinterLogoImageMutation = {
  putPrinterLogoImage: { hash?: string | null };
};

export type DeletePrinterLogoImagesMutationVariables = Exact<{
  printLayoutBaseKey: PrintLayoutBaseKey;
}>;

export type DeletePrinterLogoImagesMutation = {
  deletePrinterLogoImages: boolean;
};

export type ListPrintersQueryVariables = Exact<{
  shopKey: ShopKey;
  filterType?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListPrintersQuery = {
  listPrinters: Array<{
    vPrinterID: number;
    bindMethod: PrinterBindMethod;
    deviceCode?: string | null;
    type: PrinterType;
    name?: string | null;
    paperSize?: PrinterPaperSize | null;
    displayOrder: number;
    linkVPrinterPPrinters?: Array<{ pPrinterID: number } | null> | null;
  }>;
};

export type CopyApplyPrinterToShopsMutationVariables = Exact<{
  shopKey: ShopKey;
  shopIDs: Array<Scalars['Int32']['input']> | Scalars['Int32']['input'];
}>;

export type CopyApplyPrinterToShopsMutation = {
  copyApplyPrinterToShops: boolean;
};

export type UpdateDisplayOrderOfVPrintersMutationVariables = Exact<{
  input: PrinterDisplayOrderInput;
}>;

export type UpdateDisplayOrderOfVPrintersMutation = {
  updateDisplayOrderOfVPrinters: boolean;
};

export type CreateAvPrinterMutationVariables = Exact<{
  shopKey: ShopKey;
  input: PrinterInput;
}>;

export type CreateAvPrinterMutation = {
  createAVPrinter: { vPrinterID: number };
};

export type UpdateAvPrinterMutationVariables = Exact<{
  vPrinterKey: VPrinterKey;
  input: PrinterInput;
}>;

export type UpdateAvPrinterMutation = { updateAVPrinter: boolean };

export type DeleteAvPrinterMutationVariables = Exact<{
  vPrinterKey: VPrinterKey;
}>;

export type DeleteAvPrinterMutation = { deleteAVPrinter: boolean };

export type ListCustomizedPapersQueryVariables = Exact<{
  shopKey: ShopKey;
}>;

export type ListCustomizedPapersQuery = {
  listCustomizedPapers: Array<{
    ticketID: number;
    name?: string | null;
    title?: string | null;
    content?: string | null;
    qrcode: CustomizedPaperQrCode;
    qrcodeContent?: string | null;
    ticketCustomizedPaperImages?: Array<{
      imageID: number;
      hash?: string | null;
    } | null> | null;
  }>;
};

export type ListStickerCustomizedNotesQueryVariables = Exact<{
  shopKey: ShopKey;
}>;

export type ListStickerCustomizedNotesQuery = {
  listStickerCustomizedNotes: Array<{
    ticketID: number;
    content?: string | null;
  }>;
};

export type UpdateACustomizedTicketMutationVariables = Exact<{
  shopKey: ShopKey;
  ticketID?: InputMaybe<Scalars['Int32']['input']>;
  input: UpdateCustomizedTicketPayload;
}>;

export type UpdateACustomizedTicketMutation = {
  updateACustomizedTicket: boolean;
};

export type DeleteACustomizedTicketMutationVariables = Exact<{
  shopKey: ShopKey;
  type: TicketCustomizedType;
  ticketID: Scalars['Int32']['input'];
  force?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type DeleteACustomizedTicketMutation = {
  deleteACustomizedTicket: boolean;
};

export type GetAPrinterQueryVariables = Exact<{
  vPrinterKey: VPrinterKey;
}>;

export type GetAPrinterQuery = {
  getAPrinter?: {
    vPrinterID: number;
    bindMethod: PrinterBindMethod;
    deviceCode?: string | null;
    type: PrinterType;
    name?: string | null;
    paperSize?: PrinterPaperSize | null;
    displayOrder: number;
    linkVPrinterPPrinters?: Array<{
      pPrinter: {
        connectMedia: ConnectMediaType;
        printerBrand: string;
        printerModel?: string | null;
        printerInfo: Record<string, unknown>;
        vDevice?: { vDeviceID: number; name: string } | null;
      };
    } | null> | null;
    tickets?: Array<{
      ticketID: number;
      of: TicketOf;
      ticket?:
        | { __typename: 'TicketCheckout'; note?: string | null }
        | { __typename: 'TicketEodClose' }
        | { __typename: 'TicketInvoice' }
        | { __typename: 'TicketKitchen'; note?: string | null }
        | { __typename: 'TicketOrder'; note?: string | null }
        | { __typename: 'TicketQueue'; note?: string | null }
        | { __typename: 'TicketScanOrder' }
        | { __typename: 'TicketShiftClose' }
        | { __typename: 'TicketSticker'; note?: string | null }
        | null;
    } | null> | null;
  } | null;
};

export type ListPrinterStylesQueryVariables = Exact<{
  shopKey: ShopKey;
  vPrinterID?: InputMaybe<Scalars['Int32']['input']>;
  type: PrinterType;
}>;

export type ListPrinterStylesQuery = {
  listPrinterStyles: Array<{
    vPrinterID?: number | null;
    name?: string | null;
    printerStyle?: Array<{
      vPrinterID?: number | null;
      of?: TicketOf | null;
      ticketID?: number | null;
      displayOrder?: number | null;
      note?: string | null;
      printEnabled?: boolean | null;
    }> | null;
  }>;
};

export type CreateATicketMutationVariables = Exact<{
  vPrinterKey: VPrinterKey;
  input: TicketInput;
}>;

export type CreateATicketMutation = { createATicket?: number | null };

export type DeleteATicketMutationVariables = Exact<{
  ticketKey: TicketKey;
}>;

export type DeleteATicketMutation = { deleteATicket: boolean };

export type GetATicketQueryVariables = Exact<{
  ticketKey: TicketKey;
}>;

export type GetATicketQuery = {
  getATicket?:
    | {
        __typename: 'TicketCheckout';
        ticketID: number;
        printEnabled: boolean;
        note?: string | null;
        printingDiningOptionArea: Record<string, unknown>;
        barcodeValueMaxChars: number;
        printTrigger: Record<string, unknown>;
        printingNumber: number;
        targetItems: PrintingTargetItemScope;
        fontSize: FontSize;
        printMethodItem: PrintMethodItem;
        printMethodLabel: PrintMethodLabel;
        positionItemQty: PositionItemQty;
        printingMethodCombo: PrintingMethodCombo;
        sortItemMethod: SortItemMethod;
        printAmountBarcode: boolean;
        barcodeType?: BarcodeType | null;
        barcodeValue?: string | null;
        printTxnBarcode: boolean;
        printLoyaltyDetail: boolean;
        notPrintItemOfPriceZero: boolean;
        printItemStats: boolean;
        printServicewareStats: boolean;
        clipperBlank: boolean;
        beeperEnabled: boolean;
        hideNameWhenPriceZero: boolean;
        updatedAt: string;
        printItemCategories?: Array<{
          itemCategoryID: number;
          itemCategory: { name: string };
        }> | null;
        printItemPriceOptions?: Array<{
          itemID: number;
          itemPriceOptionID: number;
          item: { name: string };
          itemPriceOption: {
            priceType: ItemPriceType;
            name: string;
            displayOrder: number;
            originPrice: number;
            price: number;
          };
        }> | null;
        printCustomizedPapers?: Array<{
          ticketCustomizedPaperID: number;
          needCut: boolean;
          displayOrder: number;
          ticketCustomizedPaper: { name?: string | null };
        }> | null;
      }
    | {
        __typename: 'TicketEodClose';
        ticketID: number;
        printEnabled: boolean;
        printingNumber: number;
        printSaleRecords: boolean;
        printSaleRecordsWithoutDetails: boolean;
        printEodStats: boolean;
        beeperEnabled: boolean;
        updatedAt: string;
        exclItems?: Array<{ itemID: number; item: { name: string } }> | null;
      }
    | {
        __typename: 'TicketInvoice';
        ticketID: number;
        txnDetailFontSize: FontSize;
        positionItemQty: PositionItemQty;
        printMethodLabel: PrintMethodLabel;
        printTxnDetails: PrintTxnDetails;
        printingMethodCombo: PrintingMethodCombo;
        sortItemMethod: SortItemMethod;
        cutMethodTxnDetail: boolean;
        hideNameWhenPriceZero: boolean;
        updatedAt: string;
        printCustomizedPapers?: Array<{
          ticketCustomizedPaperID: number;
          needCut: boolean;
          displayOrder: number;
          ticketCustomizedPaper: { name?: string | null };
        }> | null;
      }
    | {
        __typename: 'TicketKitchen';
        ticketID: number;
        printEnabled: boolean;
        note?: string | null;
        printingDiningOptionArea: Record<string, unknown>;
        printTrigger: Record<string, unknown>;
        changingTableRemind?: Record<string, unknown> | null;
        printingNumber: number;
        targetItems: PrintingTargetItemScope;
        targetLabels: PrintingTargetLabelScope;
        fontSize: FontSize;
        printMethodItem: PrintMethodItem;
        printMethodLabel: PrintMethodLabel;
        positionItemQty: PositionItemQty;
        sortItemMethod: SortItemMethod;
        cutMethod: CutMethod;
        cutMethodMergeCombo: boolean;
        printConsumerNumber: boolean;
        clipperBlank: boolean;
        beeperEnabled: boolean;
        updatedAt: string;
        kitchenCombo: PrintingMethodComboOfKitchenSticker;
        printItemCategories?: Array<{
          itemCategoryID: number;
          itemCategory: { name: string };
        }> | null;
        printItemPriceOptions?: Array<{
          itemID: number;
          itemPriceOptionID: number;
          item: { name: string };
          itemPriceOption: {
            priceType: ItemPriceType;
            name: string;
            displayOrder: number;
            originPrice: number;
            price: number;
          };
        }> | null;
        printLabelGroups?: Array<{
          labelGroupID: number;
          labelGroup: { name: string };
        }> | null;
        printLabels?: Array<{
          labelID: number;
          label: { name: string; displayOrder: number; price: number };
        }> | null;
      }
    | {
        __typename: 'TicketOrder';
        ticketID: number;
        printEnabled: boolean;
        note?: string | null;
        printingDiningOptionArea: Record<string, unknown>;
        printTrigger: Record<string, unknown>;
        changingTableRemind?: Record<string, unknown> | null;
        printingNumber: number;
        targetItems: PrintingTargetItemScope;
        fontSize: FontSize;
        printMethodItem: PrintMethodItem;
        printMethodLabel: PrintMethodLabel;
        positionItemQty: PositionItemQty;
        printingMethodCombo: PrintingMethodCombo;
        sortItemMethod: SortItemMethod;
        printTxnBarcode: boolean;
        printAdditionalOrderAmount: boolean;
        printItemStats: boolean;
        printServicewareStats: boolean;
        clipperBlank: boolean;
        beeperEnabled: boolean;
        hideNameWhenPriceZero: boolean;
        updatedAt: string;
        printItemCategories?: Array<{
          itemCategoryID: number;
          itemCategory: { name: string };
        }> | null;
        printItemPriceOptions?: Array<{
          itemID: number;
          itemPriceOptionID: number;
          item: { name: string };
          itemPriceOption: {
            priceType: ItemPriceType;
            name: string;
            displayOrder: number;
            originPrice: number;
            price: number;
          };
        }> | null;
        printCustomizedPapers?: Array<{
          ticketCustomizedPaperID: number;
          needCut: boolean;
          displayOrder: number;
          ticketCustomizedPaper: { name?: string | null };
        }> | null;
      }
    | {
        __typename: 'TicketQueue';
        ticketID: number;
        printEnabled: boolean;
        note?: string | null;
        printingNumber: number;
        clipperBlank: boolean;
        beeperEnabled: boolean;
        updatedAt: string;
      }
    | {
        __typename: 'TicketScanOrder';
        ticketID: number;
        printEnabled: boolean;
        note?: string | null;
        printingDiningOptionArea: Record<string, unknown>;
        printingNumber: number;
        printShopName: boolean;
        printTableNo: boolean;
        updatedAt: string;
        printCustomizedPapers?: Array<{
          ticketCustomizedPaperID: number;
          needCut: boolean;
          displayOrder: number;
          ticketCustomizedPaper: { name?: string | null };
        }> | null;
      }
    | {
        __typename: 'TicketShiftClose';
        ticketID: number;
        printEnabled: boolean;
        printingNumber: number;
        printSaleRecords: boolean;
        printSaleRecordsWithoutDetails: boolean;
        beeperEnabled: boolean;
        updatedAt: string;
      }
    | {
        __typename: 'TicketSticker';
        ticketID: number;
        printEnabled: boolean;
        note?: string | null;
        layoutMode: StickerLayoutMode;
        printingDiningOptionArea: Record<string, unknown>;
        printTrigger: Record<string, unknown>;
        printingNumber: number;
        targetItems: PrintingTargetItemScope;
        targetLabels: PrintingTargetLabelScope;
        fontSize: FontSize;
        printTicketNo: PrintTicketNo;
        printMethodItem: PrintMethodItem;
        sortItemMethod: SortItemMethod;
        cutMethod: CutMethod;
        printingMethodCustomizedNote: PrintingMethodCustomizedNote;
        beeperEnabled: boolean;
        updatedAt: string;
        stickerCombo?: PrintingMethodComboOfKitchenSticker | null;
        printItemCategories?: Array<{
          itemCategoryID: number;
          itemCategory: { name: string };
        }> | null;
        printItemPriceOptions?: Array<{
          itemID: number;
          itemPriceOptionID: number;
          item: { name: string };
          itemPriceOption: {
            priceType: ItemPriceType;
            name: string;
            displayOrder: number;
            originPrice: number;
            price: number;
          };
        }> | null;
        printLabelGroups?: Array<{
          labelGroupID: number;
          labelGroup: { name: string };
        }> | null;
        printLabels?: Array<{
          labelID: number;
          label: { name: string; displayOrder: number; price: number };
        }> | null;
        printCustomizedNotes?: Array<{
          ticketCustomizedNoteID: number;
          ticketCustomizedNote: { content?: string | null };
        }> | null;
      }
    | null;
};

export type UpdateATicketMutationVariables = Exact<{
  input: UpdateTicketInput;
}>;

export type UpdateATicketMutation = { updateATicket: boolean };

export type CopyVPrinterStylesMutationVariables = Exact<{
  srcVPrinterKey: VPrinterKey;
  destVPrinterKey?: InputMaybe<VPrinterKey>;
  destShopKey?: InputMaybe<ShopKey>;
  printerInput?: InputMaybe<PrinterInput>;
  mode: SingleCopyMode;
  includeCustomized?: InputMaybe<Scalars['Boolean']['input']>;
  dedupeCustomized?: InputMaybe<Scalars['Boolean']['input']>;
  selectedTickets: Array<TicketKey> | TicketKey;
}>;

export type CopyVPrinterStylesMutation = { copyVPrinterStyles: boolean };

export type UpdateDisplayOrderOfTicketsMutationVariables = Exact<{
  input?: InputMaybe<Array<TicketDisplayOrderInput> | TicketDisplayOrderInput>;
}>;

export type UpdateDisplayOrderOfTicketsMutation = {
  updateDisplayOrderOfTickets: boolean;
};

export type CopyATicketOfVPrinterMutationVariables = Exact<{
  ticketKey: TicketKey;
}>;

export type CopyATicketOfVPrinterMutation = { copyATicketOfVPrinter: boolean };

export type GetShopReasonSettingsQueryVariables = Exact<{
  shopKey: ShopKey;
  reasonType: ReasonType;
}>;

export type GetShopReasonSettingsQuery = {
  getShopReasonSettings?: Array<{
    reasonTemplateID: number;
    selected: boolean;
    displayOrder: number;
    reasonTemplate: { name: string };
  }> | null;
};

export type UpdateShopReasonSettingsMutationVariables = Exact<{
  input: UpdateAShopReasonSettingInput;
}>;

export type UpdateShopReasonSettingsMutation = {
  updateShopReasonSettings: boolean;
};

export type GetBrandReasonTemplatesQueryVariables = Exact<{
  brandKey: BrandKey;
  reasonType: ReasonType;
}>;

export type GetBrandReasonTemplatesQuery = {
  getBrandReasonTemplates?: Array<{
    reasonTemplateID: number;
    name: string;
    disabled: boolean;
    cashDrawerTransactionType?: CashDrawerTransactionType | null;
    cashDrawerReasonCode?: string | null;
  }> | null;
};

export type UpdateBrandReasonTemplatesMutationVariables = Exact<{
  input: UpdateABrandReasonTemplateInput;
}>;

export type UpdateBrandReasonTemplatesMutation = {
  updateBrandReasonTemplates: boolean;
};

export type ListRolesQueryVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
  searchParams: RoleSearchParams;
  pageInput: CursorPageInput;
}>;

export type ListRolesQuery = {
  listRoles: {
    roles: Array<{
      permissionCount: number;
      usageCount: number;
      role: {
        roleID: number;
        activate: boolean;
        of: PermissionScope;
        roleTemplate: {
          roleTemplateID: string;
          code: string;
          name: string;
          description?: string | null;
          visibility: RoleVisibility;
          createdAt: string;
          updatedAt: string;
        };
      };
    }>;
    pageInfo: { nextCursor?: string | null; prevCursor?: string | null };
  };
};

export type GetRolePermissionQueryVariables = Exact<{
  roleTemplateID: Scalars['UUID']['input'];
}>;

export type GetRolePermissionQuery = {
  getRolePermission: Array<{ permissionDetailID: string; code: string }>;
};

export type DisableRoleMutationVariables = Exact<{
  roleID: Scalars['Int32']['input'];
}>;

export type DisableRoleMutation = { disableRole: boolean };

export type DuplicateRoleMutationVariables = Exact<{
  roleID: Scalars['Int32']['input'];
}>;

export type DuplicateRoleMutation = { duplicateRole: boolean };

export type DeleteRoleMutationVariables = Exact<{
  input: DeleteRoleInput;
}>;

export type DeleteRoleMutation = { deleteRole: boolean };

export type UpdateRoleMutationVariables = Exact<{
  input: UpdateRoleInput;
}>;

export type UpdateRoleMutation = { updateRole: boolean };

export type UpdateRolePermissionMutationVariables = Exact<{
  input: UpdateRolePermissionInput;
}>;

export type UpdateRolePermissionMutation = { updateRolePermission: boolean };

export type UpdateRoleTemplatePermissionsMutationVariables = Exact<{
  roleTemplateID: Scalars['UUID']['input'];
  permissionDetailIDs:
    | Array<Scalars['UUID']['input']>
    | Scalars['UUID']['input'];
}>;

export type UpdateRoleTemplatePermissionsMutation = {
  updateRoleTemplatePermissions: { roleTemplateID: string };
};

export type AddRoleMutationVariables = Exact<{
  name: Scalars['String']['input'];
  descr?: InputMaybe<Scalars['String']['input']>;
  workspaceID: Scalars['UUID']['input'];
}>;

export type AddRoleMutation = {
  addRole: {
    roleID: number;
    roleName: string;
    roleDescription: string;
    roleCount: number;
    roleTemplateID: string;
  };
};

export type ListRolePermissionsQueryVariables = Exact<{ [key: string]: never }>;

export type ListRolePermissionsQuery = {
  listRolePermissions: Array<{
    permissionID: string;
    name: string;
    slug: string;
    displayOrder: number;
    permissionDetails: Array<{
      permissionDetailID: string;
      code: string;
      description?: string | null;
    }>;
    children?: Array<{
      permissionID: string;
      name: string;
      slug: string;
      displayOrder: number;
      permissionDetails: Array<{
        permissionDetailID: string;
        code: string;
        description?: string | null;
      }>;
      children?: Array<{
        permissionID: string;
        name: string;
        slug: string;
        displayOrder: number;
        permissionDetails: Array<{
          permissionDetailID: string;
          code: string;
          description?: string | null;
        }>;
        children?: Array<{
          permissionID: string;
          name: string;
          slug: string;
          displayOrder: number;
          permissionDetails: Array<{
            permissionDetailID: string;
            code: string;
          }>;
        }> | null;
      }> | null;
    }> | null;
  }>;
};

export type ListPosPermissionsQueryVariables = Exact<{ [key: string]: never }>;

export type ListPosPermissionsQuery = {
  listPOSPermissions: Array<{
    permissionID: string;
    name: string;
    slug: string;
    displayOrder: number;
    permissionDetails: Array<{
      permissionDetailID: string;
      code: string;
      description?: string | null;
    }>;
    children?: Array<{
      permissionID: string;
      name: string;
      slug: string;
      displayOrder: number;
      permissionDetails: Array<{
        permissionDetailID: string;
        code: string;
        description?: string | null;
      }>;
      children?: Array<{
        permissionID: string;
        name: string;
        slug: string;
        displayOrder: number;
        permissionDetails: Array<{
          permissionDetailID: string;
          code: string;
          description?: string | null;
        }>;
        children?: Array<{
          permissionID: string;
          name: string;
          slug: string;
          displayOrder: number;
          permissionDetails: Array<{
            permissionDetailID: string;
            code: string;
          }>;
        }> | null;
      }> | null;
    }> | null;
  }>;
};

export type ListShopPermissionVerificationsQueryVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
  brandID: Scalars['Int32']['input'];
  shopID: Scalars['Int32']['input'];
}>;

export type ListShopPermissionVerificationsQuery = {
  listShopPermissionVerifications: Array<{
    permissionID: string;
    permissionDetails: Array<{ permissionDetailID: string }>;
  }>;
};

export type UpdateShopPermissionVerificationsMutationVariables = Exact<{
  input: UpdateShopPermissionVerificationsInput;
}>;

export type UpdateShopPermissionVerificationsMutation = {
  updateShopPermissionVerifications: boolean;
};

export type GetScanOrderSettingQueryVariables = Exact<{
  shopKey: ShopKey;
}>;

export type GetScanOrderSettingQuery = {
  getScanOrderSetting?: {
    scanOrderActivate: boolean;
    showItemStock: boolean;
    cashOnSiteActivate: boolean;
    cashOnSiteDiningIn: boolean;
    cashOnSiteTakeaway: boolean;
    linePayActivate: boolean;
    linePayOnDineIn: boolean;
    linePayOnTakeAway: boolean;
    creditCardActivate: boolean;
    creditCardOnDineIn: boolean;
    creditCardOnTakeAway: boolean;
    hideItemSpecialRequire: boolean;
    hideOrderNote: boolean;
    menuType: MenuType;
    memberLoginRequired: O2OMemberLoginRequiredType;
    memberLoginTiming: O2OMemberLoginTimingType;
    memberSourceID?: string | null;
    banners: Array<{ bannerID: number; hash: string }>;
  } | null;
};

export type SetScanOrderSettingMutationVariables = Exact<{
  shopKey: ShopKey;
  scanOrderSettingInput: ScanOrderSettingInput;
}>;

export type SetScanOrderSettingMutation = { setScanOrderSetting: boolean };

export type GetScanOrderSettingTakeOutQueryVariables = Exact<{
  shopKey: ShopKey;
}>;

export type GetScanOrderSettingTakeOutQuery = {
  getScanOrderSettingTakeOut?: {
    scanOrderTakeOutURL: string;
    scanOrderSettingTakeOut?: {
      scanOrderTakeOutActivate: boolean;
      unpaidOrderAcceptance: ScanOrderAcceptanceMode;
      paidOrderAcceptance: ScanOrderAcceptanceMode;
      autoCheckoutAfterPaidOrderAcceptedActivate: boolean;
      notes?: string | null;
      brandDiningOptionID?: number | null;
    } | null;
  } | null;
};

export type SetScanOrderSettingTakeOutMutationVariables = Exact<{
  shopKey: ShopKey;
  scanOrderSettingTakeOutInput: ScanOrderSettingTakeOutInput;
}>;

export type SetScanOrderSettingTakeOutMutation = {
  setScanOrderSettingTakeOut: boolean;
};

export type GetScanOrderSettingDiningInQueryVariables = Exact<{
  shopKey: ShopKey;
}>;

export type GetScanOrderSettingDiningInQuery = {
  getScanOrderSettingDiningIn?: {
    scanOrderDiningInURL?: string | null;
    scanOrderSettingDiningIn?: {
      scanOrderDiningInActivate: boolean;
      qrCodeType: ScanOrderQrCodeType;
      billingMode: ScanOrderBillingMode;
      diningTimeLimitActivate: boolean;
      diningTimeLimitInMinutes: number;
      lastOrderReminderActivate: boolean;
      lastOrderReminderInMinutes: number;
      lastOrderLimitActivate: boolean;
      lastOrderLimitInMinutes: number;
      unpaidOrderAcceptance: ScanOrderAcceptanceMode;
      paidOrderAcceptance: ScanOrderAcceptanceMode;
      autoCheckoutAfterPaidOrderAcceptedActivate: boolean;
      hideOrderAmount: boolean;
      tableSelectionRequired: boolean;
      distanceLimitActivate: boolean;
      distanceLimitInMeters?: number | null;
      notes?: string | null;
      brandDiningOptionID?: number | null;
    } | null;
  } | null;
};

export type ExportTableQrCodesQueryVariables = Exact<{
  shopKey: ShopKey;
}>;

export type ExportTableQrCodesQuery = { exportTableQRCodes: string };

export type SetScanOrderSettingDiningInMutationVariables = Exact<{
  shopKey: ShopKey;
  scanOrderSettingDiningInInput: ScanOrderSettingDiningInInput;
}>;

export type SetScanOrderSettingDiningInMutation = {
  setScanOrderSettingDiningIn: boolean;
};

export type ListShopDiningOptionsQueryVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
  brandID: Scalars['Int32']['input'];
  shopID?: InputMaybe<Scalars['Int32']['input']>;
}>;

export type ListShopDiningOptionsQuery = {
  listShops: Array<{
    shopDiningOptions: Array<{
      disabled: boolean;
      brandDiningOption: {
        brandDiningOptionID: number;
        name: string;
        diningOptionType: DiningOptionType;
        disabled: boolean;
        id: number;
      };
    }>;
  }>;
};

export type GetAServiceFeeQueryVariables = Exact<{
  shopKey: ShopKey;
}>;

export type GetAServiceFeeQuery = {
  getAServiceFee: {
    enabled: boolean;
    percentage: number;
    advName: string;
    roundingRule: DiscountRoundingRule;
    shopDiningOptionApplyMode: ShopDiningOptionApplyMode;
    taxCategory: TaxCategory;
    taxGroupID?: number | null;
    selDiningOptions: Array<{ brandDiningOptionID: number }>;
    exclItems: Array<{
      itemID: number;
      item: {
        name: string;
        code: string;
        itemPriceOptions: Array<{ itemCode: string }>;
      };
    }>;
  };
};

export type UpdateAServiceFeeMutationVariables = Exact<{
  input: UpdateAServiceFeeInput;
}>;

export type UpdateAServiceFeeMutation = { updateAServiceFee: boolean };

export type ListServicewaresQueryVariables = Exact<{
  brandKey: BrandKey;
  searchParams?: InputMaybe<ServicewareSearchParams>;
  pageInput: CursorPageInput;
}>;

export type ListServicewaresQuery = {
  listServicewares: {
    servicewares: Array<{
      itemCount: number;
      labelCount: number;
      serviceware: {
        workspaceID: string;
        brandID: number;
        servicewareID: string;
        name: string;
        displayOrder: number;
        activate: boolean;
        createdAt: string;
        updatedAt: string;
        servicewareItems?: Array<{
          itemID: number;
          itemPriceOptionID: number;
          quantity: number;
          itemPriceOption: {
            itemID: number;
            itemPriceOptionID: number;
            price: number;
            name: string;
            item: { itemID: number; name: string };
          };
        }> | null;
        servicewareLabels?: Array<{
          labelID: number;
          label: {
            labelID: number;
            name: string;
            price: number;
            displayOrder: number;
          };
        }> | null;
      };
    }>;
    pageInfo: { prevCursor?: string | null; nextCursor?: string | null };
  };
};

export type GetServicewaresQueryVariables = Exact<{
  brandKey: BrandKey;
}>;

export type GetServicewaresQuery = {
  getServicewares: Array<{
    workspaceID: string;
    brandID: number;
    servicewareID: string;
    name: string;
    displayOrder: number;
    activate: boolean;
    createdAt: string;
    updatedAt: string;
  }>;
};

export type UpsertServicewareMutationVariables = Exact<{
  input: UpsertServicewareInput;
}>;

export type UpsertServicewareMutation = { upsertServiceware: boolean };

export type UpdateServicewareRelationsMutationVariables = Exact<{
  input: UpdateServicewareRelationsInput;
}>;

export type UpdateServicewareRelationsMutation = {
  updateServicewareRelations: boolean;
};

export type ListAndSearchShopGroupsQueryVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
  brandID: Scalars['Int32']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;

export type ListAndSearchShopGroupsQuery = {
  listAndSearchShopGroups: Array<{
    groupID: number;
    name: string;
    displayOrder: number;
  }>;
};

export type ListShopsWithShopGroupsQueryVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
  brandID: Scalars['Int32']['input'];
  subBrandID?: InputMaybe<Scalars['Int32']['input']>;
  shopGroupID?: InputMaybe<Scalars['Int32']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  pageInput: CursorPageInput;
}>;

export type ListShopsWithShopGroupsQuery = {
  listShopsWithShopGroups: {
    shops: Array<{
      shopID: number;
      name: string;
      code?: string | null;
      e164CountryCode?: string | null;
      subBrandName?: string | null;
      address?: string | null;
      landLine?: string | null;
      id: number;
      shopGroups?: Array<{ name: string }> | null;
    }>;
    pageInfo: { prevCursor?: string | null; nextCursor?: string | null };
  };
};

export type ListShopsQueryVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
  brandID: Scalars['Int32']['input'];
  shopID?: InputMaybe<Scalars['Int32']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<SortOrder>;
  sortField?: InputMaybe<ShopSortField>;
}>;

export type ListShopsQuery = {
  listShops: Array<{
    shopID: number;
    name: string;
    displayOrder: number;
    code?: string | null;
    id: number;
    subBrand?: { name: string } | null;
  }>;
};

export type UpdateShopDisplayOrderMutationVariables = Exact<{
  input: UpdateShopDisplayOrderInput;
}>;

export type UpdateShopDisplayOrderMutation = {
  updateShopDisplayOrder: boolean;
};

export type UpsertShopGroupsMutationVariables = Exact<{
  input: UpsertShopGroupInput;
}>;

export type UpsertShopGroupsMutation = { upsertShopGroups: boolean };

export type GetShopDetailsQueryVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
  brandID: Scalars['Int32']['input'];
  shopID: Scalars['Int32']['input'];
}>;

export type GetShopDetailsQuery = {
  getShopDetails: {
    shop: {
      shopID: number;
      name: string;
      code?: string | null;
      brandID: number;
      aliasName?: string | null;
      subBrandID?: number | null;
      timezoneID: string;
      languageID: string;
      description?: string | null;
      cityCounty?: string | null;
      district?: string | null;
      road?: string | null;
      zipCode?: string | null;
      doorNo?: string | null;
      buildingFloor?: string | null;
      countryCode?: string | null;
      landLine?: string | null;
      dayTimeType?: DayTimeType | null;
      updatedAt: string;
      id: number;
      subBrand?: { name: string } | null;
      e164CountryCode?: { name: string; code: string } | null;
    };
    shopImages: Array<{
      imageID: number;
      hash: string;
      mime: ImageMimeType;
      width: number;
      height: number;
      fileSize: number;
      displayOrder: number;
    }>;
    shopGroups: Array<{ groupID: number; name: string }>;
    shopBusinessHours: Array<{
      shopBusinessHoursID: number;
      weekDay: number;
      startTime: string;
      endTime: string;
    }>;
  };
};

export type ShopEditListAndSearchShopGroupsQueryVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
  brandID: Scalars['Int32']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;

export type ShopEditListAndSearchShopGroupsQuery = {
  listAndSearchShopGroups: Array<{ groupID: number; name: string }>;
};

export type UpsertShopDetailsMutationVariables = Exact<{
  input: UpsertShopDetailsInput;
}>;

export type UpsertShopDetailsMutation = { upsertShopDetails: boolean };

export type PutShopImageMutationVariables = Exact<{
  shopKey: ShopKey;
  files: Array<Scalars['Upload']['input']> | Scalars['Upload']['input'];
}>;

export type PutShopImageMutation = { putShopImage: Array<{ imageID: number }> };

export type DelShopImagesMutationVariables = Exact<{
  shopKey: ShopKey;
  imageIDs: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type DelShopImagesMutation = { delShopImages: boolean };

export type ListEmployeesQueryVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
  searchParams: EmployeeSearchParams;
  pageInput: CursorPageInput;
}>;

export type ListEmployeesQuery = {
  listEmployees: {
    employees: Array<{
      employeeID: string;
      firstName?: string | null;
      lastName?: string | null;
      activate: boolean;
      createdAt: string;
      roles?: Array<{
        roleID: number;
        displayID: string;
        roleTemplate: { name: string };
      }> | null;
      employeeUniqueCode?: { employeeCode?: string | null } | null;
      employeePortraits?: Array<{ hash: string }> | null;
      user?: {
        email: string;
        validated: boolean;
        lastSendMailVerificationAt?: string | null;
        lastActivity?: { activityID: number; createdAt: string } | null;
      } | null;
    }>;
    pageInfo: { nextCursor?: string | null; prevCursor?: string | null };
  };
};

export type GetEmployeeQueryVariables = Exact<{
  employeeID: Scalars['UUID']['input'];
  workspaceID: Scalars['UUID']['input'];
}>;

export type GetEmployeeQuery = {
  getEmployee: {
    portrait?: string | null;
    employee: {
      employeeID: string;
      activate: boolean;
      firstName?: string | null;
      lastName?: string | null;
      createdAt: string;
      updatedAt: string;
      orgBelongs: Array<{
        belongID: number;
        workspaceID: string;
        brandID?: number | null;
        shopID?: number | null;
        brand?: { name: string; code: string } | null;
        shop?: { name: string; code?: string | null } | null;
      }>;
      employeeUniqueCode?: {
        employeeCode?: string | null;
        pin?: string | null;
      } | null;
      user?: {
        email: string;
        validated: boolean;
        lastSendMailVerificationAt?: string | null;
        lastActivity?: { createdAt: string } | null;
      } | null;
    };
    role?: {
      roleID: number;
      roleTemplateID: string;
      roleTemplate: { name: string; code: string };
    } | null;
    permissionDetails: Array<{ permissionDetailID: string; code: string }>;
  };
};

export type BindEmployeeEmailMutationVariables = Exact<{
  employeeID: Scalars['UUID']['input'];
  email: Scalars['String']['input'];
}>;

export type BindEmployeeEmailMutation = { bindEmployeeEmail: boolean };

export type ChangeEmployeeEmailMutationVariables = Exact<{
  employeeID: Scalars['UUID']['input'];
  email: Scalars['String']['input'];
}>;

export type ChangeEmployeeEmailMutation = { changeEmployeeEmail: boolean };

export type DisableEmployeeMutationVariables = Exact<{
  employeeID: Scalars['UUID']['input'];
}>;

export type DisableEmployeeMutation = { disableEmployee: boolean };

export type DeleteEmployeeMutationVariables = Exact<{
  employeeID: Scalars['UUID']['input'];
}>;

export type DeleteEmployeeMutation = { deleteEmployee: boolean };

export type LinkEmployeeMutationVariables = Exact<{
  input: LinkEmployeeInput;
}>;

export type LinkEmployeeMutation = { linkEmployee: boolean };

export type SendEmailVerificationInBatchMutationVariables = Exact<{
  emails: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;

export type SendEmailVerificationInBatchMutation = {
  sendEmailVerificationInBatch: { success: boolean; numberSent: number };
};

export type StaffListBrandsQueryVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
}>;

export type StaffListBrandsQuery = {
  listBrands: Array<{
    brandID: number;
    code: string;
    name: string;
    subBrands: Array<{
      shops: Array<{ name: string; shopID: number; code?: string | null }>;
    }>;
    uncategorizedShops: Array<{
      name: string;
      shopID: number;
      code?: string | null;
    }>;
  }>;
};

export type UpdateEmployeeMutationVariables = Exact<{
  input: UpdateEmployeeInput;
}>;

export type UpdateEmployeeMutation = { updateEmployee: string };

export type EmployeePinGenAndCheckMutationVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
  pin?: InputMaybe<Scalars['String']['input']>;
}>;

export type EmployeePinGenAndCheckMutation = {
  employeePinGenAndCheck: { pin?: string | null; validation?: boolean | null };
};

export type UpdateEmployeePortraitMutationVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
  employeeID: Scalars['UUID']['input'];
  file: Scalars['Upload']['input'];
}>;

export type UpdateEmployeePortraitMutation = {
  updateEmployeePortrait: {
    employeeImage: {
      employeeID: string;
      portraitID: string;
      hash: string;
      alg: ImageHashAlg;
      mime: ImageMimeType;
      width: number;
      height: number;
      fileSize: number;
      createdAt: string;
      updatedAt: string;
    };
  };
};

export type DeleteEmployeePortraitMutationVariables = Exact<{
  employeeID: Scalars['UUID']['input'];
}>;

export type DeleteEmployeePortraitMutation = {
  deleteEmployeePortrait: boolean;
};

export type StaffListRolesQueryVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
  searchParams: RoleSearchParams;
  pageInput: CursorPageInput;
}>;

export type StaffListRolesQuery = {
  listRoles: {
    roles: Array<{
      role: {
        roleID: number;
        of: PermissionScope;
        roleTemplate: { code: string; name: string };
      };
    }>;
  };
};

export type ListPublishTasksQueryVariables = Exact<{
  brandKey: BrandKey;
  shopID?: InputMaybe<Scalars['Int32']['input']>;
  pageInput: CursorPageInput;
}>;

export type ListPublishTasksQuery = {
  listPublishTasks: {
    publishTasks?: Array<{
      publishTaskID: number;
      name: string;
      version: number;
      description: string;
      effectiveTime: string;
      cancelTime?: string | null;
      status: PublishStatus;
      createdAt: string;
      id: number;
      shopPublishTasks: Array<{ shopID: number; updatedAt: string }>;
    }> | null;
    pageInfo: { nextCursor?: string | null; prevCursor?: string | null };
  };
};

export type CancelPublishTaskMutationVariables = Exact<{
  input: CancelPublishTaskInput;
}>;

export type CancelPublishTaskMutation = { cancelPublishTask: boolean };

export type ShopAreaListQueryVariables = Exact<{
  shopKey: ShopKey;
  search?: InputMaybe<Scalars['String']['input']>;
  pageInput: CursorPageInput;
}>;

export type ShopAreaListQuery = {
  shopAreaList: Array<{
    shopAreas: Array<{
      shopAreaID: number;
      name: string;
      displayOrder: number;
      shopTables: Array<{
        name: string;
        displayOrder: number;
        capacity: number;
      }>;
    } | null>;
    pageInfo: { nextCursor?: string | null; prevCursor?: string | null };
  } | null>;
};

export type GetShopAreasQueryVariables = Exact<{
  shopKey: ShopKey;
}>;

export type GetShopAreasQuery = {
  getShopAreas: Array<{
    shopAreaID: number;
    name: string;
    displayOrder: number;
    shopTables: Array<{ name: string }>;
  } | null>;
};

export type GetShopAreaInfoQueryVariables = Exact<{
  shopKey: ShopKey;
  shopAreaID: Scalars['Int32']['input'];
}>;

export type GetShopAreaInfoQuery = {
  getShopAreaInfo: {
    shopTables: Array<{
      shopTableID: number;
      name: string;
      capacity: number;
      shape: ShopTableShape;
      width: number;
      height: number;
      x: number;
      y: number;
      rotation: number;
      position: ShopTablePosition;
      displayOrder: number;
      zOrder: number;
    } | null>;
    shopAreaDecorations: Array<{
      shopAreaDecorationID: number;
      type: ShopTableDecorationType;
      content?: string | null;
      width: number;
      height: number;
      x: number;
      y: number;
      rotation: number;
      zOrder: number;
    } | null>;
  };
};

export type UpdateShopAreaInfoMutationVariables = Exact<{
  shopKey: ShopKey;
  shopAreaID: Scalars['Int32']['input'];
  shopTableInput:
    | Array<InputMaybe<ShopTableInput>>
    | InputMaybe<ShopTableInput>;
  shopAreaDecorationInput:
    | Array<InputMaybe<ShopAreaDecorationInput>>
    | InputMaybe<ShopAreaDecorationInput>;
}>;

export type UpdateShopAreaInfoMutation = { updateShopAreaInfo: boolean };

export type UpdateShopAreaMutationVariables = Exact<{
  shopKey: ShopKey;
  deleteShopAreaIDs?: InputMaybe<
    | Array<InputMaybe<Scalars['Int32']['input']>>
    | InputMaybe<Scalars['Int32']['input']>
  >;
  shopAreaInput: Array<InputMaybe<ShopAreaInput>> | InputMaybe<ShopAreaInput>;
}>;

export type UpdateShopAreaMutation = { updateShopArea: boolean };

export type UpdateShopTableMutationVariables = Exact<{
  shopKey: ShopKey;
  shopAreaID: Scalars['Int32']['input'];
  shopTableInput:
    | Array<InputMaybe<ShopTableInput>>
    | InputMaybe<ShopTableInput>;
}>;

export type UpdateShopTableMutation = { updateShopTable: boolean };

export type DeleteShopTableMutationVariables = Exact<{
  shopKey: ShopKey;
  shopAreaID: Scalars['Int32']['input'];
  shopTableID: Scalars['Int32']['input'];
}>;

export type DeleteShopTableMutation = { deleteShopTable: boolean };

export type DeleteShopAreaDecorationMutationVariables = Exact<{
  shopKey: ShopKey;
  shopAreaID: Scalars['Int32']['input'];
  shopAreaDecorationIDs:
    | Array<InputMaybe<Scalars['Int32']['input']>>
    | InputMaybe<Scalars['Int32']['input']>;
}>;

export type DeleteShopAreaDecorationMutation = {
  deleteShopAreaDecoration: boolean;
};

export type CopyShopTableMutationVariables = Exact<{
  shopKey: ShopKey;
  shopAreaID: Scalars['Int32']['input'];
  shopTableID: Scalars['Int32']['input'];
}>;

export type CopyShopTableMutation = {
  copyShopTable: {
    shopTableID: number;
    name: string;
    capacity: number;
    shape: ShopTableShape;
    width: number;
    height: number;
    x: number;
    y: number;
    rotation: number;
    position: ShopTablePosition;
    displayOrder: number;
    zOrder: number;
  };
};

export type ListTaxUnitsOfWorkspaceQueryVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
}>;

export type ListTaxUnitsOfWorkspaceQuery = {
  listTaxUnitsOfWorkspace: Array<{
    workspaceID: string;
    taxID: number;
    name: string;
    taxMethod: TaxMethod;
    roundingRule: StandardRoundingRule;
    rate: number;
    displaySuffix: string;
    id: number;
  }>;
};

export type ListTaxGroupsOfWorkspaceQueryVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
  available?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ListTaxGroupsOfWorkspaceQuery = {
  listTaxGroupsOfWorkspace: Array<{
    workspaceID: string;
    taxGroupID: number;
    name: string;
    calculationMethod: TaxGroupCalculationMethod;
    enableDiningOptionDefaultTax: boolean;
    taxGroupUnits: Array<{
      taxUnit: {
        taxID: number;
        name: string;
        taxMethod: TaxMethod;
        roundingRule: StandardRoundingRule;
        rate: number;
        id: number;
      };
    }>;
    workspaceDiningOptionDefaultTaxes: Array<{
      diningOptionType: DiningOptionType;
      taxID: number;
    }>;
  }>;
};

export type CreateATaxUnitMutationVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
  input: TaxUnitInput;
}>;

export type CreateATaxUnitMutation = { createATaxUnit: boolean };

export type UpdateATaxUnitMutationVariables = Exact<{
  taxUnitKey: TaxUnitKey;
  input: TaxUnitInput;
}>;

export type UpdateATaxUnitMutation = { updateATaxUnit: boolean };

export type DeleteATaxUnitMutationVariables = Exact<{
  taxUnitKey: TaxUnitKey;
}>;

export type DeleteATaxUnitMutation = { deleteATaxUnit: boolean };

export type CreateATaxGroupMutationVariables = Exact<{
  workspaceID: Scalars['UUID']['input'];
  taxGroupInput: TaxGroupInput;
  workspaceDiningOptionDefaultTaxInput?: InputMaybe<
    | Array<WorkspaceDiningOptionDefaultTaxInput>
    | WorkspaceDiningOptionDefaultTaxInput
  >;
}>;

export type CreateATaxGroupMutation = { createATaxGroup: boolean };

export type UpdateATaxGroupMutationVariables = Exact<{
  taxGroupKey: TaxGroupKey;
  taxGroupInput: TaxGroupInput;
  workspaceDiningOptionDefaultTaxInput?: InputMaybe<
    | Array<WorkspaceDiningOptionDefaultTaxInput>
    | WorkspaceDiningOptionDefaultTaxInput
  >;
}>;

export type UpdateATaxGroupMutation = { updateATaxGroup: boolean };

export type DeleteATaxGroupMutationVariables = Exact<{
  taxGroupKey: TaxGroupKey;
}>;

export type DeleteATaxGroupMutation = { deleteATaxGroup: boolean };

export type ListTransactionsQueryVariables = Exact<{
  shopKey: ShopKey;
  searchParams: TransactionSearchParams;
  searchCondition: TransactionSearchCondition;
  search?: InputMaybe<Scalars['String']['input']>;
  pageInput: CursorPageInput;
}>;

export type ListTransactionsQuery = {
  listTransactions: {
    transactions?: Array<{
      transactionID: string;
      createdAt: string;
      transactionNo: string;
      transactionType: TransactionType;
      totalAmount: number;
      businessDate: string;
      transactionStatus: TransactionStatus;
      discountAmount: number;
      serviceFeeAmount: number;
      payments: Array<{ brandPaymentMethodName: string; amount: number }>;
      order: {
        orderID: string;
        totalAmount: number;
        createdAt: string;
        orderNo: string;
        orderCode: string;
      };
      currentInvoices: Array<{
        invoiceNo: string;
        amount: number;
        invoiceStatus: InvoiceStatus;
      }>;
      opUser?: { lastName?: string | null; firstName?: string | null } | null;
    }> | null;
    pageInfo: { nextCursor?: string | null; prevCursor?: string | null };
  };
};

export type ExportTransactionsCsvFileMutationVariables = Exact<{
  input: TransactionsCsvInput;
}>;

export type ExportTransactionsCsvFileMutation = {
  exportTransactionsCSVFile: string;
};
